(function () {
function $cd5a47cf8ef6d766$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $ad1c00e896d27009$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $f17388ede13a49cc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f17388ede13a49cc$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $f17388ede13a49cc$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


var $de78fff7b3201fb9$export$935bc35302f21d93 = function(game, render) {
    return function(e) {
        if (game.win || game.lose) return;
        var directionMap = {
            ArrowUp: "up",
            ArrowDown: "down",
            ArrowLeft: "left",
            ArrowRight: "right"
        };
        if (directionMap[e.key]) {
            game.move(directionMap[e.key]);
            render();
        }
    };
};
var $de78fff7b3201fb9$export$f11d8654acca7032 = function(e) {
    if (e.touches.length > 1) e.preventDefault(); // Забороняє масштабування при багатоточкових дотиках
};
var $de78fff7b3201fb9$export$81df17ce304cb8dd = function(e) {
    e.preventDefault(); // Забороняє масштабування жестом "щипок"
};
var $de78fff7b3201fb9$export$9474d409c1ed53c7 = function(e) {
    e.preventDefault();
};


var $75ea2ebfb38b72b5$export$d777e9849b416b53 = function(game, render) {
    var tileContainer = document.querySelector(".tile-container");
    var startX = 0;
    var startY = 0;
    tileContainer.addEventListener("touchmove", (0, $de78fff7b3201fb9$export$9474d409c1ed53c7), {
        passive: false
    });
    tileContainer.addEventListener("touchstart", function(e) {
        var touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
    });
    tileContainer.addEventListener("touchend", function(e) {
        if (game.win || game.lose) return;
        var touch = e.changedTouches[0];
        var endX = touch.clientX;
        var endY = touch.clientY;
        var diffX = endX - startX;
        var diffY = endY - startY;
        var swipeThereshold = 30;
        if (Math.abs(diffX) < swipeThereshold && Math.abs(diffY) < swipeThereshold) return;
        // Визначення напряму свайпу
        if (Math.abs(diffX) > Math.abs(diffY)) {
            if (diffX > swipeThereshold) game.move("right");
            else game.move("left");
        } else if (diffY > swipeThereshold) game.move("down");
        else game.move("up");
        render();
    });
};


var $fea6c9abafe78b66$export$38f891585d03ce96 = 4;
var $fea6c9abafe78b66$export$e3ab40feca470fea = "hidden";
var $fea6c9abafe78b66$export$41f26d2536af779f = "hideTip";
var $fea6c9abafe78b66$export$dfddea1e81ae2895 = "bestScore";
var $fea6c9abafe78b66$export$78da66fbfc3ec44a = {
    text: "Do you want to continue playing?",
    yesText: "Continue",
    noText: "Restart",
    isWin: true,
    winMessage: "Winner! Congrats! You did it!"
};
var $fea6c9abafe78b66$export$7e1cad2321981b86 = {
    text: "Do you want to try again?",
    yesText: "Restart",
    noText: "Cancel",
    isLose: true,
    loseMessage: "Game Over! You lost!"
};
var $fea6c9abafe78b66$export$f981ec3b27145abc = {
    text: "Are you sure you want to restart the game?"
};


function $4b8aec50238c028e$export$d28b580074e273aa() {
    var root = document.documentElement;
    var gameSize = (0, $fea6c9abafe78b66$export$38f891585d03ce96); // Кількість плиток у рядку/стовпці
    var headerHeightRatio = 0.3;
    var verticalMarginsRatio = 0.1;
    var horizontalMarginsRatio = 0.1;
    var gapRatio = 0.1; // Відступи між плитками
    var screenWidth = window.innerWidth;
    var screenHeight = window.innerHeight;
    // Максимально можливий розмір base-unit
    var maxBaseUnitWidth = Math.floor(screenWidth * (1 - horizontalMarginsRatio) * 0.9 / gameSize);
    var maxBaseUnitHeight = Math.floor(screenHeight * (1 - verticalMarginsRatio - headerHeightRatio) * 0.9 / gameSize);
    var baseUnit = Math.min(maxBaseUnitWidth, maxBaseUnitHeight);
    var cellGap = Math.floor(baseUnit * gapRatio);
    var borderRadius = Math.floor(baseUnit * 0.1);
    root.style.setProperty("--game-size", gameSize);
    root.style.setProperty("--base-unit", "".concat(baseUnit, "px"));
    root.style.setProperty("--cell-gap", "".concat(cellGap, "px"));
    root.style.setProperty("--border-radius", "".concat(borderRadius, "px"));
}



function $c0ec718a77f6c5b5$export$f5a33026233531be() {
    var field = document.querySelector(".field");
    for(var i = 0; i < (0, $fea6c9abafe78b66$export$38f891585d03ce96) * (0, $fea6c9abafe78b66$export$38f891585d03ce96); i++){
        var cell = document.createElement("div");
        cell.classList.add("field__cell");
        field.appendChild(cell);
    }
}



var $76925737f7718e27$var$headerButton = document.querySelector(".header__button");
var $76925737f7718e27$var$confirmContainer = document.querySelector(".confirm");
var $76925737f7718e27$var$confirmText = document.querySelector(".confirm__text");
var $76925737f7718e27$var$confirmYesButton = document.querySelector(".confirm__button--yes");
var $76925737f7718e27$var$confirmNoButton = document.querySelector(".confirm__button--no");
var $76925737f7718e27$var$confirmWinMessage = document.querySelector(".confirm__message.message--win");
var $76925737f7718e27$var$confirmLoseMessage = document.querySelector(".confirm__message.message--lose");
var $76925737f7718e27$var$SHOWED_CONFIRM_CLASS = "confirm--showed";
var $76925737f7718e27$var$DEFAULT_YES_TEXT = "Yes";
var $76925737f7718e27$var$DEFAULT_NO_TEXT = "No";
var $76925737f7718e27$var$ANIMATION_DURATION = 400;
function $76925737f7718e27$var$setMessageVisibility(element, message, isVisible) {
    if (isVisible) {
        element.textContent = message;
        element.classList.remove((0, $fea6c9abafe78b66$export$e3ab40feca470fea));
    } else element.classList.add((0, $fea6c9abafe78b66$export$e3ab40feca470fea));
}
function $76925737f7718e27$var$setButtonAction(button, action) {
    button.onclick = function() {
        if (action) action();
        $76925737f7718e27$export$3c93e0c85d59da11();
    };
}
function $76925737f7718e27$export$2b8c3b960bb992d3(data) {
    var text = data.text, yesText = data.yesText, noText = data.noText, onConfirm = data.onConfirm, onReject = data.onReject, isWin = data.isWin, winMessage = data.winMessage, isLose = data.isLose, loseMessage = data.loseMessage;
    $76925737f7718e27$var$setMessageVisibility($76925737f7718e27$var$confirmWinMessage, winMessage, isWin);
    $76925737f7718e27$var$setMessageVisibility($76925737f7718e27$var$confirmLoseMessage, loseMessage, isLose);
    $76925737f7718e27$var$confirmText.textContent = text;
    $76925737f7718e27$var$confirmYesButton.textContent = yesText || $76925737f7718e27$var$DEFAULT_YES_TEXT;
    $76925737f7718e27$var$confirmNoButton.textContent = noText || $76925737f7718e27$var$DEFAULT_NO_TEXT;
    $76925737f7718e27$var$setButtonAction($76925737f7718e27$var$confirmYesButton, onConfirm);
    $76925737f7718e27$var$setButtonAction($76925737f7718e27$var$confirmNoButton, onReject);
    if (!$76925737f7718e27$var$confirmContainer) return;
    $76925737f7718e27$var$confirmContainer.classList.remove((0, $fea6c9abafe78b66$export$e3ab40feca470fea));
    requestAnimationFrame(function() {
        $76925737f7718e27$var$confirmContainer.classList.add($76925737f7718e27$var$SHOWED_CONFIRM_CLASS);
        $76925737f7718e27$var$headerButton.disabled = true;
    });
}
function $76925737f7718e27$export$3c93e0c85d59da11() {
    if (!$76925737f7718e27$var$confirmContainer) return;
    setTimeout(function() {
        $76925737f7718e27$var$setMessageVisibility($76925737f7718e27$var$confirmWinMessage, "", false);
        $76925737f7718e27$var$setMessageVisibility($76925737f7718e27$var$confirmLoseMessage, "", false);
        $76925737f7718e27$var$confirmContainer.classList.add((0, $fea6c9abafe78b66$export$e3ab40feca470fea));
    }, $76925737f7718e27$var$ANIMATION_DURATION);
    requestAnimationFrame(function() {
        $76925737f7718e27$var$confirmContainer.classList.remove($76925737f7718e27$var$SHOWED_CONFIRM_CLASS);
        $76925737f7718e27$var$headerButton.disabled = false;
    });
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


var $9918acfb2b9f8e73$export$3c5f89dae98e900b = function(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
};
var $9918acfb2b9f8e73$export$9cb09a71b7d66923 = function(grid) {
    return grid[0].map(function(_, colIndex) {
        return grid.map(function(row) {
            return row[colIndex];
        });
    });
};
var $9918acfb2b9f8e73$export$18c4334ab504ad4b = function(grid) {
    return grid.map(function(row) {
        return row.slice().reverse();
    });
};
var $9918acfb2b9f8e73$export$6c40052bed430212 = function(grid) {
    return grid.map(function(row) {
        return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
    });
};
var $9918acfb2b9f8e73$export$de363e709c412c8a = function(func, limit) {
    var lastCall = 0;
    return function throttle() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var now = Date.now();
        if (now - lastCall >= limit) {
            lastCall = now;
            func.apply(this, args);
        }
    };
};






function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}





var $f4cdfd32d5d95340$export$985739bfa5723e08 = /*#__PURE__*/ function() {
    "use strict";
    function Game() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $fea6c9abafe78b66$export$38f891585d03ce96);
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.size = size;
        this.grid = this.createEmptyGrid();
        this.score = 0;
        this.bestScore = Number(localStorage.getItem((0, $fea6c9abafe78b66$export$dfddea1e81ae2895))) || 0;
        this.win = false;
        this.lose = false;
        this.hasContinued = false;
        this.newTiles = [];
        this.movesAndMerges = [];
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "createEmptyGrid",
            value: function createEmptyGrid() {
                var _this = this;
                return Array.from({
                    length: this.size
                }, function() {
                    return Array(_this.size).fill(0);
                });
            }
        },
        {
            key: "spawnTile",
            value: function spawnTile() {
                var emptyCells = this.getEmptyCells();
                if (emptyCells.length > 0) {
                    var _emptyCells_randomInt = emptyCells[(0, $9918acfb2b9f8e73$export$3c5f89dae98e900b)(0, emptyCells.length)], row = _emptyCells_randomInt.row, col = _emptyCells_randomInt.col;
                    this.grid[row][col] = Math.random() < 0.9 ? 2 : 4;
                    this.newTiles.push({
                        row: row,
                        col: col
                    });
                }
            }
        },
        {
            key: "getEmptyCells",
            value: function getEmptyCells() {
                var emptyCells = [];
                this.grid.forEach(function(row, rowIndex) {
                    row.forEach(function(value, colIndex) {
                        if (value === 0) emptyCells.push({
                            row: rowIndex,
                            col: colIndex
                        });
                    });
                });
                return emptyCells;
            }
        },
        {
            key: "transformGrid",
            value: function transformGrid(direction) {
                var reverse = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var transposeAndReverse = function(grid) {
                    return (0, $9918acfb2b9f8e73$export$18c4334ab504ad4b)((0, $9918acfb2b9f8e73$export$9cb09a71b7d66923)(grid));
                };
                var reverseAndTranspose = function(grid) {
                    return (0, $9918acfb2b9f8e73$export$9cb09a71b7d66923)((0, $9918acfb2b9f8e73$export$18c4334ab504ad4b)(grid));
                };
                switch(direction){
                    case "up":
                        this.grid = (0, $9918acfb2b9f8e73$export$9cb09a71b7d66923)(this.grid);
                        break;
                    case "down":
                        this.grid = reverse ? reverseAndTranspose(this.grid) : transposeAndReverse(this.grid);
                        break;
                    case "right":
                        this.grid = (0, $9918acfb2b9f8e73$export$18c4334ab504ad4b)(this.grid);
                        break;
                }
            }
        },
        {
            key: "move",
            value: function move(direction) {
                var originalGrid = (0, $9918acfb2b9f8e73$export$6c40052bed430212)(this.grid);
                this.newTiles = [];
                this.movesAndMerges = [];
                this.transformGrid(direction);
                for(var row = 0; row < this.size; row++){
                    var _this_movesAndMerges;
                    var _this_slideAndMerge = this.slideAndMerge(this.grid[row], row, direction), result = _this_slideAndMerge.result, moves = _this_slideAndMerge.moves;
                    this.grid[row] = result;
                    if (moves.length > 0) (_this_movesAndMerges = this.movesAndMerges).push.apply(_this_movesAndMerges, (0, $227c6742e0ff6f82$export$71511d61b312f219)(moves));
                }
                this.transformGrid(direction, true);
                if (JSON.stringify(originalGrid) !== JSON.stringify(this.grid)) {
                    this.spawnTile();
                    this.checkGameState();
                }
            }
        },
        {
            key: "slideAndMerge",
            value: function slideAndMerge(row, rowIndex, direction) {
                var _this = this;
                var moves = [];
                var result = Array(row.length).fill(0);
                var occupiedPositions = new Array(row.length).fill(false);
                var targetIndex = 0;
                var addMove = function(param) {
                    var fromCol = param.fromCol, toCol = param.toCol, fromRow = param.fromRow, toRow = param.toRow, value = param.value, isMerged = param.isMerged;
                    if (fromCol === toCol && fromRow === toRow) return;
                    moves.push({
                        fromCol: fromCol,
                        toCol: toCol,
                        fromRow: fromRow,
                        toRow: toRow,
                        value: value,
                        isMerged: isMerged
                    });
                };
                var getCoordinates = function(i, tIndex) {
                    var fromCol, toCol, fromRow, toRow;
                    switch(direction){
                        case "left":
                            fromCol = i;
                            toCol = tIndex;
                            fromRow = rowIndex;
                            toRow = rowIndex;
                            break;
                        case "right":
                            fromCol = Math.abs(i - (_this.size - 1));
                            toCol = Math.abs(tIndex - (_this.size - 1));
                            fromRow = rowIndex;
                            toRow = rowIndex;
                            break;
                        case "up":
                            fromCol = rowIndex;
                            toCol = rowIndex;
                            fromRow = i;
                            toRow = tIndex;
                            break;
                        case "down":
                            fromCol = rowIndex;
                            toCol = rowIndex;
                            fromRow = Math.abs(i - (_this.size - 1));
                            toRow = Math.abs(tIndex - (_this.size - 1));
                            break;
                    }
                    return {
                        fromCol: fromCol,
                        toCol: toCol,
                        fromRow: fromRow,
                        toRow: toRow
                    };
                };
                for(var i = 0; i < row.length; i++){
                    if (row[i] === 0) continue;
                    if (result[targetIndex] === 0) {
                        result[targetIndex] = row[i];
                        var _getCoordinates = getCoordinates(i, targetIndex), fromCol = _getCoordinates.fromCol, toCol = _getCoordinates.toCol, fromRow = _getCoordinates.fromRow, toRow = _getCoordinates.toRow;
                        addMove({
                            fromCol: fromCol,
                            toCol: toCol,
                            fromRow: fromRow,
                            toRow: toRow,
                            value: row[i],
                            isMerged: false
                        });
                    } else if (result[targetIndex] === row[i] && !occupiedPositions[targetIndex]) {
                        result[targetIndex] *= 2;
                        this.score += result[targetIndex];
                        if (this.score > this.bestScore) {
                            this.bestScore = this.score;
                            localStorage.setItem((0, $fea6c9abafe78b66$export$dfddea1e81ae2895), this.bestScore);
                        }
                        occupiedPositions[targetIndex] = true;
                        var _getCoordinates1 = getCoordinates(i, targetIndex), fromCol1 = _getCoordinates1.fromCol, toCol1 = _getCoordinates1.toCol, fromRow1 = _getCoordinates1.fromRow, toRow1 = _getCoordinates1.toRow;
                        addMove({
                            fromCol: fromCol1,
                            toCol: toCol1,
                            fromRow: fromRow1,
                            toRow: toRow1,
                            value: row[i],
                            isMerged: true
                        });
                        targetIndex++;
                    } else {
                        targetIndex++;
                        result[targetIndex] = row[i];
                        var _getCoordinates2 = getCoordinates(i, targetIndex), fromCol2 = _getCoordinates2.fromCol, toCol2 = _getCoordinates2.toCol, fromRow2 = _getCoordinates2.fromRow, toRow2 = _getCoordinates2.toRow;
                        addMove({
                            fromCol: fromCol2,
                            toCol: toCol2,
                            fromRow: fromRow2,
                            toRow: toRow2,
                            value: row[i],
                            isMerged: false
                        });
                    }
                }
                return {
                    result: result,
                    moves: moves
                };
            }
        },
        {
            key: "checkGameState",
            value: function checkGameState() {
                var _this = this;
                if (!this.hasContinued && this.grid.flat().includes(2048)) this.win = true;
                var movesAvailable = function() {
                    for(var row = 0; row < _this.size; row++)for(var col = 0; col < _this.size; col++){
                        if (_this.grid[row][col] === 0) return true;
                        if (col < _this.size - 1 && _this.grid[row][col] === _this.grid[row][col + 1]) return true;
                        if (row < _this.size - 1 && _this.grid[row][col] === _this.grid[row + 1][col]) return true;
                    }
                    return false;
                };
                if (!movesAvailable()) this.lose = true;
            }
        },
        {
            key: "resetGame",
            value: function resetGame() {
                this.grid = this.createEmptyGrid();
                this.score = 0;
                this.win = false;
                this.lose = false;
                this.hasContinued = false;
                this.spawnTile();
                this.spawnTile();
            }
        }
    ]);
    return Game;
}();


var $46a4ebb2ff2c0b16$var$CLASS_MOVING_TILE = "moving-tile";
var $46a4ebb2ff2c0b16$var$CLASS_MERGE_ANIMATION = "merge-animation";
var $46a4ebb2ff2c0b16$var$CLASS_NEW_TILE = "new-tile";
var $46a4ebb2ff2c0b16$var$CLASS_TILE = "tile";
function $46a4ebb2ff2c0b16$var$updateTilePosition(param) {
    var tile = param.tile, toCol = param.toCol, toRow = param.toRow, value = param.value, isMerged = param.isMerged;
    tile.classList.add($46a4ebb2ff2c0b16$var$CLASS_MOVING_TILE);
    tile.style.setProperty("--x", toCol);
    tile.style.setProperty("--y", toRow);
    tile.dataset.x = toCol;
    tile.dataset.y = toRow;
    if (isMerged) {
        tile.textContent = value * 2;
        tile.classList.remove("tile--".concat(value));
        tile.classList.add("tile--".concat(value * 2));
        tile.classList.add($46a4ebb2ff2c0b16$var$CLASS_MERGE_ANIMATION);
        tile.addEventListener("animationend", function() {
            tile.classList.remove($46a4ebb2ff2c0b16$var$CLASS_MERGE_ANIMATION);
        }, {
            once: true
        });
    }
}
function $46a4ebb2ff2c0b16$var$removeInvalidTiles(param) {
    var tiles = param.tiles, grid = param.grid, tileContainer = param.tileContainer;
    tiles.forEach(function(tile) {
        var x = parseInt(tile.dataset.x, 10);
        var y = parseInt(tile.dataset.y, 10);
        if (!grid[y] || grid[y][x] !== parseInt(tile.textContent, 10)) tileContainer.removeChild(tile);
    });
}
function $46a4ebb2ff2c0b16$var$createTile(param) {
    var col = param.col, row = param.row, value = param.value, newTiles = param.newTiles;
    var tile = document.createElement("div");
    tile.className = "".concat($46a4ebb2ff2c0b16$var$CLASS_TILE, " tile--").concat(value);
    tile.textContent = value;
    if (newTiles.some(function(t) {
        return t.row === row && t.col === col;
    })) tile.classList.add($46a4ebb2ff2c0b16$var$CLASS_NEW_TILE);
    tile.style.setProperty("--x", col);
    tile.style.setProperty("--y", row);
    tile.dataset.x = col;
    tile.dataset.y = row;
    return tile;
}
function $46a4ebb2ff2c0b16$var$clearTileClasses(tiles) {
    tiles.forEach(function(tile) {
        tile.classList.remove($46a4ebb2ff2c0b16$var$CLASS_NEW_TILE, $46a4ebb2ff2c0b16$var$CLASS_MOVING_TILE, $46a4ebb2ff2c0b16$var$CLASS_MERGE_ANIMATION);
    });
}
var $46a4ebb2ff2c0b16$export$791665666f8a0d2 = function(game, tileContainer) {
    var size = game.size, grid = game.grid, newTiles = game.newTiles, movesAndMerges = game.movesAndMerges;
    var tiles = tileContainer.querySelectorAll("." + $46a4ebb2ff2c0b16$var$CLASS_TILE);
    $46a4ebb2ff2c0b16$var$clearTileClasses(tiles);
    movesAndMerges.forEach(function(param) {
        var fromCol = param.fromCol, fromRow = param.fromRow, toCol = param.toCol, toRow = param.toRow, value = param.value, isMerged = param.isMerged;
        var tile = tileContainer.querySelector('.tile[data-x="'.concat(fromCol, '"][data-y="').concat(fromRow, '"]'));
        if (tile) $46a4ebb2ff2c0b16$var$updateTilePosition({
            tile: tile,
            toCol: toCol,
            toRow: toRow,
            value: value,
            isMerged: isMerged
        });
    });
    setTimeout(function() {
        $46a4ebb2ff2c0b16$var$removeInvalidTiles({
            tiles: tiles,
            grid: grid,
            tileContainer: tileContainer
        });
        for(var row = 0; row < size; row++)for(var col = 0; col < size; col++){
            var value = grid[row][col];
            if (value !== 0) {
                var existingTile = tileContainer.querySelector('.tile[data-x="'.concat(col, '"][data-y="').concat(row, '"]'));
                if (!existingTile) {
                    var tile = $46a4ebb2ff2c0b16$var$createTile({
                        col: col,
                        row: row,
                        value: value,
                        newTiles: newTiles
                    });
                    tileContainer.appendChild(tile);
                }
            }
        }
    }, 100);
};




function $ae9d277b5847b878$export$71511d61b312f219(o, p) {
    $ae9d277b5847b878$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ae9d277b5847b878$export$71511d61b312f219(o, p);
}


function $3cd308d6b98edc5a$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $ae9d277b5847b878$export$71511d61b312f219)(subClass, superClass);
}


function $02fe9748b9e38ccb$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $0b5c99e6a0876eaa$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


function $04a501f287790d91$export$71511d61b312f219(self, call) {
    if (call && ((0, $0b5c99e6a0876eaa$export$71511d61b312f219)(call) === "object" || typeof call === "function")) return call;
    return (0, $02fe9748b9e38ccb$export$71511d61b312f219)(self);
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}




function $87e65cc21f1ac8a6$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($87e65cc21f1ac8a6$export$71511d61b312f219 = function() {
        return !!result;
    })();
}



function $afcb8bf546bf0e4a$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $87e65cc21f1ac8a6$export$71511d61b312f219)()) $afcb8bf546bf0e4a$export$71511d61b312f219 = Reflect.construct;
    else $afcb8bf546bf0e4a$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $ae9d277b5847b878$export$71511d61b312f219)(instance, Class.prototype);
        return instance;
    };
    return $afcb8bf546bf0e4a$export$71511d61b312f219.apply(null, arguments);
}


function $0b83a35ce2cd1792$export$71511d61b312f219(o) {
    $0b83a35ce2cd1792$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0b83a35ce2cd1792$export$71511d61b312f219(o);
}


function $93f23ebd967272a8$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}



function $b853fd5b3c362aee$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $b853fd5b3c362aee$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $93f23ebd967272a8$export$71511d61b312f219)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $afcb8bf546bf0e4a$export$71511d61b312f219)(Class, arguments, (0, $0b83a35ce2cd1792$export$71511d61b312f219)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $ae9d277b5847b878$export$71511d61b312f219)(Wrapper, Class);
    };
    return $b853fd5b3c362aee$export$71511d61b312f219(Class);
}





function $fdc48b7b7f0be826$export$71511d61b312f219(Derived) {
    var hasNativeReflectConstruct = (0, $87e65cc21f1ac8a6$export$71511d61b312f219)();
    return function _createSuperInternal() {
        var Super = (0, $0b83a35ce2cd1792$export$71511d61b312f219)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $0b83a35ce2cd1792$export$71511d61b312f219)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $04a501f287790d91$export$71511d61b312f219)(this, result);
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $fc5e3658b603cf39$var$extendStatics = function extendStatics1(d, b) {
    $fc5e3658b603cf39$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $fc5e3658b603cf39$var$extendStatics(d, b);
};
function $fc5e3658b603cf39$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $fc5e3658b603cf39$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $fc5e3658b603cf39$export$18ce0697a983be9b = function __assign1() {
    $fc5e3658b603cf39$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc5e3658b603cf39$export$18ce0697a983be9b.apply(this, arguments);
};
function $fc5e3658b603cf39$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $fc5e3658b603cf39$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $fc5e3658b603cf39$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $fc5e3658b603cf39$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $fc5e3658b603cf39$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $fc5e3658b603cf39$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $0b5c99e6a0876eaa$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $fc5e3658b603cf39$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $0b5c99e6a0876eaa$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $fc5e3658b603cf39$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $fc5e3658b603cf39$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $fc5e3658b603cf39$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $fc5e3658b603cf39$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $fc5e3658b603cf39$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $fc5e3658b603cf39$export$45d3717a4c69092e(o, m, p);
}
function $fc5e3658b603cf39$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $fc5e3658b603cf39$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $fc5e3658b603cf39$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($fc5e3658b603cf39$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $fc5e3658b603cf39$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $fc5e3658b603cf39$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $fc5e3658b603cf39$export$10c90e4f7922046c(v) {
    return this instanceof $fc5e3658b603cf39$export$10c90e4f7922046c ? (this.v = v, this) : new $fc5e3658b603cf39$export$10c90e4f7922046c(v);
}
function $fc5e3658b603cf39$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $fc5e3658b603cf39$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $fc5e3658b603cf39$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $fc5e3658b603cf39$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $fc5e3658b603cf39$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $fc5e3658b603cf39$export$19a8beecd37a4c45 === "function" ? $fc5e3658b603cf39$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $fc5e3658b603cf39$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $fc5e3658b603cf39$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $fc5e3658b603cf39$var$ownKeys = function ownKeys1(o) {
    $fc5e3658b603cf39$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $fc5e3658b603cf39$var$ownKeys(o);
};
function $fc5e3658b603cf39$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $fc5e3658b603cf39$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $fc5e3658b603cf39$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $fc5e3658b603cf39$var$__setModuleDefault(result, mod);
    return result;
}
function $fc5e3658b603cf39$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $fc5e3658b603cf39$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $fc5e3658b603cf39$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $fc5e3658b603cf39$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $fc5e3658b603cf39$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $fc5e3658b603cf39$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $fc5e3658b603cf39$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $fc5e3658b603cf39$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $fc5e3658b603cf39$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $fc5e3658b603cf39$export$2e2bcd8739ae039 = {
    __extends: $fc5e3658b603cf39$export$a8ba968b8961cb8a,
    __assign: $fc5e3658b603cf39$export$18ce0697a983be9b,
    __rest: $fc5e3658b603cf39$export$3c9a16f847548506,
    __decorate: $fc5e3658b603cf39$export$29e00dfd3077644b,
    __param: $fc5e3658b603cf39$export$d5ad3fd78186038f,
    __esDecorate: $fc5e3658b603cf39$export$3a84e1ae4e97e9b0,
    __runInitializers: $fc5e3658b603cf39$export$d831c04e792af3d,
    __propKey: $fc5e3658b603cf39$export$6a2a36740a146cb8,
    __setFunctionName: $fc5e3658b603cf39$export$d1a06452d3489bc7,
    __metadata: $fc5e3658b603cf39$export$f1db080c865becb9,
    __awaiter: $fc5e3658b603cf39$export$1050f835b63b671e,
    __generator: $fc5e3658b603cf39$export$67ebef60e6f28a6,
    __createBinding: $fc5e3658b603cf39$export$45d3717a4c69092e,
    __exportStar: $fc5e3658b603cf39$export$f33643c0debef087,
    __values: $fc5e3658b603cf39$export$19a8beecd37a4c45,
    __read: $fc5e3658b603cf39$export$8d051b38c9118094,
    __spread: $fc5e3658b603cf39$export$afc72e2116322959,
    __spreadArrays: $fc5e3658b603cf39$export$6388937ca91ccae8,
    __spreadArray: $fc5e3658b603cf39$export$1216008129fb82ed,
    __await: $fc5e3658b603cf39$export$10c90e4f7922046c,
    __asyncGenerator: $fc5e3658b603cf39$export$e427f37a30a4de9b,
    __asyncDelegator: $fc5e3658b603cf39$export$bbd80228419bb833,
    __asyncValues: $fc5e3658b603cf39$export$e3b29a3d6162315f,
    __makeTemplateObject: $fc5e3658b603cf39$export$4fb47efe1390b86f,
    __importStar: $fc5e3658b603cf39$export$c21735bcef00d192,
    __importDefault: $fc5e3658b603cf39$export$da59b14a69baef04,
    __classPrivateFieldGet: $fc5e3658b603cf39$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $fc5e3658b603cf39$export$d40a35129aaff81f,
    __classPrivateFieldIn: $fc5e3658b603cf39$export$81fdc39f203e4e04,
    __addDisposableResource: $fc5e3658b603cf39$export$88ac25d8e944e405,
    __disposeResources: $fc5e3658b603cf39$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $fc5e3658b603cf39$export$889dfb5d17574b0b
};


var $2bb54e1a7d9957b8$var$Q3 = Object.defineProperty, $2bb54e1a7d9957b8$var$e0 = Object.defineProperties;
var $2bb54e1a7d9957b8$var$t0 = Object.getOwnPropertyDescriptors;
var $2bb54e1a7d9957b8$var$D1 = Object.getOwnPropertySymbols;
var $2bb54e1a7d9957b8$var$Q2 = Object.prototype.hasOwnProperty, $2bb54e1a7d9957b8$var$e3 = Object.prototype.propertyIsEnumerable;
var $2bb54e1a7d9957b8$var$d2 = function(c, n, i) {
    return n in c ? $2bb54e1a7d9957b8$var$Q3(c, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: i
    }) : c[n] = i;
}, $2bb54e1a7d9957b8$var$x = function(c, n) {
    for(var i in n || (n = {}))$2bb54e1a7d9957b8$var$Q2.call(n, i) && $2bb54e1a7d9957b8$var$d2(c, i, n[i]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($2bb54e1a7d9957b8$var$D1) try {
        for(var _iterator = $2bb54e1a7d9957b8$var$D1(n)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var i = _step.value;
            $2bb54e1a7d9957b8$var$e3.call(n, i) && $2bb54e1a7d9957b8$var$d2(c, i, n[i]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return c;
}, $2bb54e1a7d9957b8$var$D = function(c, n) {
    return $2bb54e1a7d9957b8$var$e0(c, $2bb54e1a7d9957b8$var$t0(n));
};
var $2bb54e1a7d9957b8$var$k1 = function(c, n) {
    var i = {};
    for(var s in c)$2bb54e1a7d9957b8$var$Q2.call(c, s) && n.indexOf(s) < 0 && (i[s] = c[s]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (c != null && $2bb54e1a7d9957b8$var$D1) try {
        for(var _iterator = $2bb54e1a7d9957b8$var$D1(c)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            n.indexOf(s) < 0 && $2bb54e1a7d9957b8$var$e3.call(c, s) && (i[s] = c[s]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return i;
};
var $2bb54e1a7d9957b8$var$_ = function(c, n, i) {
    return $2bb54e1a7d9957b8$var$d2(c, (typeof n === "undefined" ? "undefined" : (0, $0b5c99e6a0876eaa$export$71511d61b312f219)(n)) != "symbol" ? n + "" : n, i);
};
var $2bb54e1a7d9957b8$var$g = function(c, n, i) {
    return new Promise(function(s, d) {
        var f = function(E) {
            try {
                M(i.next(E));
            } catch (A) {
                d(A);
            }
        }, b = function(E) {
            try {
                M(i.throw(E));
            } catch (A) {
                d(A);
            }
        }, M = function(E) {
            return E.done ? s(E.value) : Promise.resolve(E.value).then(f, b);
        };
        M((i = i.apply(c, n)).next());
    });
};
var $2bb54e1a7d9957b8$var$u2 = /*#__PURE__*/ function() {
    "use strict";
    function u2() {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, u2);
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(u2, [
        {
            key: "requestAnimationFrame",
            value: function requestAnimationFrame1(n) {
                return requestAnimationFrame(n);
            }
        },
        {
            key: "cancelAnimationFrame",
            value: function cancelAnimationFrame1(n) {
                cancelAnimationFrame(n);
            }
        }
    ]);
    return u2;
}(), $2bb54e1a7d9957b8$var$l2 = /*#__PURE__*/ function() {
    "use strict";
    function l2() {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, l2);
        $2bb54e1a7d9957b8$var$_(this, "_lastHandleId", 0);
        $2bb54e1a7d9957b8$var$_(this, "_lastImmediate", null);
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(l2, [
        {
            key: "requestAnimationFrame",
            value: function requestAnimationFrame1(n) {
                return this._lastHandleId >= Number.MAX_SAFE_INTEGER && (this._lastHandleId = 0), this._lastHandleId += 1, this._lastImmediate = setImmediate(function() {
                    n(Date.now());
                }), this._lastHandleId;
            }
        },
        {
            key: "cancelAnimationFrame",
            value: function cancelAnimationFrame1(n) {
                this._lastImmediate && clearImmediate(this._lastImmediate);
            }
        }
    ]);
    return l2;
}(), $2bb54e1a7d9957b8$var$O1 = /*#__PURE__*/ function() {
    "use strict";
    function O1() {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, O1);
        $2bb54e1a7d9957b8$var$_(this, "_strategy");
        this._strategy = typeof requestAnimationFrame == "function" ? new $2bb54e1a7d9957b8$var$u2 : new $2bb54e1a7d9957b8$var$l2;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(O1, [
        {
            key: "requestAnimationFrame",
            value: function requestAnimationFrame1(n) {
                return this._strategy.requestAnimationFrame(n);
            }
        },
        {
            key: "cancelAnimationFrame",
            value: function cancelAnimationFrame1(n) {
                this._strategy.cancelAnimationFrame(n);
            }
        }
    ]);
    return O1;
}();
var $2bb54e1a7d9957b8$var$F = typeof window != "undefined" && typeof window.document != "undefined";
var $2bb54e1a7d9957b8$var$z1 = new Uint8Array([
    80,
    75,
    3,
    4
]), $2bb54e1a7d9957b8$var$t3 = [
    "v",
    "ip",
    "op",
    "layers",
    "fr",
    "w",
    "h"
], $2bb54e1a7d9957b8$var$h2 = "0.40.1", $2bb54e1a7d9957b8$var$c2 = "@lottiefiles/dotlottie-web", $2bb54e1a7d9957b8$var$n3 = .75;
var $2bb54e1a7d9957b8$var$n0 = function() {
    var n;
    var c = typeof document != "undefined" ? (n = document.currentScript) == null ? void 0 : n.src : void 0;
    return function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var _this = this;
        var s, d = i, f, b, M = new Promise(function(e, t) {
            f = e, b = t;
        }), E = Object.assign({}, d), A = "./this.program", k = "", u1;
        typeof document != "undefined" && document.currentScript && (k = document.currentScript.src), c && (k = c), k.startsWith("blob:") ? k = "" : k = k.substr(0, k.replace(/[?#].*/, "").lastIndexOf("/") + 1), u1 = function(e) {
            return fetch(e, {
                credentials: "same-origin"
            }).then(function(t) {
                return t.ok ? t.arrayBuffer() : Promise.reject(Error(t.status + " : " + t.url));
            });
        };
        var Z = d.printErr || console.error.bind(console);
        Object.assign(d, E), E = null, d.thisProgram && (A = d.thisProgram);
        var e1 = d.wasmBinary, L1, C1 = !1, U1, a1, O, o1, l1, t1, P, w2, b2;
        function L2() {
            var e = L1.buffer;
            d.HEAP8 = a1 = new Int8Array(e), d.HEAP16 = o1 = new Int16Array(e), d.HEAPU8 = O = new Uint8Array(e), d.HEAPU16 = l1 = new Uint16Array(e), d.HEAP32 = t1 = new Int32Array(e), d.HEAPU32 = P = new Uint32Array(e), d.HEAPF32 = w2 = new Float32Array(e), d.HEAPF64 = b2 = new Float64Array(e);
        }
        var C2 = [], M2 = [], E2 = [];
        function h3() {
            var e = d.preRun.shift();
            C2.unshift(e);
        }
        var n1 = 0, h1 = null;
        function M1(e) {
            var t;
            throw (t = d.onAbort) == null || t.call(d, e), e = "Aborted(" + e + ")", Z(e), C1 = !0, e = new WebAssembly.RuntimeError(e + ". Build with -sASSERTIONS for more info."), b(e), e;
        }
        var P2 = function(e) {
            return e.startsWith("data:application/octet-stream;base64,");
        }, c1;
        function I2(e) {
            if (e == c1 && e1) return new Uint8Array(e1);
            throw "both async and sync fetching of the wasm failed";
        }
        function c3(e) {
            return e1 ? Promise.resolve().then(function() {
                return I2(e);
            }) : u1(e).then(function(t) {
                return new Uint8Array(t);
            }, function() {
                return I2(e);
            });
        }
        function S2(e, t, r) {
            return c3(e).then(function(a) {
                return WebAssembly.instantiate(a, t);
            }).then(r, function(a) {
                Z("failed to asynchronously prepare wasm: ".concat(a)), M1(a);
            });
        }
        function p3(e, t) {
            var r = c1;
            return e1 || typeof WebAssembly.instantiateStreaming != "function" || P2(r) || typeof fetch != "function" ? S2(r, e, t) : fetch(r, {
                credentials: "same-origin"
            }).then(function(a) {
                return WebAssembly.instantiateStreaming(a, e).then(t, function(o) {
                    return Z("wasm streaming compile failed: ".concat(o)), Z("falling back to ArrayBuffer instantiation"), S2(r, e, t);
                });
            });
        }
        var T2 = function T2(t) {
            "use strict";
            (0, $8713978b2328d32b$export$71511d61b312f219)(this, T2);
            $2bb54e1a7d9957b8$var$_(this, "name", "ExitStatus");
            this.message = "Program terminated with exit(".concat(t, ")"), this.status = t;
        };
        var j1 = function(e) {
            for(; 0 < e.length;)e.shift()(d);
        }, H1 = d.noExitRuntime || !0, x2 = typeof TextDecoder != "undefined" ? new TextDecoder : void 0, E1 = function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN;
            var r = O, a = e + t;
            for(t = e; r[t] && !(t >= a);)++t;
            if (16 < t - e && r.buffer && x2) return x2.decode(r.subarray(e, t));
            for(a = ""; e < t;){
                var o = r[e++];
                if (o & 128) {
                    var u = r[e++] & 63;
                    if ((o & 224) == 192) a += String.fromCharCode((o & 31) << 6 | u);
                    else {
                        var h = r[e++] & 63;
                        o = (o & 240) == 224 ? (o & 15) << 12 | u << 6 | h : (o & 7) << 18 | u << 12 | h << 6 | r[e++] & 63, 65536 > o ? a += String.fromCharCode(o) : (o -= 65536, a += String.fromCharCode(55296 | o >> 10, 56320 | o & 1023));
                    }
                } else a += String.fromCharCode(o);
            }
            return a;
        };
        var v3 = function v3(t) {
            "use strict";
            (0, $8713978b2328d32b$export$71511d61b312f219)(this, v3);
            this.va = t - 24;
        };
        var F2 = 0, p1 = function(e, t, r) {
            var a = O;
            if (0 < r) {
                r = t + r - 1;
                for(var o = 0; o < e.length; ++o){
                    var u = e.charCodeAt(o);
                    if (55296 <= u && 57343 >= u) {
                        var h = e.charCodeAt(++o);
                        u = 65536 + ((u & 1023) << 10) | h & 1023;
                    }
                    if (127 >= u) {
                        if (t >= r) break;
                        a[t++] = u;
                    } else {
                        if (2047 >= u) {
                            if (t + 1 >= r) break;
                            a[t++] = 192 | u >> 6;
                        } else {
                            if (65535 >= u) {
                                if (t + 2 >= r) break;
                                a[t++] = 224 | u >> 12;
                            } else {
                                if (t + 3 >= r) break;
                                a[t++] = 240 | u >> 18, a[t++] = 128 | u >> 12 & 63;
                            }
                            a[t++] = 128 | u >> 6 & 63;
                        }
                        a[t++] = 128 | u & 63;
                    }
                }
                a[t] = 0;
            }
        }, P1 = {}, N1 = function(e) {
            for(; e.length;){
                var t = e.pop();
                e.pop()(t);
            }
        };
        function v1(e) {
            return this.fromWireType(P[e >> 2]);
        }
        var s1 = {}, i1 = {}, I1 = {}, f1, Q = function(e, t, r) {
            var a = function a(l) {
                if (l = r(l), l.length !== e.length) throw new f1("Mismatched type converter count");
                for(var p = 0; p < e.length; ++p)H(e[p], l[p]);
            };
            e.forEach(function(l) {
                return I1[l] = t;
            });
            var o = Array(t.length), u = [], h = 0;
            t.forEach(function(l, p) {
                i1.hasOwnProperty(l) ? o[p] = i1[l] : (u.push(l), s1.hasOwnProperty(l) || (s1[l] = []), s1[l].push(function() {
                    o[p] = i1[l], ++h, h === u.length && a(o);
                }));
            }), u.length === 0 && a(o);
        }, A2, R = function(e) {
            for(var t = ""; O[e];)t += A2[O[e++]];
            return t;
        }, y;
        function m3(e, t) {
            var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            var a = t.name;
            if (!e) throw new y('type "'.concat(a, '" must have a positive integer typeid pointer'));
            if (i1.hasOwnProperty(e)) {
                if (r.$a) return;
                throw new y("Cannot register type '".concat(a, "' twice"));
            }
            i1[e] = t, delete I1[e], s1.hasOwnProperty(e) && (t = s1[e], delete s1[e], t.forEach(function(o) {
                return o();
            }));
        }
        function H(e, t) {
            var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return m3(e, t, r);
        }
        var V1 = function(e) {
            throw new y(e.ta.wa.ua.name + " instance already deleted");
        }, J1 = !1, R2 = function() {}, D2 = function(e, t, r) {
            return t === r ? e : r.za === void 0 ? null : (e = D2(e, t, r.za), e === null ? null : r.Ta(e));
        }, k2 = {}, _3 = {}, g3 = function(e, t) {
            if (t === void 0) throw new y("ptr should not be undefined");
            for(; e.za;)t = e.Ja(t), e = e.za;
            return _3[t];
        }, S1 = function(e, t) {
            if (!t.wa || !t.va) throw new f1("makeClassHandle requires ptr and ptrType");
            if (!!t.Aa != !!t.ya) throw new f1("Both smartPtrType and smartPtr must be specified");
            return t.count = {
                value: 1
            }, m1(Object.create(e, {
                ta: {
                    value: t,
                    writable: !0
                }
            }));
        }, m1 = function(e) {
            return typeof FinalizationRegistry == "undefined" ? (m1 = function(t) {
                return t;
            }, e) : (J1 = new FinalizationRegistry(function(t) {
                t = t.ta, --t.count.value, t.count.value === 0 && (t.ya ? t.Aa.Da(t.ya) : t.wa.ua.Da(t.va));
            }), m1 = function(t) {
                var r = t.ta;
                return r.ya && J1.register(t, {
                    ta: r
                }, t), t;
            }, R2 = function(t) {
                J1.unregister(t);
            }, m1(e));
        };
        function T1() {}
        var _1 = function(e, t) {
            return Object.defineProperty(t, "name", {
                value: e
            });
        }, O2 = function(e, t, r) {
            if (e[t].xa === void 0) {
                var a = e[t];
                e[t] = function O2() {
                    for(var _len = arguments.length, o = new Array(_len), _key = 0; _key < _len; _key++){
                        o[_key] = arguments[_key];
                    }
                    if (!e[t].xa.hasOwnProperty(o.length)) throw new y("Function '".concat(r, "' called with an invalid number of arguments (").concat(o.length, ") - expects one of (").concat(e[t].xa, ")!"));
                    return e[t].xa[o.length].apply(this, o);
                }, e[t].xa = [], e[t].xa[a.Ga] = a;
            }
        }, G1 = function(e, t, r) {
            if (d.hasOwnProperty(e)) {
                if (r === void 0 || d[e].xa !== void 0 && d[e].xa[r] !== void 0) throw new y("Cannot register public name '".concat(e, "' twice"));
                if (O2(d, e, e), d[e].xa.hasOwnProperty(r)) throw new y("Cannot register multiple overloads of a function with the same number of arguments (".concat(r, ")!"));
                d[e].xa[r] = t;
            } else d[e] = t, d[e].Ga = r;
        }, w3 = function(e) {
            e = e.replace(/[^a-zA-Z0-9_]/g, "$");
            var t = e.charCodeAt(0);
            return 48 <= t && 57 >= t ? "_".concat(e) : e;
        };
        function b3(e, t, r, a, o, u, h, l) {
            this.name = e, this.constructor = t, this.Fa = r, this.Da = a, this.za = o, this.Va = u, this.Ja = h, this.Ta = l, this.bb = [];
        }
        var q1 = function(e, t, r) {
            for(; t !== r;){
                if (!t.Ja) throw new y("Expected null or instance of ".concat(r.name, ", got an instance of ").concat(t.name));
                e = t.Ja(e), t = t.za;
            }
            return e;
        };
        function L3(e, t) {
            if (t === null) {
                if (this.Ma) throw new y("null is not a valid ".concat(this.name));
                return 0;
            }
            if (!t.ta) throw new y('Cannot pass "'.concat(t2(t), '" as a ').concat(this.name));
            if (!t.ta.va) throw new y("Cannot pass deleted object as a pointer of type ".concat(this.name));
            return q1(t.ta.va, t.ta.wa.ua, this.ua);
        }
        function C3(e, t) {
            if (t === null) {
                if (this.Ma) throw new y("null is not a valid ".concat(this.name));
                if (this.La) {
                    var r = this.Na();
                    return e !== null && e.push(this.Da, r), r;
                }
                return 0;
            }
            if (!t || !t.ta) throw new y('Cannot pass "'.concat(t2(t), '" as a ').concat(this.name));
            if (!t.ta.va) throw new y("Cannot pass deleted object as a pointer of type ".concat(this.name));
            if (!this.Ka && t.ta.wa.Ka) throw new y("Cannot convert argument of type ".concat(t.ta.Aa ? t.ta.Aa.name : t.ta.wa.name, " to parameter type ").concat(this.name));
            if (r = q1(t.ta.va, t.ta.wa.ua, this.ua), this.La) {
                if (t.ta.ya === void 0) throw new y("Passing raw pointer to smart pointer is illegal");
                switch(this.hb){
                    case 0:
                        if (t.ta.Aa === this) r = t.ta.ya;
                        else throw new y("Cannot convert argument of type ".concat(t.ta.Aa ? t.ta.Aa.name : t.ta.wa.name, " to parameter type ").concat(this.name));
                        break;
                    case 1:
                        r = t.ta.ya;
                        break;
                    case 2:
                        if (t.ta.Aa === this) r = t.ta.ya;
                        else {
                            var a = t.clone();
                            r = this.cb(r, F1(function() {
                                return a.delete();
                            })), e !== null && e.push(this.Da, r);
                        }
                        break;
                    default:
                        throw new y("Unsupporting sharing policy");
                }
            }
            return r;
        }
        function M3(e, t) {
            if (t === null) {
                if (this.Ma) throw new y("null is not a valid ".concat(this.name));
                return 0;
            }
            if (!t.ta) throw new y('Cannot pass "'.concat(t2(t), '" as a ').concat(this.name));
            if (!t.ta.va) throw new y("Cannot pass deleted object as a pointer of type ".concat(this.name));
            if (t.ta.wa.Ka) throw new y("Cannot convert argument of type ".concat(t.ta.wa.name, " to parameter type ").concat(this.name));
            return q1(t.ta.va, t.ta.wa.ua, this.ua);
        }
        function g1(e, t, r, a, o, u, h, l, p, v, m) {
            this.name = e, this.ua = t, this.Ma = r, this.Ka = a, this.La = o, this.ab = u, this.hb = h, this.Ra = l, this.Na = p, this.cb = v, this.Da = m, o || t.za !== void 0 ? this.toWireType = C3 : (this.toWireType = a ? L3 : M3, this.Ca = null);
        }
        var z2 = function(e, t, r) {
            if (!d.hasOwnProperty(e)) throw new f1("Replacing nonexistent public symbol");
            d[e].xa !== void 0 && r !== void 0 ? d[e].xa[r] = t : (d[e] = t, d[e].Ga = r);
        }, j, E3 = function(e, t) {
            var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
            return e.includes("j") ? (e = e.replace(/p/g, "i"), t = (0, d["dynCall_" + e]).apply(_this, [
                t
            ].concat((0, $227c6742e0ff6f82$export$71511d61b312f219)(r)))) : t = j.get(t).apply(_this, (0, $227c6742e0ff6f82$export$71511d61b312f219)(r)), t;
        }, P3 = function(e, t) {
            return function() {
                for(var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++){
                    r[_key] = arguments[_key];
                }
                return E3(e, t, r);
            };
        }, z = function(e, t) {
            e = R(e);
            var r = e.includes("j") ? P3(e, t) : j.get(t);
            if (typeof r != "function") throw new y("unknown function pointer with signature ".concat(e, ": ").concat(t));
            return r;
        }, W2, $2 = function(e) {
            e = q2(e);
            var t = R(e);
            return Y(e), t;
        }, x1 = function(e, t) {
            function r(u) {
                o[u] || i1[u] || (I1[u] ? I1[u].forEach(r) : (a.push(u), o[u] = !0));
            }
            var a = [], o = {};
            throw t.forEach(r), new W2("".concat(e, ": ") + a.map($2).join([
                ", "
            ]));
        }, K1 = function(e, t) {
            for(var r = [], a = 0; a < e; a++)r.push(P[t + 4 * a >> 2]);
            return r;
        };
        function I3(e) {
            for(var t = 1; t < e.length; ++t)if (e[t] !== null && e[t].Ca === void 0) return !0;
            return !1;
        }
        function Y1(e, t, r, a, o) {
            var u = t.length;
            if (2 > u) throw new y("argTypes array size mismatch! Must at least get return value and 'this' types!");
            var h = t[1] !== null && r !== null, l = I3(t), p = t[0].name !== "void", v = u - 2, m = Array(v), w = [], L = [];
            return _1(e, function() {
                for(var _len = arguments.length, U = new Array(_len), _key = 0; _key < _len; _key++){
                    U[_key] = arguments[_key];
                }
                if (L.length = 0, w.length = h ? 2 : 1, w[0] = o, h) {
                    var I = t[1].toWireType(L, this);
                    w[1] = I;
                }
                for(var T = 0; T < v; ++T)m[T] = t[T + 2].toWireType(L, U[T]), w.push(m[T]);
                if (U = a.apply(void 0, (0, $227c6742e0ff6f82$export$71511d61b312f219)(w)), l) N1(L);
                else for(T = h ? 1 : 2; T < t.length; T++){
                    var N = T === 1 ? I : m[T - 2];
                    t[T].Ca !== null && t[T].Ca(N);
                }
                return I = p ? t[0].fromWireType(U) : void 0, I;
            });
        }
        var U2 = function(e) {
            e = e.trim();
            var t = e.indexOf("(");
            return t !== -1 ? e.substr(0, t) : e;
        }, X1 = [], K = [], Z1 = function(e) {
            9 < e && --K[e + 1] === 0 && (K[e] = void 0, X1.push(e));
        }, Q1 = function(e) {
            if (!e) throw new y("Cannot use deleted val. handle = " + e);
            return K[e];
        }, F1 = function(e) {
            switch(e){
                case void 0:
                    return 2;
                case null:
                    return 4;
                case !0:
                    return 6;
                case !1:
                    return 8;
                default:
                    var t = X1.pop() || K.length;
                    return K[t] = e, K[t + 1] = 1, t;
            }
        }, B2 = {
            name: "emscripten::val",
            fromWireType: function(e) {
                var t = Q1(e);
                return Z1(e), t;
            },
            toWireType: function(e, t) {
                return F1(t);
            },
            Ba: 8,
            readValueFromPointer: v1,
            Ca: null
        }, S3 = function(e, t, r) {
            switch(t){
                case 1:
                    return r ? function S3(a) {
                        return this.fromWireType(a1[a]);
                    } : function(a) {
                        return this.fromWireType(O[a]);
                    };
                case 2:
                    return r ? function(a) {
                        return this.fromWireType(o1[a >> 1]);
                    } : function(a) {
                        return this.fromWireType(l1[a >> 1]);
                    };
                case 4:
                    return r ? function(a) {
                        return this.fromWireType(t1[a >> 2]);
                    } : function(a) {
                        return this.fromWireType(P[a >> 2]);
                    };
                default:
                    throw new TypeError("invalid integer width (".concat(t, "): ").concat(e));
            }
        }, e2 = function(e, t) {
            var r = i1[e];
            if (r === void 0) throw e = "".concat(t, " has unknown type ").concat($2(e)), new y(e);
            return r;
        }, t2 = function(e) {
            if (e === null) return "null";
            var t = typeof e === "undefined" ? "undefined" : (0, $0b5c99e6a0876eaa$export$71511d61b312f219)(e);
            return t === "object" || t === "array" || t === "function" ? e.toString() : "" + e;
        }, T3 = function(e, t) {
            switch(t){
                case 4:
                    return function T3(r) {
                        return this.fromWireType(w2[r >> 2]);
                    };
                case 8:
                    return function(r) {
                        return this.fromWireType(b2[r >> 3]);
                    };
                default:
                    throw new TypeError("invalid float width (".concat(t, "): ").concat(e));
            }
        }, x3 = function(e, t, r) {
            switch(t){
                case 1:
                    return r ? function(a) {
                        return a1[a];
                    } : function(a) {
                        return O[a];
                    };
                case 2:
                    return r ? function(a) {
                        return o1[a >> 1];
                    } : function(a) {
                        return l1[a >> 1];
                    };
                case 4:
                    return r ? function(a) {
                        return t1[a >> 2];
                    } : function(a) {
                        return P[a >> 2];
                    };
                default:
                    throw new TypeError("invalid integer width (".concat(t, "): ").concat(e));
            }
        }, F3 = Object.assign({
            optional: !0
        }, B2), j2 = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : void 0, A3 = function(e, t) {
            for(var r = e >> 1, a = r + t / 2; !(r >= a) && l1[r];)++r;
            if (r <<= 1, 32 < r - e && j2) return j2.decode(O.subarray(e, r));
            for(r = "", a = 0; !(a >= t / 2); ++a){
                var o = o1[e + 2 * a >> 1];
                if (o == 0) break;
                r += String.fromCharCode(o);
            }
            return r;
        }, R3 = function(e, t, r) {
            if (r != null || (r = 2147483647), 2 > r) return 0;
            r -= 2;
            var a = t;
            r = r < 2 * e.length ? r / 2 : e.length;
            for(var o = 0; o < r; ++o)o1[t >> 1] = e.charCodeAt(o), t += 2;
            return o1[t >> 1] = 0, t - a;
        }, D3 = function(e) {
            return 2 * e.length;
        }, k3 = function(e, t) {
            for(var r = 0, a = ""; !(r >= t / 4);){
                var o = t1[e + 4 * r >> 2];
                if (o == 0) break;
                ++r, 65536 <= o ? (o -= 65536, a += String.fromCharCode(55296 | o >> 10, 56320 | o & 1023)) : a += String.fromCharCode(o);
            }
            return a;
        }, O3 = function(e, t, r) {
            if (r != null || (r = 2147483647), 4 > r) return 0;
            var a = t;
            r = a + r - 4;
            for(var o = 0; o < e.length; ++o){
                var u = e.charCodeAt(o);
                if (55296 <= u && 57343 >= u) {
                    var h = e.charCodeAt(++o);
                    u = 65536 + ((u & 1023) << 10) | h & 1023;
                }
                if (t1[t >> 2] = u, t += 4, t + 4 > r) break;
            }
            return t1[t >> 2] = 0, t - a;
        }, z3 = function(e) {
            for(var t = 0, r = 0; r < e.length; ++r){
                var a = e.charCodeAt(r);
                55296 <= a && 57343 >= a && ++r, t += 4;
            }
            return t;
        }, n2 = 0, i2 = [], W3 = function(e) {
            var t = i2.length;
            return i2.push(e), t;
        }, $3 = function(e, t) {
            for(var r = Array(e), a = 0; a < e; ++a)r[a] = e2(P[t + 4 * a >> 2], "parameter " + a);
            return r;
        }, U3 = Reflect.construct, y1 = {}, H2 = function(e) {
            if (!(e instanceof T2 || e == "unwind")) throw e;
        }, N2 = function(e) {
            var t;
            throw U1 = e, H1 || 0 < n2 || ((t = d.onExit) == null || t.call(d, e), C1 = !0), new T2(e);
        }, B3 = function(e) {
            if (!C1) try {
                if (e(), !(H1 || 0 < n2)) try {
                    U1 = e = U1, N2(e);
                } catch (t) {
                    H2(t);
                }
            } catch (t) {
                H2(t);
            }
        }, r2 = {}, V2 = function() {
            if (!a2) {
                var e = {
                    USER: "web_user",
                    LOGNAME: "web_user",
                    PATH: "/",
                    PWD: "/",
                    HOME: "/home/web_user",
                    LANG: (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8",
                    _: A || "./this.program"
                }, t;
                for(t in r2)r2[t] === void 0 ? delete e[t] : e[t] = r2[t];
                var r = [];
                for(t in e)r.push("".concat(t, "=").concat(e[t]));
                a2 = r;
            }
            return a2;
        }, a2, j3 = function() {
            if (typeof crypto == "object" && typeof crypto.getRandomValues == "function") return function(e) {
                return crypto.getRandomValues(e);
            };
            M1("initRandomDevice");
        }, J2 = function(e) {
            return (J2 = j3())(e);
        };
        f1 = d.InternalError = /*#__PURE__*/ function(Error1) {
            "use strict";
            (0, $3cd308d6b98edc5a$export$71511d61b312f219)(_class, Error1);
            var _super = (0, $fdc48b7b7f0be826$export$71511d61b312f219)(_class);
            function _class(e) {
                (0, $8713978b2328d32b$export$71511d61b312f219)(this, _class);
                var _this;
                _this = _super.call(this, e), _this.name = "InternalError";
                return (0, $04a501f287790d91$export$71511d61b312f219)(_this);
            }
            return _class;
        }((0, $b853fd5b3c362aee$export$71511d61b312f219)(Error));
        for(var G2 = Array(256), A1 = 0; 256 > A1; ++A1)G2[A1] = String.fromCharCode(A1);
        A2 = G2, y = d.BindingError = /*#__PURE__*/ function(Error1) {
            "use strict";
            (0, $3cd308d6b98edc5a$export$71511d61b312f219)(_class, Error1);
            var _super = (0, $fdc48b7b7f0be826$export$71511d61b312f219)(_class);
            function _class(e) {
                (0, $8713978b2328d32b$export$71511d61b312f219)(this, _class);
                var _this;
                _this = _super.call(this, e), _this.name = "BindingError";
                return (0, $04a501f287790d91$export$71511d61b312f219)(_this);
            }
            return _class;
        }((0, $b853fd5b3c362aee$export$71511d61b312f219)(Error)), Object.assign(T1.prototype, {
            isAliasOf: function isAliasOf(e) {
                if (!(this instanceof T1 && e instanceof T1)) return !1;
                var t = this.ta.wa.ua, r = this.ta.va;
                e.ta = e.ta;
                var a = e.ta.wa.ua;
                for(e = e.ta.va; t.za;)r = t.Ja(r), t = t.za;
                for(; a.za;)e = a.Ja(e), a = a.za;
                return t === a && r === e;
            },
            clone: function clone() {
                if (this.ta.va || V1(this), this.ta.Ia) return this.ta.count.value += 1, this;
                var e = m1, t = Object, r = t.create, a = Object.getPrototypeOf(this), o = this.ta;
                return e = e(r.call(t, a, {
                    ta: {
                        value: {
                            count: o.count,
                            Ha: o.Ha,
                            Ia: o.Ia,
                            va: o.va,
                            wa: o.wa,
                            ya: o.ya,
                            Aa: o.Aa
                        }
                    }
                })), e.ta.count.value += 1, e.ta.Ha = !1, e;
            },
            delete: function() {
                if (this.ta.va || V1(this), this.ta.Ha && !this.ta.Ia) throw new y("Object already scheduled for deletion");
                R2(this);
                var e = this.ta;
                --e.count.value, e.count.value === 0 && (e.ya ? e.Aa.Da(e.ya) : e.wa.ua.Da(e.va)), this.ta.Ia || (this.ta.ya = void 0, this.ta.va = void 0);
            },
            isDeleted: function isDeleted() {
                return !this.ta.va;
            },
            deleteLater: function deleteLater() {
                if (this.ta.va || V1(this), this.ta.Ha && !this.ta.Ia) throw new y("Object already scheduled for deletion");
                return this.ta.Ha = !0, this;
            }
        }), Object.assign(g1.prototype, {
            Wa: function(e) {
                return this.Ra && (e = this.Ra(e)), e;
            },
            Pa: function(e) {
                var t;
                (t = this.Da) == null || t.call(this, e);
            },
            Ba: 8,
            readValueFromPointer: v1,
            fromWireType: function fromWireType(e) {
                function t() {
                    return this.La ? S1(this.ua.Fa, {
                        wa: this.ab,
                        va: r,
                        Aa: this,
                        ya: e
                    }) : S1(this.ua.Fa, {
                        wa: this,
                        va: e
                    });
                }
                var r = this.Wa(e);
                if (!r) return this.Pa(e), null;
                var a = g3(this.ua, r);
                if (a !== void 0) return a.ta.count.value === 0 ? (a.ta.va = r, a.ta.ya = e, a.clone()) : (a = a.clone(), this.Pa(e), a);
                if (a = this.ua.Va(r), a = k2[a], !a) return t.call(this);
                a = this.Ka ? a.Sa : a.pointerType;
                var o = D2(r, this.ua, a.ua);
                return o === null ? t.call(this) : this.La ? S1(a.ua.Fa, {
                    wa: a,
                    va: o,
                    Aa: this,
                    ya: e
                }) : S1(a.ua.Fa, {
                    wa: a,
                    va: o
                });
            }
        }), W2 = d.UnboundTypeError = function(e, t) {
            var r = _1(t, function(a) {
                this.name = t, this.message = a, a = Error(a).stack, a !== void 0 && (this.stack = this.toString() + "\n" + a.replace(/^Error(:[^\n]*)?\n/, ""));
            });
            return r.prototype = Object.create(e.prototype), r.prototype.constructor = r, r.prototype.toString = function() {
                return this.message === void 0 ? this.name : "".concat(this.name, ": ").concat(this.message);
            }, r;
        }(Error, "UnboundTypeError"), K.push(0, 1, void 0, 1, null, 1, !0, 1, !1, 1), d.count_emval_handles = function() {
            return K.length / 2 - 5 - X1.length;
        };
        var H3 = {
            c: function(e, t, r, a) {
                return M1("Assertion failed: ".concat(e ? E1(e) : "", ", at: ") + [
                    t ? t ? E1(t) : "" : "unknown filename",
                    r,
                    a ? a ? E1(a) : "" : "unknown function"
                ]);
            },
            m: function(e, t, r) {
                var a = new v3(e);
                throw P[a.va + 16 >> 2] = 0, P[a.va + 4 >> 2] = t, P[a.va + 8 >> 2] = r, F2 = e, F2;
            },
            M: function() {},
            J: function() {},
            K: function() {},
            O: function O() {},
            L: function() {},
            Q: function() {
                return M1("");
            },
            v: function(e) {
                var t = P1[e];
                delete P1[e];
                var r = t.Na, a = t.Da, o = t.Qa, u = o.map(function(h) {
                    return h.Za;
                }).concat(o.map(function(h) {
                    return h.fb;
                }));
                Q([
                    e
                ], u, function(h) {
                    var l = {};
                    return o.forEach(function(p, v) {
                        var m = h[v], w = p.Xa, L = p.Ya, U = h[v + o.length], I = p.eb, T = p.gb;
                        l[p.Ua] = {
                            read: function(N) {
                                return m.fromWireType(w(L, N));
                            },
                            write: function(N, w1) {
                                var B = [];
                                I(T, N, U.toWireType(B, w1)), N1(B);
                            }
                        };
                    }), [
                        {
                            name: t.name,
                            fromWireType: function(p) {
                                var v = {}, m;
                                for(m in l)v[m] = l[m].read(p);
                                return a(p), v;
                            },
                            toWireType: function(p, v) {
                                for(var m in l)if (!(m in v)) throw new TypeError('Missing field: "'.concat(m, '"'));
                                var w = r();
                                for(m in l)l[m].write(w, v[m]);
                                return p !== null && p.push(a, w), w;
                            },
                            Ba: 8,
                            readValueFromPointer: v1,
                            Ca: a
                        }
                    ];
                });
            },
            C: function() {},
            V: function(e, t, r, a) {
                t = R(t), H(e, {
                    name: t,
                    fromWireType: function fromWireType(o) {
                        return !!o;
                    },
                    toWireType: function toWireType(o, u) {
                        return u ? r : a;
                    },
                    Ba: 8,
                    readValueFromPointer: function readValueFromPointer(o) {
                        return this.fromWireType(O[o]);
                    },
                    Ca: null
                });
            },
            r: function(e, t, r, a, o, u, h, l, p, v, m, w, L) {
                m = R(m), u = z(o, u), l && (l = z(h, l)), v && (v = z(p, v)), L = z(w, L);
                var U = w3(m);
                G1(U, function() {
                    x1("Cannot construct ".concat(m, " due to unbound types"), [
                        a
                    ]);
                }), Q([
                    e,
                    t,
                    r
                ], a ? [
                    a
                ] : [], function(I) {
                    if (I = I[0], a) var T = I.ua, N = T.Fa;
                    else N = T1.prototype;
                    I = _1(m, function() {
                        for(var _len = arguments.length, s2 = new Array(_len), _key = 0; _key < _len; _key++){
                            s2[_key] = arguments[_key];
                        }
                        if (Object.getPrototypeOf(this) !== w1) throw new y("Use 'new' to construct " + m);
                        if (B.Ea === void 0) throw new y(m + " has no accessible constructor");
                        var Z2 = B.Ea[s2.length];
                        if (Z2 === void 0) throw new y("Tried to invoke ctor of ".concat(m, " with invalid number of parameters (").concat(s2.length, ") - expected (").concat(Object.keys(B.Ea).toString(), ") parameters instead!"));
                        return Z2.apply(this, s2);
                    });
                    var w1 = Object.create(N, {
                        constructor: {
                            value: I
                        }
                    });
                    I.prototype = w1;
                    var B = new b3(m, I, w1, L, T, u, l, v);
                    if (B.za) {
                        var b1;
                        (b1 = B.za).Oa != null || (b1.Oa = []), B.za.Oa.push(B);
                    }
                    return T = new g1(m, B, !0, !1, !1), b1 = new g1(m + "*", B, !1, !1, !1), N = new g1(m + " const*", B, !1, !0, !1), k2[e] = {
                        pointerType: b1,
                        Sa: N
                    }, z2(U, I), [
                        T,
                        b1,
                        N
                    ];
                });
            },
            q: function(e, t, r, a, o, u) {
                var h = K1(t, r);
                o = z(a, o), Q([], [
                    e
                ], function(l) {
                    l = l[0];
                    var p = "constructor ".concat(l.name);
                    if (l.ua.Ea === void 0 && (l.ua.Ea = []), l.ua.Ea[t - 1] !== void 0) throw new y("Cannot register multiple constructors with identical number of parameters (".concat(t - 1, ") for class '").concat(l.name, "'! Overload resolution is currently only performed using the parameter count, not actual type info!"));
                    return l.ua.Ea[t - 1] = function() {
                        x1("Cannot construct ".concat(l.name, " due to unbound types"), h);
                    }, Q([], h, function(v) {
                        return v.splice(1, 0, null), l.ua.Ea[t - 1] = Y1(p, v, null, o, u), [];
                    }), [];
                });
            },
            f: function(e, t, r, a, o, u, h, l) {
                var p = K1(r, a);
                t = R(t), t = U2(t), u = z(o, u), Q([], [
                    e
                ], function(v) {
                    var m = function m() {
                        x1("Cannot call ".concat(w, " due to unbound types"), p);
                    };
                    v = v[0];
                    var w = "".concat(v.name, ".").concat(t);
                    t.startsWith("@@") && (t = Symbol[t.substring(2)]), l && v.ua.bb.push(t);
                    var L = v.ua.Fa, U = L[t];
                    return U === void 0 || U.xa === void 0 && U.className !== v.name && U.Ga === r - 2 ? (m.Ga = r - 2, m.className = v.name, L[t] = m) : (O2(L, t, w), L[t].xa[r - 2] = m), Q([], p, function(I) {
                        return I = Y1(w, I, v, u, h), L[t].xa === void 0 ? (I.Ga = r - 2, L[t] = I) : L[t].xa[r - 2] = I, [];
                    }), [];
                });
            },
            U: function(e) {
                return H(e, B2);
            },
            x: function(e, t, r, a) {
                var o = function o() {};
                t = R(t), o.values = {}, H(e, {
                    name: t,
                    constructor: o,
                    fromWireType: function fromWireType(u) {
                        return this.constructor.values[u];
                    },
                    toWireType: function(u, h) {
                        return h.value;
                    },
                    Ba: 8,
                    readValueFromPointer: S3(t, r, a),
                    Ca: null
                }), G1(t, o);
            },
            k: function(e, t, r) {
                var a = e2(e, "enum");
                t = R(t), e = a.constructor, a = Object.create(a.constructor.prototype, {
                    value: {
                        value: r
                    },
                    constructor: {
                        value: _1("".concat(a.name, "_").concat(t), function() {})
                    }
                }), e.values[r] = a, e[t] = a;
            },
            z: function(e, t, r) {
                t = R(t), H(e, {
                    name: t,
                    fromWireType: function(a) {
                        return a;
                    },
                    toWireType: function(a, o) {
                        return o;
                    },
                    Ba: 8,
                    readValueFromPointer: T3(t, r),
                    Ca: null
                });
            },
            u: function(e, t, r, a, o, u) {
                var h = K1(t, r);
                e = R(e), e = U2(e), o = z(a, o), G1(e, function() {
                    x1("Cannot call ".concat(e, " due to unbound types"), h);
                }, t - 1), Q([], h, function(l) {
                    return z2(e, Y1(e, [
                        l[0],
                        null
                    ].concat(l.slice(1)), null, o, u), t - 1), [];
                });
            },
            l: function(e, t, r, a, o) {
                if (t = R(t), o === -1 && (o = 4294967295), o = function(l) {
                    return l;
                }, a === 0) {
                    var u = 32 - 8 * r;
                    o = function(l) {
                        return l << u >>> u;
                    };
                }
                var h = t.includes("unsigned") ? function h(l, p) {
                    return p >>> 0;
                } : function(l, p) {
                    return p;
                };
                H(e, {
                    name: t,
                    fromWireType: o,
                    toWireType: h,
                    Ba: 8,
                    readValueFromPointer: x3(t, r, a !== 0),
                    Ca: null
                });
            },
            h: function(e, t, r) {
                var a = function a(u) {
                    return new o(a1.buffer, P[u + 4 >> 2], P[u >> 2]);
                };
                var o = [
                    Int8Array,
                    Uint8Array,
                    Int16Array,
                    Uint16Array,
                    Int32Array,
                    Uint32Array,
                    Float32Array,
                    Float64Array
                ][t];
                r = R(r), H(e, {
                    name: r,
                    fromWireType: a,
                    Ba: 8,
                    readValueFromPointer: a
                }, {
                    $a: !0
                });
            },
            t: function(e) {
                H(e, F3);
            },
            $: function(e, t, r, a, o, u, h, l, p, v, m, w) {
                r = R(r), u = z(o, u), l = z(h, l), v = z(p, v), w = z(m, w), Q([
                    e
                ], [
                    t
                ], function(L) {
                    return L = L[0], [
                        new g1(r, L.ua, !1, !1, !0, L, a, u, l, v, w)
                    ];
                });
            },
            A: function(e, t) {
                t = R(t);
                var r = t === "std::string";
                H(e, {
                    name: t,
                    fromWireType: function fromWireType(a) {
                        var o = P[a >> 2], u = a + 4;
                        if (r) for(var h = u, l = 0; l <= o; ++l){
                            var p = u + l;
                            if (l == o || O[p] == 0) {
                                if (h = h ? E1(h, p - h) : "", v === void 0) var v = h;
                                else v += "\x00", v += h;
                                h = p + 1;
                            }
                        }
                        else {
                            for(v = Array(o), l = 0; l < o; ++l)v[l] = String.fromCharCode(O[u + l]);
                            v = v.join("");
                        }
                        return Y(a), v;
                    },
                    toWireType: function toWireType(a, o) {
                        o instanceof ArrayBuffer && (o = new Uint8Array(o));
                        var u, h = typeof o == "string";
                        if (!(h || o instanceof Uint8Array || o instanceof Uint8ClampedArray || o instanceof Int8Array)) throw new y("Cannot pass non-string to std::string");
                        if (r && h) for(var l = u = 0; l < o.length; ++l){
                            var p = o.charCodeAt(l);
                            127 >= p ? u++ : 2047 >= p ? u += 2 : 55296 <= p && 57343 >= p ? (u += 4, ++l) : u += 3;
                        }
                        else u = o.length;
                        if (l = o2(4 + u + 1), p = l + 4, P[l >> 2] = u, r && h) p1(o, p, u + 1);
                        else if (h) for(h = 0; h < u; ++h){
                            var v = o.charCodeAt(h);
                            if (255 < v) throw Y(p), new y("String has UTF-16 code units that do not fit in 8 bits");
                            O[p + h] = v;
                        }
                        else for(h = 0; h < u; ++h)O[p + h] = o[h];
                        return a !== null && a.push(Y, l), l;
                    },
                    Ba: 8,
                    readValueFromPointer: v1,
                    Ca: function(a) {
                        Y(a);
                    }
                });
            },
            s: function(e, t, r) {
                if (r = R(r), t === 2) var a = A3, o = R3, u = D3, h = function(l) {
                    return l1[l >> 1];
                };
                else t === 4 && (a = k3, o = O3, u = z3, h = function(l) {
                    return P[l >> 2];
                });
                H(e, {
                    name: r,
                    fromWireType: function(l) {
                        for(var p = P[l >> 2], v, m = l + 4, w = 0; w <= p; ++w){
                            var L = l + 4 + w * t;
                            (w == p || h(L) == 0) && (m = a(m, L - m), v === void 0 ? v = m : (v += "\x00", v += m), m = L + t);
                        }
                        return Y(l), v;
                    },
                    toWireType: function(l, p) {
                        if (typeof p != "string") throw new y("Cannot pass non-string to C++ string type ".concat(r));
                        var v = u(p), m = o2(4 + v + t);
                        return P[m >> 2] = v / t, o(p, m + 4, v + t), l !== null && l.push(Y, m), m;
                    },
                    Ba: 8,
                    readValueFromPointer: v1,
                    Ca: function(l) {
                        Y(l);
                    }
                });
            },
            w: function(e, t, r, a, o, u) {
                P1[e] = {
                    name: R(t),
                    Na: z(r, a),
                    Da: z(o, u),
                    Qa: []
                };
            },
            j: function(e, t, r, a, o, u, h, l, p, v) {
                P1[e].Qa.push({
                    Ua: R(t),
                    Za: r,
                    Xa: z(a, o),
                    Ya: u,
                    fb: h,
                    eb: z(l, p),
                    gb: v
                });
            },
            W: function(e, t) {
                t = R(t), H(e, {
                    ib: !0,
                    name: t,
                    Ba: 0,
                    fromWireType: function() {},
                    toWireType: function() {}
                });
            },
            H: function() {
                H1 = !1, n2 = 0;
            },
            D: function() {
                throw 1 / 0;
            },
            Z: function(e, t, r, a) {
                return e = i2[e], t = Q1(t), e(null, t, r, a);
            },
            B: Z1,
            Y: function(e, t, r) {
                var a = $3(e, t), o = a.shift();
                e--;
                var u = Array(e);
                return t = "methodCaller<(".concat(a.map(function(h) {
                    return h.name;
                }).join(", "), ") => ").concat(o.name, ">"), W3(_1(t, function(h, l, p, v) {
                    for(var m = 0, w = 0; w < e; ++w)u[w] = a[w].readValueFromPointer(v + m), m += a[w].Ba;
                    return l = r === 1 ? U3(l, u) : l.apply(h, u), h = [], l = o.toWireType(h, l), h.length && (P[p >> 2] = F1(h)), l;
                }));
            },
            _: function(e) {
                9 < e && (K[e + 1] += 1);
            },
            X: function(e) {
                var t = Q1(e);
                N1(t), Z1(e);
            },
            o: function(e, t) {
                return e = e2(e, "_emval_take_value"), e = e.readValueFromPointer(t), F1(e);
            },
            E: function(e, t) {
                if (y1[e] && (clearTimeout(y1[e].id), delete y1[e]), !t) return 0;
                var r = setTimeout(function() {
                    delete y1[e], B3(function() {
                        return K2(e, performance.now());
                    });
                }, t);
                return y1[e] = {
                    id: r,
                    jb: t
                }, 0;
            },
            F: function(e, t, r, a) {
                var o = new Date().getFullYear(), u = new Date(o, 0, 1).getTimezoneOffset();
                o = new Date(o, 6, 1).getTimezoneOffset(), P[e >> 2] = 60 * Math.max(u, o), t1[t >> 2] = +(u != o), t = function(h) {
                    var l = Math.abs(h);
                    return "UTC".concat(0 <= h ? "-" : "+").concat(String(Math.floor(l / 60)).padStart(2, "0")).concat(String(l % 60).padStart(2, "0"));
                }, e = t(u), t = t(o), o < u ? (p1(e, r, 17), p1(t, a, 17)) : (p1(e, a, 17), p1(t, r, 17));
            },
            aa: function() {
                return performance.now();
            },
            G: function(e) {
                var t = O.length;
                if (e >>>= 0, 2147483648 < e) return !1;
                for(var r = 1; 4 >= r; r *= 2){
                    var a = t * (1 + .2 / r);
                    a = Math.min(a, e + 100663296);
                    e: {
                        a = (Math.min(2147483648, 65536 * Math.ceil(Math.max(e, a) / 65536)) - L1.buffer.byteLength + 65535) / 65536 | 0;
                        try {
                            L1.grow(a), L2();
                            var o = 1;
                            break e;
                        } catch (u) {}
                        o = void 0;
                    }
                    if (o) return !0;
                }
                return !1;
            },
            S: function(e, t) {
                var r = 0;
                return V2().forEach(function(a, o) {
                    var u = t + r;
                    for(o = P[e + 4 * o >> 2] = u, u = 0; u < a.length; ++u)a1[o++] = a.charCodeAt(u);
                    a1[o] = 0, r += a.length + 1;
                }), 0;
            },
            T: function(e, t) {
                var r = V2();
                P[e >> 2] = r.length;
                var a = 0;
                return r.forEach(function(o) {
                    return a += o.length + 1;
                }), P[t >> 2] = a, 0;
            },
            P: function() {
                return 52;
            },
            N: function() {
                return 52;
            },
            i: q3,
            d: G3,
            e: J3,
            p: K3,
            y: Z3,
            b: V3,
            a: N3,
            g: X3,
            n: Y3,
            R: N2,
            I: function(e, t) {
                return J2(O.subarray(e, e + t)), 0;
            }
        }, S = function() {
            var r;
            function e(a) {
                var o;
                return S = a.exports, L1 = S.ba, L2(), j = S.fa, M2.unshift(S.ca), n1--, (o = d.monitorRunDependencies) == null || o.call(d, n1), n1 == 0 && h1 && (a = h1, h1 = null, a()), S;
            }
            n1++, (r = d.monitorRunDependencies) == null || r.call(d, n1);
            var t = {
                a: H3
            };
            if (d.instantiateWasm) try {
                return d.instantiateWasm(t, e);
            } catch (a) {
                Z("Module.instantiateWasm callback failed with error: ".concat(a)), b(a);
            }
            return c1 != null || (c1 = P2("DotLottiePlayer.wasm") ? "DotLottiePlayer.wasm" : d.locateFile ? d.locateFile("DotLottiePlayer.wasm", k) : k + "DotLottiePlayer.wasm"), p3(t, function(a) {
                e(a.instance);
            }).catch(b), {};
        }(), o2 = function(e) {
            return (o2 = S.da)(e);
        }, q2 = function(e) {
            return (q2 = S.ea)(e);
        }, Y = function(e) {
            return (Y = S.ga)(e);
        }, K2 = function(e, t) {
            return (K2 = S.ha)(e, t);
        }, V = function(e, t) {
            return (V = S.ia)(e, t);
        }, J = function(e) {
            return (J = S.ja)(e);
        }, G = function() {
            return (G = S.ka)();
        };
        d.dynCall_iijj = function(e, t, r, a, o, u) {
            return (d.dynCall_iijj = S.la)(e, t, r, a, o, u);
        }, d.dynCall_vijj = function(e, t, r, a, o, u) {
            return (d.dynCall_vijj = S.ma)(e, t, r, a, o, u);
        }, d.dynCall_jiii = function(e, t, r, a) {
            return (d.dynCall_jiii = S.na)(e, t, r, a);
        }, d.dynCall_jii = function(e, t, r) {
            return (d.dynCall_jii = S.oa)(e, t, r);
        }, d.dynCall_viijii = function(e, t, r, a, o, u, h) {
            return (d.dynCall_viijii = S.pa)(e, t, r, a, o, u, h);
        }, d.dynCall_iiiiij = function(e, t, r, a, o, u, h) {
            return (d.dynCall_iiiiij = S.qa)(e, t, r, a, o, u, h);
        }, d.dynCall_iiiiijj = function(e, t, r, a, o, u, h, l, p) {
            return (d.dynCall_iiiiijj = S.ra)(e, t, r, a, o, u, h, l, p);
        }, d.dynCall_iiiiiijj = function(e, t, r, a, o, u, h, l, p, v) {
            return (d.dynCall_iiiiiijj = S.sa)(e, t, r, a, o, u, h, l, p, v);
        };
        function N3(e, t, r) {
            var a = G();
            try {
                j.get(e)(t, r);
            } catch (o) {
                if (J(a), o !== o + 0) throw o;
                V(1, 0);
            }
        }
        function V3(e, t) {
            var r = G();
            try {
                j.get(e)(t);
            } catch (a) {
                if (J(r), a !== a + 0) throw a;
                V(1, 0);
            }
        }
        function J3(e, t, r, a) {
            var o = G();
            try {
                return j.get(e)(t, r, a);
            } catch (u) {
                if (J(o), u !== u + 0) throw u;
                V(1, 0);
            }
        }
        function G3(e, t, r) {
            var a = G();
            try {
                return j.get(e)(t, r);
            } catch (o) {
                if (J(a), o !== o + 0) throw o;
                V(1, 0);
            }
        }
        function q3(e, t) {
            var r = G();
            try {
                return j.get(e)(t);
            } catch (a) {
                if (J(r), a !== a + 0) throw a;
                V(1, 0);
            }
        }
        function K3(e, t, r, a, o, u) {
            var h = G();
            try {
                return j.get(e)(t, r, a, o, u);
            } catch (l) {
                if (J(h), l !== l + 0) throw l;
                V(1, 0);
            }
        }
        function Y3(e, t, r, a, o) {
            var u = G();
            try {
                j.get(e)(t, r, a, o);
            } catch (h) {
                if (J(u), h !== h + 0) throw h;
                V(1, 0);
            }
        }
        function X3(e, t, r, a) {
            var o = G();
            try {
                j.get(e)(t, r, a);
            } catch (u) {
                if (J(o), u !== u + 0) throw u;
                V(1, 0);
            }
        }
        function Z3(e) {
            var t = G();
            try {
                j.get(e)();
            } catch (r) {
                if (J(t), r !== r + 0) throw r;
                V(1, 0);
            }
        }
        var R1;
        h1 = function e() {
            R1 || Y2(), R1 || (h1 = e);
        };
        function Y2() {
            function e() {
                var r;
                if (!R1 && (R1 = !0, d.calledRun = !0, !C1)) {
                    if (j1(M2), f(d), (r = d.onRuntimeInitialized) == null || r.call(d), d.postRun) for(typeof d.postRun == "function" && (d.postRun = [
                        d.postRun
                    ]); d.postRun.length;){
                        var t = d.postRun.shift();
                        E2.unshift(t);
                    }
                    j1(E2);
                }
            }
            if (!(0 < n1)) {
                if (d.preRun) for(typeof d.preRun == "function" && (d.preRun = [
                    d.preRun
                ]); d.preRun.length;)h3();
                j1(C2), 0 < n1 || (d.setStatus ? (d.setStatus("Running..."), setTimeout(function() {
                    setTimeout(function() {
                        return d.setStatus("");
                    }, 1), e();
                }, 1)) : e());
            }
        }
        if (d.preInit) for(typeof d.preInit == "function" && (d.preInit = [
            d.preInit
        ]); 0 < d.preInit.length;)d.preInit.pop()();
        return Y2(), s = M, s;
    };
}(), $2bb54e1a7d9957b8$var$i3 = $2bb54e1a7d9957b8$var$n0;
var $2bb54e1a7d9957b8$var$r1 = /*#__PURE__*/ function() {
    "use strict";
    function r1() {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, r1);
        throw new Error("RendererLoader is a static class and cannot be instantiated.");
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(r1, null, [
        {
            key: "_tryLoad",
            value: function _tryLoad(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $2bb54e1a7d9957b8$var$i3({
                                        locateFile: function() {
                                            return n;
                                        }
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_loadWithBackup",
            value: function _loadWithBackup() {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _this;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        _this = this;
                        return [
                            2,
                            (this._ModulePromise || (this._ModulePromise = this._tryLoad(this._wasmURL).catch(function(n) {
                                return $2bb54e1a7d9957b8$var$g(_this, null, function() {
                                    var i, s;
                                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                i = "https://unpkg.com/".concat($2bb54e1a7d9957b8$var$c2, "@").concat($2bb54e1a7d9957b8$var$h2, "/dist/dotlottie-player.wasm");
                                                console.warn("Primary WASM load failed from ".concat(this._wasmURL, ". Error: ").concat(n.message)), console.warn("Attempting to load WASM from backup URL: ".concat(i));
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                return [
                                                    4,
                                                    this._tryLoad(i)
                                                ];
                                            case 2:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                            case 3:
                                                s = _state.sent();
                                                throw console.error("Primary WASM URL failed: ".concat(n.message)), console.error("Backup WASM URL failed: ".concat(s.message)), new Error("WASM loading failed from all sources.");
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            })), this._ModulePromise)
                        ];
                    });
                });
            }
        },
        {
            key: "load",
            value: function load() {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        return [
                            2,
                            this._loadWithBackup()
                        ];
                    });
                });
            }
        },
        {
            key: "setWasmUrl",
            value: function setWasmUrl(n) {
                n !== this._wasmURL && (this._wasmURL = n, this._ModulePromise = null);
            }
        }
    ]);
    return r1;
}();
$2bb54e1a7d9957b8$var$_($2bb54e1a7d9957b8$var$r1, "_ModulePromise", null), $2bb54e1a7d9957b8$var$_($2bb54e1a7d9957b8$var$r1, "_wasmURL", "https://cdn.jsdelivr.net/npm/".concat($2bb54e1a7d9957b8$var$c2, "@").concat($2bb54e1a7d9957b8$var$h2, "/dist/dotlottie-player.wasm"));
var $2bb54e1a7d9957b8$var$d1 = /*#__PURE__*/ function() {
    "use strict";
    function d1() {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, d1);
        $2bb54e1a7d9957b8$var$_(this, "_eventListeners", new Map);
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(d1, [
        {
            key: "addEventListener",
            value: function addEventListener(n, i) {
                var s = this._eventListeners.get(n);
                s || (s = new Set, this._eventListeners.set(n, s)), s.add(i);
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(n, i) {
                var s = this._eventListeners.get(n);
                s && (i ? (s.delete(i), s.size === 0 && this._eventListeners.delete(n)) : this._eventListeners.delete(n));
            }
        },
        {
            key: "dispatch",
            value: function dispatch(n) {
                var i = this._eventListeners.get(n.type);
                i == null || i.forEach(function(s) {
                    return s(n);
                });
            }
        },
        {
            key: "removeAllEventListeners",
            value: function removeAllEventListeners() {
                this._eventListeners.clear();
            }
        }
    ]);
    return d1;
}();
var $2bb54e1a7d9957b8$var$W = /*#__PURE__*/ function() {
    "use strict";
    function W() {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, W);
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(W, null, [
        {
            key: "_initializeObserver",
            value: function _initializeObserver() {
                var _this = this;
                if (this._observer) return;
                var n = function(i) {
                    i.forEach(function(s) {
                        var d = _this._observedCanvases.get(s.target);
                        d && (s.isIntersecting ? d.unfreeze() : d.freeze());
                    });
                };
                this._observer = new IntersectionObserver(n, {
                    threshold: 0
                });
            }
        },
        {
            key: "observe",
            value: function observe(n, i) {
                var s;
                this._initializeObserver(), !this._observedCanvases.has(n) && (this._observedCanvases.set(n, i), (s = this._observer) == null || s.observe(n));
            }
        },
        {
            key: "unobserve",
            value: function unobserve(n) {
                var i, s;
                (i = this._observer) == null || i.unobserve(n), this._observedCanvases.delete(n), this._observedCanvases.size === 0 && ((s = this._observer) == null || s.disconnect(), this._observer = null);
            }
        }
    ]);
    return W;
}();
$2bb54e1a7d9957b8$var$_($2bb54e1a7d9957b8$var$W, "_observer", null), $2bb54e1a7d9957b8$var$_($2bb54e1a7d9957b8$var$W, "_observedCanvases", new Map);
var $2bb54e1a7d9957b8$var$$ = /*#__PURE__*/ function() {
    "use strict";
    function $() {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, $);
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)($, null, [
        {
            key: "_initializeObserver",
            value: function _initializeObserver() {
                var _this = this;
                if (this._observer) return;
                var n = function(i) {
                    i.forEach(function(s) {
                        var d = _this._observedCanvases.get(s.target);
                        if (!d) return;
                        var _d = (0, $efec029548ccee7f$export$71511d61b312f219)(d, 2), f = _d[0], b = _d[1];
                        clearTimeout(b);
                        var M = setTimeout(function() {
                            f.resize();
                        }, 100);
                        _this._observedCanvases.set(s.target, [
                            f,
                            M
                        ]);
                    });
                };
                this._observer = new ResizeObserver(n);
            }
        },
        {
            key: "observe",
            value: function observe(n, i) {
                var s;
                this._initializeObserver(), !this._observedCanvases.has(n) && (this._observedCanvases.set(n, [
                    i,
                    0
                ]), (s = this._observer) == null || s.observe(n));
            }
        },
        {
            key: "unobserve",
            value: function unobserve(n) {
                var i, s;
                (i = this._observer) == null || i.unobserve(n), this._observedCanvases.delete(n), this._observedCanvases.size === 0 && ((s = this._observer) == null || s.disconnect(), this._observer = null);
            }
        }
    ]);
    return $;
}();
$2bb54e1a7d9957b8$var$_($2bb54e1a7d9957b8$var$$, "_observer", null), $2bb54e1a7d9957b8$var$_($2bb54e1a7d9957b8$var$$, "_observedCanvases", new Map);
function $2bb54e1a7d9957b8$var$i0(c) {
    return RegExp("^#([\\da-f]{6}|[\\da-f]{8})$", "iu").test(c);
}
function $2bb54e1a7d9957b8$var$a3(c) {
    if (!$2bb54e1a7d9957b8$var$i0(c)) return 0;
    var n = c.replace("#", "");
    return n = n.length === 6 ? "".concat(n, "ff") : n, parseInt(n, 16);
}
function $2bb54e1a7d9957b8$var$p2(c) {
    if (c.byteLength < 4) return !1;
    var n = new Uint8Array(c.slice(0, $2bb54e1a7d9957b8$var$z1.byteLength));
    for(var i = 0; i < $2bb54e1a7d9957b8$var$z1.length; i += 1)if ($2bb54e1a7d9957b8$var$z1[i] !== n[i]) return !1;
    return !0;
}
function $2bb54e1a7d9957b8$var$r3(c) {
    return $2bb54e1a7d9957b8$var$t3.every(function(n) {
        return Object.prototype.hasOwnProperty.call(c, n);
    });
}
function $2bb54e1a7d9957b8$var$v2(c) {
    if (typeof c == "string") try {
        return $2bb54e1a7d9957b8$var$r3(JSON.parse(c));
    } catch (n) {
        return !1;
    }
    else return $2bb54e1a7d9957b8$var$r3(c);
}
function $2bb54e1a7d9957b8$var$X() {
    return 1 + (($2bb54e1a7d9957b8$var$F ? window.devicePixelRatio : 1) - 1) * $2bb54e1a7d9957b8$var$n3;
}
function $2bb54e1a7d9957b8$var$W1(c) {
    var n = c.getBoundingClientRect();
    return n.top >= 0 && n.left >= 0 && n.bottom <= (window.innerHeight || document.documentElement.clientHeight) && n.right <= (window.innerWidth || document.documentElement.clientWidth);
}
var $2bb54e1a7d9957b8$var$f2 = function(c, n) {
    return c === "reverse" ? n.Mode.Reverse : c === "bounce" ? n.Mode.Bounce : c === "reverse-bounce" ? n.Mode.ReverseBounce : n.Mode.Forward;
}, $2bb54e1a7d9957b8$var$m2 = function(c, n) {
    return c === "contain" ? n.Fit.Contain : c === "cover" ? n.Fit.Cover : c === "fill" ? n.Fit.Fill : c === "fit-height" ? n.Fit.FitHeight : c === "fit-width" ? n.Fit.FitWidth : n.Fit.None;
}, $2bb54e1a7d9957b8$var$_2 = function(c, n) {
    var i = new n.VectorFloat;
    return i.push_back(c[0]), i.push_back(c[1]), i;
}, $2bb54e1a7d9957b8$var$g2 = function(c, n) {
    var i = new n.VectorFloat;
    return c.length !== 2 || (i.push_back(c[0]), i.push_back(c[1])), i;
}, $2bb54e1a7d9957b8$var$C = /*#__PURE__*/ function() {
    "use strict";
    function C(n) {
        var _this = this;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, C);
        $2bb54e1a7d9957b8$var$_(this, "_canvas");
        $2bb54e1a7d9957b8$var$_(this, "_context", null);
        $2bb54e1a7d9957b8$var$_(this, "_eventManager");
        $2bb54e1a7d9957b8$var$_(this, "_animationFrameId", null);
        $2bb54e1a7d9957b8$var$_(this, "_frameManager");
        $2bb54e1a7d9957b8$var$_(this, "_dotLottieCore", null);
        $2bb54e1a7d9957b8$var$_(this, "_renderConfig", {});
        $2bb54e1a7d9957b8$var$_(this, "_isFrozen", !1);
        $2bb54e1a7d9957b8$var$_(this, "_backgroundColor", null);
        $2bb54e1a7d9957b8$var$_(this, "_pointerUpMethod");
        $2bb54e1a7d9957b8$var$_(this, "_pointerDownMethod");
        $2bb54e1a7d9957b8$var$_(this, "_pointerMoveMethod");
        $2bb54e1a7d9957b8$var$_(this, "_pointerEnterMethod");
        $2bb54e1a7d9957b8$var$_(this, "_pointerExitMethod");
        var i, s, d;
        this._canvas = n.canvas, this._context = this._canvas.getContext("2d"), this._eventManager = new $2bb54e1a7d9957b8$var$d1, this._frameManager = new $2bb54e1a7d9957b8$var$O1, this._renderConfig = $2bb54e1a7d9957b8$var$D($2bb54e1a7d9957b8$var$x({}, n.renderConfig), {
            devicePixelRatio: ((i = n.renderConfig) == null ? void 0 : i.devicePixelRatio) || $2bb54e1a7d9957b8$var$X(),
            freezeOnOffscreen: (d = (s = n.renderConfig) == null ? void 0 : s.freezeOnOffscreen) != null ? d : !0
        }), $2bb54e1a7d9957b8$var$r1.load().then(function(f) {
            var b, M, E, A, k, u1, Z, e1;
            C._wasmModule = f, _this._dotLottieCore = new f.DotLottiePlayer({
                themeId: (b = n.themeId) != null ? b : "",
                autoplay: (M = n.autoplay) != null ? M : !1,
                backgroundColor: 0,
                loopAnimation: (E = n.loop) != null ? E : !1,
                mode: $2bb54e1a7d9957b8$var$f2((A = n.mode) != null ? A : "forward", f),
                segment: $2bb54e1a7d9957b8$var$g2((k = n.segment) != null ? k : [], f),
                speed: (u1 = n.speed) != null ? u1 : 1,
                useFrameInterpolation: (Z = n.useFrameInterpolation) != null ? Z : !0,
                marker: (e1 = n.marker) != null ? e1 : "",
                layout: n.layout ? {
                    align: $2bb54e1a7d9957b8$var$_2(n.layout.align, f),
                    fit: $2bb54e1a7d9957b8$var$m2(n.layout.fit, f)
                } : f.createDefaultLayout()
            }), _this._eventManager.dispatch({
                type: "ready"
            }), n.data ? _this._loadFromData(n.data) : n.src && _this._loadFromSrc(n.src), n.backgroundColor && _this.setBackgroundColor(n.backgroundColor);
        }).catch(function(f) {
            _this._eventManager.dispatch({
                type: "loadError",
                error: new Error("Failed to load wasm module: ".concat(f))
            });
        }), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(C, [
        {
            key: "_dispatchError",
            value: function _dispatchError(n) {
                console.error(n), this._eventManager.dispatch({
                    type: "loadError",
                    error: new Error(n)
                });
            }
        },
        {
            key: "_fetchData",
            value: function _fetchData(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var i, s;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch(n)
                                ];
                            case 1:
                                i = _state.sent();
                                if (!i.ok) throw new Error("Failed to fetch animation data from URL: ".concat(n, ". ").concat(i.status, ": ").concat(i.statusText));
                                return [
                                    4,
                                    i.arrayBuffer()
                                ];
                            case 2:
                                s = _state.sent();
                                return [
                                    2,
                                    $2bb54e1a7d9957b8$var$p2(s) ? s : new TextDecoder().decode(s)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_loadFromData",
            value: function _loadFromData(n) {
                if (this._dotLottieCore === null) return;
                var i = this._canvas.width, s = this._canvas.height, d = !1;
                if (typeof n == "string") {
                    if (!$2bb54e1a7d9957b8$var$v2(n)) {
                        this._dispatchError("Invalid Lottie JSON string: The provided string does not conform to the Lottie JSON format.");
                        return;
                    }
                    d = this._dotLottieCore.loadAnimationData(n, i, s);
                } else if (n instanceof ArrayBuffer) {
                    if (!$2bb54e1a7d9957b8$var$p2(n)) {
                        this._dispatchError("Invalid dotLottie ArrayBuffer: The provided ArrayBuffer does not conform to the dotLottie format.");
                        return;
                    }
                    d = this._dotLottieCore.loadDotLottieData(n, i, s);
                } else if (typeof n == "object") {
                    if (!$2bb54e1a7d9957b8$var$v2(n)) {
                        this._dispatchError("Invalid Lottie JSON object: The provided object does not conform to the Lottie JSON format.");
                        return;
                    }
                    d = this._dotLottieCore.loadAnimationData(JSON.stringify(n), i, s);
                } else {
                    this._dispatchError("Unsupported data type for animation data. Expected: \n          - string (Lottie JSON),\n          - ArrayBuffer (dotLottie),\n          - object (Lottie JSON). \n          Received: ".concat(typeof n === "undefined" ? "undefined" : (0, $0b5c99e6a0876eaa$export$71511d61b312f219)(n)));
                    return;
                }
                d ? (this._eventManager.dispatch({
                    type: "load"
                }), $2bb54e1a7d9957b8$var$F && this.resize(), this._eventManager.dispatch({
                    type: "frame",
                    currentFrame: this.currentFrame
                }), this._render(), this._dotLottieCore.config().autoplay && (this._dotLottieCore.play(), this._dotLottieCore.isPlaying() ? (this._eventManager.dispatch({
                    type: "play"
                }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))) : console.error("something went wrong, the animation was suppose to autoplay")), $2bb54e1a7d9957b8$var$F && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.freezeOnOffscreen && $2bb54e1a7d9957b8$var$W.observe(this._canvas, this), this._renderConfig.autoResize && $2bb54e1a7d9957b8$var$$.observe(this._canvas, this))) : this._dispatchError("Failed to load animation data");
            }
        },
        {
            key: "_loadFromSrc",
            value: function _loadFromSrc(n) {
                var _this = this;
                this._fetchData(n).then(function(i) {
                    return _this._loadFromData(i);
                }).catch(function(i) {
                    return _this._dispatchError("Failed to load animation data from URL: ".concat(n, ". ").concat(i));
                });
            }
        },
        {
            key: "activeAnimationId",
            get: function get() {
                var n;
                return (n = this._dotLottieCore) == null ? void 0 : n.activeAnimationId();
            }
        },
        {
            key: "activeThemeId",
            get: function get() {
                var n;
                return (n = this._dotLottieCore) == null ? void 0 : n.activeThemeId();
            }
        },
        {
            key: "layout",
            get: function get() {
                var i;
                var n = (i = this._dotLottieCore) == null ? void 0 : i.config().layout;
                if (n) return {
                    align: [
                        n.align.get(0),
                        n.align.get(1)
                    ],
                    fit: function() {
                        var s, d, f, b, M, E;
                        switch(n.fit){
                            case (s = C._wasmModule) == null ? void 0 : s.Fit.Contain:
                                return "contain";
                            case (d = C._wasmModule) == null ? void 0 : d.Fit.Cover:
                                return "cover";
                            case (f = C._wasmModule) == null ? void 0 : f.Fit.Fill:
                                return "fill";
                            case (b = C._wasmModule) == null ? void 0 : b.Fit.FitHeight:
                                return "fit-height";
                            case (M = C._wasmModule) == null ? void 0 : M.Fit.FitWidth:
                                return "fit-width";
                            case (E = C._wasmModule) == null ? void 0 : E.Fit.None:
                                return "none";
                            default:
                                return "contain";
                        }
                    }()
                };
            }
        },
        {
            key: "marker",
            get: function get() {
                var i;
                return (i = this._dotLottieCore) == null ? void 0 : i.config().marker;
            }
        },
        {
            key: "manifest",
            get: function get() {
                var n;
                try {
                    var i = (n = this._dotLottieCore) == null ? void 0 : n.manifestString();
                    if (this._dotLottieCore === null || !i) return null;
                    var s = JSON.parse(i);
                    return Object.keys(s).length === 0 ? null : s;
                } catch (i) {
                    return null;
                }
            }
        },
        {
            key: "renderConfig",
            get: function get() {
                return this._renderConfig;
            }
        },
        {
            key: "segment",
            get: function get() {
                var i;
                var n = (i = this._dotLottieCore) == null ? void 0 : i.config().segment;
                if (n && n.size() === 2) return [
                    n.get(0),
                    n.get(1)
                ];
            }
        },
        {
            key: "loop",
            get: function get() {
                var n, i;
                return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().loopAnimation) != null ? i : !1;
            }
        },
        {
            key: "mode",
            get: function get() {
                var i, s, d, f;
                var n = (i = this._dotLottieCore) == null ? void 0 : i.config().mode;
                return n === ((s = C._wasmModule) == null ? void 0 : s.Mode.Reverse) ? "reverse" : n === ((d = C._wasmModule) == null ? void 0 : d.Mode.Bounce) ? "bounce" : n === ((f = C._wasmModule) == null ? void 0 : f.Mode.ReverseBounce) ? "reverse-bounce" : "forward";
            }
        },
        {
            key: "isFrozen",
            get: function get() {
                return this._isFrozen;
            }
        },
        {
            key: "backgroundColor",
            get: function get() {
                var n;
                return (n = this._backgroundColor) != null ? n : "";
            }
        },
        {
            key: "autoplay",
            get: function get() {
                var n, i;
                return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().autoplay) != null ? i : !1;
            }
        },
        {
            key: "useFrameInterpolation",
            get: function get() {
                var n, i;
                return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().useFrameInterpolation) != null ? i : !1;
            }
        },
        {
            key: "speed",
            get: function get() {
                var n, i;
                return (i = (n = this._dotLottieCore) == null ? void 0 : n.config().speed) != null ? i : 0;
            }
        },
        {
            key: "isReady",
            get: function get() {
                return this._dotLottieCore !== null;
            }
        },
        {
            key: "isLoaded",
            get: function get() {
                var n, i;
                return (i = (n = this._dotLottieCore) == null ? void 0 : n.isLoaded()) != null ? i : !1;
            }
        },
        {
            key: "isPlaying",
            get: function get() {
                var n, i;
                return (i = (n = this._dotLottieCore) == null ? void 0 : n.isPlaying()) != null ? i : !1;
            }
        },
        {
            key: "isPaused",
            get: function get() {
                var n, i;
                return (i = (n = this._dotLottieCore) == null ? void 0 : n.isPaused()) != null ? i : !1;
            }
        },
        {
            key: "isStopped",
            get: function get() {
                var n, i;
                return (i = (n = this._dotLottieCore) == null ? void 0 : n.isStopped()) != null ? i : !1;
            }
        },
        {
            key: "currentFrame",
            get: function get() {
                return this._dotLottieCore ? Math.round(this._dotLottieCore.currentFrame() * 100) / 100 : 0;
            }
        },
        {
            key: "loopCount",
            get: function get() {
                var n, i;
                return (i = (n = this._dotLottieCore) == null ? void 0 : n.loopCount()) != null ? i : 0;
            }
        },
        {
            key: "totalFrames",
            get: function get() {
                var n, i;
                return (i = (n = this._dotLottieCore) == null ? void 0 : n.totalFrames()) != null ? i : 0;
            }
        },
        {
            key: "duration",
            get: function get() {
                var n, i;
                return (i = (n = this._dotLottieCore) == null ? void 0 : n.duration()) != null ? i : 0;
            }
        },
        {
            key: "segmentDuration",
            get: function get() {
                var n, i;
                return (i = (n = this._dotLottieCore) == null ? void 0 : n.segmentDuration()) != null ? i : 0;
            }
        },
        {
            key: "canvas",
            get: function get() {
                return this._canvas;
            }
        },
        {
            key: "load",
            value: function load(n) {
                var i, s, d, f, b, M, E, A, k;
                this._dotLottieCore === null || C._wasmModule === null || (this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null), this._dotLottieCore.setConfig({
                    themeId: (i = n.themeId) != null ? i : "",
                    autoplay: (s = n.autoplay) != null ? s : !1,
                    backgroundColor: 0,
                    loopAnimation: (d = n.loop) != null ? d : !1,
                    mode: $2bb54e1a7d9957b8$var$f2((f = n.mode) != null ? f : "forward", C._wasmModule),
                    segment: $2bb54e1a7d9957b8$var$g2((b = n.segment) != null ? b : [], C._wasmModule),
                    speed: (M = n.speed) != null ? M : 1,
                    useFrameInterpolation: (E = n.useFrameInterpolation) != null ? E : !0,
                    marker: (A = n.marker) != null ? A : "",
                    layout: n.layout ? {
                        align: $2bb54e1a7d9957b8$var$_2(n.layout.align, C._wasmModule),
                        fit: $2bb54e1a7d9957b8$var$m2(n.layout.fit, C._wasmModule)
                    } : C._wasmModule.createDefaultLayout()
                }), n.data ? this._loadFromData(n.data) : n.src && this._loadFromSrc(n.src), this.setBackgroundColor((k = n.backgroundColor) != null ? k : ""));
            }
        },
        {
            key: "_render",
            value: function _render() {
                if (this._dotLottieCore === null || this._context === null) return !1;
                if (this._dotLottieCore.render()) {
                    var i = this._dotLottieCore.buffer(), s = new Uint8ClampedArray(i, 0, this._canvas.width * this._canvas.height * 4), d = null;
                    return typeof ImageData == "undefined" ? (d = this._context.createImageData(this._canvas.width, this._canvas.height), d.data.set(s)) : d = new ImageData(s, this._canvas.width, this._canvas.height), this._context.putImageData(d, 0, 0), this._eventManager.dispatch({
                        type: "render",
                        currentFrame: this.currentFrame
                    }), !0;
                }
                return !1;
            }
        },
        {
            key: "_draw",
            value: function _draw() {
                if (this._dotLottieCore === null || this._context === null || !this._dotLottieCore.isPlaying()) return;
                var n = Math.round(this._dotLottieCore.requestFrame() * 100) / 100;
                this._dotLottieCore.setFrame(n) && (this._eventManager.dispatch({
                    type: "frame",
                    currentFrame: this.currentFrame
                }), this._render() && this._dotLottieCore.isComplete() && (this._dotLottieCore.config().loopAnimation ? this._eventManager.dispatch({
                    type: "loop",
                    loopCount: this._dotLottieCore.loopCount()
                }) : this._eventManager.dispatch({
                    type: "complete"
                }))), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this));
            }
        },
        {
            key: "play",
            value: function play() {
                if (this._dotLottieCore === null) return;
                (this._dotLottieCore.play() || this._dotLottieCore.isPlaying()) && (this._isFrozen = !1, this._eventManager.dispatch({
                    type: "play"
                }), this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this))), $2bb54e1a7d9957b8$var$F && this._canvas instanceof HTMLCanvasElement && this._renderConfig.freezeOnOffscreen && !$2bb54e1a7d9957b8$var$W1(this._canvas) && this.freeze();
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this._dotLottieCore === null) return;
                (this._dotLottieCore.pause() || this._dotLottieCore.isPaused()) && this._eventManager.dispatch({
                    type: "pause"
                });
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this._dotLottieCore === null) return;
                this._dotLottieCore.stop() && (this._eventManager.dispatch({
                    type: "frame",
                    currentFrame: this.currentFrame
                }), this._render(), this._eventManager.dispatch({
                    type: "stop"
                }));
            }
        },
        {
            key: "setFrame",
            value: function setFrame(n) {
                if (this._dotLottieCore === null || n < 0 || n > this._dotLottieCore.totalFrames()) return;
                this._dotLottieCore.seek(n) && (this._eventManager.dispatch({
                    type: "frame",
                    currentFrame: this.currentFrame
                }), this._render());
            }
        },
        {
            key: "setSpeed",
            value: function setSpeed(n) {
                this._dotLottieCore !== null && this._dotLottieCore.setConfig($2bb54e1a7d9957b8$var$D($2bb54e1a7d9957b8$var$x({}, this._dotLottieCore.config()), {
                    speed: n
                }));
            }
        },
        {
            key: "setBackgroundColor",
            value: function setBackgroundColor(n) {
                this._dotLottieCore !== null && ($2bb54e1a7d9957b8$var$F && this._canvas instanceof HTMLCanvasElement ? this._canvas.style.backgroundColor = n : this._dotLottieCore.setConfig($2bb54e1a7d9957b8$var$D($2bb54e1a7d9957b8$var$x({}, this._dotLottieCore.config()), {
                    backgroundColor: $2bb54e1a7d9957b8$var$a3(n)
                })), this._backgroundColor = n);
            }
        },
        {
            key: "setLoop",
            value: function setLoop(n) {
                this._dotLottieCore !== null && this._dotLottieCore.setConfig($2bb54e1a7d9957b8$var$D($2bb54e1a7d9957b8$var$x({}, this._dotLottieCore.config()), {
                    loopAnimation: n
                }));
            }
        },
        {
            key: "setUseFrameInterpolation",
            value: function setUseFrameInterpolation(n) {
                this._dotLottieCore !== null && this._dotLottieCore.setConfig($2bb54e1a7d9957b8$var$D($2bb54e1a7d9957b8$var$x({}, this._dotLottieCore.config()), {
                    useFrameInterpolation: n
                }));
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(n, i) {
                this._eventManager.addEventListener(n, i);
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(n, i) {
                this._eventManager.removeEventListener(n, i);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var n;
                $2bb54e1a7d9957b8$var$F && this._canvas instanceof HTMLCanvasElement && ($2bb54e1a7d9957b8$var$W.unobserve(this._canvas), $2bb54e1a7d9957b8$var$$.unobserve(this._canvas)), (n = this._dotLottieCore) == null || n.delete(), this._dotLottieCore = null, this._context = null, this._eventManager.dispatch({
                    type: "destroy"
                }), this._eventManager.removeAllEventListeners(), this._cleanupStateMachineListeners();
            }
        },
        {
            key: "freeze",
            value: function freeze() {
                this._animationFrameId !== null && (this._frameManager.cancelAnimationFrame(this._animationFrameId), this._animationFrameId = null, this._isFrozen = !0, this._eventManager.dispatch({
                    type: "freeze"
                }));
            }
        },
        {
            key: "unfreeze",
            value: function unfreeze() {
                this._animationFrameId === null && (this._animationFrameId = this._frameManager.requestAnimationFrame(this._draw.bind(this)), this._isFrozen = !1, this._eventManager.dispatch({
                    type: "unfreeze"
                }));
            }
        },
        {
            key: "resize",
            value: function resize() {
                if (!this._dotLottieCore || !this.isLoaded) return;
                if ($2bb54e1a7d9957b8$var$F && this._canvas instanceof HTMLCanvasElement) {
                    var i = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, _this__canvas_getBoundingClientRect = this._canvas.getBoundingClientRect(), s = _this__canvas_getBoundingClientRect.height, d = _this__canvas_getBoundingClientRect.width;
                    s !== 0 && d !== 0 && (this._canvas.width = d * i, this._canvas.height = s * i);
                }
                this._dotLottieCore.resize(this._canvas.width, this._canvas.height) && this._render();
            }
        },
        {
            key: "setSegment",
            value: function setSegment(n, i) {
                this._dotLottieCore === null || C._wasmModule === null || this._dotLottieCore.setConfig($2bb54e1a7d9957b8$var$D($2bb54e1a7d9957b8$var$x({}, this._dotLottieCore.config()), {
                    segment: $2bb54e1a7d9957b8$var$g2([
                        n,
                        i
                    ], C._wasmModule)
                }));
            }
        },
        {
            key: "setMode",
            value: function setMode(n) {
                this._dotLottieCore === null || C._wasmModule === null || this._dotLottieCore.setConfig($2bb54e1a7d9957b8$var$D($2bb54e1a7d9957b8$var$x({}, this._dotLottieCore.config()), {
                    mode: $2bb54e1a7d9957b8$var$f2(n, C._wasmModule)
                }));
            }
        },
        {
            key: "setRenderConfig",
            value: function setRenderConfig(n) {
                var f = n, i = f.devicePixelRatio, s = f.freezeOnOffscreen, d = $2bb54e1a7d9957b8$var$k1(f, [
                    "devicePixelRatio",
                    "freezeOnOffscreen"
                ]);
                this._renderConfig = $2bb54e1a7d9957b8$var$D($2bb54e1a7d9957b8$var$x($2bb54e1a7d9957b8$var$x({}, this._renderConfig), d), {
                    devicePixelRatio: i || $2bb54e1a7d9957b8$var$X(),
                    freezeOnOffscreen: s != null ? s : !0
                }), $2bb54e1a7d9957b8$var$F && this._canvas instanceof HTMLCanvasElement && (this._renderConfig.autoResize ? $2bb54e1a7d9957b8$var$$.observe(this._canvas, this) : $2bb54e1a7d9957b8$var$$.unobserve(this._canvas), this._renderConfig.freezeOnOffscreen ? $2bb54e1a7d9957b8$var$W.observe(this._canvas, this) : ($2bb54e1a7d9957b8$var$W.unobserve(this._canvas), this._isFrozen && this.unfreeze()));
            }
        },
        {
            key: "loadAnimation",
            value: function loadAnimation(n) {
                if (this._dotLottieCore === null || this._dotLottieCore.activeAnimationId() === n) return;
                this._dotLottieCore.loadAnimation(n, this._canvas.width, this._canvas.height) ? (this._eventManager.dispatch({
                    type: "load"
                }), this.resize()) : this._eventManager.dispatch({
                    type: "loadError",
                    error: new Error("Failed to animation :".concat(n))
                });
            }
        },
        {
            key: "setMarker",
            value: function setMarker(n) {
                this._dotLottieCore !== null && this._dotLottieCore.setConfig($2bb54e1a7d9957b8$var$D($2bb54e1a7d9957b8$var$x({}, this._dotLottieCore.config()), {
                    marker: n
                }));
            }
        },
        {
            key: "markers",
            value: function markers() {
                var i;
                var n = (i = this._dotLottieCore) == null ? void 0 : i.markers();
                if (n) {
                    var s = [];
                    for(var d = 0; d < n.size(); d += 1){
                        var f = n.get(d);
                        s.push({
                            name: f.name,
                            time: f.time,
                            duration: f.duration
                        });
                    }
                    return s;
                }
                return [];
            }
        },
        {
            key: "setTheme",
            value: function setTheme(n) {
                if (this._dotLottieCore === null) return !1;
                var i = this._dotLottieCore.setTheme(n);
                return this._render(), i;
            }
        },
        {
            key: "resetTheme",
            value: function resetTheme() {
                return this._dotLottieCore === null ? !1 : this._dotLottieCore.resetTheme();
            }
        },
        {
            key: "setThemeData",
            value: function setThemeData(n) {
                if (this._dotLottieCore === null) return !1;
                var i = this._dotLottieCore.setThemeData(n);
                return this._render(), i;
            }
        },
        {
            key: "setSlots",
            value: function setSlots(n) {
                this._dotLottieCore !== null && this._dotLottieCore.setSlots(n);
            }
        },
        {
            key: "setLayout",
            value: function setLayout(n) {
                this._dotLottieCore === null || C._wasmModule === null || this._dotLottieCore.setConfig($2bb54e1a7d9957b8$var$D($2bb54e1a7d9957b8$var$x({}, this._dotLottieCore.config()), {
                    layout: {
                        align: $2bb54e1a7d9957b8$var$_2(n.align, C._wasmModule),
                        fit: $2bb54e1a7d9957b8$var$m2(n.fit, C._wasmModule)
                    }
                }));
            }
        },
        {
            key: "setViewport",
            value: function setViewport(n, i, s, d) {
                return this._dotLottieCore === null ? !1 : this._dotLottieCore.setViewport(n, i, s, d);
            }
        },
        {
            key: "loadStateMachine",
            value: function loadStateMachine(n) {
                var i, s;
                return (s = (i = this._dotLottieCore) == null ? void 0 : i.loadStateMachine(n)) != null ? s : !1;
            }
        },
        {
            key: "startStateMachine",
            value: function startStateMachine() {
                var i, s;
                var n = (s = (i = this._dotLottieCore) == null ? void 0 : i.startStateMachine()) != null ? s : !1;
                return n && this._setupStateMachineListeners(), n;
            }
        },
        {
            key: "stopStateMachine",
            value: function stopStateMachine() {
                var i, s;
                var n = (s = (i = this._dotLottieCore) == null ? void 0 : i.stopStateMachine()) != null ? s : !1;
                return n && this._cleanupStateMachineListeners(), n;
            }
        },
        {
            key: "_getPointerPosition",
            value: function _getPointerPosition(n) {
                var i = this._canvas.getBoundingClientRect(), s = this._canvas.width / i.width, d = this._canvas.height / i.height, f = this._renderConfig.devicePixelRatio || window.devicePixelRatio || 1, b = (n.clientX - i.left) * s / f, M = (n.clientY - i.top) * d / f;
                return {
                    x: b,
                    y: M
                };
            }
        },
        {
            key: "_onPointerUp",
            value: function _onPointerUp(n) {
                var _this__getPointerPosition = this._getPointerPosition(n), i = _this__getPointerPosition.x, s = _this__getPointerPosition.y;
                this.postPointerUpEvent(i, s);
            }
        },
        {
            key: "_onPointerDown",
            value: function _onPointerDown(n) {
                var _this__getPointerPosition = this._getPointerPosition(n), i = _this__getPointerPosition.x, s = _this__getPointerPosition.y;
                this.postPointerDownEvent(i, s);
            }
        },
        {
            key: "_onPointerMove",
            value: function _onPointerMove(n) {
                var _this__getPointerPosition = this._getPointerPosition(n), i = _this__getPointerPosition.x, s = _this__getPointerPosition.y;
                this.postPointerMoveEvent(i, s);
            }
        },
        {
            key: "_onPointerEnter",
            value: function _onPointerEnter(n) {
                var _this__getPointerPosition = this._getPointerPosition(n), i = _this__getPointerPosition.x, s = _this__getPointerPosition.y;
                this.postPointerEnterEvent(i, s);
            }
        },
        {
            key: "_onPointerLeave",
            value: function _onPointerLeave(n) {
                var _this__getPointerPosition = this._getPointerPosition(n), i = _this__getPointerPosition.x, s = _this__getPointerPosition.y;
                this.postPointerExitEvent(i, s);
            }
        },
        {
            key: "postPointerUpEvent",
            value: function postPointerUpEvent(n, i) {
                var s;
                return (s = this._dotLottieCore) == null ? void 0 : s.postPointerUpEvent(n, i);
            }
        },
        {
            key: "postPointerDownEvent",
            value: function postPointerDownEvent(n, i) {
                var s;
                return (s = this._dotLottieCore) == null ? void 0 : s.postPointerDownEvent(n, i);
            }
        },
        {
            key: "postPointerMoveEvent",
            value: function postPointerMoveEvent(n, i) {
                var s;
                return (s = this._dotLottieCore) == null ? void 0 : s.postPointerMoveEvent(n, i);
            }
        },
        {
            key: "postPointerEnterEvent",
            value: function postPointerEnterEvent(n, i) {
                var s;
                return (s = this._dotLottieCore) == null ? void 0 : s.postPointerEnterEvent(n, i);
            }
        },
        {
            key: "postPointerExitEvent",
            value: function postPointerExitEvent(n, i) {
                var s;
                return (s = this._dotLottieCore) == null ? void 0 : s.postPointerExitEvent(n, i);
            }
        },
        {
            key: "getStateMachineListeners",
            value: function getStateMachineListeners() {
                if (!this._dotLottieCore) return [];
                var n = this._dotLottieCore.stateMachineFrameworkSetup(), i = [];
                for(var s = 0; s < n.size(); s += 1)i.push(n.get(s));
                return i;
            }
        },
        {
            key: "_setupStateMachineListeners",
            value: function _setupStateMachineListeners() {
                if ($2bb54e1a7d9957b8$var$F && this._canvas instanceof HTMLCanvasElement && this._dotLottieCore !== null && this.isLoaded) {
                    var n = this.getStateMachineListeners();
                    n.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), n.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), n.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), n.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), n.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
                }
            }
        },
        {
            key: "_cleanupStateMachineListeners",
            value: function _cleanupStateMachineListeners() {
                $2bb54e1a7d9957b8$var$F && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
            }
        },
        {
            key: "loadStateMachineData",
            value: function loadStateMachineData(n) {
                var i, s;
                return (s = (i = this._dotLottieCore) == null ? void 0 : i.loadStateMachineData(n)) != null ? s : !1;
            }
        },
        {
            key: "animationSize",
            value: function animationSize() {
                var s, d, f, b;
                var n = (d = (s = this._dotLottieCore) == null ? void 0 : s.animationSize().get(0)) != null ? d : 0, i = (b = (f = this._dotLottieCore) == null ? void 0 : f.animationSize().get(1)) != null ? b : 0;
                return {
                    width: n,
                    height: i
                };
            }
        },
        {
            key: "setStateMachineBooleanContext",
            value: function setStateMachineBooleanContext(n, i) {
                var s, d;
                return (d = (s = this._dotLottieCore) == null ? void 0 : s.setStateMachineBooleanContext(n, i)) != null ? d : !1;
            }
        },
        {
            key: "setStateMachineNumericContext",
            value: function setStateMachineNumericContext(n, i) {
                var s, d;
                return (d = (s = this._dotLottieCore) == null ? void 0 : s.setStateMachineNumericContext(n, i)) != null ? d : !1;
            }
        },
        {
            key: "setStateMachineStringContext",
            value: function setStateMachineStringContext(n, i) {
                var s, d;
                return (d = (s = this._dotLottieCore) == null ? void 0 : s.setStateMachineStringContext(n, i)) != null ? d : !1;
            }
        },
        {
            key: "getLayerBoundingBox",
            value: function getLayerBoundingBox(n) {
                var M;
                var i = (M = this._dotLottieCore) == null ? void 0 : M.getLayerBounds(n);
                if (!i || i.size() !== 4) return;
                var s = i.get(0), d = i.get(1), f = i.get(2), b = i.get(3);
                return {
                    x: s,
                    y: d,
                    width: f,
                    height: b
                };
            }
        }
    ], [
        {
            key: "setWasmUrl",
            value: function setWasmUrl(n) {
                $2bb54e1a7d9957b8$var$r1.setWasmUrl(n);
            }
        },
        {
            key: "transformThemeToLottieSlots",
            value: function transformThemeToLottieSlots(n, i) {
                var s, d;
                return (d = (s = C._wasmModule) == null ? void 0 : s.transformThemeToLottieSlots(n, i)) != null ? d : "";
            }
        }
    ]);
    return C;
}();
$2bb54e1a7d9957b8$var$_($2bb54e1a7d9957b8$var$C, "_wasmModule", null);
var $2bb54e1a7d9957b8$export$2c434b74e61f4f56 = $2bb54e1a7d9957b8$var$C;
var $2bb54e1a7d9957b8$var$y2 = function y2() {
    "use strict";
    (0, $8713978b2328d32b$export$71511d61b312f219)(this, y2);
    if (typeof Worker == "undefined") throw new Error("Worker is not supported in this environment.");
    var n = new Blob([
        new Uint8Array([
            34,
            117,
            115,
            101,
            32,
            115,
            116,
            114,
            105,
            99,
            116,
            34,
            59,
            10,
            40,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            95,
            100,
            101,
            102,
            80,
            114,
            111,
            112,
            32,
            61,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            100,
            101,
            102,
            105,
            110,
            101,
            80,
            114,
            111,
            112,
            101,
            114,
            116,
            121,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            95,
            100,
            101,
            102,
            80,
            114,
            111,
            112,
            115,
            32,
            61,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            100,
            101,
            102,
            105,
            110,
            101,
            80,
            114,
            111,
            112,
            101,
            114,
            116,
            105,
            101,
            115,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            95,
            103,
            101,
            116,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            68,
            101,
            115,
            99,
            115,
            32,
            61,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            103,
            101,
            116,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            101,
            114,
            116,
            121,
            68,
            101,
            115,
            99,
            114,
            105,
            112,
            116,
            111,
            114,
            115,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            95,
            103,
            101,
            116,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            83,
            121,
            109,
            98,
            111,
            108,
            115,
            32,
            61,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            103,
            101,
            116,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            101,
            114,
            116,
            121,
            83,
            121,
            109,
            98,
            111,
            108,
            115,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            95,
            104,
            97,
            115,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            32,
            61,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            112,
            114,
            111,
            116,
            111,
            116,
            121,
            112,
            101,
            46,
            104,
            97,
            115,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            101,
            114,
            116,
            121,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            95,
            112,
            114,
            111,
            112,
            73,
            115,
            69,
            110,
            117,
            109,
            32,
            61,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            112,
            114,
            111,
            116,
            111,
            116,
            121,
            112,
            101,
            46,
            112,
            114,
            111,
            112,
            101,
            114,
            116,
            121,
            73,
            115,
            69,
            110,
            117,
            109,
            101,
            114,
            97,
            98,
            108,
            101,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            95,
            100,
            101,
            102,
            78,
            111,
            114,
            109,
            97,
            108,
            80,
            114,
            111,
            112,
            32,
            61,
            32,
            40,
            111,
            98,
            106,
            44,
            32,
            107,
            101,
            121,
            44,
            32,
            118,
            97,
            108,
            117,
            101,
            41,
            32,
            61,
            62,
            32,
            107,
            101,
            121,
            32,
            105,
            110,
            32,
            111,
            98,
            106,
            32,
            63,
            32,
            95,
            95,
            100,
            101,
            102,
            80,
            114,
            111,
            112,
            40,
            111,
            98,
            106,
            44,
            32,
            107,
            101,
            121,
            44,
            32,
            123,
            32,
            101,
            110,
            117,
            109,
            101,
            114,
            97,
            98,
            108,
            101,
            58,
            32,
            116,
            114,
            117,
            101,
            44,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            117,
            114,
            97,
            98,
            108,
            101,
            58,
            32,
            116,
            114,
            117,
            101,
            44,
            32,
            119,
            114,
            105,
            116,
            97,
            98,
            108,
            101,
            58,
            32,
            116,
            114,
            117,
            101,
            44,
            32,
            118,
            97,
            108,
            117,
            101,
            32,
            125,
            41,
            32,
            58,
            32,
            111,
            98,
            106,
            91,
            107,
            101,
            121,
            93,
            32,
            61,
            32,
            118,
            97,
            108,
            117,
            101,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            115,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            112,
            114,
            111,
            112,
            32,
            105,
            110,
            32,
            98,
            32,
            124,
            124,
            32,
            40,
            98,
            32,
            61,
            32,
            123,
            125,
            41,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            95,
            95,
            104,
            97,
            115,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            46,
            99,
            97,
            108,
            108,
            40,
            98,
            44,
            32,
            112,
            114,
            111,
            112,
            41,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            100,
            101,
            102,
            78,
            111,
            114,
            109,
            97,
            108,
            80,
            114,
            111,
            112,
            40,
            97,
            44,
            32,
            112,
            114,
            111,
            112,
            44,
            32,
            98,
            91,
            112,
            114,
            111,
            112,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            95,
            95,
            103,
            101,
            116,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            83,
            121,
            109,
            98,
            111,
            108,
            115,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            112,
            114,
            111,
            112,
            32,
            111,
            102,
            32,
            95,
            95,
            103,
            101,
            116,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            83,
            121,
            109,
            98,
            111,
            108,
            115,
            40,
            98,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            95,
            95,
            112,
            114,
            111,
            112,
            73,
            115,
            69,
            110,
            117,
            109,
            46,
            99,
            97,
            108,
            108,
            40,
            98,
            44,
            32,
            112,
            114,
            111,
            112,
            41,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            100,
            101,
            102,
            78,
            111,
            114,
            109,
            97,
            108,
            80,
            114,
            111,
            112,
            40,
            97,
            44,
            32,
            112,
            114,
            111,
            112,
            44,
            32,
            98,
            91,
            112,
            114,
            111,
            112,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            97,
            59,
            10,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            80,
            114,
            111,
            112,
            115,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            95,
            95,
            100,
            101,
            102,
            80,
            114,
            111,
            112,
            115,
            40,
            97,
            44,
            32,
            95,
            95,
            103,
            101,
            116,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            68,
            101,
            115,
            99,
            115,
            40,
            98,
            41,
            41,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            95,
            111,
            98,
            106,
            82,
            101,
            115,
            116,
            32,
            61,
            32,
            40,
            115,
            111,
            117,
            114,
            99,
            101,
            44,
            32,
            101,
            120,
            99,
            108,
            117,
            100,
            101,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            116,
            97,
            114,
            103,
            101,
            116,
            32,
            61,
            32,
            123,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            112,
            114,
            111,
            112,
            32,
            105,
            110,
            32,
            115,
            111,
            117,
            114,
            99,
            101,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            95,
            95,
            104,
            97,
            115,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            46,
            99,
            97,
            108,
            108,
            40,
            115,
            111,
            117,
            114,
            99,
            101,
            44,
            32,
            112,
            114,
            111,
            112,
            41,
            32,
            38,
            38,
            32,
            101,
            120,
            99,
            108,
            117,
            100,
            101,
            46,
            105,
            110,
            100,
            101,
            120,
            79,
            102,
            40,
            112,
            114,
            111,
            112,
            41,
            32,
            60,
            32,
            48,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            97,
            114,
            103,
            101,
            116,
            91,
            112,
            114,
            111,
            112,
            93,
            32,
            61,
            32,
            115,
            111,
            117,
            114,
            99,
            101,
            91,
            112,
            114,
            111,
            112,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            115,
            111,
            117,
            114,
            99,
            101,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            38,
            38,
            32,
            95,
            95,
            103,
            101,
            116,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            83,
            121,
            109,
            98,
            111,
            108,
            115,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            112,
            114,
            111,
            112,
            32,
            111,
            102,
            32,
            95,
            95,
            103,
            101,
            116,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            83,
            121,
            109,
            98,
            111,
            108,
            115,
            40,
            115,
            111,
            117,
            114,
            99,
            101,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            101,
            120,
            99,
            108,
            117,
            100,
            101,
            46,
            105,
            110,
            100,
            101,
            120,
            79,
            102,
            40,
            112,
            114,
            111,
            112,
            41,
            32,
            60,
            32,
            48,
            32,
            38,
            38,
            32,
            95,
            95,
            112,
            114,
            111,
            112,
            73,
            115,
            69,
            110,
            117,
            109,
            46,
            99,
            97,
            108,
            108,
            40,
            115,
            111,
            117,
            114,
            99,
            101,
            44,
            32,
            112,
            114,
            111,
            112,
            41,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            97,
            114,
            103,
            101,
            116,
            91,
            112,
            114,
            111,
            112,
            93,
            32,
            61,
            32,
            115,
            111,
            117,
            114,
            99,
            101,
            91,
            112,
            114,
            111,
            112,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            97,
            114,
            103,
            101,
            116,
            59,
            10,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            32,
            61,
            32,
            40,
            111,
            98,
            106,
            44,
            32,
            107,
            101,
            121,
            44,
            32,
            118,
            97,
            108,
            117,
            101,
            41,
            32,
            61,
            62,
            32,
            95,
            95,
            100,
            101,
            102,
            78,
            111,
            114,
            109,
            97,
            108,
            80,
            114,
            111,
            112,
            40,
            111,
            98,
            106,
            44,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            107,
            101,
            121,
            32,
            33,
            61,
            61,
            32,
            34,
            115,
            121,
            109,
            98,
            111,
            108,
            34,
            32,
            63,
            32,
            107,
            101,
            121,
            32,
            43,
            32,
            34,
            34,
            32,
            58,
            32,
            107,
            101,
            121,
            44,
            32,
            118,
            97,
            108,
            117,
            101,
            41,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            95,
            97,
            115,
            121,
            110,
            99,
            32,
            61,
            32,
            40,
            95,
            95,
            116,
            104,
            105,
            115,
            44,
            32,
            95,
            95,
            97,
            114,
            103,
            117,
            109,
            101,
            110,
            116,
            115,
            44,
            32,
            103,
            101,
            110,
            101,
            114,
            97,
            116,
            111,
            114,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            110,
            101,
            119,
            32,
            80,
            114,
            111,
            109,
            105,
            115,
            101,
            40,
            40,
            114,
            101,
            115,
            111,
            108,
            118,
            101,
            44,
            32,
            114,
            101,
            106,
            101,
            99,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            102,
            117,
            108,
            102,
            105,
            108,
            108,
            101,
            100,
            32,
            61,
            32,
            40,
            118,
            97,
            108,
            117,
            101,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            116,
            101,
            112,
            40,
            103,
            101,
            110,
            101,
            114,
            97,
            116,
            111,
            114,
            46,
            110,
            101,
            120,
            116,
            40,
            118,
            97,
            108,
            117,
            101,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            106,
            101,
            99,
            116,
            40,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            114,
            101,
            106,
            101,
            99,
            116,
            101,
            100,
            32,
            61,
            32,
            40,
            118,
            97,
            108,
            117,
            101,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            116,
            101,
            112,
            40,
            103,
            101,
            110,
            101,
            114,
            97,
            116,
            111,
            114,
            46,
            116,
            104,
            114,
            111,
            119,
            40,
            118,
            97,
            108,
            117,
            101,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            106,
            101,
            99,
            116,
            40,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            115,
            116,
            101,
            112,
            32,
            61,
            32,
            40,
            120,
            41,
            32,
            61,
            62,
            32,
            120,
            46,
            100,
            111,
            110,
            101,
            32,
            63,
            32,
            114,
            101,
            115,
            111,
            108,
            118,
            101,
            40,
            120,
            46,
            118,
            97,
            108,
            117,
            101,
            41,
            32,
            58,
            32,
            80,
            114,
            111,
            109,
            105,
            115,
            101,
            46,
            114,
            101,
            115,
            111,
            108,
            118,
            101,
            40,
            120,
            46,
            118,
            97,
            108,
            117,
            101,
            41,
            46,
            116,
            104,
            101,
            110,
            40,
            102,
            117,
            108,
            102,
            105,
            108,
            108,
            101,
            100,
            44,
            32,
            114,
            101,
            106,
            101,
            99,
            116,
            101,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            116,
            101,
            112,
            40,
            40,
            103,
            101,
            110,
            101,
            114,
            97,
            116,
            111,
            114,
            32,
            61,
            32,
            103,
            101,
            110,
            101,
            114,
            97,
            116,
            111,
            114,
            46,
            97,
            112,
            112,
            108,
            121,
            40,
            95,
            95,
            116,
            104,
            105,
            115,
            44,
            32,
            95,
            95,
            97,
            114,
            103,
            117,
            109,
            101,
            110,
            116,
            115,
            41,
            41,
            46,
            110,
            101,
            120,
            116,
            40,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            125,
            59,
            10,
            10,
            32,
            32,
            47,
            47,
            32,
            115,
            114,
            99,
            47,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            45,
            102,
            114,
            97,
            109,
            101,
            45,
            109,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            116,
            115,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            87,
            101,
            98,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            83,
            116,
            114,
            97,
            116,
            101,
            103,
            121,
            32,
            61,
            32,
            99,
            108,
            97,
            115,
            115,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            40,
            99,
            97,
            108,
            108,
            98,
            97,
            99,
            107,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            40,
            99,
            97,
            108,
            108,
            98,
            97,
            99,
            107,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            99,
            97,
            110,
            99,
            101,
            108,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            40,
            105,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            110,
            99,
            101,
            108,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            40,
            105,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            78,
            111,
            100,
            101,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            83,
            116,
            114,
            97,
            116,
            101,
            103,
            121,
            32,
            61,
            32,
            99,
            108,
            97,
            115,
            115,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            108,
            97,
            115,
            116,
            72,
            97,
            110,
            100,
            108,
            101,
            73,
            100,
            34,
            44,
            32,
            48,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            108,
            97,
            115,
            116,
            73,
            109,
            109,
            101,
            100,
            105,
            97,
            116,
            101,
            34,
            44,
            32,
            110,
            117,
            108,
            108,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            40,
            99,
            97,
            108,
            108,
            98,
            97,
            99,
            107,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            108,
            97,
            115,
            116,
            72,
            97,
            110,
            100,
            108,
            101,
            73,
            100,
            32,
            62,
            61,
            32,
            78,
            117,
            109,
            98,
            101,
            114,
            46,
            77,
            65,
            88,
            95,
            83,
            65,
            70,
            69,
            95,
            73,
            78,
            84,
            69,
            71,
            69,
            82,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            108,
            97,
            115,
            116,
            72,
            97,
            110,
            100,
            108,
            101,
            73,
            100,
            32,
            61,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            108,
            97,
            115,
            116,
            72,
            97,
            110,
            100,
            108,
            101,
            73,
            100,
            32,
            43,
            61,
            32,
            49,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            108,
            97,
            115,
            116,
            73,
            109,
            109,
            101,
            100,
            105,
            97,
            116,
            101,
            32,
            61,
            32,
            115,
            101,
            116,
            73,
            109,
            109,
            101,
            100,
            105,
            97,
            116,
            101,
            40,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            108,
            108,
            98,
            97,
            99,
            107,
            40,
            68,
            97,
            116,
            101,
            46,
            110,
            111,
            119,
            40,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            108,
            97,
            115,
            116,
            72,
            97,
            110,
            100,
            108,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            99,
            97,
            110,
            99,
            101,
            108,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            40,
            95,
            105,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            108,
            97,
            115,
            116,
            73,
            109,
            109,
            101,
            100,
            105,
            97,
            116,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            108,
            101,
            97,
            114,
            73,
            109,
            109,
            101,
            100,
            105,
            97,
            116,
            101,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            108,
            97,
            115,
            116,
            73,
            109,
            109,
            101,
            100,
            105,
            97,
            116,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            32,
            61,
            32,
            99,
            108,
            97,
            115,
            115,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            115,
            116,
            114,
            97,
            116,
            101,
            103,
            121,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            115,
            116,
            114,
            97,
            116,
            101,
            103,
            121,
            32,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            32,
            61,
            61,
            61,
            32,
            34,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            34,
            32,
            63,
            32,
            110,
            101,
            119,
            32,
            87,
            101,
            98,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            83,
            116,
            114,
            97,
            116,
            101,
            103,
            121,
            40,
            41,
            32,
            58,
            32,
            110,
            101,
            119,
            32,
            78,
            111,
            100,
            101,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            83,
            116,
            114,
            97,
            116,
            101,
            103,
            121,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            40,
            99,
            97,
            108,
            108,
            98,
            97,
            99,
            107,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            115,
            116,
            114,
            97,
            116,
            101,
            103,
            121,
            46,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            40,
            99,
            97,
            108,
            108,
            98,
            97,
            99,
            107,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            99,
            97,
            110,
            99,
            101,
            108,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            40,
            105,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            115,
            116,
            114,
            97,
            116,
            101,
            103,
            121,
            46,
            99,
            97,
            110,
            99,
            101,
            108,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            40,
            105,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            125,
            59,
            10,
            10,
            32,
            32,
            47,
            47,
            32,
            115,
            114,
            99,
            47,
            99,
            111,
            110,
            115,
            116,
            97,
            110,
            116,
            115,
            46,
            116,
            115,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            73,
            83,
            95,
            66,
            82,
            79,
            87,
            83,
            69,
            82,
            32,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            119,
            105,
            110,
            100,
            111,
            119,
            32,
            33,
            61,
            61,
            32,
            34,
            117,
            110,
            100,
            101,
            102,
            105,
            110,
            101,
            100,
            34,
            32,
            38,
            38,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            119,
            105,
            110,
            100,
            111,
            119,
            46,
            100,
            111,
            99,
            117,
            109,
            101,
            110,
            116,
            32,
            33,
            61,
            61,
            32,
            34,
            117,
            110,
            100,
            101,
            102,
            105,
            110,
            101,
            100,
            34,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            90,
            73,
            80,
            95,
            83,
            73,
            71,
            78,
            65,
            84,
            85,
            82,
            69,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            85,
            105,
            110,
            116,
            56,
            65,
            114,
            114,
            97,
            121,
            40,
            91,
            56,
            48,
            44,
            32,
            55,
            53,
            44,
            32,
            51,
            44,
            32,
            52,
            93,
            41,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            76,
            79,
            84,
            84,
            73,
            69,
            95,
            74,
            83,
            79,
            78,
            95,
            77,
            65,
            78,
            68,
            65,
            84,
            79,
            82,
            89,
            95,
            70,
            73,
            69,
            76,
            68,
            83,
            32,
            61,
            32,
            91,
            34,
            118,
            34,
            44,
            32,
            34,
            105,
            112,
            34,
            44,
            32,
            34,
            111,
            112,
            34,
            44,
            32,
            34,
            108,
            97,
            121,
            101,
            114,
            115,
            34,
            44,
            32,
            34,
            102,
            114,
            34,
            44,
            32,
            34,
            119,
            34,
            44,
            32,
            34,
            104,
            34,
            93,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            80,
            65,
            67,
            75,
            65,
            71,
            69,
            95,
            86,
            69,
            82,
            83,
            73,
            79,
            78,
            32,
            61,
            32,
            34,
            48,
            46,
            52,
            48,
            46,
            49,
            34,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            80,
            65,
            67,
            75,
            65,
            71,
            69,
            95,
            78,
            65,
            77,
            69,
            32,
            61,
            32,
            34,
            64,
            108,
            111,
            116,
            116,
            105,
            101,
            102,
            105,
            108,
            101,
            115,
            47,
            100,
            111,
            116,
            108,
            111,
            116,
            116,
            105,
            101,
            45,
            119,
            101,
            98,
            34,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            68,
            69,
            70,
            65,
            85,
            76,
            84,
            95,
            68,
            80,
            82,
            95,
            70,
            65,
            67,
            84,
            79,
            82,
            32,
            61,
            32,
            48,
            46,
            55,
            53,
            59,
            10,
            10,
            32,
            32,
            47,
            47,
            32,
            115,
            114,
            99,
            47,
            99,
            111,
            114,
            101,
            47,
            100,
            111,
            116,
            108,
            111,
            116,
            116,
            105,
            101,
            45,
            112,
            108,
            97,
            121,
            101,
            114,
            46,
            106,
            115,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            80,
            108,
            97,
            121,
            101,
            114,
            77,
            111,
            100,
            117,
            108,
            101,
            32,
            61,
            32,
            40,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            115,
            99,
            114,
            105,
            112,
            116,
            78,
            97,
            109,
            101,
            32,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            100,
            111,
            99,
            117,
            109,
            101,
            110,
            116,
            32,
            33,
            61,
            32,
            34,
            117,
            110,
            100,
            101,
            102,
            105,
            110,
            101,
            100,
            34,
            32,
            63,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            100,
            111,
            99,
            117,
            109,
            101,
            110,
            116,
            46,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            83,
            99,
            114,
            105,
            112,
            116,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            115,
            114,
            99,
            32,
            58,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            109,
            111,
            100,
            117,
            108,
            101,
            65,
            114,
            103,
            32,
            61,
            32,
            123,
            125,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            82,
            116,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            107,
            32,
            61,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            65,
            114,
            103,
            44,
            32,
            97,
            97,
            44,
            32,
            98,
            97,
            44,
            32,
            101,
            97,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            80,
            114,
            111,
            109,
            105,
            115,
            101,
            40,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            97,
            32,
            61,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            97,
            32,
            61,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            44,
            32,
            102,
            97,
            32,
            61,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            97,
            115,
            115,
            105,
            103,
            110,
            40,
            123,
            125,
            44,
            32,
            107,
            41,
            44,
            32,
            104,
            97,
            32,
            61,
            32,
            34,
            46,
            47,
            116,
            104,
            105,
            115,
            46,
            112,
            114,
            111,
            103,
            114,
            97,
            109,
            34,
            44,
            32,
            112,
            32,
            61,
            32,
            34,
            34,
            44,
            32,
            105,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            117,
            110,
            100,
            101,
            102,
            105,
            110,
            101,
            100,
            34,
            32,
            33,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            100,
            111,
            99,
            117,
            109,
            101,
            110,
            116,
            32,
            38,
            38,
            32,
            100,
            111,
            99,
            117,
            109,
            101,
            110,
            116,
            46,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            83,
            99,
            114,
            105,
            112,
            116,
            32,
            38,
            38,
            32,
            40,
            112,
            32,
            61,
            32,
            100,
            111,
            99,
            117,
            109,
            101,
            110,
            116,
            46,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            83,
            99,
            114,
            105,
            112,
            116,
            46,
            115,
            114,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            115,
            99,
            114,
            105,
            112,
            116,
            78,
            97,
            109,
            101,
            32,
            38,
            38,
            32,
            40,
            112,
            32,
            61,
            32,
            95,
            115,
            99,
            114,
            105,
            112,
            116,
            78,
            97,
            109,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            112,
            46,
            115,
            116,
            97,
            114,
            116,
            115,
            87,
            105,
            116,
            104,
            40,
            34,
            98,
            108,
            111,
            98,
            58,
            34,
            41,
            32,
            63,
            32,
            112,
            32,
            61,
            32,
            34,
            34,
            32,
            58,
            32,
            112,
            32,
            61,
            32,
            112,
            46,
            115,
            117,
            98,
            115,
            116,
            114,
            40,
            48,
            44,
            32,
            112,
            46,
            114,
            101,
            112,
            108,
            97,
            99,
            101,
            40,
            47,
            91,
            63,
            35,
            93,
            46,
            42,
            47,
            44,
            32,
            34,
            34,
            41,
            46,
            108,
            97,
            115,
            116,
            73,
            110,
            100,
            101,
            120,
            79,
            102,
            40,
            34,
            47,
            34,
            41,
            32,
            43,
            32,
            49,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            97,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            102,
            101,
            116,
            99,
            104,
            40,
            97,
            44,
            32,
            123,
            32,
            99,
            114,
            101,
            100,
            101,
            110,
            116,
            105,
            97,
            108,
            115,
            58,
            32,
            34,
            115,
            97,
            109,
            101,
            45,
            111,
            114,
            105,
            103,
            105,
            110,
            34,
            32,
            125,
            41,
            46,
            116,
            104,
            101,
            110,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            40,
            98,
            41,
            32,
            61,
            62,
            32,
            98,
            46,
            111,
            107,
            32,
            63,
            32,
            98,
            46,
            97,
            114,
            114,
            97,
            121,
            66,
            117,
            102,
            102,
            101,
            114,
            40,
            41,
            32,
            58,
            32,
            80,
            114,
            111,
            109,
            105,
            115,
            101,
            46,
            114,
            101,
            106,
            101,
            99,
            116,
            40,
            69,
            114,
            114,
            111,
            114,
            40,
            98,
            46,
            115,
            116,
            97,
            116,
            117,
            115,
            32,
            43,
            32,
            34,
            32,
            58,
            32,
            34,
            32,
            43,
            32,
            98,
            46,
            117,
            114,
            108,
            41,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            116,
            32,
            61,
            32,
            107,
            46,
            112,
            114,
            105,
            110,
            116,
            69,
            114,
            114,
            32,
            124,
            124,
            32,
            99,
            111,
            110,
            115,
            111,
            108,
            101,
            46,
            101,
            114,
            114,
            111,
            114,
            46,
            98,
            105,
            110,
            100,
            40,
            99,
            111,
            110,
            115,
            111,
            108,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            97,
            115,
            115,
            105,
            103,
            110,
            40,
            107,
            44,
            32,
            102,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            97,
            32,
            61,
            32,
            110,
            117,
            108,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            116,
            104,
            105,
            115,
            80,
            114,
            111,
            103,
            114,
            97,
            109,
            32,
            38,
            38,
            32,
            40,
            104,
            97,
            32,
            61,
            32,
            107,
            46,
            116,
            104,
            105,
            115,
            80,
            114,
            111,
            103,
            114,
            97,
            109,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            106,
            97,
            32,
            61,
            32,
            107,
            46,
            119,
            97,
            115,
            109,
            66,
            105,
            110,
            97,
            114,
            121,
            44,
            32,
            107,
            97,
            44,
            32,
            108,
            97,
            32,
            61,
            32,
            102,
            97,
            108,
            115,
            101,
            44,
            32,
            109,
            97,
            44,
            32,
            119,
            44,
            32,
            120,
            44,
            32,
            121,
            44,
            32,
            122,
            44,
            32,
            67,
            44,
            32,
            68,
            44,
            32,
            110,
            97,
            44,
            32,
            111,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            112,
            97,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            97,
            32,
            61,
            32,
            107,
            97,
            46,
            98,
            117,
            102,
            102,
            101,
            114,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            72,
            69,
            65,
            80,
            56,
            32,
            61,
            32,
            119,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            73,
            110,
            116,
            56,
            65,
            114,
            114,
            97,
            121,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            72,
            69,
            65,
            80,
            49,
            54,
            32,
            61,
            32,
            121,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            73,
            110,
            116,
            49,
            54,
            65,
            114,
            114,
            97,
            121,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            72,
            69,
            65,
            80,
            85,
            56,
            32,
            61,
            32,
            120,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            85,
            105,
            110,
            116,
            56,
            65,
            114,
            114,
            97,
            121,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            72,
            69,
            65,
            80,
            85,
            49,
            54,
            32,
            61,
            32,
            122,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            85,
            105,
            110,
            116,
            49,
            54,
            65,
            114,
            114,
            97,
            121,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            72,
            69,
            65,
            80,
            51,
            50,
            32,
            61,
            32,
            67,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            73,
            110,
            116,
            51,
            50,
            65,
            114,
            114,
            97,
            121,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            72,
            69,
            65,
            80,
            85,
            51,
            50,
            32,
            61,
            32,
            68,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            85,
            105,
            110,
            116,
            51,
            50,
            65,
            114,
            114,
            97,
            121,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            72,
            69,
            65,
            80,
            70,
            51,
            50,
            32,
            61,
            32,
            110,
            97,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            70,
            108,
            111,
            97,
            116,
            51,
            50,
            65,
            114,
            114,
            97,
            121,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            72,
            69,
            65,
            80,
            70,
            54,
            52,
            32,
            61,
            32,
            111,
            97,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            70,
            108,
            111,
            97,
            116,
            54,
            52,
            65,
            114,
            114,
            97,
            121,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            113,
            97,
            32,
            61,
            32,
            91,
            93,
            44,
            32,
            114,
            97,
            32,
            61,
            32,
            91,
            93,
            44,
            32,
            115,
            97,
            32,
            61,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            116,
            97,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            97,
            32,
            61,
            32,
            107,
            46,
            112,
            114,
            101,
            82,
            117,
            110,
            46,
            115,
            104,
            105,
            102,
            116,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            113,
            97,
            46,
            117,
            110,
            115,
            104,
            105,
            102,
            116,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            70,
            32,
            61,
            32,
            48,
            44,
            32,
            117,
            97,
            32,
            61,
            32,
            110,
            117,
            108,
            108,
            44,
            32,
            71,
            32,
            61,
            32,
            110,
            117,
            108,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            118,
            97,
            40,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            50,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            40,
            95,
            97,
            50,
            32,
            61,
            32,
            107,
            46,
            111,
            110,
            65,
            98,
            111,
            114,
            116,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            50,
            46,
            99,
            97,
            108,
            108,
            40,
            107,
            44,
            32,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            32,
            61,
            32,
            34,
            65,
            98,
            111,
            114,
            116,
            101,
            100,
            40,
            34,
            32,
            43,
            32,
            97,
            32,
            43,
            32,
            34,
            41,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            97,
            32,
            61,
            32,
            116,
            114,
            117,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            87,
            101,
            98,
            65,
            115,
            115,
            101,
            109,
            98,
            108,
            121,
            46,
            82,
            117,
            110,
            116,
            105,
            109,
            101,
            69,
            114,
            114,
            111,
            114,
            40,
            97,
            32,
            43,
            32,
            34,
            46,
            32,
            66,
            117,
            105,
            108,
            100,
            32,
            119,
            105,
            116,
            104,
            32,
            45,
            115,
            65,
            83,
            83,
            69,
            82,
            84,
            73,
            79,
            78,
            83,
            32,
            102,
            111,
            114,
            32,
            109,
            111,
            114,
            101,
            32,
            105,
            110,
            102,
            111,
            46,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            97,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            119,
            97,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            97,
            46,
            115,
            116,
            97,
            114,
            116,
            115,
            87,
            105,
            116,
            104,
            40,
            34,
            100,
            97,
            116,
            97,
            58,
            97,
            112,
            112,
            108,
            105,
            99,
            97,
            116,
            105,
            111,
            110,
            47,
            111,
            99,
            116,
            101,
            116,
            45,
            115,
            116,
            114,
            101,
            97,
            109,
            59,
            98,
            97,
            115,
            101,
            54,
            52,
            44,
            34,
            41,
            44,
            32,
            120,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            121,
            97,
            40,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            97,
            32,
            61,
            61,
            32,
            120,
            97,
            32,
            38,
            38,
            32,
            106,
            97,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            110,
            101,
            119,
            32,
            85,
            105,
            110,
            116,
            56,
            65,
            114,
            114,
            97,
            121,
            40,
            106,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            34,
            98,
            111,
            116,
            104,
            32,
            97,
            115,
            121,
            110,
            99,
            32,
            97,
            110,
            100,
            32,
            115,
            121,
            110,
            99,
            32,
            102,
            101,
            116,
            99,
            104,
            105,
            110,
            103,
            32,
            111,
            102,
            32,
            116,
            104,
            101,
            32,
            119,
            97,
            115,
            109,
            32,
            102,
            97,
            105,
            108,
            101,
            100,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            122,
            97,
            40,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            106,
            97,
            32,
            63,
            32,
            80,
            114,
            111,
            109,
            105,
            115,
            101,
            46,
            114,
            101,
            115,
            111,
            108,
            118,
            101,
            40,
            41,
            46,
            116,
            104,
            101,
            110,
            40,
            40,
            41,
            32,
            61,
            62,
            32,
            121,
            97,
            40,
            97,
            41,
            41,
            32,
            58,
            32,
            105,
            97,
            40,
            97,
            41,
            46,
            116,
            104,
            101,
            110,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            40,
            98,
            41,
            32,
            61,
            62,
            32,
            110,
            101,
            119,
            32,
            85,
            105,
            110,
            116,
            56,
            65,
            114,
            114,
            97,
            121,
            40,
            98,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            121,
            97,
            40,
            97,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            65,
            97,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            122,
            97,
            40,
            97,
            41,
            46,
            116,
            104,
            101,
            110,
            40,
            40,
            100,
            41,
            32,
            61,
            62,
            32,
            87,
            101,
            98,
            65,
            115,
            115,
            101,
            109,
            98,
            108,
            121,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            116,
            105,
            97,
            116,
            101,
            40,
            100,
            44,
            32,
            98,
            41,
            41,
            46,
            116,
            104,
            101,
            110,
            40,
            99,
            44,
            32,
            40,
            100,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            40,
            96,
            102,
            97,
            105,
            108,
            101,
            100,
            32,
            116,
            111,
            32,
            97,
            115,
            121,
            110,
            99,
            104,
            114,
            111,
            110,
            111,
            117,
            115,
            108,
            121,
            32,
            112,
            114,
            101,
            112,
            97,
            114,
            101,
            32,
            119,
            97,
            115,
            109,
            58,
            32,
            36,
            123,
            100,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            40,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            66,
            97,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            120,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            106,
            97,
            32,
            124,
            124,
            32,
            34,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            34,
            32,
            33,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            87,
            101,
            98,
            65,
            115,
            115,
            101,
            109,
            98,
            108,
            121,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            116,
            105,
            97,
            116,
            101,
            83,
            116,
            114,
            101,
            97,
            109,
            105,
            110,
            103,
            32,
            124,
            124,
            32,
            119,
            97,
            40,
            99,
            41,
            32,
            124,
            124,
            32,
            34,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            34,
            32,
            33,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            102,
            101,
            116,
            99,
            104,
            32,
            63,
            32,
            65,
            97,
            40,
            99,
            44,
            32,
            97,
            44,
            32,
            98,
            41,
            32,
            58,
            32,
            102,
            101,
            116,
            99,
            104,
            40,
            99,
            44,
            32,
            123,
            32,
            99,
            114,
            101,
            100,
            101,
            110,
            116,
            105,
            97,
            108,
            115,
            58,
            32,
            34,
            115,
            97,
            109,
            101,
            45,
            111,
            114,
            105,
            103,
            105,
            110,
            34,
            32,
            125,
            41,
            46,
            116,
            104,
            101,
            110,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            40,
            100,
            41,
            32,
            61,
            62,
            32,
            87,
            101,
            98,
            65,
            115,
            115,
            101,
            109,
            98,
            108,
            121,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            116,
            105,
            97,
            116,
            101,
            83,
            116,
            114,
            101,
            97,
            109,
            105,
            110,
            103,
            40,
            100,
            44,
            32,
            97,
            41,
            46,
            116,
            104,
            101,
            110,
            40,
            98,
            44,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            40,
            96,
            119,
            97,
            115,
            109,
            32,
            115,
            116,
            114,
            101,
            97,
            109,
            105,
            110,
            103,
            32,
            99,
            111,
            109,
            112,
            105,
            108,
            101,
            32,
            102,
            97,
            105,
            108,
            101,
            100,
            58,
            32,
            36,
            123,
            101,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            40,
            34,
            102,
            97,
            108,
            108,
            105,
            110,
            103,
            32,
            98,
            97,
            99,
            107,
            32,
            116,
            111,
            32,
            65,
            114,
            114,
            97,
            121,
            66,
            117,
            102,
            102,
            101,
            114,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            116,
            105,
            97,
            116,
            105,
            111,
            110,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            65,
            97,
            40,
            99,
            44,
            32,
            97,
            44,
            32,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            108,
            97,
            115,
            115,
            32,
            67,
            97,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            40,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            110,
            97,
            109,
            101,
            34,
            44,
            32,
            34,
            69,
            120,
            105,
            116,
            83,
            116,
            97,
            116,
            117,
            115,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            109,
            101,
            115,
            115,
            97,
            103,
            101,
            32,
            61,
            32,
            96,
            80,
            114,
            111,
            103,
            114,
            97,
            109,
            32,
            116,
            101,
            114,
            109,
            105,
            110,
            97,
            116,
            101,
            100,
            32,
            119,
            105,
            116,
            104,
            32,
            101,
            120,
            105,
            116,
            40,
            36,
            123,
            97,
            125,
            41,
            96,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            115,
            116,
            97,
            116,
            117,
            115,
            32,
            61,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            68,
            97,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            59,
            32,
            48,
            32,
            60,
            32,
            97,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            32,
            41,
            32,
            97,
            46,
            115,
            104,
            105,
            102,
            116,
            40,
            41,
            40,
            107,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            69,
            97,
            32,
            61,
            32,
            107,
            46,
            110,
            111,
            69,
            120,
            105,
            116,
            82,
            117,
            110,
            116,
            105,
            109,
            101,
            32,
            124,
            124,
            32,
            116,
            114,
            117,
            101,
            44,
            32,
            70,
            97,
            32,
            61,
            32,
            34,
            117,
            110,
            100,
            101,
            102,
            105,
            110,
            101,
            100,
            34,
            32,
            33,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            84,
            101,
            120,
            116,
            68,
            101,
            99,
            111,
            100,
            101,
            114,
            32,
            63,
            32,
            110,
            101,
            119,
            32,
            84,
            101,
            120,
            116,
            68,
            101,
            99,
            111,
            100,
            101,
            114,
            40,
            41,
            32,
            58,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            44,
            32,
            71,
            97,
            32,
            61,
            32,
            40,
            97,
            32,
            61,
            32,
            48,
            44,
            32,
            98,
            32,
            61,
            32,
            78,
            97,
            78,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            120,
            44,
            32,
            100,
            32,
            61,
            32,
            97,
            32,
            43,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            98,
            32,
            61,
            32,
            97,
            59,
            32,
            99,
            91,
            98,
            93,
            32,
            38,
            38,
            32,
            33,
            40,
            98,
            32,
            62,
            61,
            32,
            100,
            41,
            59,
            32,
            41,
            32,
            43,
            43,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            49,
            54,
            32,
            60,
            32,
            98,
            32,
            45,
            32,
            97,
            32,
            38,
            38,
            32,
            99,
            46,
            98,
            117,
            102,
            102,
            101,
            114,
            32,
            38,
            38,
            32,
            70,
            97,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            70,
            97,
            46,
            100,
            101,
            99,
            111,
            100,
            101,
            40,
            99,
            46,
            115,
            117,
            98,
            97,
            114,
            114,
            97,
            121,
            40,
            97,
            44,
            32,
            98,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            100,
            32,
            61,
            32,
            34,
            34,
            59,
            32,
            97,
            32,
            60,
            32,
            98,
            59,
            32,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            101,
            32,
            61,
            32,
            99,
            91,
            97,
            43,
            43,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            101,
            32,
            38,
            32,
            49,
            50,
            56,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            102,
            32,
            61,
            32,
            99,
            91,
            97,
            43,
            43,
            93,
            32,
            38,
            32,
            54,
            51,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            49,
            57,
            50,
            32,
            61,
            61,
            32,
            40,
            101,
            32,
            38,
            32,
            50,
            50,
            52,
            41,
            41,
            32,
            100,
            32,
            43,
            61,
            32,
            83,
            116,
            114,
            105,
            110,
            103,
            46,
            102,
            114,
            111,
            109,
            67,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            40,
            40,
            101,
            32,
            38,
            32,
            51,
            49,
            41,
            32,
            60,
            60,
            32,
            54,
            32,
            124,
            32,
            102,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            104,
            32,
            61,
            32,
            99,
            91,
            97,
            43,
            43,
            93,
            32,
            38,
            32,
            54,
            51,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            32,
            61,
            32,
            50,
            50,
            52,
            32,
            61,
            61,
            32,
            40,
            101,
            32,
            38,
            32,
            50,
            52,
            48,
            41,
            32,
            63,
            32,
            40,
            101,
            32,
            38,
            32,
            49,
            53,
            41,
            32,
            60,
            60,
            32,
            49,
            50,
            32,
            124,
            32,
            102,
            32,
            60,
            60,
            32,
            54,
            32,
            124,
            32,
            104,
            32,
            58,
            32,
            40,
            101,
            32,
            38,
            32,
            55,
            41,
            32,
            60,
            60,
            32,
            49,
            56,
            32,
            124,
            32,
            102,
            32,
            60,
            60,
            32,
            49,
            50,
            32,
            124,
            32,
            104,
            32,
            60,
            60,
            32,
            54,
            32,
            124,
            32,
            99,
            91,
            97,
            43,
            43,
            93,
            32,
            38,
            32,
            54,
            51,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            54,
            53,
            53,
            51,
            54,
            32,
            62,
            32,
            101,
            32,
            63,
            32,
            100,
            32,
            43,
            61,
            32,
            83,
            116,
            114,
            105,
            110,
            103,
            46,
            102,
            114,
            111,
            109,
            67,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            40,
            101,
            41,
            32,
            58,
            32,
            40,
            101,
            32,
            45,
            61,
            32,
            54,
            53,
            53,
            51,
            54,
            44,
            32,
            100,
            32,
            43,
            61,
            32,
            83,
            116,
            114,
            105,
            110,
            103,
            46,
            102,
            114,
            111,
            109,
            67,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            40,
            53,
            53,
            50,
            57,
            54,
            32,
            124,
            32,
            101,
            32,
            62,
            62,
            32,
            49,
            48,
            44,
            32,
            53,
            54,
            51,
            50,
            48,
            32,
            124,
            32,
            101,
            32,
            38,
            32,
            49,
            48,
            50,
            51,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            100,
            32,
            43,
            61,
            32,
            83,
            116,
            114,
            105,
            110,
            103,
            46,
            102,
            114,
            111,
            109,
            67,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            40,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            108,
            97,
            115,
            115,
            32,
            72,
            97,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            40,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            118,
            97,
            32,
            61,
            32,
            97,
            32,
            45,
            32,
            50,
            52,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            73,
            97,
            32,
            61,
            32,
            48,
            44,
            32,
            74,
            97,
            32,
            61,
            32,
            48,
            44,
            32,
            72,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            120,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            48,
            32,
            60,
            32,
            99,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            32,
            61,
            32,
            98,
            32,
            43,
            32,
            99,
            32,
            45,
            32,
            49,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            101,
            32,
            61,
            32,
            48,
            59,
            32,
            101,
            32,
            60,
            32,
            97,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            32,
            43,
            43,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            102,
            32,
            61,
            32,
            97,
            46,
            99,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            65,
            116,
            40,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            53,
            53,
            50,
            57,
            54,
            32,
            60,
            61,
            32,
            102,
            32,
            38,
            38,
            32,
            53,
            55,
            51,
            52,
            51,
            32,
            62,
            61,
            32,
            102,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            104,
            32,
            61,
            32,
            97,
            46,
            99,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            65,
            116,
            40,
            43,
            43,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            32,
            61,
            32,
            54,
            53,
            53,
            51,
            54,
            32,
            43,
            32,
            40,
            40,
            102,
            32,
            38,
            32,
            49,
            48,
            50,
            51,
            41,
            32,
            60,
            60,
            32,
            49,
            48,
            41,
            32,
            124,
            32,
            104,
            32,
            38,
            32,
            49,
            48,
            50,
            51,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            49,
            50,
            55,
            32,
            62,
            61,
            32,
            102,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            98,
            32,
            62,
            61,
            32,
            99,
            41,
            32,
            98,
            114,
            101,
            97,
            107,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            91,
            98,
            43,
            43,
            93,
            32,
            61,
            32,
            102,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            50,
            48,
            52,
            55,
            32,
            62,
            61,
            32,
            102,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            98,
            32,
            43,
            32,
            49,
            32,
            62,
            61,
            32,
            99,
            41,
            32,
            98,
            114,
            101,
            97,
            107,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            91,
            98,
            43,
            43,
            93,
            32,
            61,
            32,
            49,
            57,
            50,
            32,
            124,
            32,
            102,
            32,
            62,
            62,
            32,
            54,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            54,
            53,
            53,
            51,
            53,
            32,
            62,
            61,
            32,
            102,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            98,
            32,
            43,
            32,
            50,
            32,
            62,
            61,
            32,
            99,
            41,
            32,
            98,
            114,
            101,
            97,
            107,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            91,
            98,
            43,
            43,
            93,
            32,
            61,
            32,
            50,
            50,
            52,
            32,
            124,
            32,
            102,
            32,
            62,
            62,
            32,
            49,
            50,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            98,
            32,
            43,
            32,
            51,
            32,
            62,
            61,
            32,
            99,
            41,
            32,
            98,
            114,
            101,
            97,
            107,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            91,
            98,
            43,
            43,
            93,
            32,
            61,
            32,
            50,
            52,
            48,
            32,
            124,
            32,
            102,
            32,
            62,
            62,
            32,
            49,
            56,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            91,
            98,
            43,
            43,
            93,
            32,
            61,
            32,
            49,
            50,
            56,
            32,
            124,
            32,
            102,
            32,
            62,
            62,
            32,
            49,
            50,
            32,
            38,
            32,
            54,
            51,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            91,
            98,
            43,
            43,
            93,
            32,
            61,
            32,
            49,
            50,
            56,
            32,
            124,
            32,
            102,
            32,
            62,
            62,
            32,
            54,
            32,
            38,
            32,
            54,
            51,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            91,
            98,
            43,
            43,
            93,
            32,
            61,
            32,
            49,
            50,
            56,
            32,
            124,
            32,
            102,
            32,
            38,
            32,
            54,
            51,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            91,
            98,
            93,
            32,
            61,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            75,
            97,
            32,
            61,
            32,
            123,
            125,
            44,
            32,
            76,
            97,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            59,
            32,
            97,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            32,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            98,
            32,
            61,
            32,
            97,
            46,
            112,
            111,
            112,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            46,
            112,
            111,
            112,
            40,
            41,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            73,
            40,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            40,
            68,
            91,
            97,
            32,
            62,
            62,
            32,
            50,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            74,
            32,
            61,
            32,
            123,
            125,
            44,
            32,
            75,
            32,
            61,
            32,
            123,
            125,
            44,
            32,
            77,
            97,
            32,
            61,
            32,
            123,
            125,
            44,
            32,
            76,
            44,
            32,
            78,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            100,
            40,
            103,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            103,
            32,
            61,
            32,
            99,
            40,
            103,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            103,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            32,
            33,
            61,
            61,
            32,
            97,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            76,
            40,
            34,
            77,
            105,
            115,
            109,
            97,
            116,
            99,
            104,
            101,
            100,
            32,
            116,
            121,
            112,
            101,
            32,
            99,
            111,
            110,
            118,
            101,
            114,
            116,
            101,
            114,
            32,
            99,
            111,
            117,
            110,
            116,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            108,
            32,
            61,
            32,
            48,
            59,
            32,
            108,
            32,
            60,
            32,
            97,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            32,
            43,
            43,
            108,
            41,
            32,
            77,
            40,
            97,
            91,
            108,
            93,
            44,
            32,
            103,
            91,
            108,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            46,
            102,
            111,
            114,
            69,
            97,
            99,
            104,
            40,
            40,
            103,
            41,
            32,
            61,
            62,
            32,
            77,
            97,
            91,
            103,
            93,
            32,
            61,
            32,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            101,
            32,
            61,
            32,
            65,
            114,
            114,
            97,
            121,
            40,
            98,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            41,
            44,
            32,
            102,
            32,
            61,
            32,
            91,
            93,
            44,
            32,
            104,
            32,
            61,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            46,
            102,
            111,
            114,
            69,
            97,
            99,
            104,
            40,
            40,
            103,
            44,
            32,
            108,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            75,
            46,
            104,
            97,
            115,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            101,
            114,
            116,
            121,
            40,
            103,
            41,
            32,
            63,
            32,
            101,
            91,
            108,
            93,
            32,
            61,
            32,
            75,
            91,
            103,
            93,
            32,
            58,
            32,
            40,
            102,
            46,
            112,
            117,
            115,
            104,
            40,
            103,
            41,
            44,
            32,
            74,
            46,
            104,
            97,
            115,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            101,
            114,
            116,
            121,
            40,
            103,
            41,
            32,
            124,
            124,
            32,
            40,
            74,
            91,
            103,
            93,
            32,
            61,
            32,
            91,
            93,
            41,
            44,
            32,
            74,
            91,
            103,
            93,
            46,
            112,
            117,
            115,
            104,
            40,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            91,
            108,
            93,
            32,
            61,
            32,
            75,
            91,
            103,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            43,
            43,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            104,
            32,
            61,
            61,
            61,
            32,
            102,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            32,
            38,
            38,
            32,
            100,
            40,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            102,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            32,
            38,
            38,
            32,
            100,
            40,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            78,
            97,
            44,
            32,
            79,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            98,
            32,
            61,
            32,
            34,
            34,
            59,
            32,
            120,
            91,
            97,
            93,
            59,
            32,
            41,
            32,
            98,
            32,
            43,
            61,
            32,
            78,
            97,
            91,
            120,
            91,
            97,
            43,
            43,
            93,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            80,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            80,
            97,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            32,
            61,
            32,
            123,
            125,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            98,
            46,
            110,
            97,
            109,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            96,
            116,
            121,
            112,
            101,
            32,
            34,
            36,
            123,
            100,
            125,
            34,
            32,
            109,
            117,
            115,
            116,
            32,
            104,
            97,
            118,
            101,
            32,
            97,
            32,
            112,
            111,
            115,
            105,
            116,
            105,
            118,
            101,
            32,
            105,
            110,
            116,
            101,
            103,
            101,
            114,
            32,
            116,
            121,
            112,
            101,
            105,
            100,
            32,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            75,
            46,
            104,
            97,
            115,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            101,
            114,
            116,
            121,
            40,
            97,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            99,
            46,
            36,
            97,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            114,
            101,
            103,
            105,
            115,
            116,
            101,
            114,
            32,
            116,
            121,
            112,
            101,
            32,
            39,
            36,
            123,
            100,
            125,
            39,
            32,
            116,
            119,
            105,
            99,
            101,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            75,
            91,
            97,
            93,
            32,
            61,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            101,
            108,
            101,
            116,
            101,
            32,
            77,
            97,
            91,
            97,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            74,
            46,
            104,
            97,
            115,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            101,
            114,
            116,
            121,
            40,
            97,
            41,
            32,
            38,
            38,
            32,
            40,
            98,
            32,
            61,
            32,
            74,
            91,
            97,
            93,
            44,
            32,
            100,
            101,
            108,
            101,
            116,
            101,
            32,
            74,
            91,
            97,
            93,
            44,
            32,
            98,
            46,
            102,
            111,
            114,
            69,
            97,
            99,
            104,
            40,
            40,
            101,
            41,
            32,
            61,
            62,
            32,
            101,
            40,
            41,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            77,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            32,
            61,
            32,
            123,
            125,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            80,
            97,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            81,
            97,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            97,
            46,
            116,
            97,
            46,
            119,
            97,
            46,
            117,
            97,
            46,
            110,
            97,
            109,
            101,
            32,
            43,
            32,
            34,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            97,
            108,
            114,
            101,
            97,
            100,
            121,
            32,
            100,
            101,
            108,
            101,
            116,
            101,
            100,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            82,
            97,
            32,
            61,
            32,
            102,
            97,
            108,
            115,
            101,
            44,
            32,
            83,
            97,
            32,
            61,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            84,
            97,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            98,
            32,
            61,
            61,
            61,
            32,
            99,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            99,
            46,
            122,
            97,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            110,
            117,
            108,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            32,
            61,
            32,
            84,
            97,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            46,
            122,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            110,
            117,
            108,
            108,
            32,
            61,
            61,
            61,
            32,
            97,
            32,
            63,
            32,
            110,
            117,
            108,
            108,
            32,
            58,
            32,
            99,
            46,
            84,
            97,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            85,
            97,
            32,
            61,
            32,
            123,
            125,
            44,
            32,
            86,
            97,
            32,
            61,
            32,
            123,
            125,
            44,
            32,
            87,
            97,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            98,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            34,
            112,
            116,
            114,
            32,
            115,
            104,
            111,
            117,
            108,
            100,
            32,
            110,
            111,
            116,
            32,
            98,
            101,
            32,
            117,
            110,
            100,
            101,
            102,
            105,
            110,
            101,
            100,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            59,
            32,
            97,
            46,
            122,
            97,
            59,
            32,
            41,
            32,
            98,
            32,
            61,
            32,
            97,
            46,
            74,
            97,
            40,
            98,
            41,
            44,
            32,
            97,
            32,
            61,
            32,
            97,
            46,
            122,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            86,
            97,
            91,
            98,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            88,
            97,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            98,
            46,
            119,
            97,
            32,
            124,
            124,
            32,
            33,
            98,
            46,
            118,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            76,
            40,
            34,
            109,
            97,
            107,
            101,
            67,
            108,
            97,
            115,
            115,
            72,
            97,
            110,
            100,
            108,
            101,
            32,
            114,
            101,
            113,
            117,
            105,
            114,
            101,
            115,
            32,
            112,
            116,
            114,
            32,
            97,
            110,
            100,
            32,
            112,
            116,
            114,
            84,
            121,
            112,
            101,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            33,
            98,
            46,
            65,
            97,
            32,
            33,
            61,
            61,
            32,
            33,
            33,
            98,
            46,
            121,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            76,
            40,
            34,
            66,
            111,
            116,
            104,
            32,
            115,
            109,
            97,
            114,
            116,
            80,
            116,
            114,
            84,
            121,
            112,
            101,
            32,
            97,
            110,
            100,
            32,
            115,
            109,
            97,
            114,
            116,
            80,
            116,
            114,
            32,
            109,
            117,
            115,
            116,
            32,
            98,
            101,
            32,
            115,
            112,
            101,
            99,
            105,
            102,
            105,
            101,
            100,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            46,
            99,
            111,
            117,
            110,
            116,
            32,
            61,
            32,
            123,
            32,
            118,
            97,
            108,
            117,
            101,
            58,
            32,
            49,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            81,
            40,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            99,
            114,
            101,
            97,
            116,
            101,
            40,
            97,
            44,
            32,
            123,
            32,
            116,
            97,
            58,
            32,
            123,
            32,
            118,
            97,
            108,
            117,
            101,
            58,
            32,
            98,
            44,
            32,
            119,
            114,
            105,
            116,
            97,
            98,
            108,
            101,
            58,
            32,
            116,
            114,
            117,
            101,
            32,
            125,
            32,
            125,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            81,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            34,
            117,
            110,
            100,
            101,
            102,
            105,
            110,
            101,
            100,
            34,
            32,
            61,
            61,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            70,
            105,
            110,
            97,
            108,
            105,
            122,
            97,
            116,
            105,
            111,
            110,
            82,
            101,
            103,
            105,
            115,
            116,
            114,
            121,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            81,
            32,
            61,
            32,
            40,
            98,
            41,
            32,
            61,
            62,
            32,
            98,
            44,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            82,
            97,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            70,
            105,
            110,
            97,
            108,
            105,
            122,
            97,
            116,
            105,
            111,
            110,
            82,
            101,
            103,
            105,
            115,
            116,
            114,
            121,
            40,
            40,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            61,
            32,
            98,
            46,
            116,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            45,
            45,
            98,
            46,
            99,
            111,
            117,
            110,
            116,
            46,
            118,
            97,
            108,
            117,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            98,
            46,
            99,
            111,
            117,
            110,
            116,
            46,
            118,
            97,
            108,
            117,
            101,
            32,
            38,
            38,
            32,
            40,
            98,
            46,
            121,
            97,
            32,
            63,
            32,
            98,
            46,
            65,
            97,
            46,
            68,
            97,
            40,
            98,
            46,
            121,
            97,
            41,
            32,
            58,
            32,
            98,
            46,
            119,
            97,
            46,
            117,
            97,
            46,
            68,
            97,
            40,
            98,
            46,
            118,
            97,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            81,
            32,
            61,
            32,
            40,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            98,
            46,
            116,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            46,
            121,
            97,
            32,
            38,
            38,
            32,
            82,
            97,
            46,
            114,
            101,
            103,
            105,
            115,
            116,
            101,
            114,
            40,
            98,
            44,
            32,
            123,
            32,
            116,
            97,
            58,
            32,
            99,
            32,
            125,
            44,
            32,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            83,
            97,
            32,
            61,
            32,
            40,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            82,
            97,
            46,
            117,
            110,
            114,
            101,
            103,
            105,
            115,
            116,
            101,
            114,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            81,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            89,
            97,
            32,
            61,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            90,
            97,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            82,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            100,
            101,
            102,
            105,
            110,
            101,
            80,
            114,
            111,
            112,
            101,
            114,
            116,
            121,
            40,
            98,
            44,
            32,
            34,
            110,
            97,
            109,
            101,
            34,
            44,
            32,
            123,
            32,
            118,
            97,
            108,
            117,
            101,
            58,
            32,
            97,
            32,
            125,
            41,
            44,
            32,
            36,
            97,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            97,
            91,
            98,
            93,
            46,
            120,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            97,
            91,
            98,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            91,
            98,
            93,
            32,
            61,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            46,
            46,
            46,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            97,
            91,
            98,
            93,
            46,
            120,
            97,
            46,
            104,
            97,
            115,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            101,
            114,
            116,
            121,
            40,
            101,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            41,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            96,
            70,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            39,
            36,
            123,
            99,
            125,
            39,
            32,
            99,
            97,
            108,
            108,
            101,
            100,
            32,
            119,
            105,
            116,
            104,
            32,
            97,
            110,
            32,
            105,
            110,
            118,
            97,
            108,
            105,
            100,
            32,
            110,
            117,
            109,
            98,
            101,
            114,
            32,
            111,
            102,
            32,
            97,
            114,
            103,
            117,
            109,
            101,
            110,
            116,
            115,
            32,
            40,
            36,
            123,
            101,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            125,
            41,
            32,
            45,
            32,
            101,
            120,
            112,
            101,
            99,
            116,
            115,
            32,
            111,
            110,
            101,
            32,
            111,
            102,
            32,
            40,
            36,
            123,
            97,
            91,
            98,
            93,
            46,
            120,
            97,
            125,
            41,
            33,
            96,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            97,
            91,
            98,
            93,
            46,
            120,
            97,
            91,
            101,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            93,
            46,
            97,
            112,
            112,
            108,
            121,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            91,
            98,
            93,
            46,
            120,
            97,
            32,
            61,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            91,
            98,
            93,
            46,
            120,
            97,
            91,
            100,
            46,
            71,
            97,
            93,
            32,
            61,
            32,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            97,
            98,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            107,
            46,
            104,
            97,
            115,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            101,
            114,
            116,
            121,
            40,
            97,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            99,
            32,
            124,
            124,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            33,
            61,
            61,
            32,
            107,
            91,
            97,
            93,
            46,
            120,
            97,
            32,
            38,
            38,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            33,
            61,
            61,
            32,
            107,
            91,
            97,
            93,
            46,
            120,
            97,
            91,
            99,
            93,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            114,
            101,
            103,
            105,
            115,
            116,
            101,
            114,
            32,
            112,
            117,
            98,
            108,
            105,
            99,
            32,
            110,
            97,
            109,
            101,
            32,
            39,
            36,
            123,
            97,
            125,
            39,
            32,
            116,
            119,
            105,
            99,
            101,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            36,
            97,
            40,
            107,
            44,
            32,
            97,
            44,
            32,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            107,
            91,
            97,
            93,
            46,
            120,
            97,
            46,
            104,
            97,
            115,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            101,
            114,
            116,
            121,
            40,
            99,
            41,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            114,
            101,
            103,
            105,
            115,
            116,
            101,
            114,
            32,
            109,
            117,
            108,
            116,
            105,
            112,
            108,
            101,
            32,
            111,
            118,
            101,
            114,
            108,
            111,
            97,
            100,
            115,
            32,
            111,
            102,
            32,
            97,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            119,
            105,
            116,
            104,
            32,
            116,
            104,
            101,
            32,
            115,
            97,
            109,
            101,
            32,
            110,
            117,
            109,
            98,
            101,
            114,
            32,
            111,
            102,
            32,
            97,
            114,
            103,
            117,
            109,
            101,
            110,
            116,
            115,
            32,
            40,
            36,
            123,
            99,
            125,
            41,
            33,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            91,
            97,
            93,
            46,
            120,
            97,
            91,
            99,
            93,
            32,
            61,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            107,
            91,
            97,
            93,
            32,
            61,
            32,
            98,
            44,
            32,
            107,
            91,
            97,
            93,
            46,
            71,
            97,
            32,
            61,
            32,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            98,
            98,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            32,
            61,
            32,
            97,
            46,
            114,
            101,
            112,
            108,
            97,
            99,
            101,
            40,
            47,
            91,
            94,
            97,
            45,
            122,
            65,
            45,
            90,
            48,
            45,
            57,
            95,
            93,
            47,
            103,
            44,
            32,
            34,
            36,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            98,
            32,
            61,
            32,
            97,
            46,
            99,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            65,
            116,
            40,
            48,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            52,
            56,
            32,
            60,
            61,
            32,
            98,
            32,
            38,
            38,
            32,
            53,
            55,
            32,
            62,
            61,
            32,
            98,
            32,
            63,
            32,
            96,
            95,
            36,
            123,
            97,
            125,
            96,
            32,
            58,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            99,
            98,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            44,
            32,
            104,
            44,
            32,
            103,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            32,
            61,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            32,
            61,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            70,
            97,
            32,
            61,
            32,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            68,
            97,
            32,
            61,
            32,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            122,
            97,
            32,
            61,
            32,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            86,
            97,
            32,
            61,
            32,
            102,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            74,
            97,
            32,
            61,
            32,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            84,
            97,
            32,
            61,
            32,
            103,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            98,
            98,
            32,
            61,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            98,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            59,
            32,
            98,
            32,
            33,
            61,
            61,
            32,
            99,
            59,
            32,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            98,
            46,
            74,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            96,
            69,
            120,
            112,
            101,
            99,
            116,
            101,
            100,
            32,
            110,
            117,
            108,
            108,
            32,
            111,
            114,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            111,
            102,
            32,
            36,
            123,
            99,
            46,
            110,
            97,
            109,
            101,
            125,
            44,
            32,
            103,
            111,
            116,
            32,
            97,
            110,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            111,
            102,
            32,
            36,
            123,
            98,
            46,
            110,
            97,
            109,
            101,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            32,
            61,
            32,
            98,
            46,
            74,
            97,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            61,
            32,
            98,
            46,
            122,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            101,
            98,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            110,
            117,
            108,
            108,
            32,
            61,
            61,
            61,
            32,
            98,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            77,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            96,
            110,
            117,
            108,
            108,
            32,
            105,
            115,
            32,
            110,
            111,
            116,
            32,
            97,
            32,
            118,
            97,
            108,
            105,
            100,
            32,
            36,
            123,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            98,
            46,
            116,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            112,
            97,
            115,
            115,
            32,
            34,
            36,
            123,
            102,
            98,
            40,
            98,
            41,
            125,
            34,
            32,
            97,
            115,
            32,
            97,
            32,
            36,
            123,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            98,
            46,
            116,
            97,
            46,
            118,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            112,
            97,
            115,
            115,
            32,
            100,
            101,
            108,
            101,
            116,
            101,
            100,
            32,
            111,
            98,
            106,
            101,
            99,
            116,
            32,
            97,
            115,
            32,
            97,
            32,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            32,
            111,
            102,
            32,
            116,
            121,
            112,
            101,
            32,
            36,
            123,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            100,
            98,
            40,
            98,
            46,
            116,
            97,
            46,
            118,
            97,
            44,
            32,
            98,
            46,
            116,
            97,
            46,
            119,
            97,
            46,
            117,
            97,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            117,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            103,
            98,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            110,
            117,
            108,
            108,
            32,
            61,
            61,
            61,
            32,
            98,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            77,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            96,
            110,
            117,
            108,
            108,
            32,
            105,
            115,
            32,
            110,
            111,
            116,
            32,
            97,
            32,
            118,
            97,
            108,
            105,
            100,
            32,
            36,
            123,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            76,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            78,
            97,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            117,
            108,
            108,
            32,
            33,
            61,
            61,
            32,
            97,
            32,
            38,
            38,
            32,
            97,
            46,
            112,
            117,
            115,
            104,
            40,
            116,
            104,
            105,
            115,
            46,
            68,
            97,
            44,
            32,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            98,
            32,
            124,
            124,
            32,
            33,
            98,
            46,
            116,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            112,
            97,
            115,
            115,
            32,
            34,
            36,
            123,
            102,
            98,
            40,
            98,
            41,
            125,
            34,
            32,
            97,
            115,
            32,
            97,
            32,
            36,
            123,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            98,
            46,
            116,
            97,
            46,
            118,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            112,
            97,
            115,
            115,
            32,
            100,
            101,
            108,
            101,
            116,
            101,
            100,
            32,
            111,
            98,
            106,
            101,
            99,
            116,
            32,
            97,
            115,
            32,
            97,
            32,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            32,
            111,
            102,
            32,
            116,
            121,
            112,
            101,
            32,
            36,
            123,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            116,
            104,
            105,
            115,
            46,
            75,
            97,
            32,
            38,
            38,
            32,
            98,
            46,
            116,
            97,
            46,
            119,
            97,
            46,
            75,
            97,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            99,
            111,
            110,
            118,
            101,
            114,
            116,
            32,
            97,
            114,
            103,
            117,
            109,
            101,
            110,
            116,
            32,
            111,
            102,
            32,
            116,
            121,
            112,
            101,
            32,
            36,
            123,
            98,
            46,
            116,
            97,
            46,
            65,
            97,
            32,
            63,
            32,
            98,
            46,
            116,
            97,
            46,
            65,
            97,
            46,
            110,
            97,
            109,
            101,
            32,
            58,
            32,
            98,
            46,
            116,
            97,
            46,
            119,
            97,
            46,
            110,
            97,
            109,
            101,
            125,
            32,
            116,
            111,
            32,
            112,
            97,
            114,
            97,
            109,
            101,
            116,
            101,
            114,
            32,
            116,
            121,
            112,
            101,
            32,
            36,
            123,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            125,
            96,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            32,
            61,
            32,
            100,
            98,
            40,
            98,
            46,
            116,
            97,
            46,
            118,
            97,
            44,
            32,
            98,
            46,
            116,
            97,
            46,
            119,
            97,
            46,
            117,
            97,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            117,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            76,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            98,
            46,
            116,
            97,
            46,
            121,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            34,
            80,
            97,
            115,
            115,
            105,
            110,
            103,
            32,
            114,
            97,
            119,
            32,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            32,
            116,
            111,
            32,
            115,
            109,
            97,
            114,
            116,
            32,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            32,
            105,
            115,
            32,
            105,
            108,
            108,
            101,
            103,
            97,
            108,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            119,
            105,
            116,
            99,
            104,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            104,
            98,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            48,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            98,
            46,
            116,
            97,
            46,
            65,
            97,
            32,
            61,
            61,
            61,
            32,
            116,
            104,
            105,
            115,
            41,
            32,
            99,
            32,
            61,
            32,
            98,
            46,
            116,
            97,
            46,
            121,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            108,
            115,
            101,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            99,
            111,
            110,
            118,
            101,
            114,
            116,
            32,
            97,
            114,
            103,
            117,
            109,
            101,
            110,
            116,
            32,
            111,
            102,
            32,
            116,
            121,
            112,
            101,
            32,
            36,
            123,
            98,
            46,
            116,
            97,
            46,
            65,
            97,
            32,
            63,
            32,
            98,
            46,
            116,
            97,
            46,
            65,
            97,
            46,
            110,
            97,
            109,
            101,
            32,
            58,
            32,
            98,
            46,
            116,
            97,
            46,
            119,
            97,
            46,
            110,
            97,
            109,
            101,
            125,
            32,
            116,
            111,
            32,
            112,
            97,
            114,
            97,
            109,
            101,
            116,
            101,
            114,
            32,
            116,
            121,
            112,
            101,
            32,
            36,
            123,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            125,
            96,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            114,
            101,
            97,
            107,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            49,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            32,
            61,
            32,
            98,
            46,
            116,
            97,
            46,
            121,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            114,
            101,
            97,
            107,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            50,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            98,
            46,
            116,
            97,
            46,
            65,
            97,
            32,
            61,
            61,
            61,
            32,
            116,
            104,
            105,
            115,
            41,
            32,
            99,
            32,
            61,
            32,
            98,
            46,
            116,
            97,
            46,
            121,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            98,
            46,
            99,
            108,
            111,
            110,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            99,
            98,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            104,
            98,
            40,
            40,
            41,
            32,
            61,
            62,
            32,
            100,
            91,
            34,
            100,
            101,
            108,
            101,
            116,
            101,
            34,
            93,
            40,
            41,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            117,
            108,
            108,
            32,
            33,
            61,
            61,
            32,
            97,
            32,
            38,
            38,
            32,
            97,
            46,
            112,
            117,
            115,
            104,
            40,
            116,
            104,
            105,
            115,
            46,
            68,
            97,
            44,
            32,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            114,
            101,
            97,
            107,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            101,
            102,
            97,
            117,
            108,
            116,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            34,
            85,
            110,
            115,
            117,
            112,
            112,
            111,
            114,
            116,
            105,
            110,
            103,
            32,
            115,
            104,
            97,
            114,
            105,
            110,
            103,
            32,
            112,
            111,
            108,
            105,
            99,
            121,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            105,
            98,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            110,
            117,
            108,
            108,
            32,
            61,
            61,
            61,
            32,
            98,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            77,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            96,
            110,
            117,
            108,
            108,
            32,
            105,
            115,
            32,
            110,
            111,
            116,
            32,
            97,
            32,
            118,
            97,
            108,
            105,
            100,
            32,
            36,
            123,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            98,
            46,
            116,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            112,
            97,
            115,
            115,
            32,
            34,
            36,
            123,
            102,
            98,
            40,
            98,
            41,
            125,
            34,
            32,
            97,
            115,
            32,
            97,
            32,
            36,
            123,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            98,
            46,
            116,
            97,
            46,
            118,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            112,
            97,
            115,
            115,
            32,
            100,
            101,
            108,
            101,
            116,
            101,
            100,
            32,
            111,
            98,
            106,
            101,
            99,
            116,
            32,
            97,
            115,
            32,
            97,
            32,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            32,
            111,
            102,
            32,
            116,
            121,
            112,
            101,
            32,
            36,
            123,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            98,
            46,
            116,
            97,
            46,
            119,
            97,
            46,
            75,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            99,
            111,
            110,
            118,
            101,
            114,
            116,
            32,
            97,
            114,
            103,
            117,
            109,
            101,
            110,
            116,
            32,
            111,
            102,
            32,
            116,
            121,
            112,
            101,
            32,
            36,
            123,
            98,
            46,
            116,
            97,
            46,
            119,
            97,
            46,
            110,
            97,
            109,
            101,
            125,
            32,
            116,
            111,
            32,
            112,
            97,
            114,
            97,
            109,
            101,
            116,
            101,
            114,
            32,
            116,
            121,
            112,
            101,
            32,
            36,
            123,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            100,
            98,
            40,
            98,
            46,
            116,
            97,
            46,
            118,
            97,
            44,
            32,
            98,
            46,
            116,
            97,
            46,
            119,
            97,
            46,
            117,
            97,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            117,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            106,
            98,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            44,
            32,
            104,
            44,
            32,
            103,
            44,
            32,
            108,
            44,
            32,
            109,
            44,
            32,
            110,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            32,
            61,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            117,
            97,
            32,
            61,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            77,
            97,
            32,
            61,
            32,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            75,
            97,
            32,
            61,
            32,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            76,
            97,
            32,
            61,
            32,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            97,
            98,
            32,
            61,
            32,
            102,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            104,
            98,
            32,
            61,
            32,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            82,
            97,
            32,
            61,
            32,
            103,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            78,
            97,
            32,
            61,
            32,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            99,
            98,
            32,
            61,
            32,
            109,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            68,
            97,
            32,
            61,
            32,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            32,
            124,
            124,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            33,
            61,
            61,
            32,
            98,
            46,
            122,
            97,
            32,
            63,
            32,
            116,
            104,
            105,
            115,
            46,
            116,
            111,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            32,
            61,
            32,
            103,
            98,
            32,
            58,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            116,
            111,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            32,
            61,
            32,
            100,
            32,
            63,
            32,
            101,
            98,
            32,
            58,
            32,
            105,
            98,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            67,
            97,
            32,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            107,
            98,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            107,
            46,
            104,
            97,
            115,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            101,
            114,
            116,
            121,
            40,
            97,
            41,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            76,
            40,
            34,
            82,
            101,
            112,
            108,
            97,
            99,
            105,
            110,
            103,
            32,
            110,
            111,
            110,
            101,
            120,
            105,
            115,
            116,
            101,
            110,
            116,
            32,
            112,
            117,
            98,
            108,
            105,
            99,
            32,
            115,
            121,
            109,
            98,
            111,
            108,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            33,
            61,
            61,
            32,
            107,
            91,
            97,
            93,
            46,
            120,
            97,
            32,
            38,
            38,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            33,
            61,
            61,
            32,
            99,
            32,
            63,
            32,
            107,
            91,
            97,
            93,
            46,
            120,
            97,
            91,
            99,
            93,
            32,
            61,
            32,
            98,
            32,
            58,
            32,
            40,
            107,
            91,
            97,
            93,
            32,
            61,
            32,
            98,
            44,
            32,
            107,
            91,
            97,
            93,
            46,
            71,
            97,
            32,
            61,
            32,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            83,
            44,
            32,
            108,
            98,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            32,
            61,
            32,
            91,
            93,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            46,
            105,
            110,
            99,
            108,
            117,
            100,
            101,
            115,
            40,
            34,
            106,
            34,
            41,
            32,
            63,
            32,
            40,
            97,
            32,
            61,
            32,
            97,
            46,
            114,
            101,
            112,
            108,
            97,
            99,
            101,
            40,
            47,
            112,
            47,
            103,
            44,
            32,
            34,
            105,
            34,
            41,
            44,
            32,
            98,
            32,
            61,
            32,
            40,
            48,
            44,
            32,
            107,
            91,
            34,
            100,
            121,
            110,
            67,
            97,
            108,
            108,
            95,
            34,
            32,
            43,
            32,
            97,
            93,
            41,
            40,
            98,
            44,
            32,
            46,
            46,
            46,
            99,
            41,
            41,
            32,
            58,
            32,
            98,
            32,
            61,
            32,
            83,
            46,
            103,
            101,
            116,
            40,
            98,
            41,
            40,
            46,
            46,
            46,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            109,
            98,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            40,
            46,
            46,
            46,
            99,
            41,
            32,
            61,
            62,
            32,
            108,
            98,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            44,
            32,
            84,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            32,
            61,
            32,
            79,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            97,
            46,
            105,
            110,
            99,
            108,
            117,
            100,
            101,
            115,
            40,
            34,
            106,
            34,
            41,
            32,
            63,
            32,
            109,
            98,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            58,
            32,
            83,
            46,
            103,
            101,
            116,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            34,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            34,
            32,
            33,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            99,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            96,
            117,
            110,
            107,
            110,
            111,
            119,
            110,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            32,
            119,
            105,
            116,
            104,
            32,
            115,
            105,
            103,
            110,
            97,
            116,
            117,
            114,
            101,
            32,
            36,
            123,
            97,
            125,
            58,
            32,
            36,
            123,
            98,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            110,
            98,
            44,
            32,
            112,
            98,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            32,
            61,
            32,
            111,
            98,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            98,
            32,
            61,
            32,
            79,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            85,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            113,
            98,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            99,
            40,
            102,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            91,
            102,
            93,
            32,
            124,
            124,
            32,
            75,
            91,
            102,
            93,
            32,
            124,
            124,
            32,
            40,
            77,
            97,
            91,
            102,
            93,
            32,
            63,
            32,
            77,
            97,
            91,
            102,
            93,
            46,
            102,
            111,
            114,
            69,
            97,
            99,
            104,
            40,
            99,
            41,
            32,
            58,
            32,
            40,
            100,
            46,
            112,
            117,
            115,
            104,
            40,
            102,
            41,
            44,
            32,
            101,
            91,
            102,
            93,
            32,
            61,
            32,
            116,
            114,
            117,
            101,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            91,
            93,
            44,
            32,
            101,
            32,
            61,
            32,
            123,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            46,
            102,
            111,
            114,
            69,
            97,
            99,
            104,
            40,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            110,
            98,
            40,
            96,
            36,
            123,
            97,
            125,
            58,
            32,
            96,
            32,
            43,
            32,
            100,
            46,
            109,
            97,
            112,
            40,
            112,
            98,
            41,
            46,
            106,
            111,
            105,
            110,
            40,
            91,
            34,
            44,
            32,
            34,
            93,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            114,
            98,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            91,
            93,
            44,
            32,
            100,
            32,
            61,
            32,
            48,
            59,
            32,
            100,
            32,
            60,
            32,
            97,
            59,
            32,
            100,
            43,
            43,
            41,
            32,
            99,
            46,
            112,
            117,
            115,
            104,
            40,
            68,
            91,
            98,
            32,
            43,
            32,
            52,
            32,
            42,
            32,
            100,
            32,
            62,
            62,
            32,
            50,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            115,
            98,
            40,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            98,
            32,
            61,
            32,
            49,
            59,
            32,
            98,
            32,
            60,
            32,
            97,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            32,
            43,
            43,
            98,
            41,
            32,
            105,
            102,
            32,
            40,
            110,
            117,
            108,
            108,
            32,
            33,
            61,
            61,
            32,
            97,
            91,
            98,
            93,
            32,
            38,
            38,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            97,
            91,
            98,
            93,
            46,
            67,
            97,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            114,
            117,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            116,
            98,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            102,
            32,
            61,
            32,
            98,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            50,
            32,
            62,
            32,
            102,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            34,
            97,
            114,
            103,
            84,
            121,
            112,
            101,
            115,
            32,
            97,
            114,
            114,
            97,
            121,
            32,
            115,
            105,
            122,
            101,
            32,
            109,
            105,
            115,
            109,
            97,
            116,
            99,
            104,
            33,
            32,
            77,
            117,
            115,
            116,
            32,
            97,
            116,
            32,
            108,
            101,
            97,
            115,
            116,
            32,
            103,
            101,
            116,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            118,
            97,
            108,
            117,
            101,
            32,
            97,
            110,
            100,
            32,
            39,
            116,
            104,
            105,
            115,
            39,
            32,
            116,
            121,
            112,
            101,
            115,
            33,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            104,
            32,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            33,
            61,
            61,
            32,
            98,
            91,
            49,
            93,
            32,
            38,
            38,
            32,
            110,
            117,
            108,
            108,
            32,
            33,
            61,
            61,
            32,
            99,
            44,
            32,
            103,
            32,
            61,
            32,
            115,
            98,
            40,
            98,
            41,
            44,
            32,
            108,
            32,
            61,
            32,
            34,
            118,
            111,
            105,
            100,
            34,
            32,
            33,
            61,
            61,
            32,
            98,
            91,
            48,
            93,
            46,
            110,
            97,
            109,
            101,
            44,
            32,
            109,
            32,
            61,
            32,
            102,
            32,
            45,
            32,
            50,
            44,
            32,
            110,
            32,
            61,
            32,
            65,
            114,
            114,
            97,
            121,
            40,
            109,
            41,
            44,
            32,
            113,
            32,
            61,
            32,
            91,
            93,
            44,
            32,
            114,
            32,
            61,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            82,
            40,
            97,
            44,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            46,
            46,
            46,
            65,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            32,
            61,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            113,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            32,
            61,
            32,
            104,
            32,
            63,
            32,
            50,
            32,
            58,
            32,
            49,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            113,
            91,
            48,
            93,
            32,
            61,
            32,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            104,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            117,
            32,
            61,
            32,
            98,
            91,
            49,
            93,
            46,
            116,
            111,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            40,
            114,
            44,
            32,
            116,
            104,
            105,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            113,
            91,
            49,
            93,
            32,
            61,
            32,
            117,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            118,
            32,
            61,
            32,
            48,
            59,
            32,
            118,
            32,
            60,
            32,
            109,
            59,
            32,
            43,
            43,
            118,
            41,
            32,
            110,
            91,
            118,
            93,
            32,
            61,
            32,
            98,
            91,
            118,
            32,
            43,
            32,
            50,
            93,
            46,
            116,
            111,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            40,
            114,
            44,
            32,
            65,
            91,
            118,
            93,
            41,
            44,
            32,
            113,
            46,
            112,
            117,
            115,
            104,
            40,
            110,
            91,
            118,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            65,
            32,
            61,
            32,
            100,
            40,
            46,
            46,
            46,
            113,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            103,
            41,
            32,
            76,
            97,
            40,
            114,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            108,
            115,
            101,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            32,
            61,
            32,
            104,
            32,
            63,
            32,
            49,
            32,
            58,
            32,
            50,
            59,
            32,
            118,
            32,
            60,
            32,
            98,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            32,
            118,
            43,
            43,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            69,
            32,
            61,
            32,
            49,
            32,
            61,
            61,
            61,
            32,
            118,
            32,
            63,
            32,
            117,
            32,
            58,
            32,
            110,
            91,
            118,
            32,
            45,
            32,
            50,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            117,
            108,
            108,
            32,
            33,
            61,
            61,
            32,
            98,
            91,
            118,
            93,
            46,
            67,
            97,
            32,
            38,
            38,
            32,
            98,
            91,
            118,
            93,
            46,
            67,
            97,
            40,
            69,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            117,
            32,
            61,
            32,
            108,
            32,
            63,
            32,
            98,
            91,
            48,
            93,
            46,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            40,
            65,
            41,
            32,
            58,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            117,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            117,
            98,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            32,
            61,
            32,
            97,
            46,
            116,
            114,
            105,
            109,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            98,
            32,
            61,
            32,
            97,
            46,
            105,
            110,
            100,
            101,
            120,
            79,
            102,
            40,
            34,
            40,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            45,
            49,
            32,
            33,
            61,
            61,
            32,
            98,
            32,
            63,
            32,
            97,
            46,
            115,
            117,
            98,
            115,
            116,
            114,
            40,
            48,
            44,
            32,
            98,
            41,
            32,
            58,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            118,
            98,
            32,
            61,
            32,
            91,
            93,
            44,
            32,
            86,
            32,
            61,
            32,
            91,
            93,
            44,
            32,
            120,
            98,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            57,
            32,
            60,
            32,
            97,
            32,
            38,
            38,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            45,
            45,
            86,
            91,
            97,
            32,
            43,
            32,
            49,
            93,
            32,
            38,
            38,
            32,
            40,
            86,
            91,
            97,
            93,
            32,
            61,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            44,
            32,
            118,
            98,
            46,
            112,
            117,
            115,
            104,
            40,
            97,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            121,
            98,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            34,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            117,
            115,
            101,
            32,
            100,
            101,
            108,
            101,
            116,
            101,
            100,
            32,
            118,
            97,
            108,
            46,
            32,
            104,
            97,
            110,
            100,
            108,
            101,
            32,
            61,
            32,
            34,
            32,
            43,
            32,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            86,
            91,
            97,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            104,
            98,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            119,
            105,
            116,
            99,
            104,
            32,
            40,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            50,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            110,
            117,
            108,
            108,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            52,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            116,
            114,
            117,
            101,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            54,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            102,
            97,
            108,
            115,
            101,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            56,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            101,
            102,
            97,
            117,
            108,
            116,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            98,
            32,
            61,
            32,
            118,
            98,
            46,
            112,
            111,
            112,
            40,
            41,
            32,
            124,
            124,
            32,
            86,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            86,
            91,
            98,
            93,
            32,
            61,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            86,
            91,
            98,
            32,
            43,
            32,
            49,
            93,
            32,
            61,
            32,
            49,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            122,
            98,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            97,
            109,
            101,
            58,
            32,
            34,
            101,
            109,
            115,
            99,
            114,
            105,
            112,
            116,
            101,
            110,
            58,
            58,
            118,
            97,
            108,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            98,
            32,
            61,
            32,
            121,
            98,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            120,
            98,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            111,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            104,
            98,
            40,
            98,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            66,
            97,
            58,
            32,
            56,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            70,
            114,
            111,
            109,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            58,
            32,
            73,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            67,
            97,
            58,
            32,
            110,
            117,
            108,
            108,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            65,
            98,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            119,
            105,
            116,
            99,
            104,
            32,
            40,
            98,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            49,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            32,
            63,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            40,
            119,
            91,
            100,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            58,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            40,
            120,
            91,
            100,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            50,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            32,
            63,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            40,
            121,
            91,
            100,
            32,
            62,
            62,
            32,
            49,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            58,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            40,
            122,
            91,
            100,
            32,
            62,
            62,
            32,
            49,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            52,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            32,
            63,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            40,
            67,
            91,
            100,
            32,
            62,
            62,
            32,
            50,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            58,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            40,
            68,
            91,
            100,
            32,
            62,
            62,
            32,
            50,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            101,
            102,
            97,
            117,
            108,
            116,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            84,
            121,
            112,
            101,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            105,
            110,
            118,
            97,
            108,
            105,
            100,
            32,
            105,
            110,
            116,
            101,
            103,
            101,
            114,
            32,
            119,
            105,
            100,
            116,
            104,
            32,
            40,
            36,
            123,
            98,
            125,
            41,
            58,
            32,
            36,
            123,
            97,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            66,
            98,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            75,
            91,
            97,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            99,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            97,
            32,
            61,
            32,
            96,
            36,
            123,
            98,
            125,
            32,
            104,
            97,
            115,
            32,
            117,
            110,
            107,
            110,
            111,
            119,
            110,
            32,
            116,
            121,
            112,
            101,
            32,
            36,
            123,
            112,
            98,
            40,
            97,
            41,
            125,
            96,
            44,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            102,
            98,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            110,
            117,
            108,
            108,
            32,
            61,
            61,
            61,
            32,
            97,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            34,
            110,
            117,
            108,
            108,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            98,
            32,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            34,
            111,
            98,
            106,
            101,
            99,
            116,
            34,
            32,
            61,
            61,
            61,
            32,
            98,
            32,
            124,
            124,
            32,
            34,
            97,
            114,
            114,
            97,
            121,
            34,
            32,
            61,
            61,
            61,
            32,
            98,
            32,
            124,
            124,
            32,
            34,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            34,
            32,
            61,
            61,
            61,
            32,
            98,
            32,
            63,
            32,
            97,
            46,
            116,
            111,
            83,
            116,
            114,
            105,
            110,
            103,
            40,
            41,
            32,
            58,
            32,
            34,
            34,
            32,
            43,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            67,
            98,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            119,
            105,
            116,
            99,
            104,
            32,
            40,
            98,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            52,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            99,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            40,
            110,
            97,
            91,
            99,
            32,
            62,
            62,
            32,
            50,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            56,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            99,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            40,
            111,
            97,
            91,
            99,
            32,
            62,
            62,
            32,
            51,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            101,
            102,
            97,
            117,
            108,
            116,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            84,
            121,
            112,
            101,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            105,
            110,
            118,
            97,
            108,
            105,
            100,
            32,
            102,
            108,
            111,
            97,
            116,
            32,
            119,
            105,
            100,
            116,
            104,
            32,
            40,
            36,
            123,
            98,
            125,
            41,
            58,
            32,
            36,
            123,
            97,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            68,
            98,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            119,
            105,
            116,
            99,
            104,
            32,
            40,
            98,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            49,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            32,
            63,
            32,
            40,
            100,
            41,
            32,
            61,
            62,
            32,
            119,
            91,
            100,
            93,
            32,
            58,
            32,
            40,
            100,
            41,
            32,
            61,
            62,
            32,
            120,
            91,
            100,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            50,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            32,
            63,
            32,
            40,
            100,
            41,
            32,
            61,
            62,
            32,
            121,
            91,
            100,
            32,
            62,
            62,
            32,
            49,
            93,
            32,
            58,
            32,
            40,
            100,
            41,
            32,
            61,
            62,
            32,
            122,
            91,
            100,
            32,
            62,
            62,
            32,
            49,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            52,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            32,
            63,
            32,
            40,
            100,
            41,
            32,
            61,
            62,
            32,
            67,
            91,
            100,
            32,
            62,
            62,
            32,
            50,
            93,
            32,
            58,
            32,
            40,
            100,
            41,
            32,
            61,
            62,
            32,
            68,
            91,
            100,
            32,
            62,
            62,
            32,
            50,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            101,
            102,
            97,
            117,
            108,
            116,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            84,
            121,
            112,
            101,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            105,
            110,
            118,
            97,
            108,
            105,
            100,
            32,
            105,
            110,
            116,
            101,
            103,
            101,
            114,
            32,
            119,
            105,
            100,
            116,
            104,
            32,
            40,
            36,
            123,
            98,
            125,
            41,
            58,
            32,
            36,
            123,
            97,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            69,
            98,
            32,
            61,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            97,
            115,
            115,
            105,
            103,
            110,
            40,
            123,
            32,
            111,
            112,
            116,
            105,
            111,
            110,
            97,
            108,
            58,
            32,
            116,
            114,
            117,
            101,
            32,
            125,
            44,
            32,
            122,
            98,
            41,
            44,
            32,
            70,
            98,
            32,
            61,
            32,
            34,
            117,
            110,
            100,
            101,
            102,
            105,
            110,
            101,
            100,
            34,
            32,
            33,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            84,
            101,
            120,
            116,
            68,
            101,
            99,
            111,
            100,
            101,
            114,
            32,
            63,
            32,
            110,
            101,
            119,
            32,
            84,
            101,
            120,
            116,
            68,
            101,
            99,
            111,
            100,
            101,
            114,
            40,
            34,
            117,
            116,
            102,
            45,
            49,
            54,
            108,
            101,
            34,
            41,
            32,
            58,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            44,
            32,
            71,
            98,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            97,
            32,
            62,
            62,
            32,
            49,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            99,
            32,
            43,
            32,
            98,
            32,
            47,
            32,
            50,
            59,
            32,
            33,
            40,
            99,
            32,
            62,
            61,
            32,
            100,
            41,
            32,
            38,
            38,
            32,
            122,
            91,
            99,
            93,
            59,
            32,
            41,
            32,
            43,
            43,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            32,
            60,
            60,
            61,
            32,
            49,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            51,
            50,
            32,
            60,
            32,
            99,
            32,
            45,
            32,
            97,
            32,
            38,
            38,
            32,
            70,
            98,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            70,
            98,
            46,
            100,
            101,
            99,
            111,
            100,
            101,
            40,
            120,
            46,
            115,
            117,
            98,
            97,
            114,
            114,
            97,
            121,
            40,
            97,
            44,
            32,
            99,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            32,
            61,
            32,
            34,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            100,
            32,
            61,
            32,
            48,
            59,
            32,
            33,
            40,
            100,
            32,
            62,
            61,
            32,
            98,
            32,
            47,
            32,
            50,
            41,
            59,
            32,
            43,
            43,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            101,
            32,
            61,
            32,
            121,
            91,
            97,
            32,
            43,
            32,
            50,
            32,
            42,
            32,
            100,
            32,
            62,
            62,
            32,
            49,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            48,
            32,
            61,
            61,
            32,
            101,
            41,
            32,
            98,
            114,
            101,
            97,
            107,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            32,
            43,
            61,
            32,
            83,
            116,
            114,
            105,
            110,
            103,
            46,
            102,
            114,
            111,
            109,
            67,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            40,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            72,
            98,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            99,
            32,
            58,
            32,
            99,
            32,
            61,
            32,
            50,
            49,
            52,
            55,
            52,
            56,
            51,
            54,
            52,
            55,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            50,
            32,
            62,
            32,
            99,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            32,
            45,
            61,
            32,
            50,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            32,
            61,
            32,
            99,
            32,
            60,
            32,
            50,
            32,
            42,
            32,
            97,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            32,
            63,
            32,
            99,
            32,
            47,
            32,
            50,
            32,
            58,
            32,
            97,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            101,
            32,
            61,
            32,
            48,
            59,
            32,
            101,
            32,
            60,
            32,
            99,
            59,
            32,
            43,
            43,
            101,
            41,
            32,
            121,
            91,
            98,
            32,
            62,
            62,
            32,
            49,
            93,
            32,
            61,
            32,
            97,
            46,
            99,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            65,
            116,
            40,
            101,
            41,
            44,
            32,
            98,
            32,
            43,
            61,
            32,
            50,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            121,
            91,
            98,
            32,
            62,
            62,
            32,
            49,
            93,
            32,
            61,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            98,
            32,
            45,
            32,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            73,
            98,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            50,
            32,
            42,
            32,
            97,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            44,
            32,
            74,
            98,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            48,
            44,
            32,
            100,
            32,
            61,
            32,
            34,
            34,
            59,
            32,
            33,
            40,
            99,
            32,
            62,
            61,
            32,
            98,
            32,
            47,
            32,
            52,
            41,
            59,
            32,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            101,
            32,
            61,
            32,
            67,
            91,
            97,
            32,
            43,
            32,
            52,
            32,
            42,
            32,
            99,
            32,
            62,
            62,
            32,
            50,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            48,
            32,
            61,
            61,
            32,
            101,
            41,
            32,
            98,
            114,
            101,
            97,
            107,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            43,
            43,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            54,
            53,
            53,
            51,
            54,
            32,
            60,
            61,
            32,
            101,
            32,
            63,
            32,
            40,
            101,
            32,
            45,
            61,
            32,
            54,
            53,
            53,
            51,
            54,
            44,
            32,
            100,
            32,
            43,
            61,
            32,
            83,
            116,
            114,
            105,
            110,
            103,
            46,
            102,
            114,
            111,
            109,
            67,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            40,
            53,
            53,
            50,
            57,
            54,
            32,
            124,
            32,
            101,
            32,
            62,
            62,
            32,
            49,
            48,
            44,
            32,
            53,
            54,
            51,
            50,
            48,
            32,
            124,
            32,
            101,
            32,
            38,
            32,
            49,
            48,
            50,
            51,
            41,
            41,
            32,
            58,
            32,
            100,
            32,
            43,
            61,
            32,
            83,
            116,
            114,
            105,
            110,
            103,
            46,
            102,
            114,
            111,
            109,
            67,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            40,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            75,
            98,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            99,
            32,
            58,
            32,
            99,
            32,
            61,
            32,
            50,
            49,
            52,
            55,
            52,
            56,
            51,
            54,
            52,
            55,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            52,
            32,
            62,
            32,
            99,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            32,
            61,
            32,
            100,
            32,
            43,
            32,
            99,
            32,
            45,
            32,
            52,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            101,
            32,
            61,
            32,
            48,
            59,
            32,
            101,
            32,
            60,
            32,
            97,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            32,
            43,
            43,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            102,
            32,
            61,
            32,
            97,
            46,
            99,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            65,
            116,
            40,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            53,
            53,
            50,
            57,
            54,
            32,
            60,
            61,
            32,
            102,
            32,
            38,
            38,
            32,
            53,
            55,
            51,
            52,
            51,
            32,
            62,
            61,
            32,
            102,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            104,
            32,
            61,
            32,
            97,
            46,
            99,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            65,
            116,
            40,
            43,
            43,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            32,
            61,
            32,
            54,
            53,
            53,
            51,
            54,
            32,
            43,
            32,
            40,
            40,
            102,
            32,
            38,
            32,
            49,
            48,
            50,
            51,
            41,
            32,
            60,
            60,
            32,
            49,
            48,
            41,
            32,
            124,
            32,
            104,
            32,
            38,
            32,
            49,
            48,
            50,
            51,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            67,
            91,
            98,
            32,
            62,
            62,
            32,
            50,
            93,
            32,
            61,
            32,
            102,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            43,
            61,
            32,
            52,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            98,
            32,
            43,
            32,
            52,
            32,
            62,
            32,
            99,
            41,
            32,
            98,
            114,
            101,
            97,
            107,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            67,
            91,
            98,
            32,
            62,
            62,
            32,
            50,
            93,
            32,
            61,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            98,
            32,
            45,
            32,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            76,
            98,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            98,
            32,
            61,
            32,
            48,
            44,
            32,
            99,
            32,
            61,
            32,
            48,
            59,
            32,
            99,
            32,
            60,
            32,
            97,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            32,
            43,
            43,
            99,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            97,
            46,
            99,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            65,
            116,
            40,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            53,
            53,
            50,
            57,
            54,
            32,
            60,
            61,
            32,
            100,
            32,
            38,
            38,
            32,
            53,
            55,
            51,
            52,
            51,
            32,
            62,
            61,
            32,
            100,
            32,
            38,
            38,
            32,
            43,
            43,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            43,
            61,
            32,
            52,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            77,
            98,
            32,
            61,
            32,
            48,
            44,
            32,
            78,
            98,
            32,
            61,
            32,
            91,
            93,
            44,
            32,
            79,
            98,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            98,
            32,
            61,
            32,
            78,
            98,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            78,
            98,
            46,
            112,
            117,
            115,
            104,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            80,
            98,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            65,
            114,
            114,
            97,
            121,
            40,
            97,
            41,
            44,
            32,
            100,
            32,
            61,
            32,
            48,
            59,
            32,
            100,
            32,
            60,
            32,
            97,
            59,
            32,
            43,
            43,
            100,
            41,
            32,
            99,
            91,
            100,
            93,
            32,
            61,
            32,
            66,
            98,
            40,
            68,
            91,
            98,
            32,
            43,
            32,
            52,
            32,
            42,
            32,
            100,
            32,
            62,
            62,
            32,
            50,
            93,
            44,
            32,
            34,
            112,
            97,
            114,
            97,
            109,
            101,
            116,
            101,
            114,
            32,
            34,
            32,
            43,
            32,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            81,
            98,
            32,
            61,
            32,
            82,
            101,
            102,
            108,
            101,
            99,
            116,
            46,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            44,
            32,
            82,
            98,
            32,
            61,
            32,
            123,
            125,
            44,
            32,
            83,
            98,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            40,
            97,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            111,
            102,
            32,
            67,
            97,
            32,
            124,
            124,
            32,
            34,
            117,
            110,
            119,
            105,
            110,
            100,
            34,
            32,
            61,
            61,
            32,
            97,
            41,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            84,
            98,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            50,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            97,
            32,
            61,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            69,
            97,
            32,
            124,
            124,
            32,
            48,
            32,
            60,
            32,
            77,
            98,
            32,
            124,
            124,
            32,
            40,
            40,
            95,
            97,
            50,
            32,
            61,
            32,
            107,
            46,
            111,
            110,
            69,
            120,
            105,
            116,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            50,
            46,
            99,
            97,
            108,
            108,
            40,
            107,
            44,
            32,
            97,
            41,
            44,
            32,
            108,
            97,
            32,
            61,
            32,
            116,
            114,
            117,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            67,
            97,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            85,
            98,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            108,
            97,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            97,
            40,
            41,
            44,
            32,
            33,
            40,
            69,
            97,
            32,
            124,
            124,
            32,
            48,
            32,
            60,
            32,
            77,
            98,
            41,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            97,
            32,
            61,
            32,
            97,
            32,
            61,
            32,
            109,
            97,
            44,
            32,
            84,
            98,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            98,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            83,
            98,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            98,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            83,
            98,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            86,
            98,
            32,
            61,
            32,
            123,
            125,
            44,
            32,
            88,
            98,
            32,
            61,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            87,
            98,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            97,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            85,
            83,
            69,
            82,
            58,
            32,
            34,
            119,
            101,
            98,
            95,
            117,
            115,
            101,
            114,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            76,
            79,
            71,
            78,
            65,
            77,
            69,
            58,
            32,
            34,
            119,
            101,
            98,
            95,
            117,
            115,
            101,
            114,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            80,
            65,
            84,
            72,
            58,
            32,
            34,
            47,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            80,
            87,
            68,
            58,
            32,
            34,
            47,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            72,
            79,
            77,
            69,
            58,
            32,
            34,
            47,
            104,
            111,
            109,
            101,
            47,
            119,
            101,
            98,
            95,
            117,
            115,
            101,
            114,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            76,
            65,
            78,
            71,
            58,
            32,
            40,
            34,
            111,
            98,
            106,
            101,
            99,
            116,
            34,
            32,
            61,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            110,
            97,
            118,
            105,
            103,
            97,
            116,
            111,
            114,
            32,
            38,
            38,
            32,
            110,
            97,
            118,
            105,
            103,
            97,
            116,
            111,
            114,
            46,
            108,
            97,
            110,
            103,
            117,
            97,
            103,
            101,
            115,
            32,
            38,
            38,
            32,
            110,
            97,
            118,
            105,
            103,
            97,
            116,
            111,
            114,
            46,
            108,
            97,
            110,
            103,
            117,
            97,
            103,
            101,
            115,
            91,
            48,
            93,
            32,
            124,
            124,
            32,
            34,
            67,
            34,
            41,
            46,
            114,
            101,
            112,
            108,
            97,
            99,
            101,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            45,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            95,
            34,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            32,
            43,
            32,
            34,
            46,
            85,
            84,
            70,
            45,
            56,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            58,
            32,
            104,
            97,
            32,
            124,
            124,
            32,
            34,
            46,
            47,
            116,
            104,
            105,
            115,
            46,
            112,
            114,
            111,
            103,
            114,
            97,
            109,
            34,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            98,
            32,
            105,
            110,
            32,
            86,
            98,
            41,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            86,
            98,
            91,
            98,
            93,
            32,
            63,
            32,
            100,
            101,
            108,
            101,
            116,
            101,
            32,
            97,
            91,
            98,
            93,
            32,
            58,
            32,
            97,
            91,
            98,
            93,
            32,
            61,
            32,
            86,
            98,
            91,
            98,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            98,
            32,
            105,
            110,
            32,
            97,
            41,
            32,
            99,
            46,
            112,
            117,
            115,
            104,
            40,
            96,
            36,
            123,
            98,
            125,
            61,
            36,
            123,
            97,
            91,
            98,
            93,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            87,
            98,
            32,
            61,
            32,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            87,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            87,
            98,
            44,
            32,
            89,
            98,
            32,
            61,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            34,
            111,
            98,
            106,
            101,
            99,
            116,
            34,
            32,
            61,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            99,
            114,
            121,
            112,
            116,
            111,
            32,
            38,
            38,
            32,
            34,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            34,
            32,
            61,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            99,
            114,
            121,
            112,
            116,
            111,
            46,
            103,
            101,
            116,
            82,
            97,
            110,
            100,
            111,
            109,
            86,
            97,
            108,
            117,
            101,
            115,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            99,
            114,
            121,
            112,
            116,
            111,
            46,
            103,
            101,
            116,
            82,
            97,
            110,
            100,
            111,
            109,
            86,
            97,
            108,
            117,
            101,
            115,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            40,
            34,
            105,
            110,
            105,
            116,
            82,
            97,
            110,
            100,
            111,
            109,
            68,
            101,
            118,
            105,
            99,
            101,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            90,
            98,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            40,
            90,
            98,
            32,
            61,
            32,
            89,
            98,
            40,
            41,
            41,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            76,
            32,
            61,
            32,
            107,
            46,
            73,
            110,
            116,
            101,
            114,
            110,
            97,
            108,
            69,
            114,
            114,
            111,
            114,
            32,
            61,
            32,
            99,
            108,
            97,
            115,
            115,
            32,
            101,
            120,
            116,
            101,
            110,
            100,
            115,
            32,
            69,
            114,
            114,
            111,
            114,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            40,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            117,
            112,
            101,
            114,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            32,
            61,
            32,
            34,
            73,
            110,
            116,
            101,
            114,
            110,
            97,
            108,
            69,
            114,
            114,
            111,
            114,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            36,
            98,
            32,
            61,
            32,
            65,
            114,
            114,
            97,
            121,
            40,
            50,
            53,
            54,
            41,
            44,
            32,
            97,
            99,
            32,
            61,
            32,
            48,
            59,
            32,
            50,
            53,
            54,
            32,
            62,
            32,
            97,
            99,
            59,
            32,
            43,
            43,
            97,
            99,
            41,
            32,
            36,
            98,
            91,
            97,
            99,
            93,
            32,
            61,
            32,
            83,
            116,
            114,
            105,
            110,
            103,
            46,
            102,
            114,
            111,
            109,
            67,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            40,
            97,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            78,
            97,
            32,
            61,
            32,
            36,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            80,
            32,
            61,
            32,
            107,
            46,
            66,
            105,
            110,
            100,
            105,
            110,
            103,
            69,
            114,
            114,
            111,
            114,
            32,
            61,
            32,
            99,
            108,
            97,
            115,
            115,
            32,
            101,
            120,
            116,
            101,
            110,
            100,
            115,
            32,
            69,
            114,
            114,
            111,
            114,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            40,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            117,
            112,
            101,
            114,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            32,
            61,
            32,
            34,
            66,
            105,
            110,
            100,
            105,
            110,
            103,
            69,
            114,
            114,
            111,
            114,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            97,
            115,
            115,
            105,
            103,
            110,
            40,
            90,
            97,
            46,
            112,
            114,
            111,
            116,
            111,
            116,
            121,
            112,
            101,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            115,
            65,
            108,
            105,
            97,
            115,
            79,
            102,
            58,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            40,
            116,
            104,
            105,
            115,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            111,
            102,
            32,
            90,
            97,
            32,
            38,
            38,
            32,
            97,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            111,
            102,
            32,
            90,
            97,
            41,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            98,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            46,
            119,
            97,
            46,
            117,
            97,
            44,
            32,
            99,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            46,
            118,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            46,
            116,
            97,
            32,
            61,
            32,
            97,
            46,
            116,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            97,
            46,
            116,
            97,
            46,
            119,
            97,
            46,
            117,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            97,
            32,
            61,
            32,
            97,
            46,
            116,
            97,
            46,
            118,
            97,
            59,
            32,
            98,
            46,
            122,
            97,
            59,
            32,
            41,
            32,
            99,
            32,
            61,
            32,
            98,
            46,
            74,
            97,
            40,
            99,
            41,
            44,
            32,
            98,
            32,
            61,
            32,
            98,
            46,
            122,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            59,
            32,
            100,
            46,
            122,
            97,
            59,
            32,
            41,
            32,
            97,
            32,
            61,
            32,
            100,
            46,
            74,
            97,
            40,
            97,
            41,
            44,
            32,
            100,
            32,
            61,
            32,
            100,
            46,
            122,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            98,
            32,
            61,
            61,
            61,
            32,
            100,
            32,
            38,
            38,
            32,
            99,
            32,
            61,
            61,
            61,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            108,
            111,
            110,
            101,
            58,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            46,
            118,
            97,
            32,
            124,
            124,
            32,
            81,
            97,
            40,
            116,
            104,
            105,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            46,
            73,
            97,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            46,
            99,
            111,
            117,
            110,
            116,
            46,
            118,
            97,
            108,
            117,
            101,
            32,
            43,
            61,
            32,
            49,
            44,
            32,
            116,
            104,
            105,
            115,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            97,
            32,
            61,
            32,
            81,
            44,
            32,
            98,
            32,
            61,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            44,
            32,
            99,
            32,
            61,
            32,
            98,
            46,
            99,
            114,
            101,
            97,
            116,
            101,
            44,
            32,
            100,
            32,
            61,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            103,
            101,
            116,
            80,
            114,
            111,
            116,
            111,
            116,
            121,
            112,
            101,
            79,
            102,
            40,
            116,
            104,
            105,
            115,
            41,
            44,
            32,
            101,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            32,
            61,
            32,
            97,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            46,
            99,
            97,
            108,
            108,
            40,
            98,
            44,
            32,
            100,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            97,
            58,
            32,
            123,
            32,
            118,
            97,
            108,
            117,
            101,
            58,
            32,
            123,
            32,
            99,
            111,
            117,
            110,
            116,
            58,
            32,
            101,
            46,
            99,
            111,
            117,
            110,
            116,
            44,
            32,
            72,
            97,
            58,
            32,
            101,
            46,
            72,
            97,
            44,
            32,
            73,
            97,
            58,
            32,
            101,
            46,
            73,
            97,
            44,
            32,
            118,
            97,
            58,
            32,
            101,
            46,
            118,
            97,
            44,
            32,
            119,
            97,
            58,
            32,
            101,
            46,
            119,
            97,
            44,
            32,
            121,
            97,
            58,
            32,
            101,
            46,
            121,
            97,
            44,
            32,
            65,
            97,
            58,
            32,
            101,
            46,
            65,
            97,
            32,
            125,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            46,
            116,
            97,
            46,
            99,
            111,
            117,
            110,
            116,
            46,
            118,
            97,
            108,
            117,
            101,
            32,
            43,
            61,
            32,
            49,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            46,
            116,
            97,
            46,
            72,
            97,
            32,
            61,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            91,
            34,
            100,
            101,
            108,
            101,
            116,
            101,
            34,
            93,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            46,
            118,
            97,
            32,
            124,
            124,
            32,
            81,
            97,
            40,
            116,
            104,
            105,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            46,
            72,
            97,
            32,
            38,
            38,
            32,
            33,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            46,
            73,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            34,
            79,
            98,
            106,
            101,
            99,
            116,
            32,
            97,
            108,
            114,
            101,
            97,
            100,
            121,
            32,
            115,
            99,
            104,
            101,
            100,
            117,
            108,
            101,
            100,
            32,
            102,
            111,
            114,
            32,
            100,
            101,
            108,
            101,
            116,
            105,
            111,
            110,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            83,
            97,
            40,
            116,
            104,
            105,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            45,
            45,
            97,
            46,
            99,
            111,
            117,
            110,
            116,
            46,
            118,
            97,
            108,
            117,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            97,
            46,
            99,
            111,
            117,
            110,
            116,
            46,
            118,
            97,
            108,
            117,
            101,
            32,
            38,
            38,
            32,
            40,
            97,
            46,
            121,
            97,
            32,
            63,
            32,
            97,
            46,
            65,
            97,
            46,
            68,
            97,
            40,
            97,
            46,
            121,
            97,
            41,
            32,
            58,
            32,
            97,
            46,
            119,
            97,
            46,
            117,
            97,
            46,
            68,
            97,
            40,
            97,
            46,
            118,
            97,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            46,
            73,
            97,
            32,
            124,
            124,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            46,
            121,
            97,
            32,
            61,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            46,
            118,
            97,
            32,
            61,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            115,
            68,
            101,
            108,
            101,
            116,
            101,
            100,
            58,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            33,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            46,
            118,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            101,
            108,
            101,
            116,
            101,
            76,
            97,
            116,
            101,
            114,
            58,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            46,
            118,
            97,
            32,
            124,
            124,
            32,
            81,
            97,
            40,
            116,
            104,
            105,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            46,
            72,
            97,
            32,
            38,
            38,
            32,
            33,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            46,
            73,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            34,
            79,
            98,
            106,
            101,
            99,
            116,
            32,
            97,
            108,
            114,
            101,
            97,
            100,
            121,
            32,
            115,
            99,
            104,
            101,
            100,
            117,
            108,
            101,
            100,
            32,
            102,
            111,
            114,
            32,
            100,
            101,
            108,
            101,
            116,
            105,
            111,
            110,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            89,
            97,
            46,
            112,
            117,
            115,
            104,
            40,
            116,
            104,
            105,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            116,
            97,
            46,
            72,
            97,
            32,
            61,
            32,
            116,
            114,
            117,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            97,
            115,
            115,
            105,
            103,
            110,
            40,
            106,
            98,
            46,
            112,
            114,
            111,
            116,
            111,
            116,
            121,
            112,
            101,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            87,
            97,
            40,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            82,
            97,
            32,
            38,
            38,
            32,
            40,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            82,
            97,
            40,
            97,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            80,
            97,
            40,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            50,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            40,
            95,
            97,
            50,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            68,
            97,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            50,
            46,
            99,
            97,
            108,
            108,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            66,
            97,
            58,
            32,
            56,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            70,
            114,
            111,
            109,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            58,
            32,
            73,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            98,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            76,
            97,
            32,
            63,
            32,
            88,
            97,
            40,
            116,
            104,
            105,
            115,
            46,
            117,
            97,
            46,
            70,
            97,
            44,
            32,
            123,
            32,
            119,
            97,
            58,
            32,
            116,
            104,
            105,
            115,
            46,
            97,
            98,
            44,
            32,
            118,
            97,
            58,
            32,
            99,
            44,
            32,
            65,
            97,
            58,
            32,
            116,
            104,
            105,
            115,
            44,
            32,
            121,
            97,
            58,
            32,
            97,
            32,
            125,
            41,
            32,
            58,
            32,
            88,
            97,
            40,
            116,
            104,
            105,
            115,
            46,
            117,
            97,
            46,
            70,
            97,
            44,
            32,
            123,
            32,
            119,
            97,
            58,
            32,
            116,
            104,
            105,
            115,
            44,
            32,
            118,
            97,
            58,
            32,
            97,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            87,
            97,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            99,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            80,
            97,
            40,
            97,
            41,
            44,
            32,
            110,
            117,
            108,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            87,
            97,
            40,
            116,
            104,
            105,
            115,
            46,
            117,
            97,
            44,
            32,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            33,
            61,
            61,
            32,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            48,
            32,
            61,
            61,
            61,
            32,
            100,
            46,
            116,
            97,
            46,
            99,
            111,
            117,
            110,
            116,
            46,
            118,
            97,
            108,
            117,
            101,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            100,
            46,
            116,
            97,
            46,
            118,
            97,
            32,
            61,
            32,
            99,
            44,
            32,
            100,
            46,
            116,
            97,
            46,
            121,
            97,
            32,
            61,
            32,
            97,
            44,
            32,
            100,
            46,
            99,
            108,
            111,
            110,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            32,
            61,
            32,
            100,
            46,
            99,
            108,
            111,
            110,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            80,
            97,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            117,
            97,
            46,
            86,
            97,
            40,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            32,
            61,
            32,
            85,
            97,
            91,
            100,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            100,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            98,
            46,
            99,
            97,
            108,
            108,
            40,
            116,
            104,
            105,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            75,
            97,
            32,
            63,
            32,
            100,
            46,
            83,
            97,
            32,
            58,
            32,
            100,
            46,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            84,
            121,
            112,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            101,
            32,
            61,
            32,
            84,
            97,
            40,
            99,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            117,
            97,
            44,
            32,
            100,
            46,
            117,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            110,
            117,
            108,
            108,
            32,
            61,
            61,
            61,
            32,
            101,
            32,
            63,
            32,
            98,
            46,
            99,
            97,
            108,
            108,
            40,
            116,
            104,
            105,
            115,
            41,
            32,
            58,
            32,
            116,
            104,
            105,
            115,
            46,
            76,
            97,
            32,
            63,
            32,
            88,
            97,
            40,
            100,
            46,
            117,
            97,
            46,
            70,
            97,
            44,
            32,
            123,
            32,
            119,
            97,
            58,
            32,
            100,
            44,
            32,
            118,
            97,
            58,
            32,
            101,
            44,
            32,
            65,
            97,
            58,
            32,
            116,
            104,
            105,
            115,
            44,
            32,
            121,
            97,
            58,
            32,
            97,
            32,
            125,
            41,
            32,
            58,
            32,
            88,
            97,
            40,
            100,
            46,
            117,
            97,
            46,
            70,
            97,
            44,
            32,
            123,
            32,
            119,
            97,
            58,
            32,
            100,
            44,
            32,
            118,
            97,
            58,
            32,
            101,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            98,
            32,
            61,
            32,
            107,
            46,
            85,
            110,
            98,
            111,
            117,
            110,
            100,
            84,
            121,
            112,
            101,
            69,
            114,
            114,
            111,
            114,
            32,
            61,
            32,
            40,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            82,
            40,
            98,
            44,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            32,
            61,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            109,
            101,
            115,
            115,
            97,
            103,
            101,
            32,
            61,
            32,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            32,
            61,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            100,
            41,
            46,
            115,
            116,
            97,
            99,
            107,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            33,
            61,
            61,
            32,
            100,
            32,
            38,
            38,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            115,
            116,
            97,
            99,
            107,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            116,
            111,
            83,
            116,
            114,
            105,
            110,
            103,
            40,
            41,
            32,
            43,
            32,
            34,
            92,
            110,
            34,
            32,
            43,
            32,
            100,
            46,
            114,
            101,
            112,
            108,
            97,
            99,
            101,
            40,
            47,
            94,
            69,
            114,
            114,
            111,
            114,
            40,
            58,
            91,
            94,
            92,
            110,
            93,
            42,
            41,
            63,
            92,
            110,
            47,
            44,
            32,
            34,
            34,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            46,
            112,
            114,
            111,
            116,
            111,
            116,
            121,
            112,
            101,
            32,
            61,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            99,
            114,
            101,
            97,
            116,
            101,
            40,
            97,
            46,
            112,
            114,
            111,
            116,
            111,
            116,
            121,
            112,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            46,
            112,
            114,
            111,
            116,
            111,
            116,
            121,
            112,
            101,
            46,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            32,
            61,
            32,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            46,
            112,
            114,
            111,
            116,
            111,
            116,
            121,
            112,
            101,
            46,
            116,
            111,
            83,
            116,
            114,
            105,
            110,
            103,
            32,
            61,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            109,
            101,
            115,
            115,
            97,
            103,
            101,
            32,
            63,
            32,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            32,
            58,
            32,
            96,
            36,
            123,
            116,
            104,
            105,
            115,
            46,
            110,
            97,
            109,
            101,
            125,
            58,
            32,
            36,
            123,
            116,
            104,
            105,
            115,
            46,
            109,
            101,
            115,
            115,
            97,
            103,
            101,
            125,
            96,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            40,
            69,
            114,
            114,
            111,
            114,
            44,
            32,
            34,
            85,
            110,
            98,
            111,
            117,
            110,
            100,
            84,
            121,
            112,
            101,
            69,
            114,
            114,
            111,
            114,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            86,
            46,
            112,
            117,
            115,
            104,
            40,
            48,
            44,
            32,
            49,
            44,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            44,
            32,
            49,
            44,
            32,
            110,
            117,
            108,
            108,
            44,
            32,
            49,
            44,
            32,
            116,
            114,
            117,
            101,
            44,
            32,
            49,
            44,
            32,
            102,
            97,
            108,
            115,
            101,
            44,
            32,
            49,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            99,
            111,
            117,
            110,
            116,
            95,
            101,
            109,
            118,
            97,
            108,
            95,
            104,
            97,
            110,
            100,
            108,
            101,
            115,
            32,
            61,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            86,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            32,
            47,
            32,
            50,
            32,
            45,
            32,
            53,
            32,
            45,
            32,
            118,
            98,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            109,
            99,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            41,
            32,
            61,
            62,
            32,
            118,
            97,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            96,
            65,
            115,
            115,
            101,
            114,
            116,
            105,
            111,
            110,
            32,
            102,
            97,
            105,
            108,
            101,
            100,
            58,
            32,
            36,
            123,
            97,
            32,
            63,
            32,
            71,
            97,
            40,
            97,
            41,
            32,
            58,
            32,
            34,
            34,
            125,
            44,
            32,
            97,
            116,
            58,
            32,
            96,
            32,
            43,
            32,
            91,
            98,
            32,
            63,
            32,
            98,
            32,
            63,
            32,
            71,
            97,
            40,
            98,
            41,
            32,
            58,
            32,
            34,
            34,
            32,
            58,
            32,
            34,
            117,
            110,
            107,
            110,
            111,
            119,
            110,
            32,
            102,
            105,
            108,
            101,
            110,
            97,
            109,
            101,
            34,
            44,
            32,
            99,
            44,
            32,
            100,
            32,
            63,
            32,
            100,
            32,
            63,
            32,
            71,
            97,
            40,
            100,
            41,
            32,
            58,
            32,
            34,
            34,
            32,
            58,
            32,
            34,
            117,
            110,
            107,
            110,
            111,
            119,
            110,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            34,
            93,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            72,
            97,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            68,
            91,
            100,
            46,
            118,
            97,
            32,
            43,
            32,
            49,
            54,
            32,
            62,
            62,
            32,
            50,
            93,
            32,
            61,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            68,
            91,
            100,
            46,
            118,
            97,
            32,
            43,
            32,
            52,
            32,
            62,
            62,
            32,
            50,
            93,
            32,
            61,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            68,
            91,
            100,
            46,
            118,
            97,
            32,
            43,
            32,
            56,
            32,
            62,
            62,
            32,
            50,
            93,
            32,
            61,
            32,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            73,
            97,
            32,
            61,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            74,
            97,
            43,
            43,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            73,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            77,
            58,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            74,
            58,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            75,
            58,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            79,
            58,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            76,
            58,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            81,
            58,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            118,
            97,
            40,
            34,
            34,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            58,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            98,
            32,
            61,
            32,
            75,
            97,
            91,
            97,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            101,
            108,
            101,
            116,
            101,
            32,
            75,
            97,
            91,
            97,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            98,
            46,
            78,
            97,
            44,
            32,
            100,
            32,
            61,
            32,
            98,
            46,
            68,
            97,
            44,
            32,
            101,
            32,
            61,
            32,
            98,
            46,
            81,
            97,
            44,
            32,
            102,
            32,
            61,
            32,
            101,
            46,
            109,
            97,
            112,
            40,
            40,
            104,
            41,
            32,
            61,
            62,
            32,
            104,
            46,
            90,
            97,
            41,
            46,
            99,
            111,
            110,
            99,
            97,
            116,
            40,
            101,
            46,
            109,
            97,
            112,
            40,
            40,
            104,
            41,
            32,
            61,
            62,
            32,
            104,
            46,
            102,
            98,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            78,
            40,
            91,
            97,
            93,
            44,
            32,
            102,
            44,
            32,
            40,
            104,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            103,
            32,
            61,
            32,
            123,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            46,
            102,
            111,
            114,
            69,
            97,
            99,
            104,
            40,
            40,
            108,
            44,
            32,
            109,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            110,
            32,
            61,
            32,
            104,
            91,
            109,
            93,
            44,
            32,
            113,
            32,
            61,
            32,
            108,
            46,
            88,
            97,
            44,
            32,
            114,
            32,
            61,
            32,
            108,
            46,
            89,
            97,
            44,
            32,
            65,
            32,
            61,
            32,
            104,
            91,
            109,
            32,
            43,
            32,
            101,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            93,
            44,
            32,
            117,
            32,
            61,
            32,
            108,
            46,
            101,
            98,
            44,
            32,
            118,
            32,
            61,
            32,
            108,
            46,
            103,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            103,
            91,
            108,
            46,
            85,
            97,
            93,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            97,
            100,
            58,
            32,
            40,
            69,
            41,
            32,
            61,
            62,
            32,
            110,
            46,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            40,
            113,
            40,
            114,
            44,
            32,
            69,
            41,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            119,
            114,
            105,
            116,
            101,
            58,
            32,
            40,
            69,
            44,
            32,
            99,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            66,
            32,
            61,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            117,
            40,
            118,
            44,
            32,
            69,
            44,
            32,
            65,
            46,
            116,
            111,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            40,
            66,
            44,
            32,
            99,
            97,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            76,
            97,
            40,
            66,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            91,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            97,
            109,
            101,
            58,
            32,
            98,
            46,
            110,
            97,
            109,
            101,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            40,
            108,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            109,
            32,
            61,
            32,
            123,
            125,
            44,
            32,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            110,
            32,
            105,
            110,
            32,
            103,
            41,
            32,
            109,
            91,
            110,
            93,
            32,
            61,
            32,
            103,
            91,
            110,
            93,
            46,
            114,
            101,
            97,
            100,
            40,
            108,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            40,
            108,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            109,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            111,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            40,
            108,
            44,
            32,
            109,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            110,
            32,
            105,
            110,
            32,
            103,
            41,
            32,
            105,
            102,
            32,
            40,
            33,
            40,
            110,
            32,
            105,
            110,
            32,
            109,
            41,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            84,
            121,
            112,
            101,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            77,
            105,
            115,
            115,
            105,
            110,
            103,
            32,
            102,
            105,
            101,
            108,
            100,
            58,
            32,
            34,
            36,
            123,
            110,
            125,
            34,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            113,
            32,
            61,
            32,
            99,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            110,
            32,
            105,
            110,
            32,
            103,
            41,
            32,
            103,
            91,
            110,
            93,
            46,
            119,
            114,
            105,
            116,
            101,
            40,
            113,
            44,
            32,
            109,
            91,
            110,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            117,
            108,
            108,
            32,
            33,
            61,
            61,
            32,
            108,
            32,
            38,
            38,
            32,
            108,
            46,
            112,
            117,
            115,
            104,
            40,
            100,
            44,
            32,
            113,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            113,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            66,
            97,
            58,
            32,
            56,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            70,
            114,
            111,
            109,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            58,
            32,
            73,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            67,
            97,
            58,
            32,
            100,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            67,
            58,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            86,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            61,
            32,
            79,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            77,
            40,
            97,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            97,
            109,
            101,
            58,
            32,
            98,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            33,
            33,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            111,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            101,
            44,
            32,
            102,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            102,
            32,
            63,
            32,
            99,
            32,
            58,
            32,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            66,
            97,
            58,
            32,
            56,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            70,
            114,
            111,
            109,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            58,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            40,
            120,
            91,
            101,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            67,
            97,
            58,
            32,
            110,
            117,
            108,
            108,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            44,
            32,
            104,
            44,
            32,
            103,
            44,
            32,
            108,
            44,
            32,
            109,
            44,
            32,
            110,
            44,
            32,
            113,
            44,
            32,
            114,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            32,
            61,
            32,
            79,
            40,
            110,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            32,
            61,
            32,
            84,
            40,
            101,
            44,
            32,
            102,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            103,
            32,
            38,
            38,
            32,
            40,
            103,
            32,
            61,
            32,
            84,
            40,
            104,
            44,
            32,
            103,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            32,
            38,
            38,
            32,
            40,
            109,
            32,
            61,
            32,
            84,
            40,
            108,
            44,
            32,
            109,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            32,
            61,
            32,
            84,
            40,
            113,
            44,
            32,
            114,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            65,
            32,
            61,
            32,
            98,
            98,
            40,
            110,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            98,
            40,
            65,
            44,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            113,
            98,
            40,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            32,
            36,
            123,
            110,
            125,
            32,
            100,
            117,
            101,
            32,
            116,
            111,
            32,
            117,
            110,
            98,
            111,
            117,
            110,
            100,
            32,
            116,
            121,
            112,
            101,
            115,
            96,
            44,
            32,
            91,
            100,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            78,
            40,
            91,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            93,
            44,
            32,
            100,
            32,
            63,
            32,
            91,
            100,
            93,
            32,
            58,
            32,
            91,
            93,
            44,
            32,
            40,
            117,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            50,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            117,
            32,
            61,
            32,
            117,
            91,
            48,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            118,
            32,
            61,
            32,
            117,
            46,
            117,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            69,
            32,
            61,
            32,
            118,
            46,
            70,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            69,
            32,
            61,
            32,
            90,
            97,
            46,
            112,
            114,
            111,
            116,
            111,
            116,
            121,
            112,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            117,
            32,
            61,
            32,
            82,
            40,
            110,
            44,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            46,
            46,
            46,
            79,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            103,
            101,
            116,
            80,
            114,
            111,
            116,
            111,
            116,
            121,
            112,
            101,
            79,
            102,
            40,
            116,
            104,
            105,
            115,
            41,
            32,
            33,
            61,
            61,
            32,
            99,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            34,
            85,
            115,
            101,
            32,
            39,
            110,
            101,
            119,
            39,
            32,
            116,
            111,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            32,
            34,
            32,
            43,
            32,
            110,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            66,
            46,
            69,
            97,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            110,
            32,
            43,
            32,
            34,
            32,
            104,
            97,
            115,
            32,
            110,
            111,
            32,
            97,
            99,
            99,
            101,
            115,
            115,
            105,
            98,
            108,
            101,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            119,
            98,
            32,
            61,
            32,
            66,
            46,
            69,
            97,
            91,
            79,
            97,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            119,
            98,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            96,
            84,
            114,
            105,
            101,
            100,
            32,
            116,
            111,
            32,
            105,
            110,
            118,
            111,
            107,
            101,
            32,
            99,
            116,
            111,
            114,
            32,
            111,
            102,
            32,
            36,
            123,
            110,
            125,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            110,
            118,
            97,
            108,
            105,
            100,
            32,
            110,
            117,
            109,
            98,
            101,
            114,
            32,
            111,
            102,
            32,
            112,
            97,
            114,
            97,
            109,
            101,
            116,
            101,
            114,
            115,
            32,
            40,
            36,
            123,
            79,
            97,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            125,
            41,
            32,
            45,
            32,
            101,
            120,
            112,
            101,
            99,
            116,
            101,
            100,
            32,
            40,
            36,
            123,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            107,
            101,
            121,
            115,
            40,
            66,
            46,
            69,
            97,
            41,
            46,
            116,
            111,
            83,
            116,
            114,
            105,
            110,
            103,
            40,
            41,
            125,
            41,
            32,
            112,
            97,
            114,
            97,
            109,
            101,
            116,
            101,
            114,
            115,
            32,
            105,
            110,
            115,
            116,
            101,
            97,
            100,
            33,
            96,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            119,
            98,
            46,
            97,
            112,
            112,
            108,
            121,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            79,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            97,
            32,
            61,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            99,
            114,
            101,
            97,
            116,
            101,
            40,
            69,
            44,
            32,
            123,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            58,
            32,
            123,
            32,
            118,
            97,
            108,
            117,
            101,
            58,
            32,
            117,
            32,
            125,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            117,
            46,
            112,
            114,
            111,
            116,
            111,
            116,
            121,
            112,
            101,
            32,
            61,
            32,
            99,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            66,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            99,
            98,
            40,
            110,
            44,
            32,
            117,
            44,
            32,
            99,
            97,
            44,
            32,
            114,
            44,
            32,
            118,
            44,
            32,
            102,
            44,
            32,
            103,
            44,
            32,
            109,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            66,
            46,
            122,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            40,
            95,
            97,
            50,
            32,
            61,
            32,
            40,
            100,
            97,
            32,
            61,
            32,
            66,
            46,
            122,
            97,
            41,
            46,
            79,
            97,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            97,
            50,
            32,
            58,
            32,
            100,
            97,
            46,
            79,
            97,
            32,
            61,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            66,
            46,
            122,
            97,
            46,
            79,
            97,
            46,
            112,
            117,
            115,
            104,
            40,
            66,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            106,
            98,
            40,
            110,
            44,
            32,
            66,
            44,
            32,
            116,
            114,
            117,
            101,
            44,
            32,
            102,
            97,
            108,
            115,
            101,
            44,
            32,
            102,
            97,
            108,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            97,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            106,
            98,
            40,
            110,
            32,
            43,
            32,
            34,
            42,
            34,
            44,
            32,
            66,
            44,
            32,
            102,
            97,
            108,
            115,
            101,
            44,
            32,
            102,
            97,
            108,
            115,
            101,
            44,
            32,
            102,
            97,
            108,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            69,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            106,
            98,
            40,
            110,
            32,
            43,
            32,
            34,
            32,
            99,
            111,
            110,
            115,
            116,
            42,
            34,
            44,
            32,
            66,
            44,
            32,
            102,
            97,
            108,
            115,
            101,
            44,
            32,
            116,
            114,
            117,
            101,
            44,
            32,
            102,
            97,
            108,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            85,
            97,
            91,
            97,
            93,
            32,
            61,
            32,
            123,
            32,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            84,
            121,
            112,
            101,
            58,
            32,
            100,
            97,
            44,
            32,
            83,
            97,
            58,
            32,
            69,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            98,
            40,
            65,
            44,
            32,
            117,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            91,
            118,
            44,
            32,
            100,
            97,
            44,
            32,
            69,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            113,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            104,
            32,
            61,
            32,
            114,
            98,
            40,
            98,
            44,
            32,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            32,
            61,
            32,
            84,
            40,
            100,
            44,
            32,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            78,
            40,
            91,
            93,
            44,
            32,
            91,
            97,
            93,
            44,
            32,
            40,
            103,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            103,
            32,
            61,
            32,
            103,
            91,
            48,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            108,
            32,
            61,
            32,
            96,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            32,
            36,
            123,
            103,
            46,
            110,
            97,
            109,
            101,
            125,
            96,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            103,
            46,
            117,
            97,
            46,
            69,
            97,
            32,
            38,
            38,
            32,
            40,
            103,
            46,
            117,
            97,
            46,
            69,
            97,
            32,
            61,
            32,
            91,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            33,
            61,
            61,
            32,
            103,
            46,
            117,
            97,
            46,
            69,
            97,
            91,
            98,
            32,
            45,
            32,
            49,
            93,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            114,
            101,
            103,
            105,
            115,
            116,
            101,
            114,
            32,
            109,
            117,
            108,
            116,
            105,
            112,
            108,
            101,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            115,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            101,
            110,
            116,
            105,
            99,
            97,
            108,
            32,
            110,
            117,
            109,
            98,
            101,
            114,
            32,
            111,
            102,
            32,
            112,
            97,
            114,
            97,
            109,
            101,
            116,
            101,
            114,
            115,
            32,
            40,
            36,
            123,
            98,
            32,
            45,
            32,
            49,
            125,
            41,
            32,
            102,
            111,
            114,
            32,
            99,
            108,
            97,
            115,
            115,
            32,
            39,
            36,
            123,
            103,
            46,
            110,
            97,
            109,
            101,
            125,
            39,
            33,
            32,
            79,
            118,
            101,
            114,
            108,
            111,
            97,
            100,
            32,
            114,
            101,
            115,
            111,
            108,
            117,
            116,
            105,
            111,
            110,
            32,
            105,
            115,
            32,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            108,
            121,
            32,
            111,
            110,
            108,
            121,
            32,
            112,
            101,
            114,
            102,
            111,
            114,
            109,
            101,
            100,
            32,
            117,
            115,
            105,
            110,
            103,
            32,
            116,
            104,
            101,
            32,
            112,
            97,
            114,
            97,
            109,
            101,
            116,
            101,
            114,
            32,
            99,
            111,
            117,
            110,
            116,
            44,
            32,
            110,
            111,
            116,
            32,
            97,
            99,
            116,
            117,
            97,
            108,
            32,
            116,
            121,
            112,
            101,
            32,
            105,
            110,
            102,
            111,
            33,
            96,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            103,
            46,
            117,
            97,
            46,
            69,
            97,
            91,
            98,
            32,
            45,
            32,
            49,
            93,
            32,
            61,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            113,
            98,
            40,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            32,
            36,
            123,
            103,
            46,
            110,
            97,
            109,
            101,
            125,
            32,
            100,
            117,
            101,
            32,
            116,
            111,
            32,
            117,
            110,
            98,
            111,
            117,
            110,
            100,
            32,
            116,
            121,
            112,
            101,
            115,
            96,
            44,
            32,
            104,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            78,
            40,
            91,
            93,
            44,
            32,
            104,
            44,
            32,
            40,
            109,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            46,
            115,
            112,
            108,
            105,
            99,
            101,
            40,
            49,
            44,
            32,
            48,
            44,
            32,
            110,
            117,
            108,
            108,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            103,
            46,
            117,
            97,
            46,
            69,
            97,
            91,
            98,
            32,
            45,
            32,
            49,
            93,
            32,
            61,
            32,
            116,
            98,
            40,
            108,
            44,
            32,
            109,
            44,
            32,
            110,
            117,
            108,
            108,
            44,
            32,
            101,
            44,
            32,
            102,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            44,
            32,
            104,
            44,
            32,
            103,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            108,
            32,
            61,
            32,
            114,
            98,
            40,
            99,
            44,
            32,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            61,
            32,
            79,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            61,
            32,
            117,
            98,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            32,
            61,
            32,
            84,
            40,
            101,
            44,
            32,
            102,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            78,
            40,
            91,
            93,
            44,
            32,
            91,
            97,
            93,
            44,
            32,
            40,
            109,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            110,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            113,
            98,
            40,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            99,
            97,
            108,
            108,
            32,
            36,
            123,
            113,
            125,
            32,
            100,
            117,
            101,
            32,
            116,
            111,
            32,
            117,
            110,
            98,
            111,
            117,
            110,
            100,
            32,
            116,
            121,
            112,
            101,
            115,
            96,
            44,
            32,
            108,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            32,
            61,
            32,
            109,
            91,
            48,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            113,
            32,
            61,
            32,
            96,
            36,
            123,
            109,
            46,
            110,
            97,
            109,
            101,
            125,
            46,
            36,
            123,
            98,
            125,
            96,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            46,
            115,
            116,
            97,
            114,
            116,
            115,
            87,
            105,
            116,
            104,
            40,
            34,
            64,
            64,
            34,
            41,
            32,
            38,
            38,
            32,
            40,
            98,
            32,
            61,
            32,
            83,
            121,
            109,
            98,
            111,
            108,
            91,
            98,
            46,
            115,
            117,
            98,
            115,
            116,
            114,
            105,
            110,
            103,
            40,
            50,
            41,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            103,
            32,
            38,
            38,
            32,
            109,
            46,
            117,
            97,
            46,
            98,
            98,
            46,
            112,
            117,
            115,
            104,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            114,
            32,
            61,
            32,
            109,
            46,
            117,
            97,
            46,
            70,
            97,
            44,
            32,
            65,
            32,
            61,
            32,
            114,
            91,
            98,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            65,
            32,
            124,
            124,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            65,
            46,
            120,
            97,
            32,
            38,
            38,
            32,
            65,
            46,
            99,
            108,
            97,
            115,
            115,
            78,
            97,
            109,
            101,
            32,
            33,
            61,
            61,
            32,
            109,
            46,
            110,
            97,
            109,
            101,
            32,
            38,
            38,
            32,
            65,
            46,
            71,
            97,
            32,
            61,
            61,
            61,
            32,
            99,
            32,
            45,
            32,
            50,
            32,
            63,
            32,
            40,
            110,
            46,
            71,
            97,
            32,
            61,
            32,
            99,
            32,
            45,
            32,
            50,
            44,
            32,
            110,
            46,
            99,
            108,
            97,
            115,
            115,
            78,
            97,
            109,
            101,
            32,
            61,
            32,
            109,
            46,
            110,
            97,
            109,
            101,
            44,
            32,
            114,
            91,
            98,
            93,
            32,
            61,
            32,
            110,
            41,
            32,
            58,
            32,
            40,
            36,
            97,
            40,
            114,
            44,
            32,
            98,
            44,
            32,
            113,
            41,
            44,
            32,
            114,
            91,
            98,
            93,
            46,
            120,
            97,
            91,
            99,
            32,
            45,
            32,
            50,
            93,
            32,
            61,
            32,
            110,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            78,
            40,
            91,
            93,
            44,
            32,
            108,
            44,
            32,
            40,
            117,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            117,
            32,
            61,
            32,
            116,
            98,
            40,
            113,
            44,
            32,
            117,
            44,
            32,
            109,
            44,
            32,
            102,
            44,
            32,
            104,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            114,
            91,
            98,
            93,
            46,
            120,
            97,
            32,
            63,
            32,
            40,
            117,
            46,
            71,
            97,
            32,
            61,
            32,
            99,
            32,
            45,
            32,
            50,
            44,
            32,
            114,
            91,
            98,
            93,
            32,
            61,
            32,
            117,
            41,
            32,
            58,
            32,
            114,
            91,
            98,
            93,
            46,
            120,
            97,
            91,
            99,
            32,
            45,
            32,
            50,
            93,
            32,
            61,
            32,
            117,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            85,
            58,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            77,
            40,
            97,
            44,
            32,
            122,
            98,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            120,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            101,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            61,
            32,
            79,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            46,
            118,
            97,
            108,
            117,
            101,
            115,
            32,
            61,
            32,
            123,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            77,
            40,
            97,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            97,
            109,
            101,
            58,
            32,
            98,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            58,
            32,
            101,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            102,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            46,
            118,
            97,
            108,
            117,
            101,
            115,
            91,
            102,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            111,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            40,
            102,
            44,
            32,
            104,
            41,
            32,
            61,
            62,
            32,
            104,
            46,
            118,
            97,
            108,
            117,
            101,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            66,
            97,
            58,
            32,
            56,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            70,
            114,
            111,
            109,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            58,
            32,
            65,
            98,
            40,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            67,
            97,
            58,
            32,
            110,
            117,
            108,
            108,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            98,
            40,
            98,
            44,
            32,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            66,
            98,
            40,
            97,
            44,
            32,
            34,
            101,
            110,
            117,
            109,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            61,
            32,
            79,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            32,
            61,
            32,
            100,
            46,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            32,
            61,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            99,
            114,
            101,
            97,
            116,
            101,
            40,
            100,
            46,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            46,
            112,
            114,
            111,
            116,
            111,
            116,
            121,
            112,
            101,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            108,
            117,
            101,
            58,
            32,
            123,
            32,
            118,
            97,
            108,
            117,
            101,
            58,
            32,
            99,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            58,
            32,
            123,
            32,
            118,
            97,
            108,
            117,
            101,
            58,
            32,
            82,
            40,
            96,
            36,
            123,
            100,
            46,
            110,
            97,
            109,
            101,
            125,
            95,
            36,
            123,
            98,
            125,
            96,
            44,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            46,
            118,
            97,
            108,
            117,
            101,
            115,
            91,
            99,
            93,
            32,
            61,
            32,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            91,
            98,
            93,
            32,
            61,
            32,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            122,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            61,
            32,
            79,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            77,
            40,
            97,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            97,
            109,
            101,
            58,
            32,
            98,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            40,
            100,
            41,
            32,
            61,
            62,
            32,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            111,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            40,
            100,
            44,
            32,
            101,
            41,
            32,
            61,
            62,
            32,
            101,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            66,
            97,
            58,
            32,
            56,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            70,
            114,
            111,
            109,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            58,
            32,
            67,
            98,
            40,
            98,
            44,
            32,
            99,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            67,
            97,
            58,
            32,
            110,
            117,
            108,
            108,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            117,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            104,
            32,
            61,
            32,
            114,
            98,
            40,
            98,
            44,
            32,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            32,
            61,
            32,
            79,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            32,
            61,
            32,
            117,
            98,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            32,
            61,
            32,
            84,
            40,
            100,
            44,
            32,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            98,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            113,
            98,
            40,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            99,
            97,
            108,
            108,
            32,
            36,
            123,
            97,
            125,
            32,
            100,
            117,
            101,
            32,
            116,
            111,
            32,
            117,
            110,
            98,
            111,
            117,
            110,
            100,
            32,
            116,
            121,
            112,
            101,
            115,
            96,
            44,
            32,
            104,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            45,
            32,
            49,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            78,
            40,
            91,
            93,
            44,
            32,
            104,
            44,
            32,
            40,
            103,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            98,
            40,
            97,
            44,
            32,
            116,
            98,
            40,
            97,
            44,
            32,
            91,
            103,
            91,
            48,
            93,
            44,
            32,
            110,
            117,
            108,
            108,
            93,
            46,
            99,
            111,
            110,
            99,
            97,
            116,
            40,
            103,
            46,
            115,
            108,
            105,
            99,
            101,
            40,
            49,
            41,
            41,
            44,
            32,
            110,
            117,
            108,
            108,
            44,
            32,
            101,
            44,
            32,
            102,
            41,
            44,
            32,
            98,
            32,
            45,
            32,
            49,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            61,
            32,
            79,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            45,
            49,
            32,
            61,
            61,
            61,
            32,
            101,
            32,
            38,
            38,
            32,
            40,
            101,
            32,
            61,
            32,
            52,
            50,
            57,
            52,
            57,
            54,
            55,
            50,
            57,
            53,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            32,
            61,
            32,
            40,
            103,
            41,
            32,
            61,
            62,
            32,
            103,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            48,
            32,
            61,
            61,
            61,
            32,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            102,
            32,
            61,
            32,
            51,
            50,
            32,
            45,
            32,
            56,
            32,
            42,
            32,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            32,
            61,
            32,
            40,
            103,
            41,
            32,
            61,
            62,
            32,
            103,
            32,
            60,
            60,
            32,
            102,
            32,
            62,
            62,
            62,
            32,
            102,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            104,
            32,
            61,
            32,
            98,
            46,
            105,
            110,
            99,
            108,
            117,
            100,
            101,
            115,
            40,
            34,
            117,
            110,
            115,
            105,
            103,
            110,
            101,
            100,
            34,
            41,
            32,
            63,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            103,
            44,
            32,
            108,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            108,
            32,
            62,
            62,
            62,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            58,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            103,
            44,
            32,
            108,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            77,
            40,
            97,
            44,
            32,
            123,
            32,
            110,
            97,
            109,
            101,
            58,
            32,
            98,
            44,
            32,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            101,
            44,
            32,
            116,
            111,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            104,
            44,
            32,
            66,
            97,
            58,
            32,
            56,
            44,
            32,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            70,
            114,
            111,
            109,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            58,
            32,
            68,
            98,
            40,
            98,
            44,
            32,
            99,
            44,
            32,
            48,
            32,
            33,
            61,
            61,
            32,
            100,
            41,
            44,
            32,
            67,
            97,
            58,
            32,
            110,
            117,
            108,
            108,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            104,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            100,
            40,
            102,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            110,
            101,
            119,
            32,
            101,
            40,
            119,
            46,
            98,
            117,
            102,
            102,
            101,
            114,
            44,
            32,
            68,
            91,
            102,
            32,
            43,
            32,
            52,
            32,
            62,
            62,
            32,
            50,
            93,
            44,
            32,
            68,
            91,
            102,
            32,
            62,
            62,
            32,
            50,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            101,
            32,
            61,
            32,
            91,
            73,
            110,
            116,
            56,
            65,
            114,
            114,
            97,
            121,
            44,
            32,
            85,
            105,
            110,
            116,
            56,
            65,
            114,
            114,
            97,
            121,
            44,
            32,
            73,
            110,
            116,
            49,
            54,
            65,
            114,
            114,
            97,
            121,
            44,
            32,
            85,
            105,
            110,
            116,
            49,
            54,
            65,
            114,
            114,
            97,
            121,
            44,
            32,
            73,
            110,
            116,
            51,
            50,
            65,
            114,
            114,
            97,
            121,
            44,
            32,
            85,
            105,
            110,
            116,
            51,
            50,
            65,
            114,
            114,
            97,
            121,
            44,
            32,
            70,
            108,
            111,
            97,
            116,
            51,
            50,
            65,
            114,
            114,
            97,
            121,
            44,
            32,
            70,
            108,
            111,
            97,
            116,
            54,
            52,
            65,
            114,
            114,
            97,
            121,
            93,
            91,
            98,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            32,
            61,
            32,
            79,
            40,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            77,
            40,
            97,
            44,
            32,
            123,
            32,
            110,
            97,
            109,
            101,
            58,
            32,
            99,
            44,
            32,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            100,
            44,
            32,
            66,
            97,
            58,
            32,
            56,
            44,
            32,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            70,
            114,
            111,
            109,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            58,
            32,
            100,
            32,
            125,
            44,
            32,
            123,
            32,
            36,
            97,
            58,
            32,
            116,
            114,
            117,
            101,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            58,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            77,
            40,
            97,
            44,
            32,
            69,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            36,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            44,
            32,
            104,
            44,
            32,
            103,
            44,
            32,
            108,
            44,
            32,
            109,
            44,
            32,
            110,
            44,
            32,
            113,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            32,
            61,
            32,
            79,
            40,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            32,
            61,
            32,
            84,
            40,
            101,
            44,
            32,
            102,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            103,
            32,
            61,
            32,
            84,
            40,
            104,
            44,
            32,
            103,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            32,
            61,
            32,
            84,
            40,
            108,
            44,
            32,
            109,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            113,
            32,
            61,
            32,
            84,
            40,
            110,
            44,
            32,
            113,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            78,
            40,
            91,
            97,
            93,
            44,
            32,
            91,
            98,
            93,
            44,
            32,
            40,
            114,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            32,
            61,
            32,
            114,
            91,
            48,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            91,
            110,
            101,
            119,
            32,
            106,
            98,
            40,
            99,
            44,
            32,
            114,
            46,
            117,
            97,
            44,
            32,
            102,
            97,
            108,
            115,
            101,
            44,
            32,
            102,
            97,
            108,
            115,
            101,
            44,
            32,
            116,
            114,
            117,
            101,
            44,
            32,
            114,
            44,
            32,
            100,
            44,
            32,
            102,
            44,
            32,
            103,
            44,
            32,
            109,
            44,
            32,
            113,
            41,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            65,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            61,
            32,
            79,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            34,
            115,
            116,
            100,
            58,
            58,
            115,
            116,
            114,
            105,
            110,
            103,
            34,
            32,
            61,
            61,
            61,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            77,
            40,
            97,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            97,
            109,
            101,
            58,
            32,
            98,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            101,
            32,
            61,
            32,
            68,
            91,
            100,
            32,
            62,
            62,
            32,
            50,
            93,
            44,
            32,
            102,
            32,
            61,
            32,
            100,
            32,
            43,
            32,
            52,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            99,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            104,
            32,
            61,
            32,
            102,
            44,
            32,
            103,
            32,
            61,
            32,
            48,
            59,
            32,
            103,
            32,
            60,
            61,
            32,
            101,
            59,
            32,
            43,
            43,
            103,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            108,
            32,
            61,
            32,
            102,
            32,
            43,
            32,
            103,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            103,
            32,
            61,
            61,
            32,
            101,
            32,
            124,
            124,
            32,
            48,
            32,
            61,
            61,
            32,
            120,
            91,
            108,
            93,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            104,
            32,
            61,
            32,
            104,
            32,
            63,
            32,
            71,
            97,
            40,
            104,
            44,
            32,
            108,
            32,
            45,
            32,
            104,
            41,
            32,
            58,
            32,
            34,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            109,
            41,
            32,
            118,
            97,
            114,
            32,
            109,
            32,
            61,
            32,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            108,
            115,
            101,
            32,
            109,
            32,
            43,
            61,
            32,
            83,
            116,
            114,
            105,
            110,
            103,
            46,
            102,
            114,
            111,
            109,
            67,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            40,
            48,
            41,
            44,
            32,
            109,
            32,
            43,
            61,
            32,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            104,
            32,
            61,
            32,
            108,
            32,
            43,
            32,
            49,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            32,
            61,
            32,
            65,
            114,
            114,
            97,
            121,
            40,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            103,
            32,
            61,
            32,
            48,
            59,
            32,
            103,
            32,
            60,
            32,
            101,
            59,
            32,
            43,
            43,
            103,
            41,
            32,
            109,
            91,
            103,
            93,
            32,
            61,
            32,
            83,
            116,
            114,
            105,
            110,
            103,
            46,
            102,
            114,
            111,
            109,
            67,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            40,
            120,
            91,
            102,
            32,
            43,
            32,
            103,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            32,
            61,
            32,
            109,
            46,
            106,
            111,
            105,
            110,
            40,
            34,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            85,
            40,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            109,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            111,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            100,
            44,
            32,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            111,
            102,
            32,
            65,
            114,
            114,
            97,
            121,
            66,
            117,
            102,
            102,
            101,
            114,
            32,
            38,
            38,
            32,
            40,
            101,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            85,
            105,
            110,
            116,
            56,
            65,
            114,
            114,
            97,
            121,
            40,
            101,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            102,
            44,
            32,
            104,
            32,
            61,
            32,
            34,
            115,
            116,
            114,
            105,
            110,
            103,
            34,
            32,
            61,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            40,
            104,
            32,
            124,
            124,
            32,
            101,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            111,
            102,
            32,
            85,
            105,
            110,
            116,
            56,
            65,
            114,
            114,
            97,
            121,
            32,
            124,
            124,
            32,
            101,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            111,
            102,
            32,
            85,
            105,
            110,
            116,
            56,
            67,
            108,
            97,
            109,
            112,
            101,
            100,
            65,
            114,
            114,
            97,
            121,
            32,
            124,
            124,
            32,
            101,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            111,
            102,
            32,
            73,
            110,
            116,
            56,
            65,
            114,
            114,
            97,
            121,
            41,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            34,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            112,
            97,
            115,
            115,
            32,
            110,
            111,
            110,
            45,
            115,
            116,
            114,
            105,
            110,
            103,
            32,
            116,
            111,
            32,
            115,
            116,
            100,
            58,
            58,
            115,
            116,
            114,
            105,
            110,
            103,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            99,
            32,
            38,
            38,
            32,
            104,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            103,
            32,
            61,
            32,
            102,
            32,
            61,
            32,
            48,
            59,
            32,
            103,
            32,
            60,
            32,
            101,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            32,
            43,
            43,
            103,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            108,
            32,
            61,
            32,
            101,
            46,
            99,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            65,
            116,
            40,
            103,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            49,
            50,
            55,
            32,
            62,
            61,
            32,
            108,
            32,
            63,
            32,
            102,
            43,
            43,
            32,
            58,
            32,
            50,
            48,
            52,
            55,
            32,
            62,
            61,
            32,
            108,
            32,
            63,
            32,
            102,
            32,
            43,
            61,
            32,
            50,
            32,
            58,
            32,
            53,
            53,
            50,
            57,
            54,
            32,
            60,
            61,
            32,
            108,
            32,
            38,
            38,
            32,
            53,
            55,
            51,
            52,
            51,
            32,
            62,
            61,
            32,
            108,
            32,
            63,
            32,
            40,
            102,
            32,
            43,
            61,
            32,
            52,
            44,
            32,
            43,
            43,
            103,
            41,
            32,
            58,
            32,
            102,
            32,
            43,
            61,
            32,
            51,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            108,
            115,
            101,
            32,
            102,
            32,
            61,
            32,
            101,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            103,
            32,
            61,
            32,
            98,
            99,
            40,
            52,
            32,
            43,
            32,
            102,
            32,
            43,
            32,
            49,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            32,
            61,
            32,
            103,
            32,
            43,
            32,
            52,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            68,
            91,
            103,
            32,
            62,
            62,
            32,
            50,
            93,
            32,
            61,
            32,
            102,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            99,
            32,
            38,
            38,
            32,
            104,
            41,
            32,
            72,
            40,
            101,
            44,
            32,
            108,
            44,
            32,
            102,
            32,
            43,
            32,
            49,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            108,
            115,
            101,
            32,
            105,
            102,
            32,
            40,
            104,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            104,
            32,
            61,
            32,
            48,
            59,
            32,
            104,
            32,
            60,
            32,
            102,
            59,
            32,
            43,
            43,
            104,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            109,
            32,
            61,
            32,
            101,
            46,
            99,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            65,
            116,
            40,
            104,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            50,
            53,
            53,
            32,
            60,
            32,
            109,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            85,
            40,
            108,
            41,
            44,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            34,
            83,
            116,
            114,
            105,
            110,
            103,
            32,
            104,
            97,
            115,
            32,
            85,
            84,
            70,
            45,
            49,
            54,
            32,
            99,
            111,
            100,
            101,
            32,
            117,
            110,
            105,
            116,
            115,
            32,
            116,
            104,
            97,
            116,
            32,
            100,
            111,
            32,
            110,
            111,
            116,
            32,
            102,
            105,
            116,
            32,
            105,
            110,
            32,
            56,
            32,
            98,
            105,
            116,
            115,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            120,
            91,
            108,
            32,
            43,
            32,
            104,
            93,
            32,
            61,
            32,
            109,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            108,
            115,
            101,
            32,
            102,
            111,
            114,
            32,
            40,
            104,
            32,
            61,
            32,
            48,
            59,
            32,
            104,
            32,
            60,
            32,
            102,
            59,
            32,
            43,
            43,
            104,
            41,
            32,
            120,
            91,
            108,
            32,
            43,
            32,
            104,
            93,
            32,
            61,
            32,
            101,
            91,
            104,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            117,
            108,
            108,
            32,
            33,
            61,
            61,
            32,
            100,
            32,
            38,
            38,
            32,
            100,
            46,
            112,
            117,
            115,
            104,
            40,
            85,
            44,
            32,
            103,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            103,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            66,
            97,
            58,
            32,
            56,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            70,
            114,
            111,
            109,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            58,
            32,
            73,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            67,
            97,
            40,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            85,
            40,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            32,
            61,
            32,
            79,
            40,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            50,
            32,
            61,
            61,
            61,
            32,
            98,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            71,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            101,
            32,
            61,
            32,
            72,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            102,
            32,
            61,
            32,
            73,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            104,
            32,
            61,
            32,
            40,
            103,
            41,
            32,
            61,
            62,
            32,
            122,
            91,
            103,
            32,
            62,
            62,
            32,
            49,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            52,
            32,
            61,
            61,
            61,
            32,
            98,
            32,
            38,
            38,
            32,
            40,
            100,
            32,
            61,
            32,
            74,
            98,
            44,
            32,
            101,
            32,
            61,
            32,
            75,
            98,
            44,
            32,
            102,
            32,
            61,
            32,
            76,
            98,
            44,
            32,
            104,
            32,
            61,
            32,
            40,
            103,
            41,
            32,
            61,
            62,
            32,
            68,
            91,
            103,
            32,
            62,
            62,
            32,
            50,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            77,
            40,
            97,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            97,
            109,
            101,
            58,
            32,
            99,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            40,
            103,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            108,
            32,
            61,
            32,
            68,
            91,
            103,
            32,
            62,
            62,
            32,
            50,
            93,
            44,
            32,
            109,
            44,
            32,
            110,
            32,
            61,
            32,
            103,
            32,
            43,
            32,
            52,
            44,
            32,
            113,
            32,
            61,
            32,
            48,
            59,
            32,
            113,
            32,
            60,
            61,
            32,
            108,
            59,
            32,
            43,
            43,
            113,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            114,
            32,
            61,
            32,
            103,
            32,
            43,
            32,
            52,
            32,
            43,
            32,
            113,
            32,
            42,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            113,
            32,
            61,
            61,
            32,
            108,
            32,
            124,
            124,
            32,
            48,
            32,
            61,
            61,
            32,
            104,
            40,
            114,
            41,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            32,
            61,
            32,
            100,
            40,
            110,
            44,
            32,
            114,
            32,
            45,
            32,
            110,
            41,
            44,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            61,
            61,
            61,
            32,
            109,
            32,
            63,
            32,
            109,
            32,
            61,
            32,
            110,
            32,
            58,
            32,
            40,
            109,
            32,
            43,
            61,
            32,
            83,
            116,
            114,
            105,
            110,
            103,
            46,
            102,
            114,
            111,
            109,
            67,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            40,
            48,
            41,
            44,
            32,
            109,
            32,
            43,
            61,
            32,
            110,
            41,
            44,
            32,
            110,
            32,
            61,
            32,
            114,
            32,
            43,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            85,
            40,
            103,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            109,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            111,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            40,
            103,
            44,
            32,
            108,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            34,
            115,
            116,
            114,
            105,
            110,
            103,
            34,
            32,
            33,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            108,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            80,
            40,
            96,
            67,
            97,
            110,
            110,
            111,
            116,
            32,
            112,
            97,
            115,
            115,
            32,
            110,
            111,
            110,
            45,
            115,
            116,
            114,
            105,
            110,
            103,
            32,
            116,
            111,
            32,
            67,
            43,
            43,
            32,
            115,
            116,
            114,
            105,
            110,
            103,
            32,
            116,
            121,
            112,
            101,
            32,
            36,
            123,
            99,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            109,
            32,
            61,
            32,
            102,
            40,
            108,
            41,
            44,
            32,
            110,
            32,
            61,
            32,
            98,
            99,
            40,
            52,
            32,
            43,
            32,
            109,
            32,
            43,
            32,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            68,
            91,
            110,
            32,
            62,
            62,
            32,
            50,
            93,
            32,
            61,
            32,
            109,
            32,
            47,
            32,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            40,
            108,
            44,
            32,
            110,
            32,
            43,
            32,
            52,
            44,
            32,
            109,
            32,
            43,
            32,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            117,
            108,
            108,
            32,
            33,
            61,
            61,
            32,
            103,
            32,
            38,
            38,
            32,
            103,
            46,
            112,
            117,
            115,
            104,
            40,
            85,
            44,
            32,
            110,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            66,
            97,
            58,
            32,
            56,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            70,
            114,
            111,
            109,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            58,
            32,
            73,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            67,
            97,
            40,
            103,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            85,
            40,
            103,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            119,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            75,
            97,
            91,
            97,
            93,
            32,
            61,
            32,
            123,
            32,
            110,
            97,
            109,
            101,
            58,
            32,
            79,
            40,
            98,
            41,
            44,
            32,
            78,
            97,
            58,
            32,
            84,
            40,
            99,
            44,
            32,
            100,
            41,
            44,
            32,
            68,
            97,
            58,
            32,
            84,
            40,
            101,
            44,
            32,
            102,
            41,
            44,
            32,
            81,
            97,
            58,
            32,
            91,
            93,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            106,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            44,
            32,
            104,
            44,
            32,
            103,
            44,
            32,
            108,
            44,
            32,
            109,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            75,
            97,
            91,
            97,
            93,
            46,
            81,
            97,
            46,
            112,
            117,
            115,
            104,
            40,
            123,
            32,
            85,
            97,
            58,
            32,
            79,
            40,
            98,
            41,
            44,
            32,
            90,
            97,
            58,
            32,
            99,
            44,
            32,
            88,
            97,
            58,
            32,
            84,
            40,
            100,
            44,
            32,
            101,
            41,
            44,
            32,
            89,
            97,
            58,
            32,
            102,
            44,
            32,
            102,
            98,
            58,
            32,
            104,
            44,
            32,
            101,
            98,
            58,
            32,
            84,
            40,
            103,
            44,
            32,
            108,
            41,
            44,
            32,
            103,
            98,
            58,
            32,
            109,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            87,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            61,
            32,
            79,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            77,
            40,
            97,
            44,
            32,
            123,
            32,
            105,
            98,
            58,
            32,
            116,
            114,
            117,
            101,
            44,
            32,
            110,
            97,
            109,
            101,
            58,
            32,
            98,
            44,
            32,
            66,
            97,
            58,
            32,
            48,
            44,
            32,
            102,
            114,
            111,
            109,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            116,
            111,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            58,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            72,
            58,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            69,
            97,
            32,
            61,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            77,
            98,
            32,
            61,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            68,
            58,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            73,
            110,
            102,
            105,
            110,
            105,
            116,
            121,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            90,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            32,
            61,
            32,
            78,
            98,
            91,
            97,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            61,
            32,
            121,
            98,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            97,
            40,
            110,
            117,
            108,
            108,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            66,
            58,
            32,
            120,
            98,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            89,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            80,
            98,
            40,
            97,
            44,
            32,
            98,
            41,
            44,
            32,
            101,
            32,
            61,
            32,
            100,
            46,
            115,
            104,
            105,
            102,
            116,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            45,
            45,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            102,
            32,
            61,
            32,
            65,
            114,
            114,
            97,
            121,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            61,
            32,
            96,
            109,
            101,
            116,
            104,
            111,
            100,
            67,
            97,
            108,
            108,
            101,
            114,
            60,
            40,
            36,
            123,
            100,
            46,
            109,
            97,
            112,
            40,
            40,
            104,
            41,
            32,
            61,
            62,
            32,
            104,
            46,
            110,
            97,
            109,
            101,
            41,
            46,
            106,
            111,
            105,
            110,
            40,
            34,
            44,
            32,
            34,
            41,
            125,
            41,
            32,
            61,
            62,
            32,
            36,
            123,
            101,
            46,
            110,
            97,
            109,
            101,
            125,
            62,
            96,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            79,
            98,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            82,
            40,
            98,
            44,
            32,
            40,
            104,
            44,
            32,
            103,
            44,
            32,
            108,
            44,
            32,
            109,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            110,
            32,
            61,
            32,
            48,
            44,
            32,
            113,
            32,
            61,
            32,
            48,
            59,
            32,
            113,
            32,
            60,
            32,
            97,
            59,
            32,
            43,
            43,
            113,
            41,
            32,
            102,
            91,
            113,
            93,
            32,
            61,
            32,
            100,
            91,
            113,
            93,
            46,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            70,
            114,
            111,
            109,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            40,
            109,
            32,
            43,
            32,
            110,
            41,
            44,
            32,
            110,
            32,
            43,
            61,
            32,
            100,
            91,
            113,
            93,
            46,
            66,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            103,
            32,
            61,
            32,
            49,
            32,
            61,
            61,
            61,
            32,
            99,
            32,
            63,
            32,
            81,
            98,
            40,
            103,
            44,
            32,
            102,
            41,
            32,
            58,
            32,
            103,
            46,
            97,
            112,
            112,
            108,
            121,
            40,
            104,
            44,
            32,
            102,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            104,
            32,
            61,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            103,
            32,
            61,
            32,
            101,
            46,
            116,
            111,
            87,
            105,
            114,
            101,
            84,
            121,
            112,
            101,
            40,
            104,
            44,
            32,
            103,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            104,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            32,
            38,
            38,
            32,
            40,
            68,
            91,
            108,
            32,
            62,
            62,
            32,
            50,
            93,
            32,
            61,
            32,
            104,
            98,
            40,
            104,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            103,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            58,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            57,
            32,
            60,
            32,
            97,
            32,
            38,
            38,
            32,
            40,
            86,
            91,
            97,
            32,
            43,
            32,
            49,
            93,
            32,
            43,
            61,
            32,
            49,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            88,
            58,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            98,
            32,
            61,
            32,
            121,
            98,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            76,
            97,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            120,
            98,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            111,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            32,
            61,
            32,
            66,
            98,
            40,
            97,
            44,
            32,
            34,
            95,
            101,
            109,
            118,
            97,
            108,
            95,
            116,
            97,
            107,
            101,
            95,
            118,
            97,
            108,
            117,
            101,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            32,
            61,
            32,
            97,
            46,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            70,
            114,
            111,
            109,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            104,
            98,
            40,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            69,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            82,
            98,
            91,
            97,
            93,
            32,
            38,
            38,
            32,
            40,
            99,
            108,
            101,
            97,
            114,
            84,
            105,
            109,
            101,
            111,
            117,
            116,
            40,
            82,
            98,
            91,
            97,
            93,
            46,
            105,
            100,
            41,
            44,
            32,
            100,
            101,
            108,
            101,
            116,
            101,
            32,
            82,
            98,
            91,
            97,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            98,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            115,
            101,
            116,
            84,
            105,
            109,
            101,
            111,
            117,
            116,
            40,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            101,
            108,
            101,
            116,
            101,
            32,
            82,
            98,
            91,
            97,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            85,
            98,
            40,
            40,
            41,
            32,
            61,
            62,
            32,
            99,
            99,
            40,
            97,
            44,
            32,
            112,
            101,
            114,
            102,
            111,
            114,
            109,
            97,
            110,
            99,
            101,
            46,
            110,
            111,
            119,
            40,
            41,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            82,
            98,
            91,
            97,
            93,
            32,
            61,
            32,
            123,
            32,
            105,
            100,
            58,
            32,
            99,
            44,
            32,
            106,
            98,
            58,
            32,
            98,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            70,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            101,
            32,
            61,
            32,
            40,
            47,
            42,
            32,
            64,
            95,
            95,
            80,
            85,
            82,
            69,
            95,
            95,
            32,
            42,
            47,
            32,
            110,
            101,
            119,
            32,
            68,
            97,
            116,
            101,
            40,
            41,
            41,
            46,
            103,
            101,
            116,
            70,
            117,
            108,
            108,
            89,
            101,
            97,
            114,
            40,
            41,
            44,
            32,
            102,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            68,
            97,
            116,
            101,
            40,
            101,
            44,
            32,
            48,
            44,
            32,
            49,
            41,
            46,
            103,
            101,
            116,
            84,
            105,
            109,
            101,
            122,
            111,
            110,
            101,
            79,
            102,
            102,
            115,
            101,
            116,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            68,
            97,
            116,
            101,
            40,
            101,
            44,
            32,
            54,
            44,
            32,
            49,
            41,
            46,
            103,
            101,
            116,
            84,
            105,
            109,
            101,
            122,
            111,
            110,
            101,
            79,
            102,
            102,
            115,
            101,
            116,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            68,
            91,
            97,
            32,
            62,
            62,
            32,
            50,
            93,
            32,
            61,
            32,
            54,
            48,
            32,
            42,
            32,
            77,
            97,
            116,
            104,
            46,
            109,
            97,
            120,
            40,
            102,
            44,
            32,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            67,
            91,
            98,
            32,
            62,
            62,
            32,
            50,
            93,
            32,
            61,
            32,
            78,
            117,
            109,
            98,
            101,
            114,
            40,
            102,
            32,
            33,
            61,
            32,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            61,
            32,
            40,
            104,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            103,
            32,
            61,
            32,
            77,
            97,
            116,
            104,
            46,
            97,
            98,
            115,
            40,
            104,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            96,
            85,
            84,
            67,
            36,
            123,
            48,
            32,
            60,
            61,
            32,
            104,
            32,
            63,
            32,
            34,
            45,
            34,
            32,
            58,
            32,
            34,
            43,
            34,
            125,
            36,
            123,
            83,
            116,
            114,
            105,
            110,
            103,
            40,
            77,
            97,
            116,
            104,
            46,
            102,
            108,
            111,
            111,
            114,
            40,
            103,
            32,
            47,
            32,
            54,
            48,
            41,
            41,
            46,
            112,
            97,
            100,
            83,
            116,
            97,
            114,
            116,
            40,
            50,
            44,
            32,
            34,
            48,
            34,
            41,
            125,
            36,
            123,
            83,
            116,
            114,
            105,
            110,
            103,
            40,
            103,
            32,
            37,
            32,
            54,
            48,
            41,
            46,
            112,
            97,
            100,
            83,
            116,
            97,
            114,
            116,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            50,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            48,
            34,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            125,
            96,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            32,
            61,
            32,
            98,
            40,
            102,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            32,
            61,
            32,
            98,
            40,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            32,
            60,
            32,
            102,
            32,
            63,
            32,
            40,
            72,
            40,
            97,
            44,
            32,
            99,
            44,
            32,
            49,
            55,
            41,
            44,
            32,
            72,
            40,
            98,
            44,
            32,
            100,
            44,
            32,
            49,
            55,
            41,
            41,
            32,
            58,
            32,
            40,
            72,
            40,
            97,
            44,
            32,
            100,
            44,
            32,
            49,
            55,
            41,
            44,
            32,
            72,
            40,
            98,
            44,
            32,
            99,
            44,
            32,
            49,
            55,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            97,
            58,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            112,
            101,
            114,
            102,
            111,
            114,
            109,
            97,
            110,
            99,
            101,
            46,
            110,
            111,
            119,
            40,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            71,
            58,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            98,
            32,
            61,
            32,
            120,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            32,
            62,
            62,
            62,
            61,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            50,
            49,
            52,
            55,
            52,
            56,
            51,
            54,
            52,
            56,
            32,
            60,
            32,
            97,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            49,
            59,
            32,
            52,
            32,
            62,
            61,
            32,
            99,
            59,
            32,
            99,
            32,
            42,
            61,
            32,
            50,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            98,
            32,
            42,
            32,
            40,
            49,
            32,
            43,
            32,
            48,
            46,
            50,
            32,
            47,
            32,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            32,
            61,
            32,
            77,
            97,
            116,
            104,
            46,
            109,
            105,
            110,
            40,
            100,
            44,
            32,
            97,
            32,
            43,
            32,
            49,
            48,
            48,
            54,
            54,
            51,
            50,
            57,
            54,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            58,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            32,
            61,
            32,
            40,
            77,
            97,
            116,
            104,
            46,
            109,
            105,
            110,
            40,
            50,
            49,
            52,
            55,
            52,
            56,
            51,
            54,
            52,
            56,
            44,
            32,
            54,
            53,
            53,
            51,
            54,
            32,
            42,
            32,
            77,
            97,
            116,
            104,
            46,
            99,
            101,
            105,
            108,
            40,
            77,
            97,
            116,
            104,
            46,
            109,
            97,
            120,
            40,
            97,
            44,
            32,
            100,
            41,
            32,
            47,
            32,
            54,
            53,
            53,
            51,
            54,
            41,
            41,
            32,
            45,
            32,
            107,
            97,
            46,
            98,
            117,
            102,
            102,
            101,
            114,
            46,
            98,
            121,
            116,
            101,
            76,
            101,
            110,
            103,
            116,
            104,
            32,
            43,
            32,
            54,
            53,
            53,
            51,
            53,
            41,
            32,
            47,
            32,
            54,
            53,
            53,
            51,
            54,
            32,
            124,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            97,
            46,
            103,
            114,
            111,
            119,
            40,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            112,
            97,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            101,
            32,
            61,
            32,
            49,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            114,
            101,
            97,
            107,
            32,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            102,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            32,
            61,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            101,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            114,
            117,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            83,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            88,
            98,
            40,
            41,
            46,
            102,
            111,
            114,
            69,
            97,
            99,
            104,
            40,
            40,
            100,
            44,
            32,
            101,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            102,
            32,
            61,
            32,
            98,
            32,
            43,
            32,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            32,
            61,
            32,
            68,
            91,
            97,
            32,
            43,
            32,
            52,
            32,
            42,
            32,
            101,
            32,
            62,
            62,
            32,
            50,
            93,
            32,
            61,
            32,
            102,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            102,
            32,
            61,
            32,
            48,
            59,
            32,
            102,
            32,
            60,
            32,
            100,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            32,
            43,
            43,
            102,
            41,
            32,
            119,
            91,
            101,
            43,
            43,
            93,
            32,
            61,
            32,
            100,
            46,
            99,
            104,
            97,
            114,
            67,
            111,
            100,
            101,
            65,
            116,
            40,
            102,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            119,
            91,
            101,
            93,
            32,
            61,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            32,
            43,
            61,
            32,
            100,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            32,
            43,
            32,
            49,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            84,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            88,
            98,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            68,
            91,
            97,
            32,
            62,
            62,
            32,
            50,
            93,
            32,
            61,
            32,
            99,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            46,
            102,
            111,
            114,
            69,
            97,
            99,
            104,
            40,
            40,
            101,
            41,
            32,
            61,
            62,
            32,
            100,
            32,
            43,
            61,
            32,
            101,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            32,
            43,
            32,
            49,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            68,
            91,
            98,
            32,
            62,
            62,
            32,
            50,
            93,
            32,
            61,
            32,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            80,
            58,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            53,
            50,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            78,
            58,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            53,
            50,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            58,
            32,
            100,
            99,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            58,
            32,
            101,
            99,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            58,
            32,
            102,
            99,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            112,
            58,
            32,
            103,
            99,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            121,
            58,
            32,
            104,
            99,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            58,
            32,
            105,
            99,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            58,
            32,
            106,
            99,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            103,
            58,
            32,
            107,
            99,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            58,
            32,
            108,
            99,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            82,
            58,
            32,
            84,
            98,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            73,
            58,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            90,
            98,
            40,
            120,
            46,
            115,
            117,
            98,
            97,
            114,
            114,
            97,
            121,
            40,
            97,
            44,
            32,
            97,
            32,
            43,
            32,
            98,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            87,
            32,
            61,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            50,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            97,
            40,
            99,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            51,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            87,
            32,
            61,
            32,
            99,
            46,
            101,
            120,
            112,
            111,
            114,
            116,
            115,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            97,
            32,
            61,
            32,
            87,
            46,
            98,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            112,
            97,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            83,
            32,
            61,
            32,
            87,
            46,
            102,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            97,
            46,
            117,
            110,
            115,
            104,
            105,
            102,
            116,
            40,
            87,
            46,
            99,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            70,
            45,
            45,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            40,
            95,
            97,
            51,
            32,
            61,
            32,
            107,
            46,
            109,
            111,
            110,
            105,
            116,
            111,
            114,
            82,
            117,
            110,
            68,
            101,
            112,
            101,
            110,
            100,
            101,
            110,
            99,
            105,
            101,
            115,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            51,
            46,
            99,
            97,
            108,
            108,
            40,
            107,
            44,
            32,
            70,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            48,
            32,
            61,
            61,
            32,
            70,
            32,
            38,
            38,
            32,
            40,
            110,
            117,
            108,
            108,
            32,
            33,
            61,
            61,
            32,
            117,
            97,
            32,
            38,
            38,
            32,
            40,
            99,
            108,
            101,
            97,
            114,
            73,
            110,
            116,
            101,
            114,
            118,
            97,
            108,
            40,
            117,
            97,
            41,
            44,
            32,
            117,
            97,
            32,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            44,
            32,
            71,
            32,
            38,
            38,
            32,
            40,
            99,
            32,
            61,
            32,
            71,
            44,
            32,
            71,
            32,
            61,
            32,
            110,
            117,
            108,
            108,
            44,
            32,
            99,
            40,
            41,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            87,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            70,
            43,
            43,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            40,
            95,
            97,
            50,
            32,
            61,
            32,
            107,
            46,
            109,
            111,
            110,
            105,
            116,
            111,
            114,
            82,
            117,
            110,
            68,
            101,
            112,
            101,
            110,
            100,
            101,
            110,
            99,
            105,
            101,
            115,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            50,
            46,
            99,
            97,
            108,
            108,
            40,
            107,
            44,
            32,
            70,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            98,
            32,
            61,
            32,
            123,
            32,
            97,
            58,
            32,
            109,
            99,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            107,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            116,
            105,
            97,
            116,
            101,
            87,
            97,
            115,
            109,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            107,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            116,
            105,
            97,
            116,
            101,
            87,
            97,
            115,
            109,
            40,
            98,
            44,
            32,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            99,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            40,
            96,
            77,
            111,
            100,
            117,
            108,
            101,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            116,
            105,
            97,
            116,
            101,
            87,
            97,
            115,
            109,
            32,
            99,
            97,
            108,
            108,
            98,
            97,
            99,
            107,
            32,
            102,
            97,
            105,
            108,
            101,
            100,
            32,
            119,
            105,
            116,
            104,
            32,
            101,
            114,
            114,
            111,
            114,
            58,
            32,
            36,
            123,
            99,
            125,
            96,
            41,
            44,
            32,
            98,
            97,
            40,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            120,
            97,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            120,
            97,
            32,
            58,
            32,
            120,
            97,
            32,
            61,
            32,
            119,
            97,
            40,
            34,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            80,
            108,
            97,
            121,
            101,
            114,
            46,
            119,
            97,
            115,
            109,
            34,
            41,
            32,
            63,
            32,
            34,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            80,
            108,
            97,
            121,
            101,
            114,
            46,
            119,
            97,
            115,
            109,
            34,
            32,
            58,
            32,
            107,
            46,
            108,
            111,
            99,
            97,
            116,
            101,
            70,
            105,
            108,
            101,
            32,
            63,
            32,
            107,
            46,
            108,
            111,
            99,
            97,
            116,
            101,
            70,
            105,
            108,
            101,
            40,
            34,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            80,
            108,
            97,
            121,
            101,
            114,
            46,
            119,
            97,
            115,
            109,
            34,
            44,
            32,
            112,
            41,
            32,
            58,
            32,
            112,
            32,
            43,
            32,
            34,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            80,
            108,
            97,
            121,
            101,
            114,
            46,
            119,
            97,
            115,
            109,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            66,
            97,
            40,
            98,
            44,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            40,
            99,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            40,
            99,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            46,
            99,
            97,
            116,
            99,
            104,
            40,
            98,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            123,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            40,
            41,
            44,
            32,
            98,
            99,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            40,
            98,
            99,
            32,
            61,
            32,
            87,
            46,
            100,
            97,
            41,
            40,
            97,
            41,
            44,
            32,
            111,
            98,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            40,
            111,
            98,
            32,
            61,
            32,
            87,
            46,
            101,
            97,
            41,
            40,
            97,
            41,
            44,
            32,
            85,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            40,
            85,
            32,
            61,
            32,
            87,
            46,
            103,
            97,
            41,
            40,
            97,
            41,
            44,
            32,
            99,
            99,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            40,
            99,
            99,
            32,
            61,
            32,
            87,
            46,
            104,
            97,
            41,
            40,
            97,
            44,
            32,
            98,
            41,
            44,
            32,
            88,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            61,
            62,
            32,
            40,
            88,
            32,
            61,
            32,
            87,
            46,
            105,
            97,
            41,
            40,
            97,
            44,
            32,
            98,
            41,
            44,
            32,
            89,
            32,
            61,
            32,
            40,
            97,
            41,
            32,
            61,
            62,
            32,
            40,
            89,
            32,
            61,
            32,
            87,
            46,
            106,
            97,
            41,
            40,
            97,
            41,
            44,
            32,
            90,
            32,
            61,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            40,
            90,
            32,
            61,
            32,
            87,
            46,
            107,
            97,
            41,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            100,
            121,
            110,
            67,
            97,
            108,
            108,
            95,
            105,
            105,
            106,
            106,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            41,
            32,
            61,
            62,
            32,
            40,
            107,
            46,
            100,
            121,
            110,
            67,
            97,
            108,
            108,
            95,
            105,
            105,
            106,
            106,
            32,
            61,
            32,
            87,
            46,
            108,
            97,
            41,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            100,
            121,
            110,
            67,
            97,
            108,
            108,
            95,
            118,
            105,
            106,
            106,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            41,
            32,
            61,
            62,
            32,
            40,
            107,
            46,
            100,
            121,
            110,
            67,
            97,
            108,
            108,
            95,
            118,
            105,
            106,
            106,
            32,
            61,
            32,
            87,
            46,
            109,
            97,
            41,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            100,
            121,
            110,
            67,
            97,
            108,
            108,
            95,
            106,
            105,
            105,
            105,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            41,
            32,
            61,
            62,
            32,
            40,
            107,
            46,
            100,
            121,
            110,
            67,
            97,
            108,
            108,
            95,
            106,
            105,
            105,
            105,
            32,
            61,
            32,
            87,
            46,
            110,
            97,
            41,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            100,
            121,
            110,
            67,
            97,
            108,
            108,
            95,
            106,
            105,
            105,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            61,
            62,
            32,
            40,
            107,
            46,
            100,
            121,
            110,
            67,
            97,
            108,
            108,
            95,
            106,
            105,
            105,
            32,
            61,
            32,
            87,
            46,
            111,
            97,
            41,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            100,
            121,
            110,
            67,
            97,
            108,
            108,
            95,
            118,
            105,
            105,
            106,
            105,
            105,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            44,
            32,
            104,
            41,
            32,
            61,
            62,
            32,
            40,
            107,
            46,
            100,
            121,
            110,
            67,
            97,
            108,
            108,
            95,
            118,
            105,
            105,
            106,
            105,
            105,
            32,
            61,
            32,
            87,
            46,
            112,
            97,
            41,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            44,
            32,
            104,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            100,
            121,
            110,
            67,
            97,
            108,
            108,
            95,
            105,
            105,
            105,
            105,
            105,
            106,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            44,
            32,
            104,
            41,
            32,
            61,
            62,
            32,
            40,
            107,
            46,
            100,
            121,
            110,
            67,
            97,
            108,
            108,
            95,
            105,
            105,
            105,
            105,
            105,
            106,
            32,
            61,
            32,
            87,
            46,
            113,
            97,
            41,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            44,
            32,
            104,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            100,
            121,
            110,
            67,
            97,
            108,
            108,
            95,
            105,
            105,
            105,
            105,
            105,
            106,
            106,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            44,
            32,
            104,
            44,
            32,
            103,
            44,
            32,
            108,
            41,
            32,
            61,
            62,
            32,
            40,
            107,
            46,
            100,
            121,
            110,
            67,
            97,
            108,
            108,
            95,
            105,
            105,
            105,
            105,
            105,
            106,
            106,
            32,
            61,
            32,
            87,
            46,
            114,
            97,
            41,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            44,
            32,
            104,
            44,
            32,
            103,
            44,
            32,
            108,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            107,
            46,
            100,
            121,
            110,
            67,
            97,
            108,
            108,
            95,
            105,
            105,
            105,
            105,
            105,
            105,
            106,
            106,
            32,
            61,
            32,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            44,
            32,
            104,
            44,
            32,
            103,
            44,
            32,
            108,
            44,
            32,
            109,
            41,
            32,
            61,
            62,
            32,
            40,
            107,
            46,
            100,
            121,
            110,
            67,
            97,
            108,
            108,
            95,
            105,
            105,
            105,
            105,
            105,
            105,
            106,
            106,
            32,
            61,
            32,
            87,
            46,
            115,
            97,
            41,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            44,
            32,
            104,
            44,
            32,
            103,
            44,
            32,
            108,
            44,
            32,
            109,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            106,
            99,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            90,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            83,
            46,
            103,
            101,
            116,
            40,
            97,
            41,
            40,
            98,
            44,
            32,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            89,
            40,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            101,
            32,
            33,
            61,
            61,
            32,
            101,
            32,
            43,
            32,
            48,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            88,
            40,
            49,
            44,
            32,
            48,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            105,
            99,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            90,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            83,
            46,
            103,
            101,
            116,
            40,
            97,
            41,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            89,
            40,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            100,
            32,
            33,
            61,
            61,
            32,
            100,
            32,
            43,
            32,
            48,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            88,
            40,
            49,
            44,
            32,
            48,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            102,
            99,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            101,
            32,
            61,
            32,
            90,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            83,
            46,
            103,
            101,
            116,
            40,
            97,
            41,
            40,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            102,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            89,
            40,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            102,
            32,
            33,
            61,
            61,
            32,
            102,
            32,
            43,
            32,
            48,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            102,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            88,
            40,
            49,
            44,
            32,
            48,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            101,
            99,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            32,
            61,
            32,
            90,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            83,
            46,
            103,
            101,
            116,
            40,
            97,
            41,
            40,
            98,
            44,
            32,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            89,
            40,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            101,
            32,
            33,
            61,
            61,
            32,
            101,
            32,
            43,
            32,
            48,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            88,
            40,
            49,
            44,
            32,
            48,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            100,
            99,
            40,
            97,
            44,
            32,
            98,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            32,
            61,
            32,
            90,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            83,
            46,
            103,
            101,
            116,
            40,
            97,
            41,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            89,
            40,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            100,
            32,
            33,
            61,
            61,
            32,
            100,
            32,
            43,
            32,
            48,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            88,
            40,
            49,
            44,
            32,
            48,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            103,
            99,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            104,
            32,
            61,
            32,
            90,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            83,
            46,
            103,
            101,
            116,
            40,
            97,
            41,
            40,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            44,
            32,
            102,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            103,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            89,
            40,
            104,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            103,
            32,
            33,
            61,
            61,
            32,
            103,
            32,
            43,
            32,
            48,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            103,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            88,
            40,
            49,
            44,
            32,
            48,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            108,
            99,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            102,
            32,
            61,
            32,
            90,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            83,
            46,
            103,
            101,
            116,
            40,
            97,
            41,
            40,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            44,
            32,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            104,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            89,
            40,
            102,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            104,
            32,
            33,
            61,
            61,
            32,
            104,
            32,
            43,
            32,
            48,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            88,
            40,
            49,
            44,
            32,
            48,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            107,
            99,
            40,
            97,
            44,
            32,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            101,
            32,
            61,
            32,
            90,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            83,
            46,
            103,
            101,
            116,
            40,
            97,
            41,
            40,
            98,
            44,
            32,
            99,
            44,
            32,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            102,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            89,
            40,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            102,
            32,
            33,
            61,
            61,
            32,
            102,
            32,
            43,
            32,
            48,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            102,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            88,
            40,
            49,
            44,
            32,
            48,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            104,
            99,
            40,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            98,
            32,
            61,
            32,
            90,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            83,
            46,
            103,
            101,
            116,
            40,
            97,
            41,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            99,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            89,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            99,
            32,
            33,
            61,
            61,
            32,
            99,
            32,
            43,
            32,
            48,
            41,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            88,
            40,
            49,
            44,
            32,
            48,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            110,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            71,
            32,
            61,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            111,
            99,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            99,
            32,
            124,
            124,
            32,
            112,
            99,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            99,
            32,
            124,
            124,
            32,
            40,
            71,
            32,
            61,
            32,
            111,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            112,
            99,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            97,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            50,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            110,
            99,
            32,
            38,
            38,
            32,
            40,
            110,
            99,
            32,
            61,
            32,
            116,
            114,
            117,
            101,
            44,
            32,
            107,
            46,
            99,
            97,
            108,
            108,
            101,
            100,
            82,
            117,
            110,
            32,
            61,
            32,
            116,
            114,
            117,
            101,
            44,
            32,
            33,
            108,
            97,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            68,
            97,
            40,
            114,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            97,
            40,
            107,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            40,
            95,
            97,
            50,
            32,
            61,
            32,
            107,
            46,
            111,
            110,
            82,
            117,
            110,
            116,
            105,
            109,
            101,
            73,
            110,
            105,
            116,
            105,
            97,
            108,
            105,
            122,
            101,
            100,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            50,
            46,
            99,
            97,
            108,
            108,
            40,
            107,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            107,
            46,
            112,
            111,
            115,
            116,
            82,
            117,
            110,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            34,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            34,
            32,
            61,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            107,
            46,
            112,
            111,
            115,
            116,
            82,
            117,
            110,
            32,
            38,
            38,
            32,
            40,
            107,
            46,
            112,
            111,
            115,
            116,
            82,
            117,
            110,
            32,
            61,
            32,
            91,
            107,
            46,
            112,
            111,
            115,
            116,
            82,
            117,
            110,
            93,
            41,
            59,
            32,
            107,
            46,
            112,
            111,
            115,
            116,
            82,
            117,
            110,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            32,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            98,
            32,
            61,
            32,
            107,
            46,
            112,
            111,
            115,
            116,
            82,
            117,
            110,
            46,
            115,
            104,
            105,
            102,
            116,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            97,
            46,
            117,
            110,
            115,
            104,
            105,
            102,
            116,
            40,
            98,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            68,
            97,
            40,
            115,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            40,
            48,
            32,
            60,
            32,
            70,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            107,
            46,
            112,
            114,
            101,
            82,
            117,
            110,
            41,
            32,
            102,
            111,
            114,
            32,
            40,
            34,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            34,
            32,
            61,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            107,
            46,
            112,
            114,
            101,
            82,
            117,
            110,
            32,
            38,
            38,
            32,
            40,
            107,
            46,
            112,
            114,
            101,
            82,
            117,
            110,
            32,
            61,
            32,
            91,
            107,
            46,
            112,
            114,
            101,
            82,
            117,
            110,
            93,
            41,
            59,
            32,
            107,
            46,
            112,
            114,
            101,
            82,
            117,
            110,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            32,
            41,
            32,
            116,
            97,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            68,
            97,
            40,
            113,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            48,
            32,
            60,
            32,
            70,
            32,
            124,
            124,
            32,
            40,
            107,
            46,
            115,
            101,
            116,
            83,
            116,
            97,
            116,
            117,
            115,
            32,
            63,
            32,
            40,
            107,
            46,
            115,
            101,
            116,
            83,
            116,
            97,
            116,
            117,
            115,
            40,
            34,
            82,
            117,
            110,
            110,
            105,
            110,
            103,
            46,
            46,
            46,
            34,
            41,
            44,
            32,
            115,
            101,
            116,
            84,
            105,
            109,
            101,
            111,
            117,
            116,
            40,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            84,
            105,
            109,
            101,
            111,
            117,
            116,
            40,
            40,
            41,
            32,
            61,
            62,
            32,
            107,
            46,
            115,
            101,
            116,
            83,
            116,
            97,
            116,
            117,
            115,
            40,
            34,
            34,
            41,
            44,
            32,
            49,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            49,
            41,
            41,
            32,
            58,
            32,
            97,
            40,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            107,
            46,
            112,
            114,
            101,
            73,
            110,
            105,
            116,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            34,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            34,
            32,
            61,
            61,
            32,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            107,
            46,
            112,
            114,
            101,
            73,
            110,
            105,
            116,
            32,
            38,
            38,
            32,
            40,
            107,
            46,
            112,
            114,
            101,
            73,
            110,
            105,
            116,
            32,
            61,
            32,
            91,
            107,
            46,
            112,
            114,
            101,
            73,
            110,
            105,
            116,
            93,
            41,
            59,
            32,
            48,
            32,
            60,
            32,
            107,
            46,
            112,
            114,
            101,
            73,
            110,
            105,
            116,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            32,
            41,
            32,
            107,
            46,
            112,
            114,
            101,
            73,
            110,
            105,
            116,
            46,
            112,
            111,
            112,
            40,
            41,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            112,
            99,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            82,
            116,
            110,
            32,
            61,
            32,
            101,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            82,
            116,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            125,
            41,
            40,
            41,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            111,
            116,
            108,
            111,
            116,
            116,
            105,
            101,
            95,
            112,
            108,
            97,
            121,
            101,
            114,
            95,
            100,
            101,
            102,
            97,
            117,
            108,
            116,
            32,
            61,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            80,
            108,
            97,
            121,
            101,
            114,
            77,
            111,
            100,
            117,
            108,
            101,
            59,
            10,
            10,
            32,
            32,
            47,
            47,
            32,
            115,
            114,
            99,
            47,
            99,
            111,
            114,
            101,
            47,
            100,
            111,
            116,
            108,
            111,
            116,
            116,
            105,
            101,
            45,
            119,
            97,
            115,
            109,
            45,
            108,
            111,
            97,
            100,
            101,
            114,
            46,
            116,
            115,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            87,
            97,
            115,
            109,
            76,
            111,
            97,
            100,
            101,
            114,
            32,
            61,
            32,
            99,
            108,
            97,
            115,
            115,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            34,
            82,
            101,
            110,
            100,
            101,
            114,
            101,
            114,
            76,
            111,
            97,
            100,
            101,
            114,
            32,
            105,
            115,
            32,
            97,
            32,
            115,
            116,
            97,
            116,
            105,
            99,
            32,
            99,
            108,
            97,
            115,
            115,
            32,
            97,
            110,
            100,
            32,
            99,
            97,
            110,
            110,
            111,
            116,
            32,
            98,
            101,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            116,
            105,
            97,
            116,
            101,
            100,
            46,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            97,
            116,
            105,
            99,
            32,
            95,
            116,
            114,
            121,
            76,
            111,
            97,
            100,
            40,
            117,
            114,
            108,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            95,
            95,
            97,
            115,
            121,
            110,
            99,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            110,
            117,
            108,
            108,
            44,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            42,
            32,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            32,
            61,
            32,
            121,
            105,
            101,
            108,
            100,
            32,
            100,
            111,
            116,
            108,
            111,
            116,
            116,
            105,
            101,
            95,
            112,
            108,
            97,
            121,
            101,
            114,
            95,
            100,
            101,
            102,
            97,
            117,
            108,
            116,
            40,
            123,
            32,
            108,
            111,
            99,
            97,
            116,
            101,
            70,
            105,
            108,
            101,
            58,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            117,
            114,
            108,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            47,
            42,
            42,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            84,
            114,
            105,
            101,
            115,
            32,
            116,
            111,
            32,
            108,
            111,
            97,
            100,
            32,
            116,
            104,
            101,
            32,
            87,
            65,
            83,
            77,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            32,
            102,
            114,
            111,
            109,
            32,
            116,
            104,
            101,
            32,
            112,
            114,
            105,
            109,
            97,
            114,
            121,
            32,
            85,
            82,
            76,
            44,
            32,
            102,
            97,
            108,
            108,
            105,
            110,
            103,
            32,
            98,
            97,
            99,
            107,
            32,
            116,
            111,
            32,
            97,
            32,
            98,
            97,
            99,
            107,
            117,
            112,
            32,
            85,
            82,
            76,
            32,
            105,
            102,
            32,
            110,
            101,
            99,
            101,
            115,
            115,
            97,
            114,
            121,
            46,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            84,
            104,
            114,
            111,
            119,
            115,
            32,
            97,
            110,
            32,
            101,
            114,
            114,
            111,
            114,
            32,
            105,
            102,
            32,
            98,
            111,
            116,
            104,
            32,
            85,
            82,
            76,
            115,
            32,
            102,
            97,
            105,
            108,
            32,
            116,
            111,
            32,
            108,
            111,
            97,
            100,
            32,
            116,
            104,
            101,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            64,
            114,
            101,
            116,
            117,
            114,
            110,
            115,
            32,
            80,
            114,
            111,
            109,
            105,
            115,
            101,
            60,
            77,
            111,
            100,
            117,
            108,
            101,
            62,
            32,
            45,
            32,
            65,
            32,
            112,
            114,
            111,
            109,
            105,
            115,
            101,
            32,
            116,
            104,
            97,
            116,
            32,
            114,
            101,
            115,
            111,
            108,
            118,
            101,
            115,
            32,
            116,
            111,
            32,
            116,
            104,
            101,
            32,
            108,
            111,
            97,
            100,
            101,
            100,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            47,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            97,
            116,
            105,
            99,
            32,
            95,
            108,
            111,
            97,
            100,
            87,
            105,
            116,
            104,
            66,
            97,
            99,
            107,
            117,
            112,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            95,
            95,
            97,
            115,
            121,
            110,
            99,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            110,
            117,
            108,
            108,
            44,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            42,
            32,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            116,
            104,
            105,
            115,
            46,
            95,
            77,
            111,
            100,
            117,
            108,
            101,
            80,
            114,
            111,
            109,
            105,
            115,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            77,
            111,
            100,
            117,
            108,
            101,
            80,
            114,
            111,
            109,
            105,
            115,
            101,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            116,
            114,
            121,
            76,
            111,
            97,
            100,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            119,
            97,
            115,
            109,
            85,
            82,
            76,
            41,
            46,
            99,
            97,
            116,
            99,
            104,
            40,
            40,
            105,
            110,
            105,
            116,
            105,
            97,
            108,
            69,
            114,
            114,
            111,
            114,
            41,
            32,
            61,
            62,
            32,
            95,
            95,
            97,
            115,
            121,
            110,
            99,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            110,
            117,
            108,
            108,
            44,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            42,
            32,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            98,
            97,
            99,
            107,
            117,
            112,
            85,
            114,
            108,
            32,
            61,
            32,
            96,
            104,
            116,
            116,
            112,
            115,
            58,
            47,
            47,
            117,
            110,
            112,
            107,
            103,
            46,
            99,
            111,
            109,
            47,
            36,
            123,
            80,
            65,
            67,
            75,
            65,
            71,
            69,
            95,
            78,
            65,
            77,
            69,
            125,
            64,
            36,
            123,
            80,
            65,
            67,
            75,
            65,
            71,
            69,
            95,
            86,
            69,
            82,
            83,
            73,
            79,
            78,
            125,
            47,
            100,
            105,
            115,
            116,
            47,
            100,
            111,
            116,
            108,
            111,
            116,
            116,
            105,
            101,
            45,
            112,
            108,
            97,
            121,
            101,
            114,
            46,
            119,
            97,
            115,
            109,
            96,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            111,
            108,
            101,
            46,
            119,
            97,
            114,
            110,
            40,
            96,
            80,
            114,
            105,
            109,
            97,
            114,
            121,
            32,
            87,
            65,
            83,
            77,
            32,
            108,
            111,
            97,
            100,
            32,
            102,
            97,
            105,
            108,
            101,
            100,
            32,
            102,
            114,
            111,
            109,
            32,
            36,
            123,
            116,
            104,
            105,
            115,
            46,
            95,
            119,
            97,
            115,
            109,
            85,
            82,
            76,
            125,
            46,
            32,
            69,
            114,
            114,
            111,
            114,
            58,
            32,
            36,
            123,
            105,
            110,
            105,
            116,
            105,
            97,
            108,
            69,
            114,
            114,
            111,
            114,
            46,
            109,
            101,
            115,
            115,
            97,
            103,
            101,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            111,
            108,
            101,
            46,
            119,
            97,
            114,
            110,
            40,
            96,
            65,
            116,
            116,
            101,
            109,
            112,
            116,
            105,
            110,
            103,
            32,
            116,
            111,
            32,
            108,
            111,
            97,
            100,
            32,
            87,
            65,
            83,
            77,
            32,
            102,
            114,
            111,
            109,
            32,
            98,
            97,
            99,
            107,
            117,
            112,
            32,
            85,
            82,
            76,
            58,
            32,
            36,
            123,
            98,
            97,
            99,
            107,
            117,
            112,
            85,
            114,
            108,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            121,
            105,
            101,
            108,
            100,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            116,
            114,
            121,
            76,
            111,
            97,
            100,
            40,
            98,
            97,
            99,
            107,
            117,
            112,
            85,
            114,
            108,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            98,
            97,
            99,
            107,
            117,
            112,
            69,
            114,
            114,
            111,
            114,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            111,
            108,
            101,
            46,
            101,
            114,
            114,
            111,
            114,
            40,
            96,
            80,
            114,
            105,
            109,
            97,
            114,
            121,
            32,
            87,
            65,
            83,
            77,
            32,
            85,
            82,
            76,
            32,
            102,
            97,
            105,
            108,
            101,
            100,
            58,
            32,
            36,
            123,
            105,
            110,
            105,
            116,
            105,
            97,
            108,
            69,
            114,
            114,
            111,
            114,
            46,
            109,
            101,
            115,
            115,
            97,
            103,
            101,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            111,
            108,
            101,
            46,
            101,
            114,
            114,
            111,
            114,
            40,
            96,
            66,
            97,
            99,
            107,
            117,
            112,
            32,
            87,
            65,
            83,
            77,
            32,
            85,
            82,
            76,
            32,
            102,
            97,
            105,
            108,
            101,
            100,
            58,
            32,
            36,
            123,
            98,
            97,
            99,
            107,
            117,
            112,
            69,
            114,
            114,
            111,
            114,
            46,
            109,
            101,
            115,
            115,
            97,
            103,
            101,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            34,
            87,
            65,
            83,
            77,
            32,
            108,
            111,
            97,
            100,
            105,
            110,
            103,
            32,
            102,
            97,
            105,
            108,
            101,
            100,
            32,
            102,
            114,
            111,
            109,
            32,
            97,
            108,
            108,
            32,
            115,
            111,
            117,
            114,
            99,
            101,
            115,
            46,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            77,
            111,
            100,
            117,
            108,
            101,
            80,
            114,
            111,
            109,
            105,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            47,
            42,
            42,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            80,
            117,
            98,
            108,
            105,
            99,
            32,
            109,
            101,
            116,
            104,
            111,
            100,
            32,
            116,
            111,
            32,
            108,
            111,
            97,
            100,
            32,
            116,
            104,
            101,
            32,
            87,
            101,
            98,
            65,
            115,
            115,
            101,
            109,
            98,
            108,
            121,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            85,
            116,
            105,
            108,
            105,
            122,
            101,
            115,
            32,
            97,
            32,
            112,
            114,
            105,
            109,
            97,
            114,
            121,
            32,
            97,
            110,
            100,
            32,
            98,
            97,
            99,
            107,
            117,
            112,
            32,
            85,
            82,
            76,
            32,
            102,
            111,
            114,
            32,
            114,
            111,
            98,
            117,
            115,
            116,
            110,
            101,
            115,
            115,
            46,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            64,
            114,
            101,
            116,
            117,
            114,
            110,
            115,
            32,
            80,
            114,
            111,
            109,
            105,
            115,
            101,
            60,
            77,
            111,
            100,
            117,
            108,
            101,
            62,
            32,
            45,
            32,
            65,
            32,
            112,
            114,
            111,
            109,
            105,
            115,
            101,
            32,
            116,
            104,
            97,
            116,
            32,
            114,
            101,
            115,
            111,
            108,
            118,
            101,
            115,
            32,
            116,
            111,
            32,
            116,
            104,
            101,
            32,
            108,
            111,
            97,
            100,
            101,
            100,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            47,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            97,
            116,
            105,
            99,
            32,
            108,
            111,
            97,
            100,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            95,
            95,
            97,
            115,
            121,
            110,
            99,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            110,
            117,
            108,
            108,
            44,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            42,
            32,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            108,
            111,
            97,
            100,
            87,
            105,
            116,
            104,
            66,
            97,
            99,
            107,
            117,
            112,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            47,
            42,
            42,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            83,
            101,
            116,
            115,
            32,
            97,
            32,
            110,
            101,
            119,
            32,
            85,
            82,
            76,
            32,
            102,
            111,
            114,
            32,
            116,
            104,
            101,
            32,
            87,
            65,
            83,
            77,
            32,
            102,
            105,
            108,
            101,
            32,
            97,
            110,
            100,
            32,
            105,
            110,
            118,
            97,
            108,
            105,
            100,
            97,
            116,
            101,
            115,
            32,
            116,
            104,
            101,
            32,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            32,
            112,
            114,
            111,
            109,
            105,
            115,
            101,
            46,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            64,
            112,
            97,
            114,
            97,
            109,
            32,
            115,
            116,
            114,
            105,
            110,
            103,
            32,
            45,
            32,
            32,
            84,
            104,
            101,
            32,
            110,
            101,
            119,
            32,
            85,
            82,
            76,
            32,
            102,
            111,
            114,
            32,
            116,
            104,
            101,
            32,
            87,
            65,
            83,
            77,
            32,
            102,
            105,
            108,
            101,
            46,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            47,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            97,
            116,
            105,
            99,
            32,
            115,
            101,
            116,
            87,
            97,
            115,
            109,
            85,
            114,
            108,
            40,
            117,
            114,
            108,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            117,
            114,
            108,
            32,
            61,
            61,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            119,
            97,
            115,
            109,
            85,
            82,
            76,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            119,
            97,
            115,
            109,
            85,
            82,
            76,
            32,
            61,
            32,
            117,
            114,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            77,
            111,
            100,
            117,
            108,
            101,
            80,
            114,
            111,
            109,
            105,
            115,
            101,
            32,
            61,
            32,
            110,
            117,
            108,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            47,
            47,
            32,
            101,
            115,
            108,
            105,
            110,
            116,
            45,
            100,
            105,
            115,
            97,
            98,
            108,
            101,
            45,
            110,
            101,
            120,
            116,
            45,
            108,
            105,
            110,
            101,
            32,
            64,
            116,
            121,
            112,
            101,
            115,
            99,
            114,
            105,
            112,
            116,
            45,
            101,
            115,
            108,
            105,
            110,
            116,
            47,
            110,
            97,
            109,
            105,
            110,
            103,
            45,
            99,
            111,
            110,
            118,
            101,
            110,
            116,
            105,
            111,
            110,
            10,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            87,
            97,
            115,
            109,
            76,
            111,
            97,
            100,
            101,
            114,
            44,
            32,
            34,
            95,
            77,
            111,
            100,
            117,
            108,
            101,
            80,
            114,
            111,
            109,
            105,
            115,
            101,
            34,
            44,
            32,
            110,
            117,
            108,
            108,
            41,
            59,
            10,
            32,
            32,
            47,
            47,
            32,
            85,
            82,
            76,
            32,
            102,
            111,
            114,
            32,
            116,
            104,
            101,
            32,
            87,
            65,
            83,
            77,
            32,
            102,
            105,
            108,
            101,
            44,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            101,
            100,
            32,
            117,
            115,
            105,
            110,
            103,
            32,
            112,
            97,
            99,
            107,
            97,
            103,
            101,
            32,
            105,
            110,
            102,
            111,
            114,
            109,
            97,
            116,
            105,
            111,
            110,
            10,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            87,
            97,
            115,
            109,
            76,
            111,
            97,
            100,
            101,
            114,
            44,
            32,
            34,
            95,
            119,
            97,
            115,
            109,
            85,
            82,
            76,
            34,
            44,
            32,
            96,
            104,
            116,
            116,
            112,
            115,
            58,
            47,
            47,
            99,
            100,
            110,
            46,
            106,
            115,
            100,
            101,
            108,
            105,
            118,
            114,
            46,
            110,
            101,
            116,
            47,
            110,
            112,
            109,
            47,
            36,
            123,
            80,
            65,
            67,
            75,
            65,
            71,
            69,
            95,
            78,
            65,
            77,
            69,
            125,
            64,
            36,
            123,
            80,
            65,
            67,
            75,
            65,
            71,
            69,
            95,
            86,
            69,
            82,
            83,
            73,
            79,
            78,
            125,
            47,
            100,
            105,
            115,
            116,
            47,
            100,
            111,
            116,
            108,
            111,
            116,
            116,
            105,
            101,
            45,
            112,
            108,
            97,
            121,
            101,
            114,
            46,
            119,
            97,
            115,
            109,
            96,
            41,
            59,
            10,
            10,
            32,
            32,
            47,
            47,
            32,
            115,
            114,
            99,
            47,
            101,
            118,
            101,
            110,
            116,
            45,
            109,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            116,
            115,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            69,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            32,
            61,
            32,
            99,
            108,
            97,
            115,
            115,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            101,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            34,
            44,
            32,
            47,
            42,
            32,
            64,
            95,
            95,
            80,
            85,
            82,
            69,
            95,
            95,
            32,
            42,
            47,
            32,
            110,
            101,
            119,
            32,
            77,
            97,
            112,
            40,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            97,
            100,
            100,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            116,
            121,
            112,
            101,
            44,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            101,
            116,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            46,
            103,
            101,
            116,
            40,
            116,
            121,
            112,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            32,
            61,
            32,
            47,
            42,
            32,
            64,
            95,
            95,
            80,
            85,
            82,
            69,
            95,
            95,
            32,
            42,
            47,
            32,
            110,
            101,
            119,
            32,
            83,
            101,
            116,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            46,
            115,
            101,
            116,
            40,
            116,
            121,
            112,
            101,
            44,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            46,
            97,
            100,
            100,
            40,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            109,
            111,
            118,
            101,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            116,
            121,
            112,
            101,
            44,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            46,
            103,
            101,
            116,
            40,
            116,
            121,
            112,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            46,
            100,
            101,
            108,
            101,
            116,
            101,
            40,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            46,
            115,
            105,
            122,
            101,
            32,
            61,
            61,
            61,
            32,
            48,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            46,
            100,
            101,
            108,
            101,
            116,
            101,
            40,
            116,
            121,
            112,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            46,
            100,
            101,
            108,
            101,
            116,
            101,
            40,
            116,
            121,
            112,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            46,
            103,
            101,
            116,
            40,
            101,
            118,
            101,
            110,
            116,
            46,
            116,
            121,
            112,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            46,
            102,
            111,
            114,
            69,
            97,
            99,
            104,
            40,
            40,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            41,
            32,
            61,
            62,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            109,
            111,
            118,
            101,
            65,
            108,
            108,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            46,
            99,
            108,
            101,
            97,
            114,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            125,
            59,
            10,
            10,
            32,
            32,
            47,
            47,
            32,
            115,
            114,
            99,
            47,
            111,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            45,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            46,
            116,
            115,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            32,
            61,
            32,
            99,
            108,
            97,
            115,
            115,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            97,
            116,
            105,
            99,
            32,
            95,
            105,
            110,
            105,
            116,
            105,
            97,
            108,
            105,
            122,
            101,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            116,
            101,
            114,
            115,
            101,
            99,
            116,
            105,
            111,
            110,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            67,
            97,
            108,
            108,
            98,
            97,
            99,
            107,
            32,
            61,
            32,
            40,
            101,
            110,
            116,
            114,
            105,
            101,
            115,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            110,
            116,
            114,
            105,
            101,
            115,
            46,
            102,
            111,
            114,
            69,
            97,
            99,
            104,
            40,
            40,
            101,
            110,
            116,
            114,
            121,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            100,
            67,
            97,
            110,
            118,
            97,
            115,
            101,
            115,
            46,
            103,
            101,
            116,
            40,
            101,
            110,
            116,
            114,
            121,
            46,
            116,
            97,
            114,
            103,
            101,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            101,
            110,
            116,
            114,
            121,
            46,
            105,
            115,
            73,
            110,
            116,
            101,
            114,
            115,
            101,
            99,
            116,
            105,
            110,
            103,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            117,
            110,
            102,
            114,
            101,
            101,
            122,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            102,
            114,
            101,
            101,
            122,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            73,
            110,
            116,
            101,
            114,
            115,
            101,
            99,
            116,
            105,
            111,
            110,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            40,
            105,
            110,
            116,
            101,
            114,
            115,
            101,
            99,
            116,
            105,
            111,
            110,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            67,
            97,
            108,
            108,
            98,
            97,
            99,
            107,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            101,
            115,
            104,
            111,
            108,
            100,
            58,
            32,
            48,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            97,
            116,
            105,
            99,
            32,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            40,
            99,
            97,
            110,
            118,
            97,
            115,
            44,
            32,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            105,
            110,
            105,
            116,
            105,
            97,
            108,
            105,
            122,
            101,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            100,
            67,
            97,
            110,
            118,
            97,
            115,
            101,
            115,
            46,
            104,
            97,
            115,
            40,
            99,
            97,
            110,
            118,
            97,
            115,
            41,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            100,
            67,
            97,
            110,
            118,
            97,
            115,
            101,
            115,
            46,
            115,
            101,
            116,
            40,
            99,
            97,
            110,
            118,
            97,
            115,
            44,
            32,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            40,
            99,
            97,
            110,
            118,
            97,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            97,
            116,
            105,
            99,
            32,
            117,
            110,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            40,
            99,
            97,
            110,
            118,
            97,
            115,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            117,
            110,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            40,
            99,
            97,
            110,
            118,
            97,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            100,
            67,
            97,
            110,
            118,
            97,
            115,
            101,
            115,
            46,
            100,
            101,
            108,
            101,
            116,
            101,
            40,
            99,
            97,
            110,
            118,
            97,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            100,
            67,
            97,
            110,
            118,
            97,
            115,
            101,
            115,
            46,
            115,
            105,
            122,
            101,
            32,
            61,
            61,
            61,
            32,
            48,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            98,
            46,
            100,
            105,
            115,
            99,
            111,
            110,
            110,
            101,
            99,
            116,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            32,
            61,
            32,
            110,
            117,
            108,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            44,
            32,
            34,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            34,
            44,
            32,
            110,
            117,
            108,
            108,
            41,
            59,
            10,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            44,
            32,
            34,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            100,
            67,
            97,
            110,
            118,
            97,
            115,
            101,
            115,
            34,
            44,
            32,
            47,
            42,
            32,
            64,
            95,
            95,
            80,
            85,
            82,
            69,
            95,
            95,
            32,
            42,
            47,
            32,
            110,
            101,
            119,
            32,
            77,
            97,
            112,
            40,
            41,
            41,
            59,
            10,
            10,
            32,
            32,
            47,
            47,
            32,
            115,
            114,
            99,
            47,
            114,
            101,
            115,
            105,
            122,
            101,
            45,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            46,
            116,
            115,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            82,
            69,
            83,
            73,
            90,
            69,
            95,
            68,
            69,
            66,
            79,
            85,
            78,
            67,
            69,
            95,
            84,
            73,
            77,
            69,
            32,
            61,
            32,
            49,
            48,
            48,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            67,
            97,
            110,
            118,
            97,
            115,
            82,
            101,
            115,
            105,
            122,
            101,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            32,
            61,
            32,
            99,
            108,
            97,
            115,
            115,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            97,
            116,
            105,
            99,
            32,
            95,
            105,
            110,
            105,
            116,
            105,
            97,
            108,
            105,
            122,
            101,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            105,
            122,
            101,
            72,
            97,
            110,
            100,
            108,
            101,
            114,
            32,
            61,
            32,
            40,
            101,
            110,
            116,
            114,
            105,
            101,
            115,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            110,
            116,
            114,
            105,
            101,
            115,
            46,
            102,
            111,
            114,
            69,
            97,
            99,
            104,
            40,
            40,
            101,
            110,
            116,
            114,
            121,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            101,
            108,
            101,
            109,
            101,
            110,
            116,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            100,
            67,
            97,
            110,
            118,
            97,
            115,
            101,
            115,
            46,
            103,
            101,
            116,
            40,
            101,
            110,
            116,
            114,
            121,
            46,
            116,
            97,
            114,
            103,
            101,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            101,
            108,
            101,
            109,
            101,
            110,
            116,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            91,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            44,
            32,
            116,
            105,
            109,
            101,
            111,
            117,
            116,
            93,
            32,
            61,
            32,
            101,
            108,
            101,
            109,
            101,
            110,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            108,
            101,
            97,
            114,
            84,
            105,
            109,
            101,
            111,
            117,
            116,
            40,
            116,
            105,
            109,
            101,
            111,
            117,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            110,
            101,
            119,
            84,
            105,
            109,
            101,
            111,
            117,
            116,
            32,
            61,
            32,
            115,
            101,
            116,
            84,
            105,
            109,
            101,
            111,
            117,
            116,
            40,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            114,
            101,
            115,
            105,
            122,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            44,
            32,
            82,
            69,
            83,
            73,
            90,
            69,
            95,
            68,
            69,
            66,
            79,
            85,
            78,
            67,
            69,
            95,
            84,
            73,
            77,
            69,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            100,
            67,
            97,
            110,
            118,
            97,
            115,
            101,
            115,
            46,
            115,
            101,
            116,
            40,
            101,
            110,
            116,
            114,
            121,
            46,
            116,
            97,
            114,
            103,
            101,
            116,
            44,
            32,
            91,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            44,
            32,
            110,
            101,
            119,
            84,
            105,
            109,
            101,
            111,
            117,
            116,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            82,
            101,
            115,
            105,
            122,
            101,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            40,
            114,
            101,
            115,
            105,
            122,
            101,
            72,
            97,
            110,
            100,
            108,
            101,
            114,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            97,
            116,
            105,
            99,
            32,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            40,
            99,
            97,
            110,
            118,
            97,
            115,
            44,
            32,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            105,
            110,
            105,
            116,
            105,
            97,
            108,
            105,
            122,
            101,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            100,
            67,
            97,
            110,
            118,
            97,
            115,
            101,
            115,
            46,
            104,
            97,
            115,
            40,
            99,
            97,
            110,
            118,
            97,
            115,
            41,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            100,
            67,
            97,
            110,
            118,
            97,
            115,
            101,
            115,
            46,
            115,
            101,
            116,
            40,
            99,
            97,
            110,
            118,
            97,
            115,
            44,
            32,
            91,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            44,
            32,
            48,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            40,
            99,
            97,
            110,
            118,
            97,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            97,
            116,
            105,
            99,
            32,
            117,
            110,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            40,
            99,
            97,
            110,
            118,
            97,
            115,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            117,
            110,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            40,
            99,
            97,
            110,
            118,
            97,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            100,
            67,
            97,
            110,
            118,
            97,
            115,
            101,
            115,
            46,
            100,
            101,
            108,
            101,
            116,
            101,
            40,
            99,
            97,
            110,
            118,
            97,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            100,
            67,
            97,
            110,
            118,
            97,
            115,
            101,
            115,
            46,
            115,
            105,
            122,
            101,
            32,
            61,
            61,
            61,
            32,
            48,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            98,
            46,
            100,
            105,
            115,
            99,
            111,
            110,
            110,
            101,
            99,
            116,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            32,
            61,
            32,
            110,
            117,
            108,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            67,
            97,
            110,
            118,
            97,
            115,
            82,
            101,
            115,
            105,
            122,
            101,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            44,
            32,
            34,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            34,
            44,
            32,
            110,
            117,
            108,
            108,
            41,
            59,
            10,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            67,
            97,
            110,
            118,
            97,
            115,
            82,
            101,
            115,
            105,
            122,
            101,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            44,
            32,
            34,
            95,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            100,
            67,
            97,
            110,
            118,
            97,
            115,
            101,
            115,
            34,
            44,
            32,
            47,
            42,
            32,
            64,
            95,
            95,
            80,
            85,
            82,
            69,
            95,
            95,
            32,
            42,
            47,
            32,
            110,
            101,
            119,
            32,
            77,
            97,
            112,
            40,
            41,
            41,
            59,
            10,
            10,
            32,
            32,
            47,
            47,
            32,
            115,
            114,
            99,
            47,
            117,
            116,
            105,
            108,
            115,
            46,
            116,
            115,
            10,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            105,
            115,
            72,
            101,
            120,
            67,
            111,
            108,
            111,
            114,
            40,
            99,
            111,
            108,
            111,
            114,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            47,
            94,
            35,
            40,
            91,
            92,
            100,
            97,
            45,
            102,
            93,
            123,
            54,
            125,
            124,
            91,
            92,
            100,
            97,
            45,
            102,
            93,
            123,
            56,
            125,
            41,
            36,
            47,
            105,
            117,
            46,
            116,
            101,
            115,
            116,
            40,
            99,
            111,
            108,
            111,
            114,
            41,
            59,
            10,
            32,
            32,
            125,
            10,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            104,
            101,
            120,
            83,
            116,
            114,
            105,
            110,
            103,
            84,
            111,
            82,
            71,
            66,
            65,
            73,
            110,
            116,
            40,
            99,
            111,
            108,
            111,
            114,
            72,
            101,
            120,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            115,
            72,
            101,
            120,
            67,
            111,
            108,
            111,
            114,
            40,
            99,
            111,
            108,
            111,
            114,
            72,
            101,
            120,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            108,
            101,
            116,
            32,
            104,
            101,
            120,
            32,
            61,
            32,
            99,
            111,
            108,
            111,
            114,
            72,
            101,
            120,
            46,
            114,
            101,
            112,
            108,
            97,
            99,
            101,
            40,
            34,
            35,
            34,
            44,
            32,
            34,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            104,
            101,
            120,
            32,
            61,
            32,
            104,
            101,
            120,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            32,
            61,
            61,
            61,
            32,
            54,
            32,
            63,
            32,
            96,
            36,
            123,
            104,
            101,
            120,
            125,
            102,
            102,
            96,
            32,
            58,
            32,
            104,
            101,
            120,
            59,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            112,
            97,
            114,
            115,
            101,
            73,
            110,
            116,
            40,
            104,
            101,
            120,
            44,
            32,
            49,
            54,
            41,
            59,
            10,
            32,
            32,
            125,
            10,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            105,
            115,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            40,
            102,
            105,
            108,
            101,
            68,
            97,
            116,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            102,
            105,
            108,
            101,
            68,
            97,
            116,
            97,
            46,
            98,
            121,
            116,
            101,
            76,
            101,
            110,
            103,
            116,
            104,
            32,
            60,
            32,
            52,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            102,
            105,
            108,
            101,
            83,
            105,
            103,
            110,
            97,
            116,
            117,
            114,
            101,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            85,
            105,
            110,
            116,
            56,
            65,
            114,
            114,
            97,
            121,
            40,
            102,
            105,
            108,
            101,
            68,
            97,
            116,
            97,
            46,
            115,
            108,
            105,
            99,
            101,
            40,
            48,
            44,
            32,
            90,
            73,
            80,
            95,
            83,
            73,
            71,
            78,
            65,
            84,
            85,
            82,
            69,
            46,
            98,
            121,
            116,
            101,
            76,
            101,
            110,
            103,
            116,
            104,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            108,
            101,
            116,
            32,
            105,
            32,
            61,
            32,
            48,
            59,
            32,
            105,
            32,
            60,
            32,
            90,
            73,
            80,
            95,
            83,
            73,
            71,
            78,
            65,
            84,
            85,
            82,
            69,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            59,
            32,
            105,
            32,
            43,
            61,
            32,
            49,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            90,
            73,
            80,
            95,
            83,
            73,
            71,
            78,
            65,
            84,
            85,
            82,
            69,
            91,
            105,
            93,
            32,
            33,
            61,
            61,
            32,
            102,
            105,
            108,
            101,
            83,
            105,
            103,
            110,
            97,
            116,
            117,
            114,
            101,
            91,
            105,
            93,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            114,
            117,
            101,
            59,
            10,
            32,
            32,
            125,
            10,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            105,
            115,
            76,
            111,
            116,
            116,
            105,
            101,
            74,
            83,
            79,
            78,
            40,
            106,
            115,
            111,
            110,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            76,
            79,
            84,
            84,
            73,
            69,
            95,
            74,
            83,
            79,
            78,
            95,
            77,
            65,
            78,
            68,
            65,
            84,
            79,
            82,
            89,
            95,
            70,
            73,
            69,
            76,
            68,
            83,
            46,
            101,
            118,
            101,
            114,
            121,
            40,
            40,
            102,
            105,
            101,
            108,
            100,
            41,
            32,
            61,
            62,
            32,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            112,
            114,
            111,
            116,
            111,
            116,
            121,
            112,
            101,
            46,
            104,
            97,
            115,
            79,
            119,
            110,
            80,
            114,
            111,
            112,
            101,
            114,
            116,
            121,
            46,
            99,
            97,
            108,
            108,
            40,
            106,
            115,
            111,
            110,
            44,
            32,
            102,
            105,
            101,
            108,
            100,
            41,
            41,
            59,
            10,
            32,
            32,
            125,
            10,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            105,
            115,
            76,
            111,
            116,
            116,
            105,
            101,
            40,
            102,
            105,
            108,
            101,
            68,
            97,
            116,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            102,
            105,
            108,
            101,
            68,
            97,
            116,
            97,
            32,
            61,
            61,
            61,
            32,
            34,
            115,
            116,
            114,
            105,
            110,
            103,
            34,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            105,
            115,
            76,
            111,
            116,
            116,
            105,
            101,
            74,
            83,
            79,
            78,
            40,
            74,
            83,
            79,
            78,
            46,
            112,
            97,
            114,
            115,
            101,
            40,
            102,
            105,
            108,
            101,
            68,
            97,
            116,
            97,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            95,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            105,
            115,
            76,
            111,
            116,
            116,
            105,
            101,
            74,
            83,
            79,
            78,
            40,
            102,
            105,
            108,
            101,
            68,
            97,
            116,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            125,
            10,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            103,
            101,
            116,
            68,
            101,
            102,
            97,
            117,
            108,
            116,
            68,
            80,
            82,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            100,
            112,
            114,
            32,
            61,
            32,
            73,
            83,
            95,
            66,
            82,
            79,
            87,
            83,
            69,
            82,
            32,
            63,
            32,
            119,
            105,
            110,
            100,
            111,
            119,
            46,
            100,
            101,
            118,
            105,
            99,
            101,
            80,
            105,
            120,
            101,
            108,
            82,
            97,
            116,
            105,
            111,
            32,
            58,
            32,
            49,
            59,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            49,
            32,
            43,
            32,
            40,
            100,
            112,
            114,
            32,
            45,
            32,
            49,
            41,
            32,
            42,
            32,
            68,
            69,
            70,
            65,
            85,
            76,
            84,
            95,
            68,
            80,
            82,
            95,
            70,
            65,
            67,
            84,
            79,
            82,
            59,
            10,
            32,
            32,
            125,
            10,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            105,
            115,
            69,
            108,
            101,
            109,
            101,
            110,
            116,
            73,
            110,
            86,
            105,
            101,
            119,
            112,
            111,
            114,
            116,
            40,
            101,
            108,
            101,
            109,
            101,
            110,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            99,
            116,
            32,
            61,
            32,
            101,
            108,
            101,
            109,
            101,
            110,
            116,
            46,
            103,
            101,
            116,
            66,
            111,
            117,
            110,
            100,
            105,
            110,
            103,
            67,
            108,
            105,
            101,
            110,
            116,
            82,
            101,
            99,
            116,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            114,
            101,
            99,
            116,
            46,
            116,
            111,
            112,
            32,
            62,
            61,
            32,
            48,
            32,
            38,
            38,
            32,
            114,
            101,
            99,
            116,
            46,
            108,
            101,
            102,
            116,
            32,
            62,
            61,
            32,
            48,
            32,
            38,
            38,
            32,
            114,
            101,
            99,
            116,
            46,
            98,
            111,
            116,
            116,
            111,
            109,
            32,
            60,
            61,
            32,
            40,
            119,
            105,
            110,
            100,
            111,
            119,
            46,
            105,
            110,
            110,
            101,
            114,
            72,
            101,
            105,
            103,
            104,
            116,
            32,
            124,
            124,
            32,
            100,
            111,
            99,
            117,
            109,
            101,
            110,
            116,
            46,
            100,
            111,
            99,
            117,
            109,
            101,
            110,
            116,
            69,
            108,
            101,
            109,
            101,
            110,
            116,
            46,
            99,
            108,
            105,
            101,
            110,
            116,
            72,
            101,
            105,
            103,
            104,
            116,
            41,
            32,
            38,
            38,
            32,
            114,
            101,
            99,
            116,
            46,
            114,
            105,
            103,
            104,
            116,
            32,
            60,
            61,
            32,
            40,
            119,
            105,
            110,
            100,
            111,
            119,
            46,
            105,
            110,
            110,
            101,
            114,
            87,
            105,
            100,
            116,
            104,
            32,
            124,
            124,
            32,
            100,
            111,
            99,
            117,
            109,
            101,
            110,
            116,
            46,
            100,
            111,
            99,
            117,
            109,
            101,
            110,
            116,
            69,
            108,
            101,
            109,
            101,
            110,
            116,
            46,
            99,
            108,
            105,
            101,
            110,
            116,
            87,
            105,
            100,
            116,
            104,
            41,
            59,
            10,
            32,
            32,
            125,
            10,
            10,
            32,
            32,
            47,
            47,
            32,
            115,
            114,
            99,
            47,
            100,
            111,
            116,
            108,
            111,
            116,
            116,
            105,
            101,
            46,
            116,
            115,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            67,
            111,
            114,
            101,
            77,
            111,
            100,
            101,
            32,
            61,
            32,
            40,
            109,
            111,
            100,
            101,
            44,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            109,
            111,
            100,
            101,
            32,
            61,
            61,
            61,
            32,
            34,
            114,
            101,
            118,
            101,
            114,
            115,
            101,
            34,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            77,
            111,
            100,
            101,
            46,
            82,
            101,
            118,
            101,
            114,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            105,
            102,
            32,
            40,
            109,
            111,
            100,
            101,
            32,
            61,
            61,
            61,
            32,
            34,
            98,
            111,
            117,
            110,
            99,
            101,
            34,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            77,
            111,
            100,
            101,
            46,
            66,
            111,
            117,
            110,
            99,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            105,
            102,
            32,
            40,
            109,
            111,
            100,
            101,
            32,
            61,
            61,
            61,
            32,
            34,
            114,
            101,
            118,
            101,
            114,
            115,
            101,
            45,
            98,
            111,
            117,
            110,
            99,
            101,
            34,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            77,
            111,
            100,
            101,
            46,
            82,
            101,
            118,
            101,
            114,
            115,
            101,
            66,
            111,
            117,
            110,
            99,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            77,
            111,
            100,
            101,
            46,
            70,
            111,
            114,
            119,
            97,
            114,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            67,
            111,
            114,
            101,
            70,
            105,
            116,
            32,
            61,
            32,
            40,
            102,
            105,
            116,
            44,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            102,
            105,
            116,
            32,
            61,
            61,
            61,
            32,
            34,
            99,
            111,
            110,
            116,
            97,
            105,
            110,
            34,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            70,
            105,
            116,
            46,
            67,
            111,
            110,
            116,
            97,
            105,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            105,
            102,
            32,
            40,
            102,
            105,
            116,
            32,
            61,
            61,
            61,
            32,
            34,
            99,
            111,
            118,
            101,
            114,
            34,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            70,
            105,
            116,
            46,
            67,
            111,
            118,
            101,
            114,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            105,
            102,
            32,
            40,
            102,
            105,
            116,
            32,
            61,
            61,
            61,
            32,
            34,
            102,
            105,
            108,
            108,
            34,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            70,
            105,
            116,
            46,
            70,
            105,
            108,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            105,
            102,
            32,
            40,
            102,
            105,
            116,
            32,
            61,
            61,
            61,
            32,
            34,
            102,
            105,
            116,
            45,
            104,
            101,
            105,
            103,
            104,
            116,
            34,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            70,
            105,
            116,
            46,
            70,
            105,
            116,
            72,
            101,
            105,
            103,
            104,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            105,
            102,
            32,
            40,
            102,
            105,
            116,
            32,
            61,
            61,
            61,
            32,
            34,
            102,
            105,
            116,
            45,
            119,
            105,
            100,
            116,
            104,
            34,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            70,
            105,
            116,
            46,
            70,
            105,
            116,
            87,
            105,
            100,
            116,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            70,
            105,
            116,
            46,
            78,
            111,
            110,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            67,
            111,
            114,
            101,
            65,
            108,
            105,
            103,
            110,
            32,
            61,
            32,
            40,
            97,
            108,
            105,
            103,
            110,
            44,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            99,
            111,
            114,
            101,
            65,
            108,
            105,
            103,
            110,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            86,
            101,
            99,
            116,
            111,
            114,
            70,
            108,
            111,
            97,
            116,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            99,
            111,
            114,
            101,
            65,
            108,
            105,
            103,
            110,
            46,
            112,
            117,
            115,
            104,
            95,
            98,
            97,
            99,
            107,
            40,
            97,
            108,
            105,
            103,
            110,
            91,
            48,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            99,
            111,
            114,
            101,
            65,
            108,
            105,
            103,
            110,
            46,
            112,
            117,
            115,
            104,
            95,
            98,
            97,
            99,
            107,
            40,
            97,
            108,
            105,
            103,
            110,
            91,
            49,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            111,
            114,
            101,
            65,
            108,
            105,
            103,
            110,
            59,
            10,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            67,
            111,
            114,
            101,
            83,
            101,
            103,
            109,
            101,
            110,
            116,
            32,
            61,
            32,
            40,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            44,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            99,
            111,
            114,
            101,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            86,
            101,
            99,
            116,
            111,
            114,
            70,
            108,
            111,
            97,
            116,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            32,
            33,
            61,
            61,
            32,
            50,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            111,
            114,
            101,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            99,
            111,
            114,
            101,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            46,
            112,
            117,
            115,
            104,
            95,
            98,
            97,
            99,
            107,
            40,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            91,
            48,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            99,
            111,
            114,
            101,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            46,
            112,
            117,
            115,
            104,
            95,
            98,
            97,
            99,
            107,
            40,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            91,
            49,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            111,
            114,
            101,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            59,
            10,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            32,
            61,
            32,
            99,
            108,
            97,
            115,
            115,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            114,
            117,
            99,
            116,
            111,
            114,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            99,
            111,
            110,
            116,
            101,
            120,
            116,
            34,
            44,
            32,
            110,
            117,
            108,
            108,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            73,
            100,
            34,
            44,
            32,
            110,
            117,
            108,
            108,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            102,
            114,
            97,
            109,
            101,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            34,
            44,
            32,
            110,
            117,
            108,
            108,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            34,
            44,
            32,
            123,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            105,
            115,
            70,
            114,
            111,
            122,
            101,
            110,
            34,
            44,
            32,
            102,
            97,
            108,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            98,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            34,
            44,
            32,
            110,
            117,
            108,
            108,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            85,
            112,
            77,
            101,
            116,
            104,
            111,
            100,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            68,
            111,
            119,
            110,
            77,
            101,
            116,
            104,
            111,
            100,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            77,
            111,
            118,
            101,
            77,
            101,
            116,
            104,
            111,
            100,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            110,
            116,
            101,
            114,
            77,
            101,
            116,
            104,
            111,
            100,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            34,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            120,
            105,
            116,
            77,
            101,
            116,
            104,
            111,
            100,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            44,
            32,
            95,
            99,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            99,
            97,
            110,
            118,
            97,
            115,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            111,
            110,
            116,
            101,
            120,
            116,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            103,
            101,
            116,
            67,
            111,
            110,
            116,
            101,
            120,
            116,
            40,
            34,
            50,
            100,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            69,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            102,
            114,
            97,
            109,
            101,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            32,
            61,
            32,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            80,
            114,
            111,
            112,
            115,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            115,
            40,
            123,
            125,
            44,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            41,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            101,
            118,
            105,
            99,
            101,
            80,
            105,
            120,
            101,
            108,
            82,
            97,
            116,
            105,
            111,
            58,
            32,
            40,
            40,
            95,
            97,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            100,
            101,
            118,
            105,
            99,
            101,
            80,
            105,
            120,
            101,
            108,
            82,
            97,
            116,
            105,
            111,
            41,
            32,
            124,
            124,
            32,
            103,
            101,
            116,
            68,
            101,
            102,
            97,
            117,
            108,
            116,
            68,
            80,
            82,
            40,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            47,
            47,
            32,
            102,
            114,
            101,
            101,
            122,
            101,
            79,
            110,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            32,
            105,
            115,
            32,
            116,
            114,
            117,
            101,
            32,
            98,
            121,
            32,
            100,
            101,
            102,
            97,
            117,
            108,
            116,
            32,
            116,
            111,
            32,
            112,
            114,
            101,
            118,
            101,
            110,
            116,
            32,
            117,
            110,
            110,
            101,
            99,
            101,
            115,
            115,
            97,
            114,
            121,
            32,
            114,
            101,
            110,
            100,
            101,
            114,
            105,
            110,
            103,
            32,
            119,
            104,
            101,
            110,
            32,
            116,
            104,
            101,
            32,
            99,
            97,
            110,
            118,
            97,
            115,
            32,
            105,
            115,
            32,
            111,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            114,
            101,
            101,
            122,
            101,
            79,
            110,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            58,
            32,
            40,
            95,
            99,
            32,
            61,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            98,
            46,
            102,
            114,
            101,
            101,
            122,
            101,
            79,
            110,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            99,
            32,
            58,
            32,
            116,
            114,
            117,
            101,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            87,
            97,
            115,
            109,
            76,
            111,
            97,
            100,
            101,
            114,
            46,
            108,
            111,
            97,
            100,
            40,
            41,
            46,
            116,
            104,
            101,
            110,
            40,
            40,
            109,
            111,
            100,
            117,
            108,
            101,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            50,
            44,
            32,
            95,
            98,
            50,
            44,
            32,
            95,
            99,
            50,
            44,
            32,
            95,
            100,
            44,
            32,
            95,
            101,
            44,
            32,
            95,
            102,
            44,
            32,
            95,
            103,
            44,
            32,
            95,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            32,
            61,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            80,
            108,
            97,
            121,
            101,
            114,
            40,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            101,
            109,
            101,
            73,
            100,
            58,
            32,
            40,
            95,
            97,
            50,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            116,
            104,
            101,
            109,
            101,
            73,
            100,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            97,
            50,
            32,
            58,
            32,
            34,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            117,
            116,
            111,
            112,
            108,
            97,
            121,
            58,
            32,
            40,
            95,
            98,
            50,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            97,
            117,
            116,
            111,
            112,
            108,
            97,
            121,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            50,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            58,
            32,
            48,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            111,
            111,
            112,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            58,
            32,
            40,
            95,
            99,
            50,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            108,
            111,
            111,
            112,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            99,
            50,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            111,
            100,
            101,
            58,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            67,
            111,
            114,
            101,
            77,
            111,
            100,
            101,
            40,
            40,
            95,
            100,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            109,
            111,
            100,
            101,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            100,
            32,
            58,
            32,
            34,
            102,
            111,
            114,
            119,
            97,
            114,
            100,
            34,
            44,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            58,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            67,
            111,
            114,
            101,
            83,
            101,
            103,
            109,
            101,
            110,
            116,
            40,
            40,
            95,
            101,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            101,
            32,
            58,
            32,
            91,
            93,
            44,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            112,
            101,
            101,
            100,
            58,
            32,
            40,
            95,
            102,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            115,
            112,
            101,
            101,
            100,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            102,
            32,
            58,
            32,
            49,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            117,
            115,
            101,
            70,
            114,
            97,
            109,
            101,
            73,
            110,
            116,
            101,
            114,
            112,
            111,
            108,
            97,
            116,
            105,
            111,
            110,
            58,
            32,
            40,
            95,
            103,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            117,
            115,
            101,
            70,
            114,
            97,
            109,
            101,
            73,
            110,
            116,
            101,
            114,
            112,
            111,
            108,
            97,
            116,
            105,
            111,
            110,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            103,
            32,
            58,
            32,
            116,
            114,
            117,
            101,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            97,
            114,
            107,
            101,
            114,
            58,
            32,
            40,
            95,
            104,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            109,
            97,
            114,
            107,
            101,
            114,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            104,
            32,
            58,
            32,
            34,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            97,
            121,
            111,
            117,
            116,
            58,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            108,
            97,
            121,
            111,
            117,
            116,
            32,
            63,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            108,
            105,
            103,
            110,
            58,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            67,
            111,
            114,
            101,
            65,
            108,
            105,
            103,
            110,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            108,
            97,
            121,
            111,
            117,
            116,
            46,
            97,
            108,
            105,
            103,
            110,
            44,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            105,
            116,
            58,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            67,
            111,
            114,
            101,
            70,
            105,
            116,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            108,
            97,
            121,
            111,
            117,
            116,
            46,
            102,
            105,
            116,
            44,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            58,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            46,
            99,
            114,
            101,
            97,
            116,
            101,
            68,
            101,
            102,
            97,
            117,
            108,
            116,
            76,
            97,
            121,
            111,
            117,
            116,
            40,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            114,
            101,
            97,
            100,
            121,
            34,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            100,
            97,
            116,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            108,
            111,
            97,
            100,
            70,
            114,
            111,
            109,
            68,
            97,
            116,
            97,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            100,
            97,
            116,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            105,
            102,
            32,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            115,
            114,
            99,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            108,
            111,
            97,
            100,
            70,
            114,
            111,
            109,
            83,
            114,
            99,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            115,
            114,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            98,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            115,
            101,
            116,
            66,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            98,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            46,
            99,
            97,
            116,
            99,
            104,
            40,
            40,
            101,
            114,
            114,
            111,
            114,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            108,
            111,
            97,
            100,
            69,
            114,
            114,
            111,
            114,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            114,
            114,
            111,
            114,
            58,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            70,
            97,
            105,
            108,
            101,
            100,
            32,
            116,
            111,
            32,
            108,
            111,
            97,
            100,
            32,
            119,
            97,
            115,
            109,
            32,
            109,
            111,
            100,
            117,
            108,
            101,
            58,
            32,
            36,
            123,
            101,
            114,
            114,
            111,
            114,
            125,
            96,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            85,
            112,
            77,
            101,
            116,
            104,
            111,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            110,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            85,
            112,
            46,
            98,
            105,
            110,
            100,
            40,
            116,
            104,
            105,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            68,
            111,
            119,
            110,
            77,
            101,
            116,
            104,
            111,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            110,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            68,
            111,
            119,
            110,
            46,
            98,
            105,
            110,
            100,
            40,
            116,
            104,
            105,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            77,
            111,
            118,
            101,
            77,
            101,
            116,
            104,
            111,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            110,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            77,
            111,
            118,
            101,
            46,
            98,
            105,
            110,
            100,
            40,
            116,
            104,
            105,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            110,
            116,
            101,
            114,
            77,
            101,
            116,
            104,
            111,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            110,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            110,
            116,
            101,
            114,
            46,
            98,
            105,
            110,
            100,
            40,
            116,
            104,
            105,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            120,
            105,
            116,
            77,
            101,
            116,
            104,
            111,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            111,
            110,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            76,
            101,
            97,
            118,
            101,
            46,
            98,
            105,
            110,
            100,
            40,
            116,
            104,
            105,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            95,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            69,
            114,
            114,
            111,
            114,
            40,
            109,
            101,
            115,
            115,
            97,
            103,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            111,
            108,
            101,
            46,
            101,
            114,
            114,
            111,
            114,
            40,
            109,
            101,
            115,
            115,
            97,
            103,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            108,
            111,
            97,
            100,
            69,
            114,
            114,
            111,
            114,
            34,
            44,
            32,
            101,
            114,
            114,
            111,
            114,
            58,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            109,
            101,
            115,
            115,
            97,
            103,
            101,
            41,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            95,
            102,
            101,
            116,
            99,
            104,
            68,
            97,
            116,
            97,
            40,
            115,
            114,
            99,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            95,
            95,
            97,
            115,
            121,
            110,
            99,
            40,
            116,
            104,
            105,
            115,
            44,
            32,
            110,
            117,
            108,
            108,
            44,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            42,
            32,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            32,
            61,
            32,
            121,
            105,
            101,
            108,
            100,
            32,
            102,
            101,
            116,
            99,
            104,
            40,
            115,
            114,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            46,
            111,
            107,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            70,
            97,
            105,
            108,
            101,
            100,
            32,
            116,
            111,
            32,
            102,
            101,
            116,
            99,
            104,
            32,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            32,
            100,
            97,
            116,
            97,
            32,
            102,
            114,
            111,
            109,
            32,
            85,
            82,
            76,
            58,
            32,
            36,
            123,
            115,
            114,
            99,
            125,
            46,
            32,
            36,
            123,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            46,
            115,
            116,
            97,
            116,
            117,
            115,
            125,
            58,
            32,
            36,
            123,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            46,
            115,
            116,
            97,
            116,
            117,
            115,
            84,
            101,
            120,
            116,
            125,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            100,
            97,
            116,
            97,
            32,
            61,
            32,
            121,
            105,
            101,
            108,
            100,
            32,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            46,
            97,
            114,
            114,
            97,
            121,
            66,
            117,
            102,
            102,
            101,
            114,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            105,
            115,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            40,
            100,
            97,
            116,
            97,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            100,
            97,
            116,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            110,
            101,
            119,
            32,
            84,
            101,
            120,
            116,
            68,
            101,
            99,
            111,
            100,
            101,
            114,
            40,
            41,
            46,
            100,
            101,
            99,
            111,
            100,
            101,
            40,
            100,
            97,
            116,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            95,
            108,
            111,
            97,
            100,
            70,
            114,
            111,
            109,
            68,
            97,
            116,
            97,
            40,
            100,
            97,
            116,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            119,
            105,
            100,
            116,
            104,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            119,
            105,
            100,
            116,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            104,
            101,
            105,
            103,
            104,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            101,
            116,
            32,
            108,
            111,
            97,
            100,
            101,
            100,
            32,
            61,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            100,
            97,
            116,
            97,
            32,
            61,
            61,
            61,
            32,
            34,
            115,
            116,
            114,
            105,
            110,
            103,
            34,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            115,
            76,
            111,
            116,
            116,
            105,
            101,
            40,
            100,
            97,
            116,
            97,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            69,
            114,
            114,
            111,
            114,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            73,
            110,
            118,
            97,
            108,
            105,
            100,
            32,
            76,
            111,
            116,
            116,
            105,
            101,
            32,
            74,
            83,
            79,
            78,
            32,
            115,
            116,
            114,
            105,
            110,
            103,
            58,
            32,
            84,
            104,
            101,
            32,
            112,
            114,
            111,
            118,
            105,
            100,
            101,
            100,
            32,
            115,
            116,
            114,
            105,
            110,
            103,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            99,
            111,
            110,
            102,
            111,
            114,
            109,
            32,
            116,
            111,
            32,
            116,
            104,
            101,
            32,
            76,
            111,
            116,
            116,
            105,
            101,
            32,
            74,
            83,
            79,
            78,
            32,
            102,
            111,
            114,
            109,
            97,
            116,
            46,
            34,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            111,
            97,
            100,
            101,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            108,
            111,
            97,
            100,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            68,
            97,
            116,
            97,
            40,
            100,
            97,
            116,
            97,
            44,
            32,
            119,
            105,
            100,
            116,
            104,
            44,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            105,
            102,
            32,
            40,
            100,
            97,
            116,
            97,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            111,
            102,
            32,
            65,
            114,
            114,
            97,
            121,
            66,
            117,
            102,
            102,
            101,
            114,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            115,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            40,
            100,
            97,
            116,
            97,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            69,
            114,
            114,
            111,
            114,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            73,
            110,
            118,
            97,
            108,
            105,
            100,
            32,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            32,
            65,
            114,
            114,
            97,
            121,
            66,
            117,
            102,
            102,
            101,
            114,
            58,
            32,
            84,
            104,
            101,
            32,
            112,
            114,
            111,
            118,
            105,
            100,
            101,
            100,
            32,
            65,
            114,
            114,
            97,
            121,
            66,
            117,
            102,
            102,
            101,
            114,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            99,
            111,
            110,
            102,
            111,
            114,
            109,
            32,
            116,
            111,
            32,
            116,
            104,
            101,
            32,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            32,
            102,
            111,
            114,
            109,
            97,
            116,
            46,
            34,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            111,
            97,
            100,
            101,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            108,
            111,
            97,
            100,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            68,
            97,
            116,
            97,
            40,
            100,
            97,
            116,
            97,
            44,
            32,
            119,
            105,
            100,
            116,
            104,
            44,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            105,
            102,
            32,
            40,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            100,
            97,
            116,
            97,
            32,
            61,
            61,
            61,
            32,
            34,
            111,
            98,
            106,
            101,
            99,
            116,
            34,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            115,
            76,
            111,
            116,
            116,
            105,
            101,
            40,
            100,
            97,
            116,
            97,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            69,
            114,
            114,
            111,
            114,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            73,
            110,
            118,
            97,
            108,
            105,
            100,
            32,
            76,
            111,
            116,
            116,
            105,
            101,
            32,
            74,
            83,
            79,
            78,
            32,
            111,
            98,
            106,
            101,
            99,
            116,
            58,
            32,
            84,
            104,
            101,
            32,
            112,
            114,
            111,
            118,
            105,
            100,
            101,
            100,
            32,
            111,
            98,
            106,
            101,
            99,
            116,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            99,
            111,
            110,
            102,
            111,
            114,
            109,
            32,
            116,
            111,
            32,
            116,
            104,
            101,
            32,
            76,
            111,
            116,
            116,
            105,
            101,
            32,
            74,
            83,
            79,
            78,
            32,
            102,
            111,
            114,
            109,
            97,
            116,
            46,
            34,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            111,
            97,
            100,
            101,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            108,
            111,
            97,
            100,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            68,
            97,
            116,
            97,
            40,
            74,
            83,
            79,
            78,
            46,
            115,
            116,
            114,
            105,
            110,
            103,
            105,
            102,
            121,
            40,
            100,
            97,
            116,
            97,
            41,
            44,
            32,
            119,
            105,
            100,
            116,
            104,
            44,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            69,
            114,
            114,
            111,
            114,
            40,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            96,
            85,
            110,
            115,
            117,
            112,
            112,
            111,
            114,
            116,
            101,
            100,
            32,
            100,
            97,
            116,
            97,
            32,
            116,
            121,
            112,
            101,
            32,
            102,
            111,
            114,
            32,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            32,
            100,
            97,
            116,
            97,
            46,
            32,
            69,
            120,
            112,
            101,
            99,
            116,
            101,
            100,
            58,
            32,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            45,
            32,
            115,
            116,
            114,
            105,
            110,
            103,
            32,
            40,
            76,
            111,
            116,
            116,
            105,
            101,
            32,
            74,
            83,
            79,
            78,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            45,
            32,
            65,
            114,
            114,
            97,
            121,
            66,
            117,
            102,
            102,
            101,
            114,
            32,
            40,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            45,
            32,
            111,
            98,
            106,
            101,
            99,
            116,
            32,
            40,
            76,
            111,
            116,
            116,
            105,
            101,
            32,
            74,
            83,
            79,
            78,
            41,
            46,
            32,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            82,
            101,
            99,
            101,
            105,
            118,
            101,
            100,
            58,
            32,
            36,
            123,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            100,
            97,
            116,
            97,
            125,
            96,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            108,
            111,
            97,
            100,
            101,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            108,
            111,
            97,
            100,
            34,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            73,
            83,
            95,
            66,
            82,
            79,
            87,
            83,
            69,
            82,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            114,
            101,
            115,
            105,
            122,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            102,
            114,
            97,
            109,
            101,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            70,
            114,
            97,
            109,
            101,
            58,
            32,
            116,
            104,
            105,
            115,
            46,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            70,
            114,
            97,
            109,
            101,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            46,
            97,
            117,
            116,
            111,
            112,
            108,
            97,
            121,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            112,
            108,
            97,
            121,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            105,
            115,
            80,
            108,
            97,
            121,
            105,
            110,
            103,
            40,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            112,
            108,
            97,
            121,
            34,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            73,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            102,
            114,
            97,
            109,
            101,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            114,
            97,
            119,
            46,
            98,
            105,
            110,
            100,
            40,
            116,
            104,
            105,
            115,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            111,
            108,
            101,
            46,
            101,
            114,
            114,
            111,
            114,
            40,
            34,
            115,
            111,
            109,
            101,
            116,
            104,
            105,
            110,
            103,
            32,
            119,
            101,
            110,
            116,
            32,
            119,
            114,
            111,
            110,
            103,
            44,
            32,
            116,
            104,
            101,
            32,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            32,
            119,
            97,
            115,
            32,
            115,
            117,
            112,
            112,
            111,
            115,
            101,
            32,
            116,
            111,
            32,
            97,
            117,
            116,
            111,
            112,
            108,
            97,
            121,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            73,
            83,
            95,
            66,
            82,
            79,
            87,
            83,
            69,
            82,
            32,
            38,
            38,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            111,
            102,
            32,
            72,
            84,
            77,
            76,
            67,
            97,
            110,
            118,
            97,
            115,
            69,
            108,
            101,
            109,
            101,
            110,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            46,
            102,
            114,
            101,
            101,
            122,
            101,
            79,
            110,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            46,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            44,
            32,
            116,
            104,
            105,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            46,
            97,
            117,
            116,
            111,
            82,
            101,
            115,
            105,
            122,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            67,
            97,
            110,
            118,
            97,
            115,
            82,
            101,
            115,
            105,
            122,
            101,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            46,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            44,
            32,
            116,
            104,
            105,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            69,
            114,
            114,
            111,
            114,
            40,
            34,
            70,
            97,
            105,
            108,
            101,
            100,
            32,
            116,
            111,
            32,
            108,
            111,
            97,
            100,
            32,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            32,
            100,
            97,
            116,
            97,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            95,
            108,
            111,
            97,
            100,
            70,
            114,
            111,
            109,
            83,
            114,
            99,
            40,
            115,
            114,
            99,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            102,
            101,
            116,
            99,
            104,
            68,
            97,
            116,
            97,
            40,
            115,
            114,
            99,
            41,
            46,
            116,
            104,
            101,
            110,
            40,
            40,
            100,
            97,
            116,
            97,
            41,
            32,
            61,
            62,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            108,
            111,
            97,
            100,
            70,
            114,
            111,
            109,
            68,
            97,
            116,
            97,
            40,
            100,
            97,
            116,
            97,
            41,
            41,
            46,
            99,
            97,
            116,
            99,
            104,
            40,
            40,
            101,
            114,
            114,
            111,
            114,
            41,
            32,
            61,
            62,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            70,
            97,
            105,
            108,
            101,
            100,
            32,
            116,
            111,
            32,
            108,
            111,
            97,
            100,
            32,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            32,
            100,
            97,
            116,
            97,
            32,
            102,
            114,
            111,
            109,
            32,
            85,
            82,
            76,
            58,
            32,
            36,
            123,
            115,
            114,
            99,
            125,
            46,
            32,
            36,
            123,
            101,
            114,
            114,
            111,
            114,
            125,
            96,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            97,
            99,
            116,
            105,
            118,
            101,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            73,
            100,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            97,
            99,
            116,
            105,
            118,
            101,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            73,
            100,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            97,
            99,
            116,
            105,
            118,
            101,
            84,
            104,
            101,
            109,
            101,
            73,
            100,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            97,
            99,
            116,
            105,
            118,
            101,
            84,
            104,
            101,
            109,
            101,
            73,
            100,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            108,
            97,
            121,
            111,
            117,
            116,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            108,
            97,
            121,
            111,
            117,
            116,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            46,
            108,
            97,
            121,
            111,
            117,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            108,
            97,
            121,
            111,
            117,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            108,
            105,
            103,
            110,
            58,
            32,
            91,
            108,
            97,
            121,
            111,
            117,
            116,
            46,
            97,
            108,
            105,
            103,
            110,
            46,
            103,
            101,
            116,
            40,
            48,
            41,
            44,
            32,
            108,
            97,
            121,
            111,
            117,
            116,
            46,
            97,
            108,
            105,
            103,
            110,
            46,
            103,
            101,
            116,
            40,
            49,
            41,
            93,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            105,
            116,
            58,
            32,
            40,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            50,
            44,
            32,
            95,
            98,
            44,
            32,
            95,
            99,
            44,
            32,
            95,
            100,
            44,
            32,
            95,
            101,
            44,
            32,
            95,
            102,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            119,
            105,
            116,
            99,
            104,
            32,
            40,
            108,
            97,
            121,
            111,
            117,
            116,
            46,
            102,
            105,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            40,
            40,
            95,
            97,
            50,
            32,
            61,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            50,
            46,
            70,
            105,
            116,
            46,
            67,
            111,
            110,
            116,
            97,
            105,
            110,
            41,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            34,
            99,
            111,
            110,
            116,
            97,
            105,
            110,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            40,
            40,
            95,
            98,
            32,
            61,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            98,
            46,
            70,
            105,
            116,
            46,
            67,
            111,
            118,
            101,
            114,
            41,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            34,
            99,
            111,
            118,
            101,
            114,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            40,
            40,
            95,
            99,
            32,
            61,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            99,
            46,
            70,
            105,
            116,
            46,
            70,
            105,
            108,
            108,
            41,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            34,
            102,
            105,
            108,
            108,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            40,
            40,
            95,
            100,
            32,
            61,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            100,
            46,
            70,
            105,
            116,
            46,
            70,
            105,
            116,
            72,
            101,
            105,
            103,
            104,
            116,
            41,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            34,
            102,
            105,
            116,
            45,
            104,
            101,
            105,
            103,
            104,
            116,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            40,
            40,
            95,
            101,
            32,
            61,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            101,
            46,
            70,
            105,
            116,
            46,
            70,
            105,
            116,
            87,
            105,
            100,
            116,
            104,
            41,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            34,
            102,
            105,
            116,
            45,
            119,
            105,
            100,
            116,
            104,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            97,
            115,
            101,
            32,
            40,
            40,
            95,
            102,
            32,
            61,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            102,
            46,
            70,
            105,
            116,
            46,
            78,
            111,
            110,
            101,
            41,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            34,
            110,
            111,
            110,
            101,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            101,
            102,
            97,
            117,
            108,
            116,
            58,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            34,
            99,
            111,
            110,
            116,
            97,
            105,
            110,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            40,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            109,
            97,
            114,
            107,
            101,
            114,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            109,
            97,
            114,
            107,
            101,
            114,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            46,
            109,
            97,
            114,
            107,
            101,
            114,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            109,
            97,
            114,
            107,
            101,
            114,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            109,
            97,
            110,
            105,
            102,
            101,
            115,
            116,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            109,
            97,
            110,
            105,
            102,
            101,
            115,
            116,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            109,
            97,
            110,
            105,
            102,
            101,
            115,
            116,
            83,
            116,
            114,
            105,
            110,
            103,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            124,
            124,
            32,
            33,
            109,
            97,
            110,
            105,
            102,
            101,
            115,
            116,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            110,
            117,
            108,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            109,
            97,
            110,
            105,
            102,
            101,
            115,
            116,
            74,
            115,
            111,
            110,
            32,
            61,
            32,
            74,
            83,
            79,
            78,
            46,
            112,
            97,
            114,
            115,
            101,
            40,
            109,
            97,
            110,
            105,
            102,
            101,
            115,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            79,
            98,
            106,
            101,
            99,
            116,
            46,
            107,
            101,
            121,
            115,
            40,
            109,
            97,
            110,
            105,
            102,
            101,
            115,
            116,
            74,
            115,
            111,
            110,
            41,
            46,
            108,
            101,
            110,
            103,
            116,
            104,
            32,
            61,
            61,
            61,
            32,
            48,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            110,
            117,
            108,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            109,
            97,
            110,
            105,
            102,
            101,
            115,
            116,
            74,
            115,
            111,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            95,
            101,
            114,
            114,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            110,
            117,
            108,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            46,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            32,
            38,
            38,
            32,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            46,
            115,
            105,
            122,
            101,
            40,
            41,
            32,
            61,
            61,
            61,
            32,
            50,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            91,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            46,
            103,
            101,
            116,
            40,
            48,
            41,
            44,
            32,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            46,
            103,
            101,
            116,
            40,
            49,
            41,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            108,
            111,
            111,
            112,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            46,
            108,
            111,
            111,
            112,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            109,
            111,
            100,
            101,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            44,
            32,
            95,
            99,
            44,
            32,
            95,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            109,
            111,
            100,
            101,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            46,
            109,
            111,
            100,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            109,
            111,
            100,
            101,
            32,
            61,
            61,
            61,
            32,
            40,
            40,
            95,
            98,
            32,
            61,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            98,
            46,
            77,
            111,
            100,
            101,
            46,
            82,
            101,
            118,
            101,
            114,
            115,
            101,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            34,
            114,
            101,
            118,
            101,
            114,
            115,
            101,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            105,
            102,
            32,
            40,
            109,
            111,
            100,
            101,
            32,
            61,
            61,
            61,
            32,
            40,
            40,
            95,
            99,
            32,
            61,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            99,
            46,
            77,
            111,
            100,
            101,
            46,
            66,
            111,
            117,
            110,
            99,
            101,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            34,
            98,
            111,
            117,
            110,
            99,
            101,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            105,
            102,
            32,
            40,
            109,
            111,
            100,
            101,
            32,
            61,
            61,
            61,
            32,
            40,
            40,
            95,
            100,
            32,
            61,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            100,
            46,
            77,
            111,
            100,
            101,
            46,
            82,
            101,
            118,
            101,
            114,
            115,
            101,
            66,
            111,
            117,
            110,
            99,
            101,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            34,
            114,
            101,
            118,
            101,
            114,
            115,
            101,
            45,
            98,
            111,
            117,
            110,
            99,
            101,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            34,
            102,
            111,
            114,
            119,
            97,
            114,
            100,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            105,
            115,
            70,
            114,
            111,
            122,
            101,
            110,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            105,
            115,
            70,
            114,
            111,
            122,
            101,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            98,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            98,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            97,
            32,
            58,
            32,
            34,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            97,
            117,
            116,
            111,
            112,
            108,
            97,
            121,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            46,
            97,
            117,
            116,
            111,
            112,
            108,
            97,
            121,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            117,
            115,
            101,
            70,
            114,
            97,
            109,
            101,
            73,
            110,
            116,
            101,
            114,
            112,
            111,
            108,
            97,
            116,
            105,
            111,
            110,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            46,
            117,
            115,
            101,
            70,
            114,
            97,
            109,
            101,
            73,
            110,
            116,
            101,
            114,
            112,
            111,
            108,
            97,
            116,
            105,
            111,
            110,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            115,
            112,
            101,
            101,
            100,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            46,
            115,
            112,
            101,
            101,
            100,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            105,
            115,
            82,
            101,
            97,
            100,
            121,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            33,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            105,
            115,
            76,
            111,
            97,
            100,
            101,
            100,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            105,
            115,
            76,
            111,
            97,
            100,
            101,
            100,
            40,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            105,
            115,
            80,
            108,
            97,
            121,
            105,
            110,
            103,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            105,
            115,
            80,
            108,
            97,
            121,
            105,
            110,
            103,
            40,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            105,
            115,
            80,
            97,
            117,
            115,
            101,
            100,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            105,
            115,
            80,
            97,
            117,
            115,
            101,
            100,
            40,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            105,
            115,
            83,
            116,
            111,
            112,
            112,
            101,
            100,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            105,
            115,
            83,
            116,
            111,
            112,
            112,
            101,
            100,
            40,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            70,
            114,
            97,
            109,
            101,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            77,
            97,
            116,
            104,
            46,
            114,
            111,
            117,
            110,
            100,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            70,
            114,
            97,
            109,
            101,
            40,
            41,
            32,
            42,
            32,
            49,
            48,
            48,
            41,
            32,
            47,
            32,
            49,
            48,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            108,
            111,
            111,
            112,
            67,
            111,
            117,
            110,
            116,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            108,
            111,
            111,
            112,
            67,
            111,
            117,
            110,
            116,
            40,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            116,
            111,
            116,
            97,
            108,
            70,
            114,
            97,
            109,
            101,
            115,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            116,
            111,
            116,
            97,
            108,
            70,
            114,
            97,
            109,
            101,
            115,
            40,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            100,
            117,
            114,
            97,
            116,
            105,
            111,
            110,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            100,
            117,
            114,
            97,
            116,
            105,
            111,
            110,
            40,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            68,
            117,
            114,
            97,
            116,
            105,
            111,
            110,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            68,
            117,
            114,
            97,
            116,
            105,
            111,
            110,
            40,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            32,
            99,
            97,
            110,
            118,
            97,
            115,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            108,
            111,
            97,
            100,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            44,
            32,
            95,
            99,
            44,
            32,
            95,
            100,
            44,
            32,
            95,
            101,
            44,
            32,
            95,
            102,
            44,
            32,
            95,
            103,
            44,
            32,
            95,
            104,
            44,
            32,
            95,
            105,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            124,
            124,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            73,
            100,
            32,
            33,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            102,
            114,
            97,
            109,
            101,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            99,
            97,
            110,
            99,
            101,
            108,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            73,
            100,
            32,
            61,
            32,
            110,
            117,
            108,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            115,
            101,
            116,
            67,
            111,
            110,
            102,
            105,
            103,
            40,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            101,
            109,
            101,
            73,
            100,
            58,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            116,
            104,
            101,
            109,
            101,
            73,
            100,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            97,
            32,
            58,
            32,
            34,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            117,
            116,
            111,
            112,
            108,
            97,
            121,
            58,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            97,
            117,
            116,
            111,
            112,
            108,
            97,
            121,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            58,
            32,
            48,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            111,
            111,
            112,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            58,
            32,
            40,
            95,
            99,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            108,
            111,
            111,
            112,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            99,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            111,
            100,
            101,
            58,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            67,
            111,
            114,
            101,
            77,
            111,
            100,
            101,
            40,
            40,
            95,
            100,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            109,
            111,
            100,
            101,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            100,
            32,
            58,
            32,
            34,
            102,
            111,
            114,
            119,
            97,
            114,
            100,
            34,
            44,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            58,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            67,
            111,
            114,
            101,
            83,
            101,
            103,
            109,
            101,
            110,
            116,
            40,
            40,
            95,
            101,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            101,
            32,
            58,
            32,
            91,
            93,
            44,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            112,
            101,
            101,
            100,
            58,
            32,
            40,
            95,
            102,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            115,
            112,
            101,
            101,
            100,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            102,
            32,
            58,
            32,
            49,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            117,
            115,
            101,
            70,
            114,
            97,
            109,
            101,
            73,
            110,
            116,
            101,
            114,
            112,
            111,
            108,
            97,
            116,
            105,
            111,
            110,
            58,
            32,
            40,
            95,
            103,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            117,
            115,
            101,
            70,
            114,
            97,
            109,
            101,
            73,
            110,
            116,
            101,
            114,
            112,
            111,
            108,
            97,
            116,
            105,
            111,
            110,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            103,
            32,
            58,
            32,
            116,
            114,
            117,
            101,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            97,
            114,
            107,
            101,
            114,
            58,
            32,
            40,
            95,
            104,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            109,
            97,
            114,
            107,
            101,
            114,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            104,
            32,
            58,
            32,
            34,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            97,
            121,
            111,
            117,
            116,
            58,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            108,
            97,
            121,
            111,
            117,
            116,
            32,
            63,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            108,
            105,
            103,
            110,
            58,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            67,
            111,
            114,
            101,
            65,
            108,
            105,
            103,
            110,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            108,
            97,
            121,
            111,
            117,
            116,
            46,
            97,
            108,
            105,
            103,
            110,
            44,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            105,
            116,
            58,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            67,
            111,
            114,
            101,
            70,
            105,
            116,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            108,
            97,
            121,
            111,
            117,
            116,
            46,
            102,
            105,
            116,
            44,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            58,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            46,
            99,
            114,
            101,
            97,
            116,
            101,
            68,
            101,
            102,
            97,
            117,
            108,
            116,
            76,
            97,
            121,
            111,
            117,
            116,
            40,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            100,
            97,
            116,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            108,
            111,
            97,
            100,
            70,
            114,
            111,
            109,
            68,
            97,
            116,
            97,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            100,
            97,
            116,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            105,
            102,
            32,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            115,
            114,
            99,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            108,
            111,
            97,
            100,
            70,
            114,
            111,
            109,
            83,
            114,
            99,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            115,
            114,
            99,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            115,
            101,
            116,
            66,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            40,
            40,
            95,
            105,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            46,
            98,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            105,
            32,
            58,
            32,
            34,
            34,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            124,
            124,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            111,
            110,
            116,
            101,
            120,
            116,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            110,
            100,
            101,
            114,
            101,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            114,
            101,
            110,
            100,
            101,
            114,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            114,
            101,
            110,
            100,
            101,
            114,
            101,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            98,
            117,
            102,
            102,
            101,
            114,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            98,
            117,
            102,
            102,
            101,
            114,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            99,
            108,
            97,
            109,
            112,
            101,
            100,
            66,
            117,
            102,
            102,
            101,
            114,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            85,
            105,
            110,
            116,
            56,
            67,
            108,
            97,
            109,
            112,
            101,
            100,
            65,
            114,
            114,
            97,
            121,
            40,
            98,
            117,
            102,
            102,
            101,
            114,
            44,
            32,
            48,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            119,
            105,
            100,
            116,
            104,
            32,
            42,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            104,
            101,
            105,
            103,
            104,
            116,
            32,
            42,
            32,
            52,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            101,
            116,
            32,
            105,
            109,
            97,
            103,
            101,
            68,
            97,
            116,
            97,
            32,
            61,
            32,
            110,
            117,
            108,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            73,
            109,
            97,
            103,
            101,
            68,
            97,
            116,
            97,
            32,
            61,
            61,
            61,
            32,
            34,
            117,
            110,
            100,
            101,
            102,
            105,
            110,
            101,
            100,
            34,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            109,
            97,
            103,
            101,
            68,
            97,
            116,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            111,
            110,
            116,
            101,
            120,
            116,
            46,
            99,
            114,
            101,
            97,
            116,
            101,
            73,
            109,
            97,
            103,
            101,
            68,
            97,
            116,
            97,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            119,
            105,
            100,
            116,
            104,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            104,
            101,
            105,
            103,
            104,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            109,
            97,
            103,
            101,
            68,
            97,
            116,
            97,
            46,
            100,
            97,
            116,
            97,
            46,
            115,
            101,
            116,
            40,
            99,
            108,
            97,
            109,
            112,
            101,
            100,
            66,
            117,
            102,
            102,
            101,
            114,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            109,
            97,
            103,
            101,
            68,
            97,
            116,
            97,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            73,
            109,
            97,
            103,
            101,
            68,
            97,
            116,
            97,
            40,
            99,
            108,
            97,
            109,
            112,
            101,
            100,
            66,
            117,
            102,
            102,
            101,
            114,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            119,
            105,
            100,
            116,
            104,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            104,
            101,
            105,
            103,
            104,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            111,
            110,
            116,
            101,
            120,
            116,
            46,
            112,
            117,
            116,
            73,
            109,
            97,
            103,
            101,
            68,
            97,
            116,
            97,
            40,
            105,
            109,
            97,
            103,
            101,
            68,
            97,
            116,
            97,
            44,
            32,
            48,
            44,
            32,
            48,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            114,
            101,
            110,
            100,
            101,
            114,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            70,
            114,
            97,
            109,
            101,
            58,
            32,
            116,
            104,
            105,
            115,
            46,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            70,
            114,
            97,
            109,
            101,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            114,
            117,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            95,
            100,
            114,
            97,
            119,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            124,
            124,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            111,
            110,
            116,
            101,
            120,
            116,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            124,
            124,
            32,
            33,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            105,
            115,
            80,
            108,
            97,
            121,
            105,
            110,
            103,
            40,
            41,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            110,
            101,
            120,
            116,
            70,
            114,
            97,
            109,
            101,
            32,
            61,
            32,
            77,
            97,
            116,
            104,
            46,
            114,
            111,
            117,
            110,
            100,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            70,
            114,
            97,
            109,
            101,
            40,
            41,
            32,
            42,
            32,
            49,
            48,
            48,
            41,
            32,
            47,
            32,
            49,
            48,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            117,
            112,
            100,
            97,
            116,
            101,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            115,
            101,
            116,
            70,
            114,
            97,
            109,
            101,
            40,
            110,
            101,
            120,
            116,
            70,
            114,
            97,
            109,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            117,
            112,
            100,
            97,
            116,
            101,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            102,
            114,
            97,
            109,
            101,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            70,
            114,
            97,
            109,
            101,
            58,
            32,
            116,
            104,
            105,
            115,
            46,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            70,
            114,
            97,
            109,
            101,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            110,
            100,
            101,
            114,
            101,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            114,
            101,
            110,
            100,
            101,
            114,
            101,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            105,
            115,
            67,
            111,
            109,
            112,
            108,
            101,
            116,
            101,
            40,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            46,
            108,
            111,
            111,
            112,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            108,
            111,
            111,
            112,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            111,
            111,
            112,
            67,
            111,
            117,
            110,
            116,
            58,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            108,
            111,
            111,
            112,
            67,
            111,
            117,
            110,
            116,
            40,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            99,
            111,
            109,
            112,
            108,
            101,
            116,
            101,
            34,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            73,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            102,
            114,
            97,
            109,
            101,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            114,
            97,
            119,
            46,
            98,
            105,
            110,
            100,
            40,
            116,
            104,
            105,
            115,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            112,
            108,
            97,
            121,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            111,
            107,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            112,
            108,
            97,
            121,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            111,
            107,
            32,
            124,
            124,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            105,
            115,
            80,
            108,
            97,
            121,
            105,
            110,
            103,
            40,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            105,
            115,
            70,
            114,
            111,
            122,
            101,
            110,
            32,
            61,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            112,
            108,
            97,
            121,
            34,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            73,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            102,
            114,
            97,
            109,
            101,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            114,
            97,
            119,
            46,
            98,
            105,
            110,
            100,
            40,
            116,
            104,
            105,
            115,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            73,
            83,
            95,
            66,
            82,
            79,
            87,
            83,
            69,
            82,
            32,
            38,
            38,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            111,
            102,
            32,
            72,
            84,
            77,
            76,
            67,
            97,
            110,
            118,
            97,
            115,
            69,
            108,
            101,
            109,
            101,
            110,
            116,
            32,
            38,
            38,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            46,
            102,
            114,
            101,
            101,
            122,
            101,
            79,
            110,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            32,
            38,
            38,
            32,
            33,
            105,
            115,
            69,
            108,
            101,
            109,
            101,
            110,
            116,
            73,
            110,
            86,
            105,
            101,
            119,
            112,
            111,
            114,
            116,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            102,
            114,
            101,
            101,
            122,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            112,
            97,
            117,
            115,
            101,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            111,
            107,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            112,
            97,
            117,
            115,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            111,
            107,
            32,
            124,
            124,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            105,
            115,
            80,
            97,
            117,
            115,
            101,
            100,
            40,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            112,
            97,
            117,
            115,
            101,
            34,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            111,
            112,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            111,
            107,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            115,
            116,
            111,
            112,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            111,
            107,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            102,
            114,
            97,
            109,
            101,
            34,
            44,
            32,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            70,
            114,
            97,
            109,
            101,
            58,
            32,
            116,
            104,
            105,
            115,
            46,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            70,
            114,
            97,
            109,
            101,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            115,
            116,
            111,
            112,
            34,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            70,
            114,
            97,
            109,
            101,
            40,
            102,
            114,
            97,
            109,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            102,
            114,
            97,
            109,
            101,
            32,
            60,
            32,
            48,
            32,
            124,
            124,
            32,
            102,
            114,
            97,
            109,
            101,
            32,
            62,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            116,
            111,
            116,
            97,
            108,
            70,
            114,
            97,
            109,
            101,
            115,
            40,
            41,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            111,
            107,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            115,
            101,
            101,
            107,
            40,
            102,
            114,
            97,
            109,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            111,
            107,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            102,
            114,
            97,
            109,
            101,
            34,
            44,
            32,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            70,
            114,
            97,
            109,
            101,
            58,
            32,
            116,
            104,
            105,
            115,
            46,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            70,
            114,
            97,
            109,
            101,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            83,
            112,
            101,
            101,
            100,
            40,
            115,
            112,
            101,
            101,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            115,
            101,
            116,
            67,
            111,
            110,
            102,
            105,
            103,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            80,
            114,
            111,
            112,
            115,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            115,
            40,
            123,
            125,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            41,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            112,
            101,
            101,
            100,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            66,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            40,
            99,
            111,
            108,
            111,
            114,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            73,
            83,
            95,
            66,
            82,
            79,
            87,
            83,
            69,
            82,
            32,
            38,
            38,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            111,
            102,
            32,
            72,
            84,
            77,
            76,
            67,
            97,
            110,
            118,
            97,
            115,
            69,
            108,
            101,
            109,
            101,
            110,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            115,
            116,
            121,
            108,
            101,
            46,
            98,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            32,
            61,
            32,
            99,
            111,
            108,
            111,
            114,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            115,
            101,
            116,
            67,
            111,
            110,
            102,
            105,
            103,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            80,
            114,
            111,
            112,
            115,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            115,
            40,
            123,
            125,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            41,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            58,
            32,
            104,
            101,
            120,
            83,
            116,
            114,
            105,
            110,
            103,
            84,
            111,
            82,
            71,
            66,
            65,
            73,
            110,
            116,
            40,
            99,
            111,
            108,
            111,
            114,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            98,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            32,
            61,
            32,
            99,
            111,
            108,
            111,
            114,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            76,
            111,
            111,
            112,
            40,
            108,
            111,
            111,
            112,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            115,
            101,
            116,
            67,
            111,
            110,
            102,
            105,
            103,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            80,
            114,
            111,
            112,
            115,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            115,
            40,
            123,
            125,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            41,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            111,
            111,
            112,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            58,
            32,
            108,
            111,
            111,
            112,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            85,
            115,
            101,
            70,
            114,
            97,
            109,
            101,
            73,
            110,
            116,
            101,
            114,
            112,
            111,
            108,
            97,
            116,
            105,
            111,
            110,
            40,
            117,
            115,
            101,
            70,
            114,
            97,
            109,
            101,
            73,
            110,
            116,
            101,
            114,
            112,
            111,
            108,
            97,
            116,
            105,
            111,
            110,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            115,
            101,
            116,
            67,
            111,
            110,
            102,
            105,
            103,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            80,
            114,
            111,
            112,
            115,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            115,
            40,
            123,
            125,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            41,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            117,
            115,
            101,
            70,
            114,
            97,
            109,
            101,
            73,
            110,
            116,
            101,
            114,
            112,
            111,
            108,
            97,
            116,
            105,
            111,
            110,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            97,
            100,
            100,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            116,
            121,
            112,
            101,
            44,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            97,
            100,
            100,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            116,
            121,
            112,
            101,
            44,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            109,
            111,
            118,
            101,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            116,
            121,
            112,
            101,
            44,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            114,
            101,
            109,
            111,
            118,
            101,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            116,
            121,
            112,
            101,
            44,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            100,
            101,
            115,
            116,
            114,
            111,
            121,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            73,
            83,
            95,
            66,
            82,
            79,
            87,
            83,
            69,
            82,
            32,
            38,
            38,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            111,
            102,
            32,
            72,
            84,
            77,
            76,
            67,
            97,
            110,
            118,
            97,
            115,
            69,
            108,
            101,
            109,
            101,
            110,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            46,
            117,
            110,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            67,
            97,
            110,
            118,
            97,
            115,
            82,
            101,
            115,
            105,
            122,
            101,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            46,
            117,
            110,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            100,
            101,
            108,
            101,
            116,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            32,
            110,
            117,
            108,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            111,
            110,
            116,
            101,
            120,
            116,
            32,
            61,
            32,
            110,
            117,
            108,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            100,
            101,
            115,
            116,
            114,
            111,
            121,
            34,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            114,
            101,
            109,
            111,
            118,
            101,
            65,
            108,
            108,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            108,
            101,
            97,
            110,
            117,
            112,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            102,
            114,
            101,
            101,
            122,
            101,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            73,
            100,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            102,
            114,
            97,
            109,
            101,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            99,
            97,
            110,
            99,
            101,
            108,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            73,
            100,
            32,
            61,
            32,
            110,
            117,
            108,
            108,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            105,
            115,
            70,
            114,
            111,
            122,
            101,
            110,
            32,
            61,
            32,
            116,
            114,
            117,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            102,
            114,
            101,
            101,
            122,
            101,
            34,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            117,
            110,
            102,
            114,
            101,
            101,
            122,
            101,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            73,
            100,
            32,
            33,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            73,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            102,
            114,
            97,
            109,
            101,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            114,
            97,
            119,
            46,
            98,
            105,
            110,
            100,
            40,
            116,
            104,
            105,
            115,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            105,
            115,
            70,
            114,
            111,
            122,
            101,
            110,
            32,
            61,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            117,
            110,
            102,
            114,
            101,
            101,
            122,
            101,
            34,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            105,
            122,
            101,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            124,
            124,
            32,
            33,
            116,
            104,
            105,
            115,
            46,
            105,
            115,
            76,
            111,
            97,
            100,
            101,
            100,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            73,
            83,
            95,
            66,
            82,
            79,
            87,
            83,
            69,
            82,
            32,
            38,
            38,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            111,
            102,
            32,
            72,
            84,
            77,
            76,
            67,
            97,
            110,
            118,
            97,
            115,
            69,
            108,
            101,
            109,
            101,
            110,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            100,
            112,
            114,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            46,
            100,
            101,
            118,
            105,
            99,
            101,
            80,
            105,
            120,
            101,
            108,
            82,
            97,
            116,
            105,
            111,
            32,
            124,
            124,
            32,
            119,
            105,
            110,
            100,
            111,
            119,
            46,
            100,
            101,
            118,
            105,
            99,
            101,
            80,
            105,
            120,
            101,
            108,
            82,
            97,
            116,
            105,
            111,
            32,
            124,
            124,
            32,
            49,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            123,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            58,
            32,
            99,
            108,
            105,
            101,
            110,
            116,
            72,
            101,
            105,
            103,
            104,
            116,
            44,
            32,
            119,
            105,
            100,
            116,
            104,
            58,
            32,
            99,
            108,
            105,
            101,
            110,
            116,
            87,
            105,
            100,
            116,
            104,
            32,
            125,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            103,
            101,
            116,
            66,
            111,
            117,
            110,
            100,
            105,
            110,
            103,
            67,
            108,
            105,
            101,
            110,
            116,
            82,
            101,
            99,
            116,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            99,
            108,
            105,
            101,
            110,
            116,
            72,
            101,
            105,
            103,
            104,
            116,
            32,
            33,
            61,
            61,
            32,
            48,
            32,
            38,
            38,
            32,
            99,
            108,
            105,
            101,
            110,
            116,
            87,
            105,
            100,
            116,
            104,
            32,
            33,
            61,
            61,
            32,
            48,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            119,
            105,
            100,
            116,
            104,
            32,
            61,
            32,
            99,
            108,
            105,
            101,
            110,
            116,
            87,
            105,
            100,
            116,
            104,
            32,
            42,
            32,
            100,
            112,
            114,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            104,
            101,
            105,
            103,
            104,
            116,
            32,
            61,
            32,
            99,
            108,
            105,
            101,
            110,
            116,
            72,
            101,
            105,
            103,
            104,
            116,
            32,
            42,
            32,
            100,
            112,
            114,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            111,
            107,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            114,
            101,
            115,
            105,
            122,
            101,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            119,
            105,
            100,
            116,
            104,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            104,
            101,
            105,
            103,
            104,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            111,
            107,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            83,
            101,
            103,
            109,
            101,
            110,
            116,
            40,
            115,
            116,
            97,
            114,
            116,
            70,
            114,
            97,
            109,
            101,
            44,
            32,
            101,
            110,
            100,
            70,
            114,
            97,
            109,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            124,
            124,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            115,
            101,
            116,
            67,
            111,
            110,
            102,
            105,
            103,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            80,
            114,
            111,
            112,
            115,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            115,
            40,
            123,
            125,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            41,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            58,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            67,
            111,
            114,
            101,
            83,
            101,
            103,
            109,
            101,
            110,
            116,
            40,
            91,
            115,
            116,
            97,
            114,
            116,
            70,
            114,
            97,
            109,
            101,
            44,
            32,
            101,
            110,
            100,
            70,
            114,
            97,
            109,
            101,
            93,
            44,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            77,
            111,
            100,
            101,
            40,
            109,
            111,
            100,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            124,
            124,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            115,
            101,
            116,
            67,
            111,
            110,
            102,
            105,
            103,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            80,
            114,
            111,
            112,
            115,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            115,
            40,
            123,
            125,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            41,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            111,
            100,
            101,
            58,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            67,
            111,
            114,
            101,
            77,
            111,
            100,
            101,
            40,
            109,
            111,
            100,
            101,
            44,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            82,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            95,
            97,
            32,
            61,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            44,
            32,
            123,
            32,
            100,
            101,
            118,
            105,
            99,
            101,
            80,
            105,
            120,
            101,
            108,
            82,
            97,
            116,
            105,
            111,
            44,
            32,
            102,
            114,
            101,
            101,
            122,
            101,
            79,
            110,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            32,
            125,
            32,
            61,
            32,
            95,
            97,
            44,
            32,
            114,
            101,
            115,
            116,
            67,
            111,
            110,
            102,
            105,
            103,
            32,
            61,
            32,
            95,
            95,
            111,
            98,
            106,
            82,
            101,
            115,
            116,
            40,
            95,
            97,
            44,
            32,
            91,
            34,
            100,
            101,
            118,
            105,
            99,
            101,
            80,
            105,
            120,
            101,
            108,
            82,
            97,
            116,
            105,
            111,
            34,
            44,
            32,
            34,
            102,
            114,
            101,
            101,
            122,
            101,
            79,
            110,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            34,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            32,
            61,
            32,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            80,
            114,
            111,
            112,
            115,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            115,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            115,
            40,
            123,
            125,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            41,
            44,
            32,
            114,
            101,
            115,
            116,
            67,
            111,
            110,
            102,
            105,
            103,
            41,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            47,
            47,
            32,
            100,
            101,
            118,
            105,
            99,
            101,
            80,
            105,
            120,
            101,
            108,
            82,
            97,
            116,
            105,
            111,
            32,
            105,
            115,
            32,
            97,
            32,
            115,
            112,
            101,
            99,
            105,
            97,
            108,
            32,
            99,
            97,
            115,
            101,
            44,
            32,
            105,
            116,
            32,
            115,
            104,
            111,
            117,
            108,
            100,
            32,
            98,
            101,
            32,
            115,
            101,
            116,
            32,
            116,
            111,
            32,
            116,
            104,
            101,
            32,
            100,
            101,
            102,
            97,
            117,
            108,
            116,
            32,
            118,
            97,
            108,
            117,
            101,
            32,
            105,
            102,
            32,
            105,
            116,
            39,
            115,
            32,
            110,
            111,
            116,
            32,
            112,
            114,
            111,
            118,
            105,
            100,
            101,
            100,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            101,
            118,
            105,
            99,
            101,
            80,
            105,
            120,
            101,
            108,
            82,
            97,
            116,
            105,
            111,
            58,
            32,
            100,
            101,
            118,
            105,
            99,
            101,
            80,
            105,
            120,
            101,
            108,
            82,
            97,
            116,
            105,
            111,
            32,
            124,
            124,
            32,
            103,
            101,
            116,
            68,
            101,
            102,
            97,
            117,
            108,
            116,
            68,
            80,
            82,
            40,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            114,
            101,
            101,
            122,
            101,
            79,
            110,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            58,
            32,
            102,
            114,
            101,
            101,
            122,
            101,
            79,
            110,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            102,
            114,
            101,
            101,
            122,
            101,
            79,
            110,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            32,
            58,
            32,
            116,
            114,
            117,
            101,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            73,
            83,
            95,
            66,
            82,
            79,
            87,
            83,
            69,
            82,
            32,
            38,
            38,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            111,
            102,
            32,
            72,
            84,
            77,
            76,
            67,
            97,
            110,
            118,
            97,
            115,
            69,
            108,
            101,
            109,
            101,
            110,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            46,
            97,
            117,
            116,
            111,
            82,
            101,
            115,
            105,
            122,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            67,
            97,
            110,
            118,
            97,
            115,
            82,
            101,
            115,
            105,
            122,
            101,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            46,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            44,
            32,
            116,
            104,
            105,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            67,
            97,
            110,
            118,
            97,
            115,
            82,
            101,
            115,
            105,
            122,
            101,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            46,
            117,
            110,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            46,
            102,
            114,
            101,
            101,
            122,
            101,
            79,
            110,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            46,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            44,
            32,
            116,
            104,
            105,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            79,
            102,
            102,
            115,
            99,
            114,
            101,
            101,
            110,
            79,
            98,
            115,
            101,
            114,
            118,
            101,
            114,
            46,
            117,
            110,
            111,
            98,
            115,
            101,
            114,
            118,
            101,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            105,
            115,
            70,
            114,
            111,
            122,
            101,
            110,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            117,
            110,
            102,
            114,
            101,
            101,
            122,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            108,
            111,
            97,
            100,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            40,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            73,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            124,
            124,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            97,
            99,
            116,
            105,
            118,
            101,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            73,
            100,
            40,
            41,
            32,
            61,
            61,
            61,
            32,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            73,
            100,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            108,
            111,
            97,
            100,
            101,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            108,
            111,
            97,
            100,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            40,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            73,
            100,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            119,
            105,
            100,
            116,
            104,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            104,
            101,
            105,
            103,
            104,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            108,
            111,
            97,
            100,
            101,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            108,
            111,
            97,
            100,
            34,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            114,
            101,
            115,
            105,
            122,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            101,
            118,
            101,
            110,
            116,
            77,
            97,
            110,
            97,
            103,
            101,
            114,
            46,
            100,
            105,
            115,
            112,
            97,
            116,
            99,
            104,
            40,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            121,
            112,
            101,
            58,
            32,
            34,
            108,
            111,
            97,
            100,
            69,
            114,
            114,
            111,
            114,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            114,
            114,
            111,
            114,
            58,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            70,
            97,
            105,
            108,
            101,
            100,
            32,
            116,
            111,
            32,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            32,
            58,
            36,
            123,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            73,
            100,
            125,
            96,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            77,
            97,
            114,
            107,
            101,
            114,
            40,
            109,
            97,
            114,
            107,
            101,
            114,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            115,
            101,
            116,
            67,
            111,
            110,
            102,
            105,
            103,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            80,
            114,
            111,
            112,
            115,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            115,
            40,
            123,
            125,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            41,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            97,
            114,
            107,
            101,
            114,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            109,
            97,
            114,
            107,
            101,
            114,
            115,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            109,
            97,
            114,
            107,
            101,
            114,
            115,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            109,
            97,
            114,
            107,
            101,
            114,
            115,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            109,
            97,
            114,
            107,
            101,
            114,
            115,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            32,
            61,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            108,
            101,
            116,
            32,
            105,
            32,
            61,
            32,
            48,
            59,
            32,
            105,
            32,
            60,
            32,
            109,
            97,
            114,
            107,
            101,
            114,
            115,
            46,
            115,
            105,
            122,
            101,
            40,
            41,
            59,
            32,
            105,
            32,
            43,
            61,
            32,
            49,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            109,
            97,
            114,
            107,
            101,
            114,
            32,
            61,
            32,
            109,
            97,
            114,
            107,
            101,
            114,
            115,
            46,
            103,
            101,
            116,
            40,
            105,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            46,
            112,
            117,
            115,
            104,
            40,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            110,
            97,
            109,
            101,
            58,
            32,
            109,
            97,
            114,
            107,
            101,
            114,
            46,
            110,
            97,
            109,
            101,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            105,
            109,
            101,
            58,
            32,
            109,
            97,
            114,
            107,
            101,
            114,
            46,
            116,
            105,
            109,
            101,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            117,
            114,
            97,
            116,
            105,
            111,
            110,
            58,
            32,
            109,
            97,
            114,
            107,
            101,
            114,
            46,
            100,
            117,
            114,
            97,
            116,
            105,
            111,
            110,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            84,
            104,
            101,
            109,
            101,
            40,
            116,
            104,
            101,
            109,
            101,
            73,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            108,
            111,
            97,
            100,
            101,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            115,
            101,
            116,
            84,
            104,
            101,
            109,
            101,
            40,
            116,
            104,
            101,
            109,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            108,
            111,
            97,
            100,
            101,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            101,
            116,
            84,
            104,
            101,
            109,
            101,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            114,
            101,
            115,
            101,
            116,
            84,
            104,
            101,
            109,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            84,
            104,
            101,
            109,
            101,
            68,
            97,
            116,
            97,
            40,
            116,
            104,
            101,
            109,
            101,
            68,
            97,
            116,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            108,
            111,
            97,
            100,
            101,
            100,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            115,
            101,
            116,
            84,
            104,
            101,
            109,
            101,
            68,
            97,
            116,
            97,
            40,
            116,
            104,
            101,
            109,
            101,
            68,
            97,
            116,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            108,
            111,
            97,
            100,
            101,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            83,
            108,
            111,
            116,
            115,
            40,
            115,
            108,
            111,
            116,
            115,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            115,
            101,
            116,
            83,
            108,
            111,
            116,
            115,
            40,
            115,
            108,
            111,
            116,
            115,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            76,
            97,
            121,
            111,
            117,
            116,
            40,
            108,
            97,
            121,
            111,
            117,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            124,
            124,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            115,
            101,
            116,
            67,
            111,
            110,
            102,
            105,
            103,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            80,
            114,
            111,
            112,
            115,
            40,
            95,
            95,
            115,
            112,
            114,
            101,
            97,
            100,
            86,
            97,
            108,
            117,
            101,
            115,
            40,
            123,
            125,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            40,
            41,
            41,
            44,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            97,
            121,
            111,
            117,
            116,
            58,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            108,
            105,
            103,
            110,
            58,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            67,
            111,
            114,
            101,
            65,
            108,
            105,
            103,
            110,
            40,
            108,
            97,
            121,
            111,
            117,
            116,
            46,
            97,
            108,
            105,
            103,
            110,
            44,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            105,
            116,
            58,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            67,
            111,
            114,
            101,
            70,
            105,
            116,
            40,
            108,
            97,
            121,
            111,
            117,
            116,
            46,
            102,
            105,
            116,
            44,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            86,
            105,
            101,
            119,
            112,
            111,
            114,
            116,
            40,
            120,
            44,
            32,
            121,
            44,
            32,
            119,
            105,
            100,
            116,
            104,
            44,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            61,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            115,
            101,
            116,
            86,
            105,
            101,
            119,
            112,
            111,
            114,
            116,
            40,
            120,
            44,
            32,
            121,
            44,
            32,
            119,
            105,
            100,
            116,
            104,
            44,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            97,
            116,
            105,
            99,
            32,
            115,
            101,
            116,
            87,
            97,
            115,
            109,
            85,
            114,
            108,
            40,
            117,
            114,
            108,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            87,
            97,
            115,
            109,
            76,
            111,
            97,
            100,
            101,
            114,
            46,
            115,
            101,
            116,
            87,
            97,
            115,
            109,
            85,
            114,
            108,
            40,
            117,
            114,
            108,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            108,
            111,
            97,
            100,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            40,
            115,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            73,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            108,
            111,
            97,
            100,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            40,
            115,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            73,
            100,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            97,
            114,
            116,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            115,
            116,
            97,
            114,
            116,
            101,
            100,
            32,
            61,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            115,
            116,
            97,
            114,
            116,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            40,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            115,
            116,
            97,
            114,
            116,
            101,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            115,
            101,
            116,
            117,
            112,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            115,
            116,
            97,
            114,
            116,
            101,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            111,
            112,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            115,
            116,
            111,
            112,
            112,
            101,
            100,
            32,
            61,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            115,
            116,
            111,
            112,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            40,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            115,
            116,
            111,
            112,
            112,
            101,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            108,
            101,
            97,
            110,
            117,
            112,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            115,
            116,
            111,
            112,
            112,
            101,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            95,
            103,
            101,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            80,
            111,
            115,
            105,
            116,
            105,
            111,
            110,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            99,
            116,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            103,
            101,
            116,
            66,
            111,
            117,
            110,
            100,
            105,
            110,
            103,
            67,
            108,
            105,
            101,
            110,
            116,
            82,
            101,
            99,
            116,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            115,
            99,
            97,
            108,
            101,
            88,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            119,
            105,
            100,
            116,
            104,
            32,
            47,
            32,
            114,
            101,
            99,
            116,
            46,
            119,
            105,
            100,
            116,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            115,
            99,
            97,
            108,
            101,
            89,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            104,
            101,
            105,
            103,
            104,
            116,
            32,
            47,
            32,
            114,
            101,
            99,
            116,
            46,
            104,
            101,
            105,
            103,
            104,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            100,
            101,
            118,
            105,
            99,
            101,
            80,
            105,
            120,
            101,
            108,
            82,
            97,
            116,
            105,
            111,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            46,
            100,
            101,
            118,
            105,
            99,
            101,
            80,
            105,
            120,
            101,
            108,
            82,
            97,
            116,
            105,
            111,
            32,
            124,
            124,
            32,
            119,
            105,
            110,
            100,
            111,
            119,
            46,
            100,
            101,
            118,
            105,
            99,
            101,
            80,
            105,
            120,
            101,
            108,
            82,
            97,
            116,
            105,
            111,
            32,
            124,
            124,
            32,
            49,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            120,
            32,
            61,
            32,
            40,
            101,
            118,
            101,
            110,
            116,
            46,
            99,
            108,
            105,
            101,
            110,
            116,
            88,
            32,
            45,
            32,
            114,
            101,
            99,
            116,
            46,
            108,
            101,
            102,
            116,
            41,
            32,
            42,
            32,
            115,
            99,
            97,
            108,
            101,
            88,
            32,
            47,
            32,
            100,
            101,
            118,
            105,
            99,
            101,
            80,
            105,
            120,
            101,
            108,
            82,
            97,
            116,
            105,
            111,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            121,
            32,
            61,
            32,
            40,
            101,
            118,
            101,
            110,
            116,
            46,
            99,
            108,
            105,
            101,
            110,
            116,
            89,
            32,
            45,
            32,
            114,
            101,
            99,
            116,
            46,
            116,
            111,
            112,
            41,
            32,
            42,
            32,
            115,
            99,
            97,
            108,
            101,
            89,
            32,
            47,
            32,
            100,
            101,
            118,
            105,
            99,
            101,
            80,
            105,
            120,
            101,
            108,
            82,
            97,
            116,
            105,
            111,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            120,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            121,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            95,
            111,
            110,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            85,
            112,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            123,
            32,
            120,
            44,
            32,
            121,
            32,
            125,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            103,
            101,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            80,
            111,
            115,
            105,
            116,
            105,
            111,
            110,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            85,
            112,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            95,
            111,
            110,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            68,
            111,
            119,
            110,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            123,
            32,
            120,
            44,
            32,
            121,
            32,
            125,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            103,
            101,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            80,
            111,
            115,
            105,
            116,
            105,
            111,
            110,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            68,
            111,
            119,
            110,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            95,
            111,
            110,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            77,
            111,
            118,
            101,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            123,
            32,
            120,
            44,
            32,
            121,
            32,
            125,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            103,
            101,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            80,
            111,
            115,
            105,
            116,
            105,
            111,
            110,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            77,
            111,
            118,
            101,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            95,
            111,
            110,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            110,
            116,
            101,
            114,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            123,
            32,
            120,
            44,
            32,
            121,
            32,
            125,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            103,
            101,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            80,
            111,
            115,
            105,
            116,
            105,
            111,
            110,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            110,
            116,
            101,
            114,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            95,
            111,
            110,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            76,
            101,
            97,
            118,
            101,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            123,
            32,
            120,
            44,
            32,
            121,
            32,
            125,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            103,
            101,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            80,
            111,
            115,
            105,
            116,
            105,
            111,
            110,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            120,
            105,
            116,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            85,
            112,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            85,
            112,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            68,
            111,
            119,
            110,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            68,
            111,
            119,
            110,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            77,
            111,
            118,
            101,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            77,
            111,
            118,
            101,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            110,
            116,
            101,
            114,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            110,
            116,
            101,
            114,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            120,
            105,
            116,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            120,
            105,
            116,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            86,
            101,
            99,
            116,
            111,
            114,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            46,
            115,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            70,
            114,
            97,
            109,
            101,
            119,
            111,
            114,
            107,
            83,
            101,
            116,
            117,
            112,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            32,
            61,
            32,
            91,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            102,
            111,
            114,
            32,
            40,
            108,
            101,
            116,
            32,
            105,
            32,
            61,
            32,
            48,
            59,
            32,
            105,
            32,
            60,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            86,
            101,
            99,
            116,
            111,
            114,
            46,
            115,
            105,
            122,
            101,
            40,
            41,
            59,
            32,
            105,
            32,
            43,
            61,
            32,
            49,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            46,
            112,
            117,
            115,
            104,
            40,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            86,
            101,
            99,
            116,
            111,
            114,
            46,
            103,
            101,
            116,
            40,
            105,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            95,
            115,
            101,
            116,
            117,
            112,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            73,
            83,
            95,
            66,
            82,
            79,
            87,
            83,
            69,
            82,
            32,
            38,
            38,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            111,
            102,
            32,
            72,
            84,
            77,
            76,
            67,
            97,
            110,
            118,
            97,
            115,
            69,
            108,
            101,
            109,
            101,
            110,
            116,
            32,
            38,
            38,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            32,
            33,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            38,
            38,
            32,
            116,
            104,
            105,
            115,
            46,
            105,
            115,
            76,
            111,
            97,
            100,
            101,
            100,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            103,
            101,
            116,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            46,
            105,
            110,
            99,
            108,
            117,
            100,
            101,
            115,
            40,
            34,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            85,
            112,
            34,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            97,
            100,
            100,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            34,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            117,
            112,
            34,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            85,
            112,
            77,
            101,
            116,
            104,
            111,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            46,
            105,
            110,
            99,
            108,
            117,
            100,
            101,
            115,
            40,
            34,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            68,
            111,
            119,
            110,
            34,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            97,
            100,
            100,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            34,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            100,
            111,
            119,
            110,
            34,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            68,
            111,
            119,
            110,
            77,
            101,
            116,
            104,
            111,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            46,
            105,
            110,
            99,
            108,
            117,
            100,
            101,
            115,
            40,
            34,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            77,
            111,
            118,
            101,
            34,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            97,
            100,
            100,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            34,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            109,
            111,
            118,
            101,
            34,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            77,
            111,
            118,
            101,
            77,
            101,
            116,
            104,
            111,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            46,
            105,
            110,
            99,
            108,
            117,
            100,
            101,
            115,
            40,
            34,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            110,
            116,
            101,
            114,
            34,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            97,
            100,
            100,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            34,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            101,
            110,
            116,
            101,
            114,
            34,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            110,
            116,
            101,
            114,
            77,
            101,
            116,
            104,
            111,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            108,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            46,
            105,
            110,
            99,
            108,
            117,
            100,
            101,
            115,
            40,
            34,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            120,
            105,
            116,
            34,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            97,
            100,
            100,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            34,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            108,
            101,
            97,
            118,
            101,
            34,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            120,
            105,
            116,
            77,
            101,
            116,
            104,
            111,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            95,
            99,
            108,
            101,
            97,
            110,
            117,
            112,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            73,
            83,
            95,
            66,
            82,
            79,
            87,
            83,
            69,
            82,
            32,
            38,
            38,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            111,
            102,
            32,
            72,
            84,
            77,
            76,
            67,
            97,
            110,
            118,
            97,
            115,
            69,
            108,
            101,
            109,
            101,
            110,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            114,
            101,
            109,
            111,
            118,
            101,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            34,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            117,
            112,
            34,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            85,
            112,
            77,
            101,
            116,
            104,
            111,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            114,
            101,
            109,
            111,
            118,
            101,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            34,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            100,
            111,
            119,
            110,
            34,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            68,
            111,
            119,
            110,
            77,
            101,
            116,
            104,
            111,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            114,
            101,
            109,
            111,
            118,
            101,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            34,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            109,
            111,
            118,
            101,
            34,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            77,
            111,
            118,
            101,
            77,
            101,
            116,
            104,
            111,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            114,
            101,
            109,
            111,
            118,
            101,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            34,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            101,
            110,
            116,
            101,
            114,
            34,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            110,
            116,
            101,
            114,
            77,
            101,
            116,
            104,
            111,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            114,
            101,
            109,
            111,
            118,
            101,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            34,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            108,
            101,
            97,
            118,
            101,
            34,
            44,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            112,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            120,
            105,
            116,
            77,
            101,
            116,
            104,
            111,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            108,
            111,
            97,
            100,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            68,
            97,
            116,
            97,
            40,
            115,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            68,
            97,
            116,
            97,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            108,
            111,
            97,
            100,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            68,
            97,
            116,
            97,
            40,
            115,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            68,
            97,
            116,
            97,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            83,
            105,
            122,
            101,
            40,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            44,
            32,
            95,
            99,
            44,
            32,
            95,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            119,
            105,
            100,
            116,
            104,
            32,
            61,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            83,
            105,
            122,
            101,
            40,
            41,
            46,
            103,
            101,
            116,
            40,
            48,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            32,
            61,
            32,
            40,
            95,
            100,
            32,
            61,
            32,
            40,
            95,
            99,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            99,
            46,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            83,
            105,
            122,
            101,
            40,
            41,
            46,
            103,
            101,
            116,
            40,
            49,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            100,
            32,
            58,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            119,
            105,
            100,
            116,
            104,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            66,
            111,
            111,
            108,
            101,
            97,
            110,
            67,
            111,
            110,
            116,
            101,
            120,
            116,
            40,
            110,
            97,
            109,
            101,
            44,
            32,
            118,
            97,
            108,
            117,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            115,
            101,
            116,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            66,
            111,
            111,
            108,
            101,
            97,
            110,
            67,
            111,
            110,
            116,
            101,
            120,
            116,
            40,
            110,
            97,
            109,
            101,
            44,
            32,
            118,
            97,
            108,
            117,
            101,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            78,
            117,
            109,
            101,
            114,
            105,
            99,
            67,
            111,
            110,
            116,
            101,
            120,
            116,
            40,
            110,
            97,
            109,
            101,
            44,
            32,
            118,
            97,
            108,
            117,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            115,
            101,
            116,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            78,
            117,
            109,
            101,
            114,
            105,
            99,
            67,
            111,
            110,
            116,
            101,
            120,
            116,
            40,
            110,
            97,
            109,
            101,
            44,
            32,
            118,
            97,
            108,
            117,
            101,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            83,
            116,
            114,
            105,
            110,
            103,
            67,
            111,
            110,
            116,
            101,
            120,
            116,
            40,
            110,
            97,
            109,
            101,
            44,
            32,
            118,
            97,
            108,
            117,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            115,
            101,
            116,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            83,
            116,
            114,
            105,
            110,
            103,
            67,
            111,
            110,
            116,
            101,
            120,
            116,
            40,
            110,
            97,
            109,
            101,
            44,
            32,
            118,
            97,
            108,
            117,
            101,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            102,
            97,
            108,
            115,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            47,
            42,
            42,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            71,
            101,
            116,
            32,
            116,
            104,
            101,
            32,
            98,
            111,
            117,
            110,
            100,
            115,
            32,
            111,
            102,
            32,
            97,
            32,
            108,
            97,
            121,
            101,
            114,
            32,
            98,
            121,
            32,
            105,
            116,
            115,
            32,
            110,
            97,
            109,
            101,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            64,
            112,
            97,
            114,
            97,
            109,
            32,
            108,
            97,
            121,
            101,
            114,
            78,
            97,
            109,
            101,
            32,
            45,
            32,
            84,
            104,
            101,
            32,
            110,
            97,
            109,
            101,
            32,
            111,
            102,
            32,
            116,
            104,
            101,
            32,
            108,
            97,
            121,
            101,
            114,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            64,
            114,
            101,
            116,
            117,
            114,
            110,
            115,
            32,
            84,
            104,
            101,
            32,
            98,
            111,
            117,
            110,
            100,
            115,
            32,
            111,
            102,
            32,
            116,
            104,
            101,
            32,
            108,
            97,
            121,
            101,
            114,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            64,
            101,
            120,
            97,
            109,
            112,
            108,
            101,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            96,
            96,
            96,
            116,
            121,
            112,
            101,
            115,
            99,
            114,
            105,
            112,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            47,
            47,
            32,
            68,
            114,
            97,
            119,
            32,
            97,
            32,
            114,
            101,
            99,
            116,
            97,
            110,
            103,
            108,
            101,
            32,
            97,
            114,
            111,
            117,
            110,
            100,
            32,
            116,
            104,
            101,
            32,
            108,
            97,
            121,
            101,
            114,
            32,
            39,
            76,
            97,
            121,
            101,
            114,
            32,
            49,
            39,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            97,
            100,
            100,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            39,
            114,
            101,
            110,
            100,
            101,
            114,
            39,
            44,
            32,
            40,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            98,
            111,
            117,
            110,
            100,
            105,
            110,
            103,
            66,
            111,
            120,
            32,
            61,
            32,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            103,
            101,
            116,
            76,
            97,
            121,
            101,
            114,
            66,
            111,
            117,
            110,
            100,
            105,
            110,
            103,
            66,
            111,
            120,
            40,
            39,
            76,
            97,
            121,
            101,
            114,
            32,
            49,
            39,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            98,
            111,
            117,
            110,
            100,
            105,
            110,
            103,
            66,
            111,
            120,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            123,
            32,
            120,
            44,
            32,
            121,
            44,
            32,
            119,
            105,
            100,
            116,
            104,
            44,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            32,
            125,
            32,
            61,
            32,
            98,
            111,
            117,
            110,
            100,
            105,
            110,
            103,
            66,
            111,
            120,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            116,
            101,
            120,
            116,
            46,
            115,
            116,
            114,
            111,
            107,
            101,
            82,
            101,
            99,
            116,
            40,
            120,
            44,
            32,
            121,
            44,
            32,
            119,
            105,
            100,
            116,
            104,
            44,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            32,
            96,
            96,
            96,
            10,
            32,
            32,
            32,
            32,
            32,
            42,
            47,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            76,
            97,
            121,
            101,
            114,
            66,
            111,
            117,
            110,
            100,
            105,
            110,
            103,
            66,
            111,
            120,
            40,
            108,
            97,
            121,
            101,
            114,
            78,
            97,
            109,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            98,
            111,
            117,
            110,
            100,
            115,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            116,
            104,
            105,
            115,
            46,
            95,
            100,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            67,
            111,
            114,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            103,
            101,
            116,
            76,
            97,
            121,
            101,
            114,
            66,
            111,
            117,
            110,
            100,
            115,
            40,
            108,
            97,
            121,
            101,
            114,
            78,
            97,
            109,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            98,
            111,
            117,
            110,
            100,
            115,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            98,
            111,
            117,
            110,
            100,
            115,
            46,
            115,
            105,
            122,
            101,
            40,
            41,
            32,
            33,
            61,
            61,
            32,
            52,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            120,
            32,
            61,
            32,
            98,
            111,
            117,
            110,
            100,
            115,
            46,
            103,
            101,
            116,
            40,
            48,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            121,
            32,
            61,
            32,
            98,
            111,
            117,
            110,
            100,
            115,
            46,
            103,
            101,
            116,
            40,
            49,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            119,
            105,
            100,
            116,
            104,
            32,
            61,
            32,
            98,
            111,
            117,
            110,
            100,
            115,
            46,
            103,
            101,
            116,
            40,
            50,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            32,
            61,
            32,
            98,
            111,
            117,
            110,
            100,
            115,
            46,
            103,
            101,
            116,
            40,
            51,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            120,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            121,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            119,
            105,
            100,
            116,
            104,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            97,
            116,
            105,
            99,
            32,
            116,
            114,
            97,
            110,
            115,
            102,
            111,
            114,
            109,
            84,
            104,
            101,
            109,
            101,
            84,
            111,
            76,
            111,
            116,
            116,
            105,
            101,
            83,
            108,
            111,
            116,
            115,
            40,
            116,
            104,
            101,
            109,
            101,
            44,
            32,
            115,
            108,
            111,
            116,
            115,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            118,
            97,
            114,
            32,
            95,
            97,
            44,
            32,
            95,
            98,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            40,
            95,
            98,
            32,
            61,
            32,
            40,
            95,
            97,
            32,
            61,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            41,
            32,
            61,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            118,
            111,
            105,
            100,
            32,
            48,
            32,
            58,
            32,
            95,
            97,
            46,
            116,
            114,
            97,
            110,
            115,
            102,
            111,
            114,
            109,
            84,
            104,
            101,
            109,
            101,
            84,
            111,
            76,
            111,
            116,
            116,
            105,
            101,
            83,
            108,
            111,
            116,
            115,
            40,
            116,
            104,
            101,
            109,
            101,
            44,
            32,
            115,
            108,
            111,
            116,
            115,
            41,
            41,
            32,
            33,
            61,
            32,
            110,
            117,
            108,
            108,
            32,
            63,
            32,
            95,
            98,
            32,
            58,
            32,
            34,
            34,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            95,
            95,
            112,
            117,
            98,
            108,
            105,
            99,
            70,
            105,
            101,
            108,
            100,
            40,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            44,
            32,
            34,
            95,
            119,
            97,
            115,
            109,
            77,
            111,
            100,
            117,
            108,
            101,
            34,
            44,
            32,
            110,
            117,
            108,
            108,
            41,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            32,
            61,
            32,
            95,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            59,
            10,
            10,
            32,
            32,
            47,
            47,
            32,
            115,
            114,
            99,
            47,
            119,
            111,
            114,
            107,
            101,
            114,
            47,
            100,
            111,
            116,
            108,
            111,
            116,
            116,
            105,
            101,
            46,
            119,
            111,
            114,
            107,
            101,
            114,
            46,
            116,
            115,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            32,
            61,
            32,
            47,
            42,
            32,
            64,
            95,
            95,
            80,
            85,
            82,
            69,
            95,
            95,
            32,
            42,
            47,
            32,
            110,
            101,
            119,
            32,
            77,
            97,
            112,
            40,
            41,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            101,
            118,
            101,
            110,
            116,
            72,
            97,
            110,
            100,
            108,
            101,
            114,
            77,
            97,
            112,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            97,
            100,
            121,
            58,
            32,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            32,
            61,
            62,
            32,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            100,
            58,
            32,
            34,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            101,
            116,
            104,
            111,
            100,
            58,
            32,
            34,
            111,
            110,
            82,
            101,
            97,
            100,
            121,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            58,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            118,
            101,
            110,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            108,
            102,
            46,
            112,
            111,
            115,
            116,
            77,
            101,
            115,
            115,
            97,
            103,
            101,
            40,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            99,
            111,
            109,
            112,
            108,
            101,
            116,
            101,
            58,
            32,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            32,
            61,
            62,
            32,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            100,
            58,
            32,
            34,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            101,
            116,
            104,
            111,
            100,
            58,
            32,
            34,
            111,
            110,
            67,
            111,
            109,
            112,
            108,
            101,
            116,
            101,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            58,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            118,
            101,
            110,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            108,
            102,
            46,
            112,
            111,
            115,
            116,
            77,
            101,
            115,
            115,
            97,
            103,
            101,
            40,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            108,
            111,
            97,
            100,
            58,
            32,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            32,
            61,
            62,
            32,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            108,
            111,
            97,
            100,
            69,
            118,
            101,
            110,
            116,
            32,
            61,
            32,
            101,
            118,
            101,
            110,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            100,
            58,
            32,
            34,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            101,
            116,
            104,
            111,
            100,
            58,
            32,
            34,
            111,
            110,
            76,
            111,
            97,
            100,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            58,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            118,
            101,
            110,
            116,
            58,
            32,
            108,
            111,
            97,
            100,
            69,
            118,
            101,
            110,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            108,
            102,
            46,
            112,
            111,
            115,
            116,
            77,
            101,
            115,
            115,
            97,
            103,
            101,
            40,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            108,
            111,
            97,
            100,
            69,
            114,
            114,
            111,
            114,
            58,
            32,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            32,
            61,
            62,
            32,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            108,
            111,
            97,
            100,
            69,
            114,
            114,
            111,
            114,
            69,
            118,
            101,
            110,
            116,
            32,
            61,
            32,
            101,
            118,
            101,
            110,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            100,
            58,
            32,
            34,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            101,
            116,
            104,
            111,
            100,
            58,
            32,
            34,
            111,
            110,
            76,
            111,
            97,
            100,
            69,
            114,
            114,
            111,
            114,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            58,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            118,
            101,
            110,
            116,
            58,
            32,
            108,
            111,
            97,
            100,
            69,
            114,
            114,
            111,
            114,
            69,
            118,
            101,
            110,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            108,
            102,
            46,
            112,
            111,
            115,
            116,
            77,
            101,
            115,
            115,
            97,
            103,
            101,
            40,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            108,
            111,
            111,
            112,
            58,
            32,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            32,
            61,
            62,
            32,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            108,
            111,
            111,
            112,
            69,
            118,
            101,
            110,
            116,
            32,
            61,
            32,
            101,
            118,
            101,
            110,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            100,
            58,
            32,
            34,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            101,
            116,
            104,
            111,
            100,
            58,
            32,
            34,
            111,
            110,
            76,
            111,
            111,
            112,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            58,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            118,
            101,
            110,
            116,
            58,
            32,
            108,
            111,
            111,
            112,
            69,
            118,
            101,
            110,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            108,
            102,
            46,
            112,
            111,
            115,
            116,
            77,
            101,
            115,
            115,
            97,
            103,
            101,
            40,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            112,
            108,
            97,
            121,
            58,
            32,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            32,
            61,
            62,
            32,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            112,
            108,
            97,
            121,
            69,
            118,
            101,
            110,
            116,
            32,
            61,
            32,
            101,
            118,
            101,
            110,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            100,
            58,
            32,
            34,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            101,
            116,
            104,
            111,
            100,
            58,
            32,
            34,
            111,
            110,
            80,
            108,
            97,
            121,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            58,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            118,
            101,
            110,
            116,
            58,
            32,
            112,
            108,
            97,
            121,
            69,
            118,
            101,
            110,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            108,
            102,
            46,
            112,
            111,
            115,
            116,
            77,
            101,
            115,
            115,
            97,
            103,
            101,
            40,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            112,
            97,
            117,
            115,
            101,
            58,
            32,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            32,
            61,
            62,
            32,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            112,
            97,
            117,
            115,
            101,
            69,
            118,
            101,
            110,
            116,
            32,
            61,
            32,
            101,
            118,
            101,
            110,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            100,
            58,
            32,
            34,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            101,
            116,
            104,
            111,
            100,
            58,
            32,
            34,
            111,
            110,
            80,
            97,
            117,
            115,
            101,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            58,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            118,
            101,
            110,
            116,
            58,
            32,
            112,
            97,
            117,
            115,
            101,
            69,
            118,
            101,
            110,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            108,
            102,
            46,
            112,
            111,
            115,
            116,
            77,
            101,
            115,
            115,
            97,
            103,
            101,
            40,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            111,
            112,
            58,
            32,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            32,
            61,
            62,
            32,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            115,
            116,
            111,
            112,
            69,
            118,
            101,
            110,
            116,
            32,
            61,
            32,
            101,
            118,
            101,
            110,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            100,
            58,
            32,
            34,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            101,
            116,
            104,
            111,
            100,
            58,
            32,
            34,
            111,
            110,
            83,
            116,
            111,
            112,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            58,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            118,
            101,
            110,
            116,
            58,
            32,
            115,
            116,
            111,
            112,
            69,
            118,
            101,
            110,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            108,
            102,
            46,
            112,
            111,
            115,
            116,
            77,
            101,
            115,
            115,
            97,
            103,
            101,
            40,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            102,
            114,
            97,
            109,
            101,
            58,
            32,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            32,
            61,
            62,
            32,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            102,
            114,
            97,
            109,
            101,
            69,
            118,
            101,
            110,
            116,
            32,
            61,
            32,
            101,
            118,
            101,
            110,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            100,
            58,
            32,
            34,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            101,
            116,
            104,
            111,
            100,
            58,
            32,
            34,
            111,
            110,
            70,
            114,
            97,
            109,
            101,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            58,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            118,
            101,
            110,
            116,
            58,
            32,
            102,
            114,
            97,
            109,
            101,
            69,
            118,
            101,
            110,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            108,
            102,
            46,
            112,
            111,
            115,
            116,
            77,
            101,
            115,
            115,
            97,
            103,
            101,
            40,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            110,
            100,
            101,
            114,
            58,
            32,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            32,
            61,
            62,
            32,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            110,
            100,
            101,
            114,
            69,
            118,
            101,
            110,
            116,
            32,
            61,
            32,
            101,
            118,
            101,
            110,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            100,
            58,
            32,
            34,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            101,
            116,
            104,
            111,
            100,
            58,
            32,
            34,
            111,
            110,
            82,
            101,
            110,
            100,
            101,
            114,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            58,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            118,
            101,
            110,
            116,
            58,
            32,
            114,
            101,
            110,
            100,
            101,
            114,
            69,
            118,
            101,
            110,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            108,
            102,
            46,
            112,
            111,
            115,
            116,
            77,
            101,
            115,
            115,
            97,
            103,
            101,
            40,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            102,
            114,
            101,
            101,
            122,
            101,
            58,
            32,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            32,
            61,
            62,
            32,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            102,
            114,
            101,
            101,
            122,
            101,
            69,
            118,
            101,
            110,
            116,
            32,
            61,
            32,
            101,
            118,
            101,
            110,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            100,
            58,
            32,
            34,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            101,
            116,
            104,
            111,
            100,
            58,
            32,
            34,
            111,
            110,
            70,
            114,
            101,
            101,
            122,
            101,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            58,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            118,
            101,
            110,
            116,
            58,
            32,
            102,
            114,
            101,
            101,
            122,
            101,
            69,
            118,
            101,
            110,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            108,
            102,
            46,
            112,
            111,
            115,
            116,
            77,
            101,
            115,
            115,
            97,
            103,
            101,
            40,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            117,
            110,
            102,
            114,
            101,
            101,
            122,
            101,
            58,
            32,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            32,
            61,
            62,
            32,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            117,
            110,
            102,
            114,
            101,
            101,
            122,
            101,
            69,
            118,
            101,
            110,
            116,
            32,
            61,
            32,
            101,
            118,
            101,
            110,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            100,
            58,
            32,
            34,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            101,
            116,
            104,
            111,
            100,
            58,
            32,
            34,
            111,
            110,
            85,
            110,
            102,
            114,
            101,
            101,
            122,
            101,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            58,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            118,
            101,
            110,
            116,
            58,
            32,
            117,
            110,
            102,
            114,
            101,
            101,
            122,
            101,
            69,
            118,
            101,
            110,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            108,
            102,
            46,
            112,
            111,
            115,
            116,
            77,
            101,
            115,
            115,
            97,
            103,
            101,
            40,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            100,
            101,
            115,
            116,
            114,
            111,
            121,
            58,
            32,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            32,
            61,
            62,
            32,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            100,
            101,
            115,
            116,
            114,
            111,
            121,
            69,
            118,
            101,
            110,
            116,
            32,
            61,
            32,
            101,
            118,
            101,
            110,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            100,
            58,
            32,
            34,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            101,
            116,
            104,
            111,
            100,
            58,
            32,
            34,
            111,
            110,
            68,
            101,
            115,
            116,
            114,
            111,
            121,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            58,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            118,
            101,
            110,
            116,
            58,
            32,
            100,
            101,
            115,
            116,
            114,
            111,
            121,
            69,
            118,
            101,
            110,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            108,
            102,
            46,
            112,
            111,
            115,
            116,
            77,
            101,
            115,
            115,
            97,
            103,
            101,
            40,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            99,
            111,
            109,
            109,
            97,
            110,
            100,
            115,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            83,
            116,
            97,
            116,
            101,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            115,
            116,
            97,
            116,
            101,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            115,
            76,
            111,
            97,
            100,
            101,
            100,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            105,
            115,
            76,
            111,
            97,
            100,
            101,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            115,
            80,
            97,
            117,
            115,
            101,
            100,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            105,
            115,
            80,
            97,
            117,
            115,
            101,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            115,
            80,
            108,
            97,
            121,
            105,
            110,
            103,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            105,
            115,
            80,
            108,
            97,
            121,
            105,
            110,
            103,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            115,
            83,
            116,
            111,
            112,
            112,
            101,
            100,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            105,
            115,
            83,
            116,
            111,
            112,
            112,
            101,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            115,
            70,
            114,
            111,
            122,
            101,
            110,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            105,
            115,
            70,
            114,
            111,
            122,
            101,
            110,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            111,
            111,
            112,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            108,
            111,
            111,
            112,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            111,
            100,
            101,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            109,
            111,
            100,
            101,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            112,
            101,
            101,
            100,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            112,
            101,
            101,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            70,
            114,
            97,
            109,
            101,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            99,
            117,
            114,
            114,
            101,
            110,
            116,
            70,
            114,
            97,
            109,
            101,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            111,
            116,
            97,
            108,
            70,
            114,
            97,
            109,
            101,
            115,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            116,
            111,
            116,
            97,
            108,
            70,
            114,
            97,
            109,
            101,
            115,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            100,
            117,
            114,
            97,
            116,
            105,
            111,
            110,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            100,
            117,
            114,
            97,
            116,
            105,
            111,
            110,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            117,
            115,
            101,
            70,
            114,
            97,
            109,
            101,
            73,
            110,
            116,
            101,
            114,
            112,
            111,
            108,
            97,
            116,
            105,
            111,
            110,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            117,
            115,
            101,
            70,
            114,
            97,
            109,
            101,
            73,
            110,
            116,
            101,
            114,
            112,
            111,
            108,
            97,
            116,
            105,
            111,
            110,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            97,
            114,
            107,
            101,
            114,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            109,
            97,
            114,
            107,
            101,
            114,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            98,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            98,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            97,
            114,
            107,
            101,
            114,
            115,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            109,
            97,
            114,
            107,
            101,
            114,
            115,
            40,
            41,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            99,
            116,
            105,
            118,
            101,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            73,
            100,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            97,
            99,
            116,
            105,
            118,
            101,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            73,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            99,
            116,
            105,
            118,
            101,
            84,
            104,
            101,
            109,
            101,
            73,
            100,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            97,
            99,
            116,
            105,
            118,
            101,
            84,
            104,
            101,
            109,
            101,
            73,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            97,
            117,
            116,
            111,
            112,
            108,
            97,
            121,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            97,
            117,
            116,
            111,
            112,
            108,
            97,
            121,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            108,
            97,
            121,
            111,
            117,
            116,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            108,
            97,
            121,
            111,
            117,
            116,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            68,
            117,
            114,
            97,
            116,
            105,
            111,
            110,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            68,
            117,
            114,
            97,
            116,
            105,
            111,
            110,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            115,
            82,
            101,
            97,
            100,
            121,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            105,
            115,
            82,
            101,
            97,
            100,
            121,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            97,
            110,
            105,
            102,
            101,
            115,
            116,
            58,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            109,
            97,
            110,
            105,
            102,
            101,
            115,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            116,
            97,
            116,
            101,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            76,
            97,
            121,
            111,
            117,
            116,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            108,
            97,
            121,
            111,
            117,
            116,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            108,
            97,
            121,
            111,
            117,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            101,
            116,
            76,
            97,
            121,
            111,
            117,
            116,
            40,
            108,
            97,
            121,
            111,
            117,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            117,
            99,
            99,
            101,
            115,
            115,
            58,
            32,
            116,
            114,
            117,
            101,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            103,
            101,
            116,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            103,
            101,
            116,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            115,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            68,
            111,
            119,
            110,
            69,
            118,
            101,
            110,
            116,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            120,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            120,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            121,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            121,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            68,
            111,
            119,
            110,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            110,
            116,
            101,
            114,
            69,
            118,
            101,
            110,
            116,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            120,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            120,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            121,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            121,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            110,
            116,
            101,
            114,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            120,
            105,
            116,
            69,
            118,
            101,
            110,
            116,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            120,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            120,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            121,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            121,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            69,
            120,
            105,
            116,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            77,
            111,
            118,
            101,
            69,
            118,
            101,
            110,
            116,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            120,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            120,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            121,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            121,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            77,
            111,
            118,
            101,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            85,
            112,
            69,
            118,
            101,
            110,
            116,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            120,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            120,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            121,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            121,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            112,
            111,
            115,
            116,
            80,
            111,
            105,
            110,
            116,
            101,
            114,
            85,
            112,
            69,
            118,
            101,
            110,
            116,
            40,
            120,
            44,
            32,
            121,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            97,
            114,
            116,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            116,
            97,
            114,
            116,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            111,
            112,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            116,
            111,
            112,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            108,
            111,
            97,
            100,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            115,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            115,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            108,
            111,
            97,
            100,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            40,
            115,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            108,
            111,
            97,
            100,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            68,
            97,
            116,
            97,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            115,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            68,
            97,
            116,
            97,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            115,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            68,
            97,
            116,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            108,
            111,
            97,
            100,
            83,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            68,
            97,
            116,
            97,
            40,
            115,
            116,
            97,
            116,
            101,
            77,
            97,
            99,
            104,
            105,
            110,
            101,
            68,
            97,
            116,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            99,
            114,
            101,
            97,
            116,
            101,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            119,
            105,
            100,
            116,
            104,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            119,
            105,
            100,
            116,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            104,
            101,
            105,
            103,
            104,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            104,
            97,
            115,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            97,
            108,
            114,
            101,
            97,
            100,
            121,
            32,
            101,
            120,
            105,
            115,
            116,
            115,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            110,
            101,
            119,
            32,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            104,
            101,
            105,
            103,
            104,
            116,
            32,
            61,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            119,
            105,
            100,
            116,
            104,
            32,
            61,
            32,
            119,
            105,
            100,
            116,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            115,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            44,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            101,
            118,
            101,
            110,
            116,
            115,
            32,
            61,
            32,
            91,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            99,
            111,
            109,
            112,
            108,
            101,
            116,
            101,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            102,
            114,
            97,
            109,
            101,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            108,
            111,
            97,
            100,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            108,
            111,
            97,
            100,
            69,
            114,
            114,
            111,
            114,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            108,
            111,
            111,
            112,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            112,
            97,
            117,
            115,
            101,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            112,
            108,
            97,
            121,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            115,
            116,
            111,
            112,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            100,
            101,
            115,
            116,
            114,
            111,
            121,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            102,
            114,
            101,
            101,
            122,
            101,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            117,
            110,
            102,
            114,
            101,
            101,
            122,
            101,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            114,
            101,
            110,
            100,
            101,
            114,
            34,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            34,
            114,
            101,
            97,
            100,
            121,
            34,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            93,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            118,
            101,
            110,
            116,
            115,
            46,
            102,
            111,
            114,
            69,
            97,
            99,
            104,
            40,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            97,
            100,
            100,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114,
            40,
            101,
            118,
            101,
            110,
            116,
            44,
            32,
            101,
            118,
            101,
            110,
            116,
            72,
            97,
            110,
            100,
            108,
            101,
            114,
            77,
            97,
            112,
            91,
            101,
            118,
            101,
            110,
            116,
            93,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            100,
            101,
            115,
            116,
            114,
            111,
            121,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            100,
            101,
            115,
            116,
            114,
            111,
            121,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            100,
            101,
            108,
            101,
            116,
            101,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            102,
            114,
            101,
            101,
            122,
            101,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            102,
            114,
            101,
            101,
            122,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            108,
            111,
            97,
            100,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            99,
            111,
            110,
            102,
            105,
            103,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            99,
            111,
            110,
            102,
            105,
            103,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            108,
            111,
            97,
            100,
            40,
            99,
            111,
            110,
            102,
            105,
            103,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            108,
            111,
            97,
            100,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            108,
            111,
            97,
            100,
            65,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            40,
            97,
            110,
            105,
            109,
            97,
            116,
            105,
            111,
            110,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            84,
            104,
            101,
            109,
            101,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            116,
            104,
            101,
            109,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            116,
            104,
            101,
            109,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            101,
            116,
            84,
            104,
            101,
            109,
            101,
            40,
            116,
            104,
            101,
            109,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            84,
            104,
            101,
            109,
            101,
            68,
            97,
            116,
            97,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            116,
            104,
            101,
            109,
            101,
            68,
            97,
            116,
            97,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            116,
            104,
            101,
            109,
            101,
            68,
            97,
            116,
            97,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            101,
            116,
            84,
            104,
            101,
            109,
            101,
            68,
            97,
            116,
            97,
            40,
            116,
            104,
            101,
            109,
            101,
            68,
            97,
            116,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            112,
            97,
            117,
            115,
            101,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            112,
            97,
            117,
            115,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            112,
            108,
            97,
            121,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            112,
            108,
            97,
            121,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            105,
            122,
            101,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            119,
            105,
            100,
            116,
            104,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            119,
            105,
            100,
            116,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            104,
            101,
            105,
            103,
            104,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            104,
            101,
            105,
            103,
            104,
            116,
            32,
            61,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            99,
            97,
            110,
            118,
            97,
            115,
            46,
            119,
            105,
            100,
            116,
            104,
            32,
            61,
            32,
            119,
            105,
            100,
            116,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            114,
            101,
            115,
            105,
            122,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            117,
            99,
            99,
            101,
            115,
            115,
            58,
            32,
            116,
            114,
            117,
            101,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            66,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            98,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            98,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            101,
            116,
            66,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            40,
            98,
            97,
            99,
            107,
            103,
            114,
            111,
            117,
            110,
            100,
            67,
            111,
            108,
            111,
            114,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            70,
            114,
            97,
            109,
            101,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            102,
            114,
            97,
            109,
            101,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            102,
            114,
            97,
            109,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            101,
            116,
            70,
            114,
            97,
            109,
            101,
            40,
            102,
            114,
            97,
            109,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            77,
            111,
            100,
            101,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            109,
            111,
            100,
            101,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            109,
            111,
            100,
            101,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            101,
            116,
            77,
            111,
            100,
            101,
            40,
            109,
            111,
            100,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            82,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            101,
            116,
            82,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            40,
            114,
            101,
            110,
            100,
            101,
            114,
            67,
            111,
            110,
            102,
            105,
            103,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            83,
            101,
            103,
            109,
            101,
            110,
            116,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            101,
            116,
            83,
            101,
            103,
            109,
            101,
            110,
            116,
            40,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            91,
            48,
            93,
            44,
            32,
            115,
            101,
            103,
            109,
            101,
            110,
            116,
            91,
            49,
            93,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            83,
            112,
            101,
            101,
            100,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            115,
            112,
            101,
            101,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            115,
            112,
            101,
            101,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            101,
            116,
            83,
            112,
            101,
            101,
            100,
            40,
            115,
            112,
            101,
            101,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            85,
            115,
            101,
            70,
            114,
            97,
            109,
            101,
            73,
            110,
            116,
            101,
            114,
            112,
            111,
            108,
            97,
            116,
            105,
            111,
            110,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            117,
            115,
            101,
            70,
            114,
            97,
            109,
            101,
            73,
            110,
            116,
            101,
            114,
            112,
            111,
            108,
            97,
            116,
            105,
            111,
            110,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            117,
            115,
            101,
            70,
            114,
            97,
            109,
            101,
            73,
            110,
            116,
            101,
            114,
            112,
            111,
            108,
            97,
            116,
            105,
            111,
            110,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            101,
            116,
            85,
            115,
            101,
            70,
            114,
            97,
            109,
            101,
            73,
            110,
            116,
            101,
            114,
            112,
            111,
            108,
            97,
            116,
            105,
            111,
            110,
            40,
            117,
            115,
            101,
            70,
            114,
            97,
            109,
            101,
            73,
            110,
            116,
            101,
            114,
            112,
            111,
            108,
            97,
            116,
            105,
            111,
            110,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            87,
            97,
            115,
            109,
            85,
            114,
            108,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            68,
            111,
            116,
            76,
            111,
            116,
            116,
            105,
            101,
            46,
            115,
            101,
            116,
            87,
            97,
            115,
            109,
            85,
            114,
            108,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            117,
            114,
            108,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            116,
            111,
            112,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            116,
            111,
            112,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            117,
            110,
            102,
            114,
            101,
            101,
            122,
            101,
            58,
            32,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            117,
            110,
            102,
            114,
            101,
            101,
            122,
            101,
            40,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            86,
            105,
            101,
            119,
            112,
            111,
            114,
            116,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            120,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            120,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            121,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            121,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            119,
            105,
            100,
            116,
            104,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            119,
            105,
            100,
            116,
            104,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            104,
            101,
            105,
            103,
            104,
            116,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            101,
            116,
            86,
            105,
            101,
            119,
            112,
            111,
            114,
            116,
            40,
            120,
            44,
            32,
            121,
            44,
            32,
            119,
            105,
            100,
            116,
            104,
            44,
            32,
            104,
            101,
            105,
            103,
            104,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            77,
            97,
            114,
            107,
            101,
            114,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            109,
            97,
            114,
            107,
            101,
            114,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            109,
            97,
            114,
            107,
            101,
            114,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            101,
            116,
            77,
            97,
            114,
            107,
            101,
            114,
            40,
            109,
            97,
            114,
            107,
            101,
            114,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            117,
            99,
            99,
            101,
            115,
            115,
            58,
            32,
            116,
            114,
            117,
            101,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            44,
            10,
            32,
            32,
            32,
            32,
            115,
            101,
            116,
            76,
            111,
            111,
            112,
            40,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            108,
            111,
            111,
            112,
            32,
            61,
            32,
            114,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            112,
            97,
            114,
            97,
            109,
            115,
            46,
            108,
            111,
            111,
            112,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            61,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            115,
            77,
            97,
            112,
            46,
            103,
            101,
            116,
            40,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            33,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            73,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            32,
            119,
            105,
            116,
            104,
            32,
            105,
            100,
            32,
            36,
            123,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            73,
            100,
            125,
            32,
            100,
            111,
            101,
            115,
            32,
            110,
            111,
            116,
            32,
            101,
            120,
            105,
            115,
            116,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            110,
            115,
            116,
            97,
            110,
            99,
            101,
            46,
            115,
            101,
            116,
            76,
            111,
            111,
            112,
            40,
            108,
            111,
            111,
            112,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            117,
            99,
            99,
            101,
            115,
            115,
            58,
            32,
            116,
            114,
            117,
            101,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            32,
            101,
            120,
            101,
            99,
            117,
            116,
            101,
            67,
            111,
            109,
            109,
            97,
            110,
            100,
            40,
            114,
            112,
            99,
            82,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            109,
            101,
            116,
            104,
            111,
            100,
            32,
            61,
            32,
            114,
            112,
            99,
            82,
            101,
            113,
            117,
            101,
            115,
            116,
            46,
            109,
            101,
            116,
            104,
            111,
            100,
            59,
            10,
            32,
            32,
            32,
            32,
            105,
            102,
            32,
            40,
            116,
            121,
            112,
            101,
            111,
            102,
            32,
            99,
            111,
            109,
            109,
            97,
            110,
            100,
            115,
            91,
            109,
            101,
            116,
            104,
            111,
            100,
            93,
            32,
            61,
            61,
            61,
            32,
            34,
            102,
            117,
            110,
            99,
            116,
            105,
            111,
            110,
            34,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            116,
            117,
            114,
            110,
            32,
            99,
            111,
            109,
            109,
            97,
            110,
            100,
            115,
            91,
            109,
            101,
            116,
            104,
            111,
            100,
            93,
            40,
            114,
            112,
            99,
            82,
            101,
            113,
            117,
            101,
            115,
            116,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            32,
            101,
            108,
            115,
            101,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            116,
            104,
            114,
            111,
            119,
            32,
            110,
            101,
            119,
            32,
            69,
            114,
            114,
            111,
            114,
            40,
            96,
            77,
            101,
            116,
            104,
            111,
            100,
            32,
            36,
            123,
            109,
            101,
            116,
            104,
            111,
            100,
            125,
            32,
            105,
            115,
            32,
            110,
            111,
            116,
            32,
            105,
            109,
            112,
            108,
            101,
            109,
            101,
            110,
            116,
            101,
            100,
            32,
            105,
            110,
            32,
            99,
            111,
            109,
            109,
            97,
            110,
            100,
            115,
            46,
            96,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            125,
            10,
            32,
            32,
            115,
            101,
            108,
            102,
            46,
            111,
            110,
            109,
            101,
            115,
            115,
            97,
            103,
            101,
            32,
            61,
            32,
            40,
            101,
            118,
            101,
            110,
            116,
            41,
            32,
            61,
            62,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            116,
            114,
            121,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            32,
            61,
            32,
            101,
            120,
            101,
            99,
            117,
            116,
            101,
            67,
            111,
            109,
            109,
            97,
            110,
            100,
            40,
            101,
            118,
            101,
            110,
            116,
            46,
            100,
            97,
            116,
            97,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            100,
            58,
            32,
            101,
            118,
            101,
            110,
            116,
            46,
            100,
            97,
            116,
            97,
            46,
            105,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            101,
            116,
            104,
            111,
            100,
            58,
            32,
            101,
            118,
            101,
            110,
            116,
            46,
            100,
            97,
            116,
            97,
            46,
            109,
            101,
            116,
            104,
            111,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            114,
            101,
            115,
            117,
            108,
            116,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            108,
            102,
            46,
            112,
            111,
            115,
            116,
            77,
            101,
            115,
            115,
            97,
            103,
            101,
            40,
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            32,
            99,
            97,
            116,
            99,
            104,
            32,
            40,
            101,
            114,
            114,
            111,
            114,
            41,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            99,
            111,
            110,
            115,
            116,
            32,
            101,
            114,
            114,
            111,
            114,
            82,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            32,
            61,
            32,
            123,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            105,
            100,
            58,
            32,
            101,
            118,
            101,
            110,
            116,
            46,
            100,
            97,
            116,
            97,
            46,
            105,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            109,
            101,
            116,
            104,
            111,
            100,
            58,
            32,
            101,
            118,
            101,
            110,
            116,
            46,
            100,
            97,
            116,
            97,
            46,
            109,
            101,
            116,
            104,
            111,
            100,
            44,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            32,
            101,
            114,
            114,
            111,
            114,
            58,
            32,
            101,
            114,
            114,
            111,
            114,
            46,
            109,
            101,
            115,
            115,
            97,
            103,
            101,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            32,
            32,
            32,
            32,
            115,
            101,
            108,
            102,
            46,
            112,
            111,
            115,
            116,
            77,
            101,
            115,
            115,
            97,
            103,
            101,
            40,
            101,
            114,
            114,
            111,
            114,
            82,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            41,
            59,
            10,
            32,
            32,
            32,
            32,
            125,
            10,
            32,
            32,
            125,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            117,
            109,
            109,
            121,
            32,
            61,
            32,
            34,
            34,
            59,
            10,
            32,
            32,
            118,
            97,
            114,
            32,
            100,
            111,
            116,
            108,
            111,
            116,
            116,
            105,
            101,
            95,
            119,
            111,
            114,
            107,
            101,
            114,
            95,
            100,
            101,
            102,
            97,
            117,
            108,
            116,
            32,
            61,
            32,
            100,
            117,
            109,
            109,
            121,
            59,
            10,
            125,
            41,
            40,
            41,
            59,
            10
        ])
    ], {
        type: "application/javascript"
    }), i = URL.createObjectURL(n), s = new Worker(i);
    return URL.revokeObjectURL(i), s;
}, $2bb54e1a7d9957b8$var$s3 = $2bb54e1a7d9957b8$var$y2;
var $2bb54e1a7d9957b8$var$$1 = /*#__PURE__*/ function() {
    "use strict";
    function $1() {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, $1);
        $2bb54e1a7d9957b8$var$_(this, "_workers", new Map);
        $2bb54e1a7d9957b8$var$_(this, "_animationWorkerMap", new Map);
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)($1, [
        {
            key: "getWorker",
            value: function getWorker(n) {
                return this._workers.has(n) || this._workers.set(n, new $2bb54e1a7d9957b8$var$s3), this._workers.get(n);
            }
        },
        {
            key: "assignAnimationToWorker",
            value: function assignAnimationToWorker(n, i) {
                this._animationWorkerMap.set(n, i);
            }
        },
        {
            key: "unassignAnimationFromWorker",
            value: function unassignAnimationFromWorker(n) {
                this._animationWorkerMap.delete(n);
            }
        },
        {
            key: "sendMessage",
            value: function sendMessage(n, i, s) {
                this.getWorker(n).postMessage(i, s || []);
            }
        },
        {
            key: "terminateWorker",
            value: function terminateWorker(n) {
                var i = this._workers.get(n);
                i && (i.terminate(), this._workers.delete(n));
            }
        }
    ]);
    return $1;
}();
function $2bb54e1a7d9957b8$var$d3(c, n) {
    if (c instanceof HTMLCanvasElement) {
        var _c_getBoundingClientRect = c.getBoundingClientRect(), i = _c_getBoundingClientRect.height, s = _c_getBoundingClientRect.width;
        if (i !== 0 && s !== 0) return {
            width: s * n,
            height: i * n
        };
    }
    return {
        width: c.width,
        height: c.height
    };
}
function $2bb54e1a7d9957b8$var$u3() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}
var $2bb54e1a7d9957b8$var$q = /*#__PURE__*/ function() {
    "use strict";
    function q(n) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, q);
        $2bb54e1a7d9957b8$var$_(this, "_eventManager", new $2bb54e1a7d9957b8$var$d1);
        $2bb54e1a7d9957b8$var$_(this, "_id");
        $2bb54e1a7d9957b8$var$_(this, "_worker");
        $2bb54e1a7d9957b8$var$_(this, "_canvas");
        $2bb54e1a7d9957b8$var$_(this, "_dotLottieInstanceState", {
            markers: [],
            autoplay: !1,
            backgroundColor: "",
            currentFrame: 0,
            duration: 0,
            loop: !1,
            mode: "forward",
            segment: [
                0,
                0
            ],
            segmentDuration: 0,
            speed: 1,
            totalFrames: 0,
            isLoaded: !1,
            isPlaying: !1,
            isPaused: !1,
            isStopped: !0,
            isFrozen: !1,
            useFrameInterpolation: !1,
            renderConfig: {
                devicePixelRatio: $2bb54e1a7d9957b8$var$X()
            },
            activeAnimationId: "",
            activeThemeId: "",
            layout: void 0,
            marker: void 0,
            isReady: !1,
            manifest: null
        });
        $2bb54e1a7d9957b8$var$_(this, "_created", !1);
        $2bb54e1a7d9957b8$var$_(this, "_pointerUpMethod");
        $2bb54e1a7d9957b8$var$_(this, "_pointerDownMethod");
        $2bb54e1a7d9957b8$var$_(this, "_pointerMoveMethod");
        $2bb54e1a7d9957b8$var$_(this, "_pointerEnterMethod");
        $2bb54e1a7d9957b8$var$_(this, "_pointerExitMethod");
        var s, d, f;
        this._canvas = n.canvas, this._id = "dotlottie-".concat($2bb54e1a7d9957b8$var$u3());
        var i = n.workerId || "defaultWorker";
        this._worker = q._workerManager.getWorker(i), q._workerManager.assignAnimationToWorker(this._id, i), q._wasmUrl && this._sendMessage("setWasmUrl", {
            url: q._wasmUrl
        }), this._create($2bb54e1a7d9957b8$var$D($2bb54e1a7d9957b8$var$x({}, n), {
            renderConfig: $2bb54e1a7d9957b8$var$D($2bb54e1a7d9957b8$var$x({}, n.renderConfig), {
                devicePixelRatio: ((s = n.renderConfig) == null ? void 0 : s.devicePixelRatio) || $2bb54e1a7d9957b8$var$X(),
                freezeOnOffscreen: (f = (d = n.renderConfig) == null ? void 0 : d.freezeOnOffscreen) != null ? f : !0
            })
        })), this._worker.addEventListener("message", this._handleWorkerEvent.bind(this)), this._pointerUpMethod = this._onPointerUp.bind(this), this._pointerDownMethod = this._onPointerDown.bind(this), this._pointerMoveMethod = this._onPointerMove.bind(this), this._pointerEnterMethod = this._onPointerEnter.bind(this), this._pointerExitMethod = this._onPointerLeave.bind(this);
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(q, [
        {
            key: "_handleWorkerEvent",
            value: function _handleWorkerEvent(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var i, _tmp, _tmp1, _tmp2, _tmp3, _tmp4, _tmp5, _tmp6, _tmp7, _tmp8, _tmp9;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                i = n.data;
                                _tmp = i.id;
                                if (_tmp) return [
                                    3,
                                    19
                                ];
                                _tmp1 = i.method === "onLoad" && i.result.instanceId === this._id;
                                if (!_tmp1) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 1:
                                _tmp1 = (_state.sent(), this._eventManager.dispatch(i.result.event), $2bb54e1a7d9957b8$var$F && this._canvas instanceof HTMLCanvasElement && (this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && $2bb54e1a7d9957b8$var$W.observe(this._canvas, this), this._dotLottieInstanceState.renderConfig.autoResize && $2bb54e1a7d9957b8$var$$.observe(this._canvas, this)));
                                _state.label = 2;
                            case 2:
                                _tmp1;
                                _tmp2 = i.method === "onComplete" && i.result.instanceId === this._id;
                                if (!_tmp2) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 3:
                                _tmp2 = (_state.sent(), this._eventManager.dispatch(i.result.event));
                                _state.label = 4;
                            case 4:
                                _tmp2, i.method === "onDestroy" && i.result.instanceId === this._id && this._eventManager.dispatch(i.result.event);
                                _tmp3 = i.method === "onUnfreeze" && i.result.instanceId === this._id;
                                if (!_tmp3) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 5:
                                _tmp3 = (_state.sent(), this._dotLottieInstanceState.isFrozen = !1, this._eventManager.dispatch(i.result.event));
                                _state.label = 6;
                            case 6:
                                _tmp3, i.method === "onFrame" && i.result.instanceId === this._id && (this._dotLottieInstanceState.currentFrame = i.result.event.currentFrame, this._eventManager.dispatch(i.result.event)), i.method === "onRender" && i.result.instanceId === this._id && this._eventManager.dispatch(i.result.event);
                                _tmp4 = i.method === "onFreeze" && i.result.instanceId === this._id;
                                if (!_tmp4) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 7:
                                _tmp4 = (_state.sent(), this._eventManager.dispatch(i.result.event));
                                _state.label = 8;
                            case 8:
                                _tmp4;
                                _tmp5 = i.method === "onPause" && i.result.instanceId === this._id;
                                if (!_tmp5) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 9:
                                _tmp5 = (_state.sent(), this._eventManager.dispatch(i.result.event));
                                _state.label = 10;
                            case 10:
                                _tmp5;
                                _tmp6 = i.method === "onPlay" && i.result.instanceId === this._id;
                                if (!_tmp6) return [
                                    3,
                                    12
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 11:
                                _tmp6 = (_state.sent(), this._eventManager.dispatch(i.result.event));
                                _state.label = 12;
                            case 12:
                                _tmp6;
                                _tmp7 = i.method === "onStop" && i.result.instanceId === this._id;
                                if (!_tmp7) return [
                                    3,
                                    14
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 13:
                                _tmp7 = (_state.sent(), this._eventManager.dispatch(i.result.event));
                                _state.label = 14;
                            case 14:
                                _tmp7;
                                _tmp8 = i.method === "onLoadError" && i.result.instanceId === this._id;
                                if (!_tmp8) return [
                                    3,
                                    16
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 15:
                                _tmp8 = (_state.sent(), this._eventManager.dispatch(i.result.event));
                                _state.label = 16;
                            case 16:
                                _tmp8;
                                _tmp9 = i.method === "onReady" && i.result.instanceId === this._id;
                                if (!_tmp9) return [
                                    3,
                                    18
                                ];
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 17:
                                _tmp9 = (_state.sent(), this._eventManager.dispatch(i.result.event));
                                _state.label = 18;
                            case 18:
                                _tmp = _tmp9;
                                _state.label = 19;
                            case 19:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_create",
            value: function _create(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var d, i, _ref, s;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this._canvas instanceof HTMLCanvasElement ? i = this._canvas.transferControlToOffscreen() : i = this._canvas;
                                return [
                                    4,
                                    this._sendMessage("create", $2bb54e1a7d9957b8$var$x({
                                        instanceId: this._id,
                                        config: $2bb54e1a7d9957b8$var$D($2bb54e1a7d9957b8$var$x({}, n), {
                                            canvas: i
                                        })
                                    }, $2bb54e1a7d9957b8$var$d3(this._canvas, ((d = n.renderConfig) == null ? void 0 : d.devicePixelRatio) || $2bb54e1a7d9957b8$var$X())), [
                                        i
                                    ])
                                ];
                            case 1:
                                _ref = _state.sent(), s = _ref.instanceId;
                                if (s !== this._id) throw new Error("Instance ID mismatch");
                                this._created = !0;
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "isLoaded",
            get: function get() {
                return this._dotLottieInstanceState.isLoaded;
            }
        },
        {
            key: "isPlaying",
            get: function get() {
                return this._dotLottieInstanceState.isPlaying;
            }
        },
        {
            key: "isPaused",
            get: function get() {
                return this._dotLottieInstanceState.isPaused;
            }
        },
        {
            key: "isStopped",
            get: function get() {
                return this._dotLottieInstanceState.isStopped;
            }
        },
        {
            key: "currentFrame",
            get: function get() {
                return this._dotLottieInstanceState.currentFrame;
            }
        },
        {
            key: "isFrozen",
            get: function get() {
                return this._dotLottieInstanceState.isFrozen;
            }
        },
        {
            key: "segmentDuration",
            get: function get() {
                return this._dotLottieInstanceState.segmentDuration;
            }
        },
        {
            key: "totalFrames",
            get: function get() {
                return this._dotLottieInstanceState.totalFrames;
            }
        },
        {
            key: "segment",
            get: function get() {
                return this._dotLottieInstanceState.segment;
            }
        },
        {
            key: "speed",
            get: function get() {
                return this._dotLottieInstanceState.speed;
            }
        },
        {
            key: "duration",
            get: function get() {
                return this._dotLottieInstanceState.duration;
            }
        },
        {
            key: "isReady",
            get: function get() {
                return this._dotLottieInstanceState.isReady;
            }
        },
        {
            key: "mode",
            get: function get() {
                return this._dotLottieInstanceState.mode;
            }
        },
        {
            key: "canvas",
            get: function get() {
                return this._canvas;
            }
        },
        {
            key: "autoplay",
            get: function get() {
                return this._dotLottieInstanceState.autoplay;
            }
        },
        {
            key: "backgroundColor",
            get: function get() {
                return this._dotLottieInstanceState.backgroundColor;
            }
        },
        {
            key: "loop",
            get: function get() {
                return this._dotLottieInstanceState.loop;
            }
        },
        {
            key: "useFrameInterpolation",
            get: function get() {
                return this._dotLottieInstanceState.useFrameInterpolation;
            }
        },
        {
            key: "renderConfig",
            get: function get() {
                return this._dotLottieInstanceState.renderConfig;
            }
        },
        {
            key: "manifest",
            get: function get() {
                return this._dotLottieInstanceState.manifest;
            }
        },
        {
            key: "activeAnimationId",
            get: function get() {
                return this._dotLottieInstanceState.activeAnimationId;
            }
        },
        {
            key: "marker",
            get: function get() {
                return this._dotLottieInstanceState.marker;
            }
        },
        {
            key: "activeThemeId",
            get: function get() {
                return this._dotLottieInstanceState.activeThemeId;
            }
        },
        {
            key: "layout",
            get: function get() {
                return this._dotLottieInstanceState.layout;
            }
        },
        {
            key: "play",
            value: function play() {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _tmp, _tmp1;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    this._sendMessage("play", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _state.sent();
                                _tmp1 = $2bb54e1a7d9957b8$var$F && this._canvas instanceof HTMLCanvasElement && this._dotLottieInstanceState.renderConfig.freezeOnOffscreen && !$2bb54e1a7d9957b8$var$W1(this._canvas);
                                if (!_tmp1) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this.freeze()
                                ];
                            case 3:
                                _tmp1 = _state.sent();
                                _state.label = 4;
                            case 4:
                                _tmp = _tmp1;
                                _state.label = 5;
                            case 5:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "pause",
            value: function pause() {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _tmp;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("pause", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "stop",
            value: function stop() {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _tmp;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("stop", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "setSpeed",
            value: function setSpeed(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _tmp;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setSpeed", {
                                        instanceId: this._id,
                                        speed: n
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "setMode",
            value: function setMode(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _tmp;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setMode", {
                                        instanceId: this._id,
                                        mode: n
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "setFrame",
            value: function setFrame(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _tmp;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setFrame", {
                                        frame: n,
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "setSegment",
            value: function setSegment(n, i) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _tmp;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setSegment", {
                                        instanceId: this._id,
                                        segment: [
                                            n,
                                            i
                                        ]
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "setRenderConfig",
            value: function setRenderConfig(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var f, i, s, d, _tmp, _tmp1, _tmp2;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created) return [
                                    2
                                ];
                                f = n, i = f.devicePixelRatio, s = f.freezeOnOffscreen, d = $2bb54e1a7d9957b8$var$k1(f, [
                                    "devicePixelRatio",
                                    "freezeOnOffscreen"
                                ]);
                                return [
                                    4,
                                    this._sendMessage("setRenderConfig", {
                                        instanceId: this._id,
                                        renderConfig: $2bb54e1a7d9957b8$var$D($2bb54e1a7d9957b8$var$x($2bb54e1a7d9957b8$var$x({}, this._dotLottieInstanceState.renderConfig), d), {
                                            devicePixelRatio: i || $2bb54e1a7d9957b8$var$X(),
                                            freezeOnOffscreen: s != null ? s : !0
                                        })
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _state.sent();
                                _tmp = $2bb54e1a7d9957b8$var$F && this._canvas instanceof HTMLCanvasElement;
                                if (!_tmp) return [
                                    3,
                                    7
                                ];
                                this._dotLottieInstanceState.renderConfig.autoResize ? $2bb54e1a7d9957b8$var$$.observe(this._canvas, this) : $2bb54e1a7d9957b8$var$$.unobserve(this._canvas);
                                if (!this._dotLottieInstanceState.renderConfig.freezeOnOffscreen) return [
                                    3,
                                    3
                                ];
                                _tmp1 = $2bb54e1a7d9957b8$var$W.observe(this._canvas, this);
                                return [
                                    3,
                                    6
                                ];
                            case 3:
                                $2bb54e1a7d9957b8$var$W.unobserve(this._canvas);
                                _tmp2 = this._dotLottieInstanceState.isFrozen;
                                if (!_tmp2) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    this.unfreeze()
                                ];
                            case 4:
                                _tmp2 = _state.sent();
                                _state.label = 5;
                            case 5:
                                _tmp1 = _tmp2;
                                _state.label = 6;
                            case 6:
                                _tmp = _tmp1;
                                _state.label = 7;
                            case 7:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "setUseFrameInterpolation",
            value: function setUseFrameInterpolation(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _tmp;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setUseFrameInterpolation", {
                                        instanceId: this._id,
                                        useFrameInterpolation: n
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "setTheme",
            value: function setTheme(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var i;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created) return [
                                    2,
                                    !1
                                ];
                                i = this._sendMessage("setTheme", {
                                    instanceId: this._id,
                                    themeId: n
                                });
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 1:
                                return [
                                    2,
                                    (_state.sent(), i)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "load",
            value: function load(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _tmp;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("load", {
                                        config: n,
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "setLoop",
            value: function setLoop(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _tmp;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setLoop", {
                                        instanceId: this._id,
                                        loop: n
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "resize",
            value: function resize() {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _d3, n, i;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created) return [
                                    2
                                ];
                                _d3 = $2bb54e1a7d9957b8$var$d3(this._canvas, this._dotLottieInstanceState.renderConfig.devicePixelRatio || $2bb54e1a7d9957b8$var$X()), n = _d3.height, i = _d3.width;
                                return [
                                    4,
                                    this._sendMessage("resize", {
                                        height: n,
                                        instanceId: this._id,
                                        width: i
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _tmp;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                this._created = !1;
                                return [
                                    4,
                                    this._sendMessage("destroy", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _tmp = (_state.sent(), this._cleanupStateMachineListeners(), q._workerManager.unassignAnimationFromWorker(this._id), this._eventManager.removeAllEventListeners(), $2bb54e1a7d9957b8$var$F && this._canvas instanceof HTMLCanvasElement && ($2bb54e1a7d9957b8$var$W.unobserve(this._canvas), $2bb54e1a7d9957b8$var$$.unobserve(this._canvas)));
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "freeze",
            value: function freeze() {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _tmp;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("freeze", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "unfreeze",
            value: function unfreeze() {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _tmp;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("unfreeze", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "setBackgroundColor",
            value: function setBackgroundColor(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _tmp;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setBackgroundColor", {
                                        instanceId: this._id,
                                        backgroundColor: n
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "loadAnimation",
            value: function loadAnimation(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _tmp;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("loadAnimation", {
                                        animationId: n,
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "setLayout",
            value: function setLayout(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _tmp;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setLayout", {
                                        instanceId: this._id,
                                        layout: n
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_updateDotLottieInstanceState",
            value: function _updateDotLottieInstanceState() {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var n;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created) return [
                                    2
                                ];
                                return [
                                    4,
                                    this._sendMessage("getDotLottieInstanceState", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                n = _state.sent();
                                this._dotLottieInstanceState = n.state;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "markers",
            value: function markers() {
                return this._dotLottieInstanceState.markers;
            }
        },
        {
            key: "setMarker",
            value: function setMarker(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _tmp;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = this._created;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    this._sendMessage("setMarker", {
                                        instanceId: this._id,
                                        marker: n
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "setThemeData",
            value: function setThemeData(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var i;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created) return [
                                    2,
                                    !1
                                ];
                                return [
                                    4,
                                    this._sendMessage("setThemeData", {
                                        instanceId: this._id,
                                        themeData: n
                                    })
                                ];
                            case 1:
                                i = _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                return [
                                    2,
                                    (_state.sent(), i)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "setViewport",
            value: function setViewport(n, i, s, d) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("setViewport", {
                                x: n,
                                y: i,
                                width: s,
                                height: d,
                                instanceId: this._id
                            }) : !1
                        ];
                    });
                });
            }
        },
        {
            key: "_sendMessage",
            value: function _sendMessage(n, i, s) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var _this, d;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        _this = this;
                        d = {
                            id: "dotlottie-request-".concat($2bb54e1a7d9957b8$var$u3()),
                            method: n,
                            params: i
                        };
                        return [
                            2,
                            (this._worker.postMessage(d, s || []), new Promise(function(f, b) {
                                var M = function(E) {
                                    var A = E.data;
                                    A.id === d.id && (_this._worker.removeEventListener("message", M), A.error ? b(new Error("Failed to execute method ".concat(n, ": ").concat(A.error))) : f(A.result));
                                };
                                _this._worker.addEventListener("message", M);
                            }))
                        ];
                    });
                });
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(n, i) {
                this._eventManager.addEventListener(n, i);
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(n, i) {
                this._eventManager.removeEventListener(n, i);
            }
        },
        {
            key: "loadStateMachine",
            value: function loadStateMachine(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var i;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created) return [
                                    2,
                                    !1
                                ];
                                return [
                                    4,
                                    this._sendMessage("loadStateMachine", {
                                        instanceId: this._id,
                                        stateMachineId: n
                                    })
                                ];
                            case 1:
                                i = _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                return [
                                    2,
                                    (_state.sent(), i)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "loadStateMachineData",
            value: function loadStateMachineData(n) {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var i;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created) return [
                                    2,
                                    !1
                                ];
                                return [
                                    4,
                                    this._sendMessage("loadStateMachineData", {
                                        instanceId: this._id,
                                        stateMachineData: n
                                    })
                                ];
                            case 1:
                                i = _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                return [
                                    2,
                                    (_state.sent(), i)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "startStateMachine",
            value: function startStateMachine() {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var n;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this._created) return [
                                    2,
                                    !1
                                ];
                                this._setupStateMachineListeners();
                                return [
                                    4,
                                    this._sendMessage("startStateMachine", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                n = _state.sent();
                                return [
                                    4,
                                    this._updateDotLottieInstanceState()
                                ];
                            case 2:
                                return [
                                    2,
                                    (_state.sent(), n)
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "stopStateMachine",
            value: function stopStateMachine() {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        return [
                            2,
                            this._created ? (this._cleanupStateMachineListeners(), this._sendMessage("stopStateMachine", {
                                instanceId: this._id
                            })) : !1
                        ];
                    });
                });
            }
        },
        {
            key: "getStateMachineListeners",
            value: function getStateMachineListeners() {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        return [
                            2,
                            this._created ? this._sendMessage("getStateMachineListeners", {
                                instanceId: this._id
                            }) : []
                        ];
                    });
                });
            }
        },
        {
            key: "_getPointerPosition",
            value: function _getPointerPosition(n) {
                var i = this._canvas.getBoundingClientRect(), s = this._canvas.width / i.width, d = this._canvas.height / i.height, f = this._dotLottieInstanceState.renderConfig.devicePixelRatio || window.devicePixelRatio || 1, b = (n.clientX - i.left) * s / f, M = (n.clientY - i.top) * d / f;
                return {
                    x: b,
                    y: M
                };
            }
        },
        {
            key: "_onPointerUp",
            value: function _onPointerUp(n) {
                var _this__getPointerPosition = this._getPointerPosition(n), i = _this__getPointerPosition.x, s = _this__getPointerPosition.y;
                this._sendMessage("postPointerUpEvent", {
                    instanceId: this._id,
                    x: i,
                    y: s
                });
            }
        },
        {
            key: "_onPointerDown",
            value: function _onPointerDown(n) {
                var _this__getPointerPosition = this._getPointerPosition(n), i = _this__getPointerPosition.x, s = _this__getPointerPosition.y;
                this._sendMessage("postPointerDownEvent", {
                    instanceId: this._id,
                    x: i,
                    y: s
                });
            }
        },
        {
            key: "_onPointerMove",
            value: function _onPointerMove(n) {
                var _this__getPointerPosition = this._getPointerPosition(n), i = _this__getPointerPosition.x, s = _this__getPointerPosition.y;
                this._sendMessage("postPointerMoveEvent", {
                    instanceId: this._id,
                    x: i,
                    y: s
                });
            }
        },
        {
            key: "_onPointerEnter",
            value: function _onPointerEnter(n) {
                var _this__getPointerPosition = this._getPointerPosition(n), i = _this__getPointerPosition.x, s = _this__getPointerPosition.y;
                this._sendMessage("postPointerEnterEvent", {
                    instanceId: this._id,
                    x: i,
                    y: s
                });
            }
        },
        {
            key: "_onPointerLeave",
            value: function _onPointerLeave(n) {
                var _this__getPointerPosition = this._getPointerPosition(n), i = _this__getPointerPosition.x, s = _this__getPointerPosition.y;
                this._sendMessage("postPointerExitEvent", {
                    instanceId: this._id,
                    x: i,
                    y: s
                });
            }
        },
        {
            key: "_setupStateMachineListeners",
            value: function _setupStateMachineListeners() {
                return $2bb54e1a7d9957b8$var$g(this, null, function() {
                    var n;
                    return (0, $fc5e3658b603cf39$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!($2bb54e1a7d9957b8$var$F && this._canvas instanceof HTMLCanvasElement && this.isLoaded)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this._sendMessage("getStateMachineListeners", {
                                        instanceId: this._id
                                    })
                                ];
                            case 1:
                                n = _state.sent();
                                n.includes("PointerUp") && this._canvas.addEventListener("pointerup", this._pointerUpMethod), n.includes("PointerDown") && this._canvas.addEventListener("pointerdown", this._pointerDownMethod), n.includes("PointerMove") && this._canvas.addEventListener("pointermove", this._pointerMoveMethod), n.includes("PointerEnter") && this._canvas.addEventListener("pointerenter", this._pointerEnterMethod), n.includes("PointerExit") && this._canvas.addEventListener("pointerleave", this._pointerExitMethod);
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_cleanupStateMachineListeners",
            value: function _cleanupStateMachineListeners() {
                $2bb54e1a7d9957b8$var$F && this._canvas instanceof HTMLCanvasElement && (this._canvas.removeEventListener("pointerup", this._pointerUpMethod), this._canvas.removeEventListener("pointerdown", this._pointerDownMethod), this._canvas.removeEventListener("pointermove", this._pointerMoveMethod), this._canvas.removeEventListener("pointerenter", this._pointerEnterMethod), this._canvas.removeEventListener("pointerleave", this._pointerExitMethod));
            }
        }
    ], [
        {
            key: "setWasmUrl",
            value: function setWasmUrl(n) {
                q._wasmUrl = n;
            }
        }
    ]);
    return q;
}();
$2bb54e1a7d9957b8$var$_($2bb54e1a7d9957b8$var$q, "_workerManager", new $2bb54e1a7d9957b8$var$$1), $2bb54e1a7d9957b8$var$_($2bb54e1a7d9957b8$var$q, "_wasmUrl", "");
var $2bb54e1a7d9957b8$export$ab8c8a3fed0b35de = $2bb54e1a7d9957b8$var$q;
 //# sourceMappingURL=index.js.map


var $9375815f372eb7c9$var$SWIPES_PATH = "https://lottie.host/eb3886c4-cdf4-4b3b-a684-270e56c2ac6b/fs03vzzBv1.lottie";
var $9375815f372eb7c9$var$ARROWS_PATH = "https://lottie.host/faad9686-d0e9-480b-a729-36159d6476dd/WfFbSC8L9V.lottie";
var $9375815f372eb7c9$var$ID_LOTTIE_CANVAS = "lottie-canvas";
var $9375815f372eb7c9$var$lottieContainer = document.querySelector("#" + $9375815f372eb7c9$var$ID_LOTTIE_CANVAS);
var $9375815f372eb7c9$var$animationDotLottie = null;
// Check if the device is mobile and return the path to the animation
function $9375815f372eb7c9$var$getAnimationPath() {
    var isMobile = "ontouchstart" in window || navigator.maxTouchPoints > 0 || window.matchMedia("(pointer: coarse)").matches;
    return isMobile ? $9375815f372eb7c9$var$SWIPES_PATH : $9375815f372eb7c9$var$ARROWS_PATH;
}
function $9375815f372eb7c9$export$efead17ed5dcfd2() {
    if ($9375815f372eb7c9$var$animationDotLottie) $9375815f372eb7c9$var$animationDotLottie.destroy();
    $9375815f372eb7c9$var$animationDotLottie = new (0, $2bb54e1a7d9957b8$export$2c434b74e61f4f56)({
        loop: true,
        speed: 1,
        canvas: $9375815f372eb7c9$var$lottieContainer,
        src: $9375815f372eb7c9$var$getAnimationPath()
    });
    $9375815f372eb7c9$var$animationDotLottie.addEventListener("load", function() {
        $9375815f372eb7c9$var$animationDotLottie.play();
    });
}
function $9375815f372eb7c9$export$3cc6f911ef1fd837() {
    if ($9375815f372eb7c9$var$animationDotLottie) $9375815f372eb7c9$var$animationDotLottie.stop();
}



var $dc89acac9bfd5967$var$ID_TIP_CHECKBOX = "tip-checkbox";
var $dc89acac9bfd5967$var$CLASS_TIP_CLOSE_BUTTON = "tip__button";
var $dc89acac9bfd5967$var$CLASS_SHOW_TIP_BUTTON = "header__show-tip";
var $dc89acac9bfd5967$var$CLASS_TIP_CONTAINER = "tip";
var $dc89acac9bfd5967$var$checkboxInput = document.querySelector("#" + $dc89acac9bfd5967$var$ID_TIP_CHECKBOX);
var $dc89acac9bfd5967$var$closeButton = document.querySelector("." + $dc89acac9bfd5967$var$CLASS_TIP_CLOSE_BUTTON);
var $dc89acac9bfd5967$var$showTipBtn = document.querySelector("." + $dc89acac9bfd5967$var$CLASS_SHOW_TIP_BUTTON);
var $dc89acac9bfd5967$var$tipContainer = document.querySelector("." + $dc89acac9bfd5967$var$CLASS_TIP_CONTAINER);
function $dc89acac9bfd5967$var$setTipVisibility(isVisible) {
    if (isVisible) {
        $dc89acac9bfd5967$var$tipContainer.classList.remove((0, $fea6c9abafe78b66$export$e3ab40feca470fea));
        (0, $9375815f372eb7c9$export$efead17ed5dcfd2)();
    } else {
        $dc89acac9bfd5967$var$tipContainer.classList.add((0, $fea6c9abafe78b66$export$e3ab40feca470fea));
        (0, $9375815f372eb7c9$export$3cc6f911ef1fd837)();
    }
}
function $dc89acac9bfd5967$export$fc105d872f19cb1d() {
    $dc89acac9bfd5967$var$setTipVisibility(true);
    $dc89acac9bfd5967$var$checkboxInput.checked = localStorage.getItem((0, $fea6c9abafe78b66$export$41f26d2536af779f)) === "true";
}
function $dc89acac9bfd5967$export$35fe36a333e89a28() {
    $dc89acac9bfd5967$var$setTipVisibility(false);
    localStorage.setItem((0, $fea6c9abafe78b66$export$41f26d2536af779f), $dc89acac9bfd5967$var$checkboxInput.checked);
}
$dc89acac9bfd5967$var$closeButton.addEventListener("click", $dc89acac9bfd5967$export$35fe36a333e89a28);
$dc89acac9bfd5967$var$showTipBtn.addEventListener("click", $dc89acac9bfd5967$export$fc105d872f19cb1d);





var $a0eaf1b91e21ed8a$var$canvas;
var $a0eaf1b91e21ed8a$var$ctx;
var $a0eaf1b91e21ed8a$var$confettiParticles = [];
var $a0eaf1b91e21ed8a$var$animationFrameId;
var $a0eaf1b91e21ed8a$var$intervalId;
function $a0eaf1b91e21ed8a$export$7a0646efa3263edf() {
    if ($a0eaf1b91e21ed8a$var$canvas) return;
    $a0eaf1b91e21ed8a$var$canvas = document.createElement("canvas");
    $a0eaf1b91e21ed8a$var$canvas.classList.add("confetti-container");
    document.body.appendChild($a0eaf1b91e21ed8a$var$canvas);
    $a0eaf1b91e21ed8a$var$ctx = $a0eaf1b91e21ed8a$var$canvas.getContext("2d");
    $a0eaf1b91e21ed8a$var$resizeCanvas();
    window.addEventListener("resize", $a0eaf1b91e21ed8a$var$resizeCanvas);
    $a0eaf1b91e21ed8a$var$createConfettiExplosion();
    $a0eaf1b91e21ed8a$var$animationFrameId = requestAnimationFrame($a0eaf1b91e21ed8a$var$updateConfetti);
}
function $a0eaf1b91e21ed8a$export$b76f4eae8c586a83() {
    cancelAnimationFrame($a0eaf1b91e21ed8a$var$animationFrameId);
    $a0eaf1b91e21ed8a$var$confettiParticles = [];
    clearInterval($a0eaf1b91e21ed8a$var$intervalId);
    $a0eaf1b91e21ed8a$var$intervalId = null;
    if ($a0eaf1b91e21ed8a$var$canvas) {
        $a0eaf1b91e21ed8a$var$canvas.remove();
        $a0eaf1b91e21ed8a$var$canvas = null;
    }
    window.removeEventListener("resize", $a0eaf1b91e21ed8a$var$resizeCanvas);
}
function $a0eaf1b91e21ed8a$var$resizeCanvas() {
    if (!$a0eaf1b91e21ed8a$var$canvas) return;
    $a0eaf1b91e21ed8a$var$canvas.width = window.innerWidth;
    $a0eaf1b91e21ed8a$var$canvas.height = window.innerHeight;
}
function $a0eaf1b91e21ed8a$var$createConfettiExplosion() {
    for(var i = 0; i < 100; i++)$a0eaf1b91e21ed8a$var$confettiParticles.push(new $a0eaf1b91e21ed8a$var$ConfettiParticle(true));
    setTimeout(function() {
        if (!$a0eaf1b91e21ed8a$var$intervalId) $a0eaf1b91e21ed8a$var$intervalId = setInterval(function() {
            $a0eaf1b91e21ed8a$var$confettiParticles.push(new $a0eaf1b91e21ed8a$var$ConfettiParticle(false));
        }, 150);
    }, 1000);
}
var $a0eaf1b91e21ed8a$var$ConfettiParticle = /*#__PURE__*/ function() {
    "use strict";
    function ConfettiParticle(isExplosion) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, ConfettiParticle);
        this.x = isExplosion ? window.innerWidth / 2 + (Math.random() - 0.5) * 200 : Math.random() * window.innerWidth; // випадкова горизонтальна відстань
        this.y = -10; // вибух з середини
        this.size = Math.random() * 4 + 8;
        this.color = "hsl(".concat(Math.random() * 360, ", 100%, 60%)");
        this.angle = (Math.random() - 0.5) * Math.PI; // Випадковий кут (-90° до 90°)
        // Випадкові швидкості
        this.velocityX = (Math.random() - 0.5) * (isExplosion ? 10 : 2);
        this.velocityY = isExplosion ? Math.random() * 7 + 1 // більш випадковий вертикальний рух при вибуху
         : Math.random() * 3 + 1;
        this.rotationSpeed = Math.random() * 0.1 - 0.05;
        this.opacity = 1;
        // Випадкова форма, яку частинка отримає один раз
        var shapeChoice = Math.random();
        if (shapeChoice > 0.66) this.shape = "square";
        else if (shapeChoice > 0.33) this.shape = "circle";
        else this.shape = "triangle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(ConfettiParticle, [
        {
            key: "update",
            value: function update() {
                this.x += this.velocityX;
                this.y += this.velocityY;
                this.angle += this.rotationSpeed;
                this.opacity -= 0.003;
                if (this.isOutOfBounds() || this.opacity <= 0) return false;
                return true;
            }
        },
        {
            key: "isOutOfBounds",
            value: function isOutOfBounds() {
                return this.x > window.innerWidth || this.x < 0 || this.y > window.innerHeight;
            }
        },
        {
            key: "draw",
            value: function draw(ctx1) {
                ctx1.save();
                ctx1.translate(this.x, this.y);
                ctx1.rotate(this.angle);
                ctx1.fillStyle = this.color;
                ctx1.globalAlpha = this.opacity;
                if (this.shape === "square") ctx1.fillRect(-this.size / 2, -this.size / 2, this.size, this.size); // квадрат
                else if (this.shape === "circle") {
                    ctx1.beginPath();
                    ctx1.arc(0, 0, this.size / 2, 0, 2 * Math.PI);
                    ctx1.fill();
                } else if (this.shape === "triangle") {
                    ctx1.beginPath();
                    ctx1.moveTo(0, -this.size / 2);
                    ctx1.lineTo(-this.size / 2, this.size / 2);
                    ctx1.lineTo(this.size / 2, this.size / 2);
                    ctx1.closePath();
                    ctx1.fill();
                }
                ctx1.restore();
            }
        }
    ]);
    return ConfettiParticle;
}();
function $a0eaf1b91e21ed8a$var$updateConfetti() {
    if (!$a0eaf1b91e21ed8a$var$canvas) return;
    $a0eaf1b91e21ed8a$var$ctx.clearRect(0, 0, $a0eaf1b91e21ed8a$var$canvas.width, $a0eaf1b91e21ed8a$var$canvas.height); // Очищаємо canvas
    $a0eaf1b91e21ed8a$var$confettiParticles = $a0eaf1b91e21ed8a$var$confettiParticles.filter(function(particle) {
        return particle.update();
    });
    $a0eaf1b91e21ed8a$var$confettiParticles.forEach(function(particle) {
        return particle.draw($a0eaf1b91e21ed8a$var$ctx);
    }); // Малюємо частинки
    $a0eaf1b91e21ed8a$var$animationFrameId = requestAnimationFrame($a0eaf1b91e21ed8a$var$updateConfetti); // Оновлюємо анімацію
}



var $d19fb46fde2c849d$var$CLASS_TILE_CONTAINER = "tile-container";
var $d19fb46fde2c849d$var$CLASS_SCORE = "game-score";
var $d19fb46fde2c849d$var$CLASS_BEST_SCORE = "game-best-score";
var $d19fb46fde2c849d$var$CLASS_BODY_GAME_OVER = "body--game-over";
var $d19fb46fde2c849d$var$CLASS_GAME_MESSAGE_CONTAINER = "game__message-container";
var $d19fb46fde2c849d$var$CLASS_MESSAGE_START = "message--start";
var $d19fb46fde2c849d$var$CLASS_RESTART_BUTTON = "header__button--restart";
var $d19fb46fde2c849d$var$CLASS_START_BUTTON = "header__button--start";
var $d19fb46fde2c849d$var$RESTART_BUTTON_TEXT = "Restart";
var $d19fb46fde2c849d$var$CONFETTI_ANIMATION_DURATION = 50000;
var $d19fb46fde2c849d$var$LOSE_APEARENCE_DELAY = 1000;
var $d19fb46fde2c849d$export$119d2a93e2780362 = new (0, $f4cdfd32d5d95340$export$985739bfa5723e08)();
var $d19fb46fde2c849d$var$tileContainer = document.querySelector("." + $d19fb46fde2c849d$var$CLASS_TILE_CONTAINER);
var $d19fb46fde2c849d$var$scoreDisplay = document.querySelector("." + $d19fb46fde2c849d$var$CLASS_SCORE);
var $d19fb46fde2c849d$var$bestScoreDisplay = document.querySelector("." + $d19fb46fde2c849d$var$CLASS_BEST_SCORE);
var $d19fb46fde2c849d$var$startButton = document.querySelector("." + $d19fb46fde2c849d$var$CLASS_START_BUTTON);
var $d19fb46fde2c849d$export$b3890eb0ae9dca99 = function() {
    requestAnimationFrame(function() {
        return (0, $46a4ebb2ff2c0b16$export$791665666f8a0d2)($d19fb46fde2c849d$export$119d2a93e2780362, $d19fb46fde2c849d$var$tileContainer);
    });
    $d19fb46fde2c849d$var$scoreDisplay.textContent = $d19fb46fde2c849d$export$119d2a93e2780362.score;
    $d19fb46fde2c849d$var$bestScoreDisplay.textContent = $d19fb46fde2c849d$export$119d2a93e2780362.bestScore;
    if ($d19fb46fde2c849d$export$119d2a93e2780362.win) $d19fb46fde2c849d$var$handleWin();
    else if ($d19fb46fde2c849d$export$119d2a93e2780362.lose) $d19fb46fde2c849d$var$handleLose();
};
var $d19fb46fde2c849d$var$handleWin = function() {
    (0, $a0eaf1b91e21ed8a$export$7a0646efa3263edf)();
    (0, $76925737f7718e27$export$2b8c3b960bb992d3)((0, $f17388ede13a49cc$export$71511d61b312f219)((0, $ad1c00e896d27009$export$71511d61b312f219)({}, (0, $fea6c9abafe78b66$export$78da66fbfc3ec44a)), {
        onConfirm: function() {
            clearTimeout(timerId);
            (0, $a0eaf1b91e21ed8a$export$b76f4eae8c586a83)();
            $d19fb46fde2c849d$export$119d2a93e2780362.win = false;
            $d19fb46fde2c849d$export$119d2a93e2780362.hasContinued = true;
            $d19fb46fde2c849d$export$b3890eb0ae9dca99();
        },
        onReject: function() {
            clearTimeout(timerId);
            (0, $a0eaf1b91e21ed8a$export$b76f4eae8c586a83)();
            $d19fb46fde2c849d$export$13063a66817085c1();
        }
    }));
    var timerId = setTimeout((0, $a0eaf1b91e21ed8a$export$b76f4eae8c586a83), $d19fb46fde2c849d$var$CONFETTI_ANIMATION_DURATION);
};
var $d19fb46fde2c849d$var$handleLose = function() {
    document.body.classList.add($d19fb46fde2c849d$var$CLASS_BODY_GAME_OVER);
    setTimeout(function() {
        requestAnimationFrame(function() {
            (0, $76925737f7718e27$export$2b8c3b960bb992d3)((0, $f17388ede13a49cc$export$71511d61b312f219)((0, $ad1c00e896d27009$export$71511d61b312f219)({}, (0, $fea6c9abafe78b66$export$7e1cad2321981b86)), {
                onConfirm: function() {
                    document.body.classList.remove($d19fb46fde2c849d$var$CLASS_BODY_GAME_OVER);
                    $d19fb46fde2c849d$export$13063a66817085c1();
                },
                onReject: function() {
                    document.body.classList.remove($d19fb46fde2c849d$var$CLASS_BODY_GAME_OVER);
                }
            }));
        });
    }, $d19fb46fde2c849d$var$LOSE_APEARENCE_DELAY);
};
var $d19fb46fde2c849d$export$5f9f2982725d71d5 = function() {
    document.querySelector("." + $d19fb46fde2c849d$var$CLASS_GAME_MESSAGE_CONTAINER).classList.add((0, $fea6c9abafe78b66$export$e3ab40feca470fea));
    document.querySelector("." + $d19fb46fde2c849d$var$CLASS_MESSAGE_START).classList.add((0, $fea6c9abafe78b66$export$e3ab40feca470fea));
    $d19fb46fde2c849d$var$tileContainer.innerHTML = "";
    if (localStorage.getItem((0, $fea6c9abafe78b66$export$41f26d2536af779f)) !== "true") (0, $dc89acac9bfd5967$export$fc105d872f19cb1d)();
    $d19fb46fde2c849d$export$119d2a93e2780362.resetGame();
    $d19fb46fde2c849d$export$b3890eb0ae9dca99();
    $d19fb46fde2c849d$var$startButton.textContent = $d19fb46fde2c849d$var$RESTART_BUTTON_TEXT;
    $d19fb46fde2c849d$var$startButton.classList.add($d19fb46fde2c849d$var$CLASS_RESTART_BUTTON);
};
var $d19fb46fde2c849d$export$13063a66817085c1 = function() {
    return $d19fb46fde2c849d$export$5f9f2982725d71d5();
};


var $197cd56b15c33885$var$CLASS_START_BUTTON = "header__button--start";
var $197cd56b15c33885$var$startButton = document.querySelector("." + $197cd56b15c33885$var$CLASS_START_BUTTON);
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    if ($197cd56b15c33885$var$startButton.classList.contains("header__button--restart")) {
        (0, $76925737f7718e27$export$2b8c3b960bb992d3)((0, $f17388ede13a49cc$export$71511d61b312f219)((0, $ad1c00e896d27009$export$71511d61b312f219)({}, (0, $fea6c9abafe78b66$export$f981ec3b27145abc)), {
            onConfirm: function() {
                return (0, $d19fb46fde2c849d$export$13063a66817085c1)();
            }
        }));
        return;
    }
    (0, $d19fb46fde2c849d$export$5f9f2982725d71d5)();
});
document.addEventListener("touchstart", (0, $de78fff7b3201fb9$export$f11d8654acca7032), {
    passive: false
});
document.addEventListener("gesturestart", (0, $de78fff7b3201fb9$export$81df17ce304cb8dd));
document.addEventListener("keydown", (0, $9918acfb2b9f8e73$export$de363e709c412c8a)((0, $de78fff7b3201fb9$export$935bc35302f21d93)((0, $d19fb46fde2c849d$export$119d2a93e2780362), (0, $d19fb46fde2c849d$export$b3890eb0ae9dca99)), 100));
window.addEventListener("resize", (0, $4b8aec50238c028e$export$d28b580074e273aa));
window.addEventListener("load", function() {
    (0, $c0ec718a77f6c5b5$export$f5a33026233531be)();
    (0, $4b8aec50238c028e$export$d28b580074e273aa)();
});
(0, $75ea2ebfb38b72b5$export$d777e9849b416b53)((0, $d19fb46fde2c849d$export$119d2a93e2780362), (0, $d19fb46fde2c849d$export$b3890eb0ae9dca99));
(0, $d19fb46fde2c849d$export$b3890eb0ae9dca99)();

})();
//# sourceMappingURL=index.127cdce9.js.map
